{
 " ao(à) paciente {nome}{cpf}": " au(à la) patient(e) {nome}{cpf}",
 " junto ao plano de saúde {c}": " auprès de la mutuelle {c}",
 " às {h}": " à {h}",
 "\"1\", \"1 / 10\" ou \"Página 1 de 10\", no canto que quiser.": "\"1\", \"1 / 10\" ou \"Page 1 sur 10\", dans le coin de votre choix.",
 "\"{nome}\" está no {provedor}.": "« {nome} » est sur {provedor}.",
 "\"{nome}\" não é JPG nem PNG. Converta para JPG e tente de novo.": "\"{nome}\" n'est ni un JPG ni un PNG. Convertissez-le en JPG et réessayez.",
 "\"{nome}\" não é um PDF.": "\"{nome}\" n'est pas un PDF.",
 "\"{nova}\" às {hora} coincide com: {outras}.": "« {nova} » à {hora} chevauche : {outras}.",
 "\"{n}\" agora é do grupo. Em até 1 minuto os outros membros veem tudo.": "« {n} » appartient maintenant au groupe. D'ici 1 minute, les autres membres verront tout.",
 "\"{titulo}\" foi criada com os mesmos dados.": "« {titulo} » a été créée avec les mêmes données.",
 "\"{titulo}\" já foi adicionado em {data}.": "« {titulo} » a déjà été ajouté le {data}.",
 "% ao mês": "% par mois",
 "(No computador do administrador: 32-LIGAR-DRIVE-ONEDRIVE.bat.)": "(Sur l'ordinateur de l'administrateur : 32-LIGAR-DRIVE-ONEDRIVE.bat.)",
 "(cópia)": "(copie)",
 "(sem título)": "(sans titre)",
 "+ Adicionar alerta": "+ Ajouter une alerte",
 "+ Adicionar outra OAB": "+ Ajouter une autre OAB",
 "+ Adicionar pausa": "+ Ajouter une pause",
 "+ Adicionar subtarefa": "+ Ajouter une sous-tâche",
 "+ Matéria em {nome}": "+ Matière dans {nome}",
 "+ Perfil": "+ Profil",
 "+ Subtarefa": "+ Sous-tâche",
 "+5 min": "+5 min",
 "+{n} acompanhante(s)": "+{n} accompagnant(s)",
 "+{n} páginas acima da meta": "+{n} pages au-dessus de l'objectif",
 ", carteirinha nº {n},": ", carte d'adhérent n° {n},",
 ", pago em {d}{f}": ", payé le {d}{f}",
 "1 cápsula": "1 gélule",
 "1 dose": "1 dose",
 "1 dose (30 g)": "1 dose (30 g)",
 "1 pessoa": "1 personne",
 "1 publicação nova": "1 nouvelle publication",
 "1 página": "1 page",
 "1 tarja no documento": "1 bande noire dans le document",
 "1. Instale o My Planner e crie sua conta.  2. Abra este link de novo (ou digite o código em Ajustes › Grupos e convites).": "1. Installez My Planner et créez votre compte.  2. Rouvrez ce lien (ou saisissez le code dans Réglages › Groupes et invitations).",
 "1. Quais dados tratamos": "1. Données que nous traitons",
 "1. Sobre o app": "1. À propos de l'app",
 "1ª dose": "1re dose",
 "2 por folha": "2 par feuille",
 "2 xícaras de farinha\n3 ovos\n1 colher de fermento": "2 tasses de farine\n3 œufs\n1 cuillère de levure",
 "2, 4, 6 ou 9 páginas em cada folha (para imprimir).": "2, 4, 6 ou 9 pages sur chaque feuille (pour imprimer).",
 "2. Para que usamos": "2. À quoi elles servent",
 "2. Sua conta": "2. Votre compte",
 "2ª dose": "2e dose",
 "3 a 5 g": "3 à 5 g",
 "3. Bases legais (LGPD)": "3. Bases légales (LGPD)",
 "3. Uso correto": "3. Bon usage",
 "3ª dose": "3e dose",
 "4 por folha": "4 par feuille",
 "4. Com quem compartilhamos": "4. Avec qui nous les partageons",
 "4. Planos e testes": "4. Formules et essais",
 "5. Limites": "5. Limites",
 "5. Segurança": "5. Sécurité",
 "6 por folha": "6 par feuille",
 "6. Por quanto tempo": "6. Durée de conservation",
 "7. Seus direitos (art. 18 da LGPD)": "7. Vos droits (art. 18 de la LGPD)",
 "8. Crianças e adolescentes": "8. Enfants et adolescents",
 "9 por folha": "9 par feuille",
 "9. Mudanças": "9. Modifications",
 "@letra-dom": "D",
 "@letra-qua": "M",
 "@letra-qui": "J",
 "@letra-sab": "S",
 "@letra-seg": "L",
 "@letra-sex": "V",
 "@letra-ter": "M",
 "A IA está classificando...": "L'IA classe les catégories...",
 "A IA está lendo a caixa...": "L'IA lit la boîte...",
 "A IA lê as páginas e o PDF passa a aceitar busca e cópia.": "L'IA lit les pages et le PDF devient consultable et copiable.",
 "A IA lê o PDF e sugere um nome claro.": "L'IA lit le PDF et suggère un nom clair.",
 "A IA não devolveu uma resposta no formato esperado. Tente de novo.": "L'IA n'a pas renvoyé de réponse au format attendu. Réessayez.",
 "A IA não encontrou dados para esta ficha no arquivo.": "L'IA n'a trouvé aucune donnée pour cette fiche dans le fichier.",
 "A IA não encontrou tarefas nesta caixa.": "L'IA n'a trouvé aucune tâche dans cette boîte.",
 "A IA resume o PDF e responde perguntas.": "L'IA résume le PDF et répond aux questions.",
 "A SEFAZ registra que a nota chegou ao seu conhecimento (não confirma nem recusa a compra) e libera o XML completo na próxima busca, em até 1 hora.": "La SEFAZ enregistre que la facture a été portée à votre connaissance (cela ne confirme ni ne refuse l'achat) et libère le XML complet lors de la prochaine recherche, sous 1 heure.",
 "A VENCER (7 DIAS)": "À VENIR (7 JOURS)",
 "A aba inteira": "L'onglet entier",
 "A aba {aba} está perto do limite. Arquive ou apague itens antigos dela.": "L'onglet {aba} approche de la limite. Archivez ou supprimez ses anciens éléments.",
 "A aba {aba} não está assinada. O vínculo fica guardado e volta ao assinar.": "L'onglet {aba} n'est pas abonné. Le lien est conservé et revient lors de l'abonnement.",
 "A busca de \"{nome}\" está ampla demais. Use o nome completo.": "La recherche « {nome} » est trop large. Utilisez le nom complet.",
 "A busca de GIFs ainda não foi ligada neste app. Enquanto isso, use as figurinhas animadas (🎉).": "La recherche de GIF n'est pas encore activée dans cette app. En attendant, utilisez les stickers animés (🎉).",
 "A cada": "Tous les",
 "A cada N páginas": "Toutes les N pages",
 "A cada quantos dias": "Tous les combien de jours",
 "A cada {n} dia(s)": "Tous les {n} jour(s)",
 "A cada {n} mês(es)": "Tous les {n} mois",
 "A cada {n} mês(es) · dia {d}": "Tous les {n} mois · jour {d}",
 "A cada {n} semana(s)": "Toutes les {n} semaine(s)",
 "A cada {n} semana(s) · {dia}": "Toutes les {n} semaine(s) · {dia}",
 "A caixa está em {aba}, em \"Anotações recebidas\".": "La boîte est dans {aba}, dans « Notes reçues ».",
 "A caixa foi para {destino}.": "La boîte a été envoyée dans {destino}.",
 "A chave fica guardada só neste dispositivo, no cofre do sistema. Em outro dispositivo, cadastre de novo.": "La clé est conservée uniquement sur cet appareil, dans le coffre du système. Sur un autre appareil, ajoutez-la à nouveau.",
 "A chave fica guardada só neste navegador. Use num computador pessoal.": "La clé est conservée uniquement dans ce navigateur. Utilisez un ordinateur personnel.",
 "A conexão é criptografada. O cofre usa criptografia de ponta a ponta (AES-256): nem o suporte consegue ler. O app pode ser bloqueado com senha, desenho ou biometria.": "La connexion est chiffrée. Le coffre utilise un chiffrement de bout en bout (AES-256) : même le support ne peut pas le lire. L'app peut être verrouillée par mot de passe, schéma ou biométrie.",
 "A confirmação pelo WhatsApp ainda não foi ligada no servidor.": "La confirmation par WhatsApp n’est pas encore activée sur le serveur.",
 "A conta e todos os dados guardados na nuvem: tarefas, anotações, abas, fichas, mensagens, arquivos enviados ao app e configurações. Também são apagados os dados deste dispositivo. Não há como desfazer.": "Le compte et toutes les données stockées dans le cloud : tâches, notes, onglets, fiches, messages, fichiers envoyés à l'app et réglages. Les données de cet appareil sont aussi supprimées. C'est irréversible.",
 "A cor aparece na barra, nos títulos e nas tarefas ligadas a esta aba.": "La couleur apparaît dans la barre, dans les titres et dans les tâches liées à cet onglet.",
 "A cor do My Planner é a cor de destaque do app. Cada tarefa pode ter uma cor própria na ficha.": "La couleur de My Planner est la couleur d'accent de l'app. Chaque tâche peut avoir sa propre couleur dans sa fiche.",
 "A data de fim é anterior à de início.": "La date de fin est antérieure à la date de début.",
 "A data inicial precisa ser antes da final.": "La date de début doit être antérieure à la date de fin.",
 "A equipe vai olhar o erro e corrigir numa próxima atualização.": "L'équipe va examiner l'erreur et la corriger dans une prochaine mise à jour.",
 "A equipe vê e altera conforme o papel de cada um": "L'équipe voit et modifie selon le rôle de chacun",
 "A fazer": "À faire",
 "A foto passa de 8 MB.": "La photo dépasse 8 Mo.",
 "A foto é grande demais. Instale o app novo para recortar a foto.": "La photo est trop grande. Installez la nouvelle version de l'app pour recadrer la photo.",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 32-LIGAR-DRIVE-ONEDRIVE.bat.": "La fonction « nuvem » n'a pas encore été publiée sur le serveur. Exécutez 32-LIGAR-DRIVE-ONEDRIVE.bat.",
 "A função \"nuvem\" ainda não foi publicada no servidor. Rode o 9-LIGAR-DRIVE-ONEDRIVE.bat (veja COMO RODAR, versão 0.15.1).": "La fonction « nuvem » n'a pas encore été publiée sur le serveur. Lancez 9-LIGAR-DRIVE-ONEDRIVE.bat (voir COMO RODAR, version 0.15.1).",
 "A gravação ainda está sendo preparada. Tente de novo em alguns minutos.": "L'enregistrement est encore en préparation. Réessayez dans quelques minutes.",
 "A hora fica marcada neste fuso. Em outro fuso, o app mostra e avisa no horário convertido.": "L'heure est fixée dans ce fuseau. Dans un autre fuseau, l'app l'affiche et vous alerte à l'heure convertie.",
 "A imagem original não está neste dispositivo.": "L'image d'origine n'est pas sur cet appareil.",
 "A pagar": "À payer",
 "A pagar: {v}": "À payer : {v}",
 "A permissão da agenda foi retirada. Libere de novo nas configurações do celular.": "L'autorisation d'accès à l'agenda a été retirée. Réactivez-la dans les réglages du téléphone.",
 "A pessoa sai do grupo e deixa de receber os envios.": "La personne quitte le groupe et ne reçoit plus les envois.",
 "A receber": "À recevoir",
 "A receber: {v}": "À recevoir : {v}",
 "A reunião ainda está sendo gravada.": "La réunion est encore en cours d'enregistrement.",
 "A senha atual não confere.": "Le mot de passe actuel est incorrect.",
 "A senha do cofre precisa ter 6 caracteres ou mais.": "Le mot de passe du coffre doit contenir au moins 6 caractères.",
 "A senha precisa ter 8 caracteres ou mais.": "Le mot de passe doit contenir 8 caractères ou plus.",
 "A senha precisa ter pelo menos 8 caracteres.": "Le mot de passe doit contenir au moins 8 caractères.",
 "A senha é a mesma no celular e no My Planner Web.": "Le mot de passe est le même sur le téléphone et sur My Planner Web.",
 "A sincronização roda ao abrir o app e depois de cada alteração. Tarefas ligadas à agenda mostram 📆.": "La synchronisation a lieu à l'ouverture de l'app et après chaque modification. Les tâches liées à l'agenda affichent 📆.",
 "A sua equipe num lugar só": "Toute votre équipe au même endroit",
 "A tarefa da casa não entra no My Planner sozinha. \"Enviar para o My Planner\" abre a ficha completa para escolher dia, horário, frequência, pausas e alertas.": "Les tâches ménagères n'entrent pas toutes seules dans My Planner. « Envoyer vers My Planner » ouvre la fiche complète pour choisir le jour, l'heure, la fréquence, les pauses et les alertes.",
 "A validade não pode ser antes da emissão.": "La date d'expiration ne peut pas être antérieure à la date de délivrance.",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web.": "La version iPhone arrive bientôt sur l'App Store. En attendant, utilisez My Planner Web.",
 "A versão para iPhone chega em breve na App Store. Enquanto isso, use o My Planner Web: no Safari, toque em Compartilhar > Adicionar à Tela de Início para ele virar um ícone no celular.": "La version iPhone arrive bientôt sur l'App Store. En attendant, utilisez My Planner Web : dans Safari, touchez Partager > Sur l'écran d'accueil pour en faire une icône sur votre téléphone.",
 "A4, Carta, A5 ou Ofício, sem cortar nada.": "A4, Lettre, A5 ou Légal, sans rien couper.",
 "ADICIONAR AMIGO": "AJOUTER UN AMI",
 "AGUARDANDO RESPOSTA": "EN ATTENTE DE RÉPONSE",
 "AMIGOS": "AMIS",
 "ANOTAÇÕES": "NOTES",
 "ANOTAÇÕES RECEBIDAS · {aba}": "NOTES REÇUES · {aba}",
 "ATIVIDADE": "ACTIVITÉ",
 "ATIVIDADE FÍSICA": "ACTIVITÉ PHYSIQUE",
 "ATRASADAS": "EN RETARD",
 "Aba": "Onglet",
 "Aba bloqueada": "Onglet verrouillé",
 "Aba {nome}": "Onglet {nome}",
 "Abas": "Onglets",
 "Abas liberadas pelo suporte": "Onglets débloqués par le support",
 "Abas para comprar": "Onglets à acheter",
 "Abas que você já tem": "Onglets que vous avez déjà",
 "Abastecimento": "Plein",
 "Abastecimentos": "Pleins",
 "Abdominal": "Crunchs",
 "Abertura do prazo da declaração do IR": "Ouverture de la période de déclaration de l'IR",
 "Abra a empresa e toque em \"Buscar notas\" para digitar a senha do cofre.": "Ouvrez l'entreprise et touchez « Rechercher des factures » pour saisir le mot de passe du coffre.",
 "Abra o My Planner Anne e entre com o seu CPF e senha.": "Ouvrez My Planner Anne et connectez-vous avec votre numéro d'identité et votre mot de passe.",
 "Abra o My Planner no celular.": "Ouvrez My Planner sur votre téléphone.",
 "Abra o cofre": "Ouvrez le coffre",
 "Abra um PDF para começar.": "Ouvrez un PDF pour commencer.",
 "Abra uma matéria e toque em \"Estudar agora\" para cronometrar. Defina metas semanais em cada matéria.": "Ouvrez une matière et touchez « Étudier maintenant » pour chronométrer. Fixez des objectifs hebdomadaires dans chaque matière.",
 "Abraço": "Câlin",
 "Abre a janela do celular: WhatsApp, e-mail, Google Drive, OneDrive, salvar em Arquivos e outros.": "Ouvre le menu de partage du téléphone : WhatsApp, e-mail, Google Drive, OneDrive, Enregistrer dans Fichiers et plus.",
 "Abre o PDF para ler aqui mesmo.": "Ouvre le PDF pour le lire ici même.",
 "Abre o Scanner PDF (bordas e sombras corrigidas).": "Ouvre le Scanner PDF (bords et ombres corrigés).",
 "Abrir": "Ouvrir",
 "Abrir Ajustes": "Ouvrir les Réglages",
 "Abrir PDF": "Ouvrir un PDF",
 "Abrir PDF do celular, Drive ou OneDrive": "Ouvrir un PDF du téléphone, de Drive ou de OneDrive",
 "Abrir a aba": "Ouvrir l'onglet",
 "Abrir a cópia guardada": "Ouvrir la copie enregistrée",
 "Abrir a pasta no Drive": "Ouvrir le dossier dans Drive",
 "Abrir com outro app": "Ouvrir avec une autre app",
 "Abrir configurações": "Ouvrir les réglages",
 "Abrir em outro app": "Ouvrir dans une autre app",
 "Abrir no DJEN": "Ouvrir dans le DJEN",
 "Abrir no modo seguro": "Ouvrir en mode sans échec",
 "Abrir normalmente": "Ouvrir normalement",
 "Abrir nota fiscal": "Ouvrir la facture",
 "Abrir o PDF": "Ouvrir le PDF",
 "Abrir o PDF no {nome}": "Ouvrir le PDF dans {nome}",
 "Abrir o XML": "Ouvrir le XML",
 "Abrir o app": "Ouvrir l'appli",
 "Abrir o app My Planner": "Ouvrir l'app My Planner",
 "Abrir o cartão": "Ouvrir la carte",
 "Abrir o cofre": "Ouvrir le coffre",
 "Abrir o cofre para ver": "Ouvrir le coffre pour voir",
 "Abrir o diário oficial": "Ouvrir le journal officiel",
 "Abrir ou baixar": "Ouvrir ou télécharger",
 "Abrir página": "Ouvrir la page",
 "Abrir site": "Ouvrir le site",
 "Abrir {nome}": "Ouvrir {nome}",
 "Acabamento": "Finitions",
 "Acabou": "Épuisé",
 "Academia": "Salle de sport",
 "Aceitar": "Accepter",
 "Aceitar, editar ou recusar": "Accepter, modifier ou refuser",
 "Aceite os termos para continuar.": "Acceptez les conditions pour continuer.",
 "Aceito": "Accepté",
 "Aceito com alterações": "Accepté avec modifications",
 "Acerto de contas": "Équilibrage des comptes",
 "Acerto de contas: {v}": "Équilibrage : {v}",
 "Acessibilidade": "Accessibilité",
 "Acesso ilimitado": "Accès illimité",
 "Acesso ilimitado a todas as funções, sem prazo": "Accès illimité à toutes les fonctions, sans limite de durée",
 "Achatar": "Aplatir",
 "Acompanha tudo, inclusive os gastos, e registra no diário.": "Suit tout, y compris les dépenses, et écrit dans le journal.",
 "Acompanhamento": "Accompagnement",
 "Acompanhantes": "Accompagnants",
 "Acrescentar no fim da página": "Ajouter à la fin de la page",
 "Adaptador de tomada": "Adaptateur de prise",
 "Adestramento": "Dressage",
 "Adicionar": "Ajouter",
 "Adicionar amigo": "Ajouter un ami",
 "Adicionar amigos do app": "Ajouter des amis de l'app",
 "Adicionar ao Planner?": "Ajouter au Planner ?",
 "Adicionar arquivo": "Ajouter un fichier",
 "Adicionar cômodo": "Ajouter une pièce",
 "Adicionar fotos e vídeos": "Ajouter photos et vidéos",
 "Adicionar imagem": "Ajouter une image",
 "Adicionar item (ex.: 2 ovos mexidos)": "Ajouter un aliment (ex. : 2 œufs brouillés)",
 "Adicionar na página": "Ajouter à la page",
 "Adicionar passo": "Ajouter une étape",
 "Adicionar país": "Ajouter un pays",
 "Adicionar página": "Ajouter une page",
 "Adicionar texto": "Ajouter du texte",
 "Adicionar {nome}": "Ajouter {nome}",
 "Adicionar à equipe": "Ajouter à l'équipe",
 "Adicione um amigo pelo código dele ou mande o seu código para quem você quer.": "Ajoutez un ami avec son code ou envoyez votre code à qui vous voulez.",
 "Admin": "Admin",
 "Administração": "Gestion",
 "Adubar a cada quantos dias": "Engrais tous les combien de jours",
 "Adubar: {p}": "Engrais : {p}",
 "Adubei hoje": "Engrais mis aujourd'hui",
 "Advogado": "Avocat",
 "Advogados": "Avocats",
 "Afundo": "Fentes",
 "Agachamento": "Squats",
 "Agenda do Google": "Google Agenda",
 "Agenda limpa": "Agenda vidé",
 "Agenda não liberada": "Agenda non autorisé",
 "Agenda sincronizada ✓": "Agenda synchronisé ✓",
 "Agenda, anotações, finanças, estudos, mensagens e muito mais num app só.": "Agenda, notes, finances, études, messages et bien plus dans une seule app.",
 "Agenda, cadastro dos pacientes e pagamentos, sem o prontuário.": "Agenda, fiches patients et paiements, sans le dossier médical.",
 "Agendado": "Planifié",
 "Agendado no My Planner": "Planifié dans My Planner",
 "Agendamento no pet shop": "Rendez-vous au toilettage",
 "Agendar": "Planifier",
 "Agendar no My Planner": "Planifier dans My Planner",
 "Agendar no My Planner (dias e horários)": "Planifier dans My Planner (jours et horaires)",
 "Agora não": "Pas maintenant",
 "Agora o verso do documento.": "Maintenant le verso du document.",
 "Agora, {hora}": "Maintenant, {hora}",
 "Agora: {ml}": "Actuel : {ml}",
 "Aguardando o celular · {s}s": "En attente du téléphone · {s} s",
 "Aguarde": "Patientez",
 "Aguarde um pouco": "Patientez un peu",
 "Aguarde...": "Patientez...",
 "Ainda a pagar no mês": "Reste à payer ce mois-ci",
 "Ainda a receber no mês": "Reste à recevoir ce mois-ci",
 "Ainda não confirmado": "Pas encore confirmé",
 "Ainda não disponível: falta configurar no servidor.": "Pas encore disponible : configuration du serveur manquante.",
 "Ainda não guardou nada este mês. Que tal separar {v} (10% do que entrou) assim que o dinheiro cair?": "Vous n'avez rien mis de côté ce mois-ci. Et si vous épargniez {v} (10 % de ce qui est entré) dès que l'argent arrive ?",
 "Ainda não há feriados deste país para este ano.": "Pas encore de jours fériés pour ce pays cette année.",
 "Ainda não há nada nesta aba para compartilhar. Crie primeiro (ex.: a viagem) e volte aqui.": "Il n'y a encore rien à partager dans cet onglet. Créez-le d'abord (ex. : le voyage) et revenez ici.",
 "Ainda não há outras pessoas no grupo (ou você não vê a lista de membros).": "Il n'y a encore personne d'autre dans le groupe (ou vous ne voyez pas la liste des membres).",
 "Ainda não marcado como feito. Toque para abrir.": "Pas encore marqué comme fait. Touchez pour ouvrir.",
 "Ainda não sincronizado": "Pas encore synchronisé",
 "Ainda sem chave neste dispositivo.": "Pas encore de clé sur cet appareil.",
 "Airbnb": "Airbnb",
 "Airbnb, Booking ou direto: reservas, limpeza no check-out, receitas, despesas e lucro do mês": "Airbnb, Booking ou en direct : réservations, ménage au départ, recettes, dépenses et bénéfice du mois",
 "Ajuda na organização": "Aide à l'organisation",
 "Ajudante": "Aide",
 "Ajustar": "Ajuster",
 "Ajustar a data final": "Ajuster la date de fin",
 "Ajustar a folha": "Ajuster la feuille",
 "Ajustar tamanho da página": "Ajuster la taille de page",
 "Ajuste visual": "Réglage visuel",
 "Ajustes": "Réglages",
 "Alarme dos remédios": "Alarme des médicaments",
 "Alarme que insiste até marcar como tomado": "Alarme qui insiste jusqu'à ce que la prise soit marquée",
 "Alemão": "Allemand",
 "Alergia": "Allergie",
 "Alergias": "Allergies",
 "Alergias e alertas": "Allergies et alertes",
 "Alertas": "Alertes",
 "Alertas das tarefas": "Alertes des tâches",
 "Alertas dos compromissos": "Alertes des rendez-vous",
 "Algo deu errado, mas o app continua aberto": "Un problème est survenu, mais l'app reste ouverte",
 "Alguns arquivos foram guardados em outro dispositivo.": "Certains fichiers ont été enregistrés sur un autre appareil.",
 "Alguns relógios (como os da Huawei) podem não enviar dados para o Health Connect. Nesse caso, digite à mão.": "Certaines montres (comme celles de Huawei) peuvent ne pas envoyer de données à Health Connect. Dans ce cas, saisissez-les manuellement.",
 "Alguém": "Quelqu'un",
 "Alguém indicou o app para você?": "Quelqu'un vous a recommandé l'app ?",
 "Alimentação": "Alimentation",
 "Alimentação & Despensa": "Alimentation & Garde-manger",
 "Alimentação {semana}": "Alimentation {semana}",
 "Alimento": "Aliment",
 "Alinhamento e balanceamento": "Parallélisme et équilibrage",
 "Almoço": "Déjeuner",
 "Alongamento": "Étirements",
 "Alta": "Haute",
 "Alterado por último por {nome}": "Modifié en dernier par {nome}",
 "Alterar metadados": "Modifier les métadonnées",
 "Alterar o valor pago": "Modifier le montant payé",
 "Alterações": "Changements",
 "Alto-falante": "Haut-parleur",
 "Aluga como": "Louer en tant que",
 "Alugar a casa ou um cômodo": "Louer le logement ou une chambre",
 "Aluguel": "Loyer",
 "Aluguel & Hospedagem": "Location & Hébergement",
 "Aluguel de carro": "Location de voiture",
 "Aluno": "Élève",
 "Alunos": "Élèves",
 "Alvará ou licença": "Permis ou licence",
 "Alvenaria": "Maçonnerie",
 "Alvo": "Objectif",
 "Alíquota do ISS (%)": "Taux de l'ISS (%)",
 "Alíquota do ISS deste serviço (%)": "Taux de l'ISS de ce service (%)",
 "Amanhã": "Demain",
 "Ambiente": "Environnement",
 "Ameno": "Doux",
 "Amigos": "Amis",
 "Amor": "Amour",
 "Amortização": "Amortissement",
 "Ampliar a foto": "Agrandir la photo",
 "Amém": "Amen",
 "Analisar com IA": "Analyser avec l'IA",
 "Anamnese e histórico (no cofre)": "Anamnèse et antécédents (dans le coffre)",
 "Anexar arquivos": "Joindre des fichiers",
 "Anexar comprovante": "Joindre un justificatif",
 "Anexar documentos, importar extratos e salvar relatórios, PDFs e cópias de segurança.": "Joindre des documents, importer des relevés et enregistrer des rapports, des PDF et des sauvegardes.",
 "Anexos": "Pièces jointes",
 "Anexos guardados aqui no dispositivo: {n}": "Pièces jointes stockées sur cet appareil : {n}",
 "Animais e natureza": "Animaux et nature",
 "Animação": "Animation",
 "Anime": "Anime",
 "Aniversário": "Anniversaire",
 "Aniversário de Campo Grande": "Anniversaire de Campo Grande",
 "Aniversário de São Paulo": "Anniversaire de São Paulo",
 "Ano": "Année",
 "Ano anterior": "Année précédente",
 "Ano de lançamento": "Année de sortie",
 "Ano de {ano}": "Année {ano}",
 "Ano passado": "L'an dernier",
 "Anotar pela foto da página": "Noter à partir de la photo de la page",
 "Anotação": "Note",
 "Anotação de {data}": "Note du {data}",
 "Anotação do professor": "Note de l'enseignant",
 "Anotação à mão": "Note manuscrite",
 "Anotações": "Notes",
 "Anotações Rápidas": "Notes rapides",
 "Anotações arquivadas": "Notes archivées",
 "Anotações arquivadas ({n})": "Notes archivées ({n})",
 "Anote cada reserva com as datas, a origem e os valores. A limpeza do check-out entra sozinha na lista de limpezas.": "Notez chaque réservation avec les dates, la provenance et les montants. Le ménage du départ s'ajoute tout seul à la liste des ménages.",
 "Anote o dia a dia da obra com fotos. Marque as fotos como Antes ou Depois para ver a evolução.": "Notez le quotidien du chantier avec des photos. Marquez les photos Avant ou Après pour voir l'évolution.",
 "Anote o que emprestou ou pegou emprestado, com foto e prazo. O app avisa no dia da devolução.": "Notez ce que vous avez prêté ou emprunté, avec photo et échéance. L'app vous prévient le jour du retour.",
 "Anote os lugares que quer conhecer. Pesquise no Google Maps ou no Waze, trace a rota passando por todos e coloque no roteiro do dia.": "Notez les lieux que vous voulez découvrir. Cherchez-les sur Google Maps ou Waze, tracez un itinéraire qui passe par tous et ajoutez-les au programme du jour.",
 "Anteriores ({n})": "Précédentes ({n})",
 "Antes": "Avant",
 "Antes de começar, confira o que o app usa e por quê. Você pode mudar tudo depois em Ajustes > Privacidade e termos.": "Avant de commencer, découvrez ce que l'app utilise et pourquoi. Vous pourrez tout modifier plus tard dans Réglages > Confidentialité et conditions.",
 "Antes de uma data": "Avant une date",
 "Antes do início": "Avant le début",
 "Antes e depois": "Avant et après",
 "Antes: {lista}": "Avant : {lista}",
 "Antipulgas": "Antipuces",
 "Anual": "Annuelle",
 "Ao ar livre": "En plein air",
 "Ao cancelar, a aba fica em preto e branco e os vínculos somem das tarefas, mas nada é apagado.": "En annulant, l'onglet passe en noir et blanc et les liens disparaissent des tâches, mais rien n'est supprimé.",
 "Ao criar a conta ou continuar usando o app, você concorda com estes termos e com a política de privacidade abaixo.": "En créant un compte ou en continuant à utiliser l'app, vous acceptez ces conditions et la politique de confidentialité ci-dessous.",
 "Ao fechar, a página é salva.": "La page est enregistrée à la fermeture.",
 "Ao salvar, você cria a senha do cofre. Este campo é criptografado no dispositivo.": "En enregistrant, vous créez le mot de passe du coffre. Ce champ est chiffré sur l'appareil.",
 "Ao tocar em \"Arquivo\" ou \"Foto\" em Estudos e Documentos, o seletor do celular mostra o Google Drive, o OneDrive e o Dropbox (quando os apps estão instalados). Escolha o arquivo direto de lá.": "Quand vous touchez « Fichier » ou « Photo » dans Études et Documents, le sélecteur du téléphone affiche Google Drive, OneDrive et Dropbox (si les apps sont installées). Choisissez le fichier directement depuis là.",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (no Android, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "Touchez un fichier joint pour l'ouvrir dans l'app du téléphone de votre choix (sur Android, « Une seule fois » ou « Toujours »). Ce que vous modifiez y est enregistré dans le fichier lui-même.",
 "Apaga a conta e todos os vencimentos dela.": "Supprime la facture et toutes ses échéances.",
 "Apaga as matérias e páginas deste fichário. As tarefas do planner continuam.": "Supprime les matières et les pages de ce classeur. Les tâches du planner sont conservées.",
 "Apaga as páginas desta matéria. O tempo estudado continua no histórico.": "Supprime les pages de cette matière. Le temps d'étude reste dans l'historique.",
 "Apaga o cartão e as compras dele.": "Supprime la carte et ses achats.",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Não há como desfazer.": "Supprime définitivement le compte et toutes les données dans le cloud et sur cet appareil. Action irréversible.",
 "Apaga todas as tarefas da agenda, passadas e futuras.": "Supprime toutes les tâches de l'agenda, passées et futures.",
 "Apaga todas as {n} parcelas.": "Supprime les {n} échéances.",
 "Apaga todos os meses desta conta.": "Supprime tous les mois de cette facture.",
 "Apagar": "Supprimer",
 "Apagar \"{nome}\"?": "Supprimer \"{nome}\" ?",
 "Apagar a caixa?": "Supprimer la boîte ?",
 "Apagar a chave": "Supprimer la clé",
 "Apagar a chave deste dispositivo?": "Supprimer la clé de cet appareil ?",
 "Apagar a conta?": "Supprimer le compte ?",
 "Apagar a lista de erros?": "Effacer la liste des erreurs ?",
 "Apagar a pasta (os documentos continuam)": "Supprimer le dossier (les documents sont conservés)",
 "Apagar as da agenda": "Supprimer celles de l'agenda",
 "Apagar caixa": "Supprimer la boîte",
 "Apagar de verdade (as páginas com tarja viram imagem)": "Effacer vraiment (les pages avec bandes deviennent des images)",
 "Apagar de vez": "Supprimer définitivement",
 "Apagar desenho": "Supprimer le dessin",
 "Apagar envio": "Supprimer l'envoi",
 "Apagar lista": "Effacer la liste",
 "Apagar minha conta": "Supprimer mon compte",
 "Apagar minha conta e todos os dados": "Supprimer mon compte et toutes les données",
 "Apagar o escritório": "Supprimer le bureau",
 "Apagar o escritório?": "Supprimer le bureau ?",
 "Apagar o grupo": "Supprimer le groupe",
 "Apagar o grupo?": "Supprimer le groupe ?",
 "Apagar o lançamento?": "Supprimer l'écriture ?",
 "Apagar para todos": "Supprimer pour tous",
 "Apagar tudo": "Tout supprimer",
 "Apagar tudo antes de": "Tout supprimer avant le",
 "Apague de uma vez as tarefas de hoje, do mês, de um período ou pelo nome. Antes de apagar, o app mostra o que vai sair e pede a sua senha.": "Supprimez d'un coup les tâches du jour, du mois, d'une période ou par nom. Avant la suppression, l'app montre ce qui va disparaître et demande votre mot de passe.",
 "Aparece na barra quando estiver liberada": "Apparaît dans la barre une fois débloqué",
 "Aparecem no Planner, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "Ils apparaissent dans le Planner, avec les jours de pont facultatifs (Carnaval, mercredi des Cendres et Fête-Dieu).",
 "Aplicar": "Appliquer",
 "Aponte a câmera do celular para este QR Code.": "Pointez l'appareil photo du téléphone vers ce QR code.",
 "Aponte para o QR Code na tela do computador": "Pointez vers le QR code affiché sur l'écran de l'ordinateur",
 "Apostila": "Polycopié",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para um grupo, cada aluno recebe no app dele.": "Polycopiés, exercices, diapos, vidéos, liens et messages. Via ⋮ › Envoyer à un groupe, chaque élève le reçoit dans son app.",
 "App usado no botão \"Rota\" dos endereços (tarefas, consultas, roteiro da viagem, obras, escola...).": "App utilisée par le bouton « Itinéraire » des adresses (tâches, rendez-vous, programme du voyage, travaux, école...).",
 "Apple Saúde": "Apple Santé",
 "Apple Watch: já grava tudo no app Saúde do iPhone. Não precisa fazer nada.": "Apple Watch : elle enregistre déjà tout dans l'app Santé de l'iPhone. Rien à faire.",
 "Apresentação": "Présentation",
 "Aprovação": "Validation",
 "Aqui": "Ici",
 "Ar-condicionado": "Climatisation",
 "Arco-íris": "Arc-en-ciel",
 "Arenoso": "Sableux",
 "Armazenamento": "Stockage",
 "Armário": "Placard",
 "Arquivadas ({n})": "Archivées ({n})",
 "Arquivados ({n})": "Archivés ({n})",
 "Arquivar": "Archiver",
 "Arquivar a caixa de anotações?": "Archiver la boîte de notes ?",
 "Arquivar conversa": "Archiver la discussion",
 "Arquivo": "Fichier",
 "Arquivo (Drive, OneDrive, Dropbox ou do dispositivo)": "Fichier (Drive, OneDrive, Dropbox ou appareil)",
 "Arquivo OFX ou CSV do banco": "Fichier OFX ou CSV de la banque",
 "Arquivo adicionado": "Fichier ajouté",
 "Arquivo menor (para WhatsApp e e-mail)": "Fichier plus léger (pour WhatsApp et e-mail)",
 "Arquivo menor para WhatsApp e e-mail.": "Fichier plus léger pour WhatsApp et e-mail.",
 "Arquivo não encontrado.": "Fichier introuvable.",
 "Arquivo ou PDF": "Fichier ou PDF",
 "Arquivo ou documento": "Fichier ou document",
 "Arquivos": "Fichiers",
 "Arquivos (frente, verso, PDF)": "Fichiers (recto, verso, PDF)",
 "Arquivos (importar e exportar)": "Fichiers (import et export)",
 "Arquivos de {nome}": "Fichiers de {nome}",
 "Arquivos na nuvem e cópias de segurança": "Fichiers dans le cloud et sauvegardes",
 "Arrasou!": "Trop fort !",
 "Arraste as bolinhas até as 4 pontas da folha. O app recorta e endireita a página.": "Faites glisser les points jusqu'aux 4 coins de la feuille. L'app recadre et redresse la page.",
 "Arraste o dedo sobre o que quer esconder. Toque numa tarja para tirar.": "Glissez le doigt sur ce que vous voulez masquer. Touchez une bande pour la retirer.",
 "Arraste para a direita para excluir, ou para a esquerda para enviar a outra aba.": "Glissez à droite pour supprimer, ou à gauche pour envoyer vers un autre onglet.",
 "Arraste para a direita para excluir.": "Faites glisser vers la droite pour supprimer.",
 "Arraste para mudar a ordem, gire, duplique, apague e ponha página em branco.": "Glissez pour changer l'ordre, faites pivoter, dupliquez, supprimez et ajoutez des pages blanches.",
 "Arraste para ver o resto do quadro. Ele cresce para baixo e para a direita.": "Faites glisser pour voir le reste du tableau. Il s'agrandit vers le bas et vers la droite.",
 "Arraste um documento para a direita para excluir.": "Faites glisser un document vers la droite pour le supprimer.",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir.": "Faites glisser une boîte vers la gauche pour l'archiver ou vers la droite pour la supprimer.",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure ⋮⋮ para mudar a ordem.": "Faites glisser une boîte vers la gauche pour l'archiver ou vers la droite pour la supprimer. Maintenez ⋮⋮ pour changer l'ordre.",
 "Arroz": "Riz",
 "Artes": "Arts plastiques",
 "As assinaturas Claude Pro, ChatGPT Plus e Gemini Advanced não podem ser usadas por outros apps. Para ligar a IA aqui, crie uma chave de API na sua conta (o Gemini tem uso gratuito; Claude e ChatGPT cobram por uso, centavos por análise).": "Les abonnements Claude Pro, ChatGPT Plus et Gemini Advanced ne peuvent pas être utilisés par d'autres apps. Pour activer l'IA ici, créez une clé API dans votre compte (Gemini propose un usage gratuit ; Claude et ChatGPT facturent à l'usage, quelques centimes par analyse).",
 "As chamadas ainda não foram ligadas no servidor (17-LIGAR-MENSAGENS.bat).": "Les appels n'ont pas encore été activés sur le serveur (17-LIGAR-MENSAGENS.bat).",
 "As compras dele também saem das Finanças.": "Ses achats sont aussi retirés de Finance.",
 "As compras parceladas entram com todas as parcelas: as próximas já aparecem nas faturas seguintes.": "Les achats en plusieurs fois sont ajoutés avec toutes les échéances : les suivantes apparaissent déjà sur les prochains relevés.",
 "As fotos deste documento estão no dispositivo onde ele foi escaneado. Lá dá para editar, compartilhar e ler o texto.": "Les photos de ce document sont sur l'appareil où il a été numérisé. Vous pouvez y modifier, partager et lire le texte.",
 "As imagens vão só para a IA que você escolheu, com a sua chave.": "Les images vont uniquement à l'IA que vous avez choisie, avec votre clé.",
 "As limpezas dos check-outs aparecem aqui sozinhas, com checklist e fotos de antes e depois.": "Les ménages des départs apparaissent ici tout seuls, avec checklist et photos avant/après.",
 "As notas emitidas aqui, as encontradas na busca e os XML importados aparecem nesta lista.": "Les factures émises ici, celles trouvées par la recherche et les XML importés apparaissent dans cette liste.",
 "As parcelas aparecem aqui. Anexe o comprovante (foto, PDF ou print do PIX) em cada uma.": "Les échéances apparaissent ici. Joignez le justificatif (photo, PDF ou capture du PIX) à chacune.",
 "As parcelas dos próximos 12 meses já estão no My Planner.": "Les échéances des 12 prochains mois sont déjà dans My Planner.",
 "As parcelas em aberto são refeitas com o valor, os juros e o prazo atuais do contrato. As pagas não mudam.": "Les échéances restantes sont recalculées avec le montant, le taux et la durée actuels du contrat. Celles déjà payées ne changent pas.",
 "As páginas deste documento estão no dispositivo onde ele foi escaneado. Abra por lá ou use a cópia guardada no Drive ou no OneDrive.": "Les pages de ce document sont sur l'appareil où il a été numérisé. Ouvrez-le là-bas ou utilisez la copie enregistrée dans Drive ou OneDrive.",
 "As páginas viram imagem mais leve: ótimo para PDFs escaneados. O texto deixa de ser pesquisável (use o OCR depois, se precisar).": "Les pages deviennent des images plus légères : idéal pour les PDF scannés. Le texte n'est plus consultable (utilisez l'OCR ensuite si besoin).",
 "As páginas vão só para a IA que você escolheu, com a sua chave.": "Les pages sont envoyées uniquement à l'IA choisie, avec votre clé.",
 "As receitas do cardápio já têm tudo na despensa.": "Le garde-manger contient déjà tout pour les recettes du menu.",
 "As senhas novas não conferem.": "Les nouveaux mots de passe ne correspondent pas.",
 "As senhas não conferem.": "Les mots de passe ne correspondent pas.",
 "As tarefas continuam no My Planner. Quer apagar também as que vieram da agenda do Google?": "Les tâches restent dans My Planner. Voulez-vous aussi supprimer celles venant de Google Agenda ?",
 "As tarefas do cômodo continuam em Minha Casa, sem cômodo.": "Les tâches de la pièce restent dans Ma Maison, sans pièce.",
 "As tarefas vinculadas continuam no My Planner.": "Les tâches liées restent dans My Planner.",
 "Aspirar e passar pano": "Aspirer et passer la serpillière",
 "Assinada": "Abonné",
 "Assinar": "Signer",
 "Assinar (simulação de teste)": "S'abonner (simulation de test)",
 "Assinar o documento": "Signer le document",
 "Assinatura": "Signature",
 "Assinatura do profissional": "Signature du praticien",
 "Assinatura e segurança": "Signature et sécurité",
 "Assinaturas (simulação de teste)": "Abonnements (simulation de test)",
 "Assine a aba em Ajustes para enviar anotações para ela.": "Abonnez-vous à l'onglet dans Réglages pour y envoyer des notes.",
 "Assine a aba em Ajustes para vincular.": "Abonnez-vous à l'onglet dans Réglages pour créer un lien.",
 "Assine a aba em Ajustes › Compras para enviar anotações para ela.": "Abonnez-vous à l'onglet dans Réglages › Achats pour y envoyer des notes.",
 "Assine a aba em Ajustes › Compras para vincular.": "Abonnez-vous à l'onglet dans Réglages › Achats pour créer un lien.",
 "Assine a aba para abrir o vínculo.": "Abonnez-vous à l'onglet pour ouvrir le lien.",
 "Assisti mais uma aula": "J'ai suivi un cours de plus",
 "Assistido": "Vu",
 "Assistindo": "En cours",
 "Assistência técnica (nome)": "Service après-vente (nom)",
 "Assistência: {nome}": "SAV : {nome}",
 "Assunto": "Sujet",
 "Assunto (ex.: Reunião semanal)": "Objet (ex. : Réunion hebdomadaire)",
 "Atender": "Répondre",
 "Atendimento": "Rendez-vous",
 "Atendimentos": "Rendez-vous",
 "Ativar avisos": "Réactiver les notifications",
 "Ativar monitor": "Activer le suivi",
 "Ativas": "Actives",
 "Atividade": "Activité",
 "Atividade do roteiro": "Activité de l'itinéraire",
 "Atividade hoje": "Activité aujourd'hui",
 "Atividade: {blocos}": "Activité : {blocos}",
 "Atividades": "Activités",
 "Atividades de hoje": "Activités du jour",
 "Atividades e materiais": "Activités et matériel",
 "Atividades físicas e saúde": "Sport et santé",
 "Atrasada": "En retard",
 "Atrasada há {n} dia(s)": "En retard de {n} jour(s)",
 "Atrasadas": "En retard",
 "Atrasados": "En retard",
 "Atuais": "Actuels",
 "Atualidades": "Actualité",
 "Atualizar": "Mettre à jour",
 "Atualizar agora": "Mettre à jour",
 "Atualizar alarmes no My Planner": "Mettre à jour les alarmes dans My Planner",
 "Atualizar rega e adubo na agenda": "Mettre à jour arrosage et engrais dans l'agenda",
 "Atualização automática disponível no app instalado (APK).": "Mise à jour automatique disponible dans l'app installée (APK).",
 "Atualização baixada. Entra ao reabrir o app ou ao tocar no aviso.": "Mise à jour téléchargée. Elle s'applique à la réouverture de l'app ou en touchant l'avis.",
 "Atualização pronta": "Mise à jour prête",
 "Atualizações": "Mises à jour",
 "Até": "Jusqu'au",
 "Audiência": "Audience",
 "Aula dada": "Cours donné",
 "Aula {a} de {n} ({p}%)": "Cours {a} sur {n} ({p}%)",
 "Aulas assistidas": "Cours suivis",
 "Autoajuda": "Développement personnel",
 "Autor": "Auteur",
 "Avaliação": "Évaluation",
 "Avaliações e notas": "Évaluations et notes",
 "Avançado": "Avancé",
 "Aveia": "Flocons d'avoine",
 "Avisar a hora de sair": "Me prévenir de l'heure de départ",
 "Avisar antes de vencer": "Prévenir avant l'expiration",
 "Avisar no celular quando alguém incluir algo": "M'avertir sur mon téléphone quand quelqu'un ajoute quelque chose",
 "Aviso": "Annonce",
 "Aviso com as tarefas do dia": "Notification avec les tâches du jour",
 "Aviso de teste enviado pelo servidor. Ele chega em alguns segundos; saia do app para ver na barra do celular.": "Notification de test envoyée par le serveur. Elle arrive dans quelques secondes ; quittez l'app pour la voir dans la barre du téléphone.",
 "Aviso enviado": "Notification envoyée",
 "Aviso {dias} dia(s) antes e no dia": "Rappel {dias} jour(s) avant et le jour même",
 "Avisos no celular": "Notifications sur le téléphone",
 "Avisos no celular passam pelos serviços da Expo, da Google e da Apple.": "Les notifications passent par les services d'Expo, de Google et d'Apple.",
 "Ação": "Action",
 "Ações": "Actions",
 "BOLETO E DOCUMENTOS": "BOLETO ET DOCUMENTS",
 "Backup importado.": "Sauvegarde importée.",
 "Bairro": "Quartier",
 "Baixa": "Basse",
 "Baixando atualização...": "Téléchargement de la mise à jour...",
 "Baixar": "Télécharger",
 "Baixar a versão {v}": "Télécharger la version {v}",
 "Baixar agora": "Télécharger",
 "Baixar o My Planner para Android": "Télécharger My Planner pour Android",
 "Baixar o My Planner para Android (versão {v})": "Télécharger My Planner pour Android (version {v})",
 "Baixar o My Planner para iPhone": "Télécharger My Planner pour iPhone",
 "Baixar o PDF da nota (DANFSe)": "Télécharger le PDF de la facture (DANFSe)",
 "Baixar o PDF?": "Télécharger le PDF ?",
 "Baixar o XML completo (dá ciência na SEFAZ)": "Télécharger le XML complet (prise de connaissance auprès de la SEFAZ)",
 "Baixe a versão mais recente para Android: {apk}": "Téléchargez la dernière version Android : {apk}",
 "Baixe aqui a versão mais recente: {link}": "Téléchargez ici la dernière version : {link}",
 "Balança": "Balance",
 "Balanço e relatórios": "Bilan et rapports",
 "Banana": "Banane",
 "Banco": "Banque",
 "Banco, financeira ou pessoa": "Banque, organisme ou personne",
 "Bandeiras": "Drapeaux",
 "Banheiro": "Salle de bain",
 "Banho": "Bain",
 "Banho e tosa": "Bain et toilettage",
 "Barra": "Barre",
 "Bateria": "Batterie",
 "Batimentos (média)": "Fréquence cardiaque (moy.)",
 "Batizado": "Baptême",
 "Bebida": "Boisson",
 "Bebê": "Bébé",
 "Beijo": "Bisou",
 "Bem": "Bien",
 "Bem clara": "Très claire",
 "Bem-Estar": "Bien-être",
 "Bem-Estar · Cronograma alimentar": "Bien-être · Plan des repas",
 "Bens": "Biens",
 "Bichos e diversão": "Animaux et loisirs",
 "Bicicleta": "Vélo",
 "Bicicleta ergométrica": "Vélo d'appartement",
 "Biografia": "Biographie",
 "Biologia": "Biologie",
 "Biometria (digital ou rosto)": "Biométrie (empreinte ou visage)",
 "Biometria ({tipos})": "Biométrie ({tipos})",
 "Biometria não confirmada.": "Biométrie non confirmée.",
 "Bloqueado": "Bloqué",
 "Bloquear": "Bloquer",
 "Bloquear agora": "Verrouiller maintenant",
 "Bloqueio": "Blocage",
 "Blusas de frio": "Pulls",
 "Boa noite": "Bonne nuit",
 "Boa sorte!": "Bonne chance !",
 "Boas-vindas ao My Planner": "Bienvenue dans My Planner",
 "Boas-vindas pelo WhatsApp": "Bienvenue par WhatsApp",
 "Boleto": "Boleto bancaire",
 "Boleto anexado": "Boleto joint",
 "Boleto do banco {b}": "Boleto de la banque {b}",
 "Boleto e documentos (foto, PDF ou arquivo)": "Boleto et documents (photo, PDF ou fichier)",
 "Boleto ou conta (foto, PDF ou arquivo)": "Boleto ou facture (photo, PDF ou fichier)",
 "Boleto por foto": "Boleto par photo",
 "Bolinha": "Rond",
 "Bom dia": "Bonjour",
 "Bom dia!": "Bonjour !",
 "Bom dia! Seu dia no My Planner": "Bonjour ! Votre journée dans My Planner",
 "Booking": "Booking",
 "Bora!": "On y va !",
 "Borboleta": "Papillon",
 "Borracha": "Gomme",
 "Botas para neve": "Bottes de neige",
 "Brasil": "Brésil",
 "Braços acima da cabeça": "Bras au-dessus de la tête",
 "Brilho": "Éclat",
 "Brinquedo ou livro para a viagem": "Jouet ou livre pour le voyage",
 "Busca de notas": "Recherche de factures",
 "Busca o nome nos diários municipais reunidos pelo Querido Diário (Open Knowledge Brasil). Nem todos os municípios estão incluídos, e os diários oficiais não fazem parte do DJEN.": "Recherche le nom dans les journaux municipaux réunis par Querido Diário (Open Knowledge Brasil). Toutes les communes ne sont pas incluses, et les journaux officiels ne font pas partie du DJEN.",
 "Buscando...": "Recherche...",
 "Buscar": "Rechercher",
 "Buscar GIF (ex.: parabéns, bom dia)": "Rechercher un GIF (ex. : bravo, bonjour)",
 "Buscar cidade, país ou GMT": "Rechercher une ville, un pays ou GMT",
 "Buscar conversa": "Rechercher une discussion",
 "Buscar documento, titular ou órgão": "Rechercher un document, un titulaire ou un organisme",
 "Buscar em {nome}": "Rechercher dans {nome}",
 "Buscar emoji (ex.: coração, risada)": "Rechercher un emoji (ex. : cœur, rire)",
 "Buscar figurinha": "Rechercher un sticker",
 "Buscar notas": "Rechercher des factures",
 "Buscar ou digitar um alimento": "Rechercher ou saisir un aliment",
 "Buscar país": "Rechercher un pays",
 "Buscar pelo nome ou pelo texto": "Rechercher par nom ou par texte",
 "Buscar produto, loja ou observação": "Rechercher un produit, un magasin ou une note",
 "Buscar tarefas": "Rechercher des tâches",
 "Buscar: processo, parte, tribunal, palavra...": "Rechercher : affaire, partie, tribunal, mot...",
 "CAIXA {n}": "CARTON {n}",
 "CARDS DE ANOTAÇÕES": "CARTES DE NOTES",
 "CARTÕES": "CARTES",
 "CEP": "CEP (code postal)",
 "CID (se o paciente pedir na declaração)": "CID (CIM, si le patient le demande sur l'attestation)",
 "CID: {c}": "CID : {c}",
 "CNH": "Permis de conduire (CNH)",
 "CNPJ (se tiver)": "CNPJ (le cas échéant)",
 "CNPJ ou CPF": "CNPJ ou CPF",
 "COMPROVANTE DE PAGAMENTO": "JUSTIFICATIF DE PAIEMENT",
 "COMPROVANTE DE RECEBIMENTO": "JUSTIFICATIF D'ENCAISSEMENT",
 "COMPROVANTES ANTERIORES": "JUSTIFICATIFS PRÉCÉDENTS",
 "CONTAS DO MÊS": "FACTURES DU MOIS",
 "CPF": "CPF",
 "CPF (Brasil)": "CPF (Brésil)",
 "CPF de quem paga": "CPF du payeur",
 "CPF do paciente": "CPF du patient",
 "CPF do pagador": "CPF du payeur",
 "CPF inválido": "CPF invalide",
 "CPF ou CNPJ de quem recebeu": "CPF ou CNPJ du bénéficiaire",
 "CPF ou senha incorretos.": "CPF ou mot de passe incorrect.",
 "CRIAR CÔMODO": "CRÉER UNE PIÈCE",
 "CRIAR UM GRUPO": "CRÉER UN GROUPE",
 "CRONOGRAMA ALIMENTAR": "PROGRAMME ALIMENTAIRE",
 "CUIDADOS PESSOAIS": "SOINS PERSONNELS",
 "Cabeleireiro": "Coiffeur",
 "Cabelo": "Cheveux",
 "Cachorro": "Chien",
 "Cactos e suculentas": "Cactus et succulentes",
 "Cada aba extra: {n} dias grátis; depois {preco} por ano.": "Chaque onglet supplémentaire : {n} jours gratuits ; ensuite {preco} par an.",
 "Cada arquivo pronto vai para o {nome}. Os PDFs abertos ficam também neste dispositivo, na lista abaixo.": "Chaque fichier terminé va dans {nome}. Les PDF ouverts restent aussi sur cet appareil, dans la liste ci-dessous.",
 "Cada dia da semana": "Chaque jour de la semaine",
 "Cada documento novo vai para o {nome} quando você sai dele. As fotos das páginas ficam só neste dispositivo.": "Chaque nouveau document part vers {nome} quand vous le quittez. Les photos des pages restent uniquement sur cet appareil.",
 "Cada pessoa da equipe recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "Chaque membre de l'équipe reçoit la réunion dans Reçus et l'ajoute au Planner d'un toucher, avec l'alerte.",
 "Cada pessoa do grupo recebe e decide se aceita.": "Chaque membre du groupe le reçoit et décide s'il l'accepte.",
 "Cada página guarda um resumo, aula ou capítulo. Marque como revisada quando terminar.": "Chaque page contient un résumé, un cours ou un chapitre. Marquez-la comme révisée quand vous avez terminé.",
 "Cada página vira uma imagem JPG.": "Chaque page devient une image JPG.",
 "Cada refeição se repete nos dias dela": "Chaque repas se répète les jours prévus",
 "Cadastrar": "Ajouter",
 "Cadastrar cartão de crédito": "Ajouter une carte de crédit",
 "Cadastrar pela foto (página do curso, certificado, folheto)": "Ajouter à partir d'une photo (page du cours, certificat, dépliant)",
 "Cadastrar pela foto da capa": "Ajouter à partir de la photo de la couverture",
 "Cadastre \"Meus dados\" para os recibos saírem com seu nome, conselho e número.": "Remplissez « Mes informations » pour que les reçus portent votre nom, ordre et numéro.",
 "Cadastre RG, CNH, passaporte, contratos e certidões. O app avisa antes de vencer e envia o documento com um toque.": "Enregistrez carte d'identité, permis de conduire, passeport, contrats et certificats. L'app vous prévient avant l'expiration et envoie le document en un geste.",
 "Cadastre a empresa (ou você, como profissional) com CNPJ ou CPF, município e regime. Depois ligue o certificado A1 para emitir NFS-e pelo Padrão Nacional e buscar as notas emitidas e recebidas.": "Enregistrez l'entreprise (ou vous-même, en tant que professionnel) avec CNPJ ou CPF, commune et régime fiscal. Puis connectez le certificat A1 pour émettre des NFS-e via le Padrão Nacional et rechercher les factures émises et reçues.",
 "Cadastre a obra e, dentro dela, as etapas com orçamento, o diário com fotos, os profissionais e as entregas de material.": "Créez le chantier puis, à l'intérieur, les étapes avec budget, le journal avec photos, les artisans et les livraisons de matériaux.",
 "Cadastre a viagem e, dentro dela, o roteiro de cada dia, as reservas e a mala. Durante a viagem, o roteiro aparece no My Planner.": "Créez le voyage puis, à l'intérieur, l'itinéraire de chaque jour, les réservations et la valise. Pendant le voyage, l'itinéraire apparaît dans My Planner.",
 "Cadastre apenas o seu próprio nome e a sua OAB.": "Enregistrez uniquement votre propre nom et votre OAB.",
 "Cadastre as crianças: provas, reuniões, consultas e vacinas ficam dentro de cada uma.": "Ajoutez les enfants : contrôles, réunions, consultations et vaccins sont rangés dans chacun.",
 "Cadastre cada pet: carteira de vacinação, vermífugos, remédios e pet shop ficam dentro dele.": "Ajoutez chaque animal : carnet de vaccination, vermifuges, médicaments et toilettage sont rangés dedans.",
 "Cadastre cada planta com luz, solo e de quantos em quantos dias regar e adubar. O app monta o calendário na agenda.": "Ajoutez chaque plante avec sa lumière, son sol et la fréquence d'arrosage et d'engrais. L'app crée le calendrier dans l'agenda.",
 "Cadastre cada veículo. Dentro dele ficam as manutenções (com aviso por km e por data) e os vencimentos de IPVA, licenciamento e seguro.": "Ajoutez chaque véhicule. Il contient les entretiens (rappel par km et par date) et les échéances d'IPVA, d'immatriculation et d'assurance.",
 "Cadastre digital ou rosto no aparelho para usar.": "Enregistrez une empreinte ou votre visage sur l'appareil pour l'utiliser.",
 "Cadastre o cartão primeiro": "Ajoutez d'abord la carte",
 "Cadastre o financiamento ou empréstimo com o valor, os juros e o número de parcelas. O app calcula as parcelas, o saldo devedor e avisa os vencimentos.": "Ajoutez le financement ou le prêt avec le montant, le taux et le nombre d'échéances. L'app calcule les échéances, le capital restant dû et vous rappelle les dates.",
 "Cadastre o imóvel inteiro ou cada quarto que você aluga. Dentro de cada um ficam as reservas, a limpeza e as despesas.": "Ajoutez le logement entier ou chaque chambre que vous louez. Réservations, ménage et dépenses se trouvent dans chacun.",
 "Cadastre o livro com o total de páginas e a meta por dia. Toque em ⋮ para somar as páginas lidas.": "Ajoutez le livre avec le nombre total de pages et l'objectif par jour. Touchez ⋮ pour ajouter les pages lues.",
 "Cadastre o remédio com os horários e toque em ⋮ para colocar na linha do tempo com alarme.": "Ajoutez le médicament avec ses horaires et touchez ⋮ pour le mettre dans la chronologie avec alarme.",
 "Cadastre os alunos da turma na aba Alunos.": "Ajoutez les élèves de la classe dans l'onglet Élèves.",
 "Cadastre os clientes para separar as horas.": "Ajoutez les clients pour séparer les heures.",
 "Cadastre os clientes que recebem as suas notas. O endereço é opcional (se preencher, informe CEP, código IBGE, rua, número e bairro).": "Enregistrez les clients qui reçoivent vos factures. L'adresse est facultative (si vous la remplissez, indiquez CEP, code IBGE, rue, numéro et quartier).",
 "Cadastre os serviços que você mais emite, com o código de tributação nacional. Na hora de emitir é só tocar.": "Enregistrez les services que vous émettez le plus, avec le code fiscal national. Au moment d'émettre, il suffit de toucher.",
 "Cadastre primeiro em {nome}.": "Ajoutez d'abord dans {nome}.",
 "Cadastre seu nome, conselho e número do registro. Eles saem nos recibos e nas declarações.": "Saisissez votre nom, ordre et numéro d'inscription. Ils figurent sur les reçus et attestations.",
 "Cadastre seus clientes na aba \"Tomadores\" da empresa para escolher aqui.": "Enregistrez vos clients dans l'onglet « Clients » de l'entreprise pour les choisir ici.",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no documento.": "Saisissez vos informations professionnelles (nom, ordre et numéro) dans « Mes informations » pour qu'elles figurent sur le document.",
 "Cadastre seus dados profissionais (nome, conselho e número) em \"Meus dados\" para sair no recibo.": "Saisissez vos informations professionnelles (nom, ordre et numéro) dans « Mes informations » pour qu'elles figurent sur le reçu.",
 "Cadastre seus pacientes. Dentro de cada um ficam os atendimentos com evolução, prescrição, pagamento, recibo e declaração para o plano de saúde.": "Ajoutez vos patients. Chacun contient ses rendez-vous avec évolution, prescription, paiement, reçu et attestation pour la mutuelle.",
 "Cadastre você e cada pessoa da família. Dentro de cada uma ficam consultas, exames, vacinas e remédios. Dados sensíveis vão para o cofre criptografado.": "Ajoutez-vous, ainsi que chaque membre de la famille. Chacun contient consultations, examens, vaccins et médicaments. Les données sensibles vont dans le coffre chiffré.",
 "Cadastro aguardando liberação: desligue \"Confirm email\" no Supabase (veja COMO RODAR).": "Inscription en attente de validation : désactivez « Confirm email » dans Supabase (voir COMO RODAR).",
 "Cadastro recebido": "Inscription reçue",
 "Cadastro: nome, CPF ou e-mail, senha (guardada só em forma protegida) e e-mail de contato.": "Inscription : nom, CPF ou e-mail, mot de passe (conservé uniquement sous forme protégée) et e-mail de contact.",
 "Cadastros": "Fiches",
 "Cadastros e comprovantes": "Fiches et justificatifs",
 "Cadeira extensora": "Leg extension",
 "Café": "Café",
 "Café da manhã": "Petit-déjeuner",
 "Café ou bar": "Café ou bar",
 "Café?": "Un café ?",
 "Cafés": "Cafés",
 "Caixa": "Carton",
 "Caixa arquivada": "Boîte archivée",
 "Caixa com checklist, lista ou texto livre": "Boîte avec checklist, liste ou texte libre",
 "Caixa {n}": "Carton {n}",
 "Caixas": "Cartons",
 "Caixas e cronograma da mudança.": "Cartons et planning du déménagement.",
 "Caixas por cômodo com etiqueta, troca de água, luz e internet, vistorias e o cronograma dos dias.": "Cartons par pièce avec étiquette, transfert d'eau, d'électricité et d'internet, états des lieux et planning des jours.",
 "Calculadora": "Calculatrice",
 "Calculando...": "Calcul en cours...",
 "Calendário": "Calendrier",
 "Calendário da planta": "Calendrier de la plante",
 "Calendário do imposto": "Calendrier fiscal",
 "Calendários": "Calendriers",
 "Calorias em atividade": "Calories en activité",
 "Calorias gastas em atividade (kcal)": "Calories brûlées en activité (kcal)",
 "Calça térmica (segunda pele)": "Pantalon thermique (sous-couche)",
 "Calças ou bermudas": "Pantalons ou shorts",
 "Cama": "Lit",
 "Caminhada": "Marche",
 "Caminhão": "Camion",
 "Camisetas": "T-shirts",
 "Campo Grande": "Campo Grande",
 "Campo Grande (MS)": "Campo Grande (MS)",
 "Campos de formulário": "Champs de formulaire",
 "Cancelada": "Annulée",
 "Canceladas": "Annulées",
 "Cancelar": "Annuler",
 "Cancelar a NFS-e": "Annuler la NFS-e",
 "Cancelar a NFS-e {n}?": "Annuler la NFS-e {n} ?",
 "Cancelar a nota": "Annuler la facture",
 "Cancelar a reunião \"{nome}\"?": "Annuler la réunion \"{nome}\" ?",
 "Cancelar reunião": "Annuler la réunion",
 "Caneta": "Stylo",
 "Captura automática do servidor: de 2 em 2 horas, das 08h às 20h": "Capture automatique du serveur : toutes les 2 heures, de 08h à 20h",
 "Captura automática: todos os dias às 08h e 12h": "Capture automatique : tous les jours à 8 h et 12 h",
 "Card": "Carte",
 "Cardápio": "Menu",
 "Cardápio da semana, receitas, lista de compras automática e validade da despensa.": "Menu de la semaine, recettes, liste de courses automatique et dates de péremption du garde-manger.",
 "Cardápio só para este dia. Os outros dias continuam com o da semana.": "Menu pour ce jour uniquement. Les autres jours gardent celui de la semaine.",
 "Carga (kg)": "Charge (kg)",
 "Carimbo": "Tampon",
 "Carnaval": "Carnaval",
 "Carne magra": "Viande maigre",
 "Carregando feriados...": "Chargement des jours fériés...",
 "Carregando...": "Chargement...",
 "Carro": "Voiture",
 "Carta": "Lettre US",
 "Carteira": "Portefeuille",
 "Carteira de trabalho": "Carnet de travail",
 "Carteira profissional (OAB, CRC, CREA...)": "Carte professionnelle (OAB, CRC, CREA...)",
 "Cartão": "Carte",
 "Cartão de contato das Mensagens: a foto, o telefone, o e-mail e a frase que você mesmo escolher pôr. Só quem conversa com você, os seus amigos e quem divide um grupo do app com você veem.": "Fiche contact de Messages : la photo, le téléphone, l'e-mail et le statut que vous choisissez d'ajouter. Seuls les personnes qui discutent avec vous, vos amis et ceux qui partagent un groupe de l'app avec vous peuvent les voir.",
 "Cartão de crédito": "Carte de crédit",
 "Cartão de débito": "Carte de débit",
 "Cartão parcelado": "Carte en plusieurs fois",
 "Cartões": "Cartes",
 "Cartões de visita": "Cartes de visite",
 "Cartões e dinheiro": "Cartes et espèces",
 "Casa": "Maison",
 "Casa e rotina": "Maison et quotidien",
 "Casa, família e veículos": "Maison, famille et véhicules",
 "Casaco leve": "Veste légère",
 "Casaco pesado": "Manteau chaud",
 "Casamento": "Mariage",
 "Castanhas": "Noix",
 "Categoria": "Catégorie",
 "Categoria de \"{d}\"": "Catégorie de « {d} »",
 "Categorias": "Catégories",
 "Caução": "Caution",
 "Ceia": "Collation du soir",
 "Celular": "Téléphone",
 "Celular confirmado": "Téléphone confirmé",
 "Celular e carregador": "Téléphone et chargeur",
 "Certidão": "Certificat",
 "Certificado digital": "Certificat numérique",
 "Certificado digital A1": "Certificat numérique A1",
 "Certificado ligado": "Certificat connecté",
 "Chamada": "Appel",
 "Chamada ainda não feita neste dia. Toque em quem faltou ou confirme todos presentes.": "Appel pas encore fait ce jour-là. Touchez les absents ou confirmez que tous sont présents.",
 "Chamada, notas, planos de aula e materiais.": "Appel, notes, plans de cours et supports.",
 "Chamadas": "Appels",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada e sem gravação.": "Les appels audio et vidéo passent par les serveurs de LiveKit, uniquement pendant l'appel et sans enregistrement.",
 "Chamadas de áudio e vídeo passam pelos servidores da LiveKit, só durante a chamada. Só há gravação nas reuniões do Escritório, quando o administrador grava, e o arquivo vai direto para o armazenamento do app.": "Les appels audio et vidéo transitent par les serveurs de LiveKit, uniquement pendant l'appel. Seules les réunions du Bureau sont enregistrées, lorsque l'administrateur lance l'enregistrement, et le fichier est envoyé directement dans le stockage de l'appli.",
 "Chamando...": "Appel en cours...",
 "Chapéu ou boné": "Chapeau ou casquette",
 "Chave da IA não cadastrada neste dispositivo (Ajustes › Inteligência artificial).": "Clé IA non enregistrée sur cet appareil (Réglages › Intelligence artificielle).",
 "Chave de acesso": "Clé d'accès",
 "Check-in": "Arrivée",
 "Check-in: {d} a partir das {h}": "Arrivée : {d} à partir de {h}",
 "Check-in: {h} · {e}": "Arrivée : {h} · {e}",
 "Check-out": "Départ",
 "Check-out: {d} até as {h}": "Départ : {d} avant {h}",
 "Check-out: {h} · {e}": "Départ : {h} · {e}",
 "Checklist": "Checklist",
 "Chinelo": "Tongs",
 "Chá de bebê": "Baby shower",
 "Cidade": "Ville",
 "Cidade (para a data dos recibos)": "Ville (pour la date des reçus)",
 "Cidade de {nome}": "Ville de {nome}",
 "Cidades": "Villes",
 "Cifrão": "Symbole dollar",
 "Cinza": "Gris",
 "Cirurgia": "Chirurgie",
 "Ciências": "Sciences",
 "Clara": "Claire",
 "Clareia PDFs escaneados: fundo branco, cinza ou preto e branco.": "Éclaircit les PDF scannés : fond blanc, gris ou noir et blanc.",
 "Claro": "Clair",
 "Classificar categorias com IA": "Classer les catégories avec l'IA",
 "Claude, ChatGPT ou Gemini": "Claude, ChatGPT ou Gemini",
 "Cliente": "Client",
 "Clientes": "Clients",
 "Clima esperado": "Climat prévu",
 "Co-anfitrião": "Co-hôte",
 "Cobrança": "Paiement dû",
 "Cobranças": "Paiements dus",
 "Coelho": "Lapin",
 "Cofre (criptografia de ponta a ponta)": "Coffre (chiffrement de bout en bout)",
 "Cofre aberto (fecha sozinho em 5 minutos sem uso)": "Coffre ouvert (se ferme seul après 5 minutes d'inactivité)",
 "Cofre ainda não criado": "Coffre pas encore créé",
 "Cofre com criptografia para RG, CNH, passaporte, contratos e certidões, com contagem até vencer e envio com um toque.": "Coffre chiffré pour carte d'identité, permis, passeport, contrats et actes, avec compte à rebours avant expiration et envoi en un geste.",
 "Cofre fechado": "Coffre fermé",
 "Cofrinho": "Tirelire",
 "Cole aqui a chave ({ini}...)": "Collez la clé ici ({ini}...)",
 "Cole o link (https://...)": "Collez le lien (https://...)",
 "Cole ou digite o código de barras (ou o Pix copia e cola) no campo do código: o app calcula o valor e o vencimento sozinho. Com a sua IA ligada, ele lê tudo pela foto.": "Collez ou saisissez le code-barres (ou le code Pix copier-coller) dans le champ du code : l'app calcule seule le montant et l'échéance. Avec votre IA activée, elle lit tout à partir de la photo.",
 "Coloca arquivos dentro do PDF.": "Place des fichiers dans le PDF.",
 "Colocar na agenda": "Mettre à l'agenda",
 "Colocar na linha do tempo com alarme": "Mettre dans la chronologie avec alarme",
 "Colocar no My Planner": "Mettre dans My Planner",
 "Colocar rega e adubo na agenda": "Mettre arrosage et engrais dans l'agenda",
 "Coloque o valor da mensalidade na turma (Editar) ou no aluno. As cobranças deste mês que já existem não se repetem.": "Indiquez la mensualité dans la classe (Modifier) ou chez l'élève. Les paiements dus de ce mois déjà créés ne sont pas dupliqués.",
 "Coluna": "Colonne",
 "Colágeno": "Collagène",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, use o desenho ou a senha.": "Avec la biométrie activée, elle apparaît en premier. En cas d'échec, utilisez le schéma ou le mot de passe.",
 "Com convênio": "Avec mutuelle",
 "Com o código do país e o DDD. Ex.: +55 41 99999-0000": "Avec l’indicatif du pays et de la région. Ex. : +55 41 99999-0000",
 "Com outras pessoas": "Chez d'autres personnes",
 "Com prazo, o app calcula quanto guardar por mês. O dinheiro guardado conta como \"Guardou\" no mês.": "Avec une échéance, l'app calcule combien épargner par mois. L'argent épargné compte comme « Épargne » du mois.",
 "Com quem": "Avec qui",
 "Com quem pagou, o paciente, a data e o valor de cada atendimento pago. Como pessoa física, lance cada um no app Receita Federal › Receita Saúde; com CNPJ, emita a nota de serviço.": "Qui a payé, le patient, la date et le montant de chaque rendez-vous payé. En tant que particulier, saisissez-les dans l'app Receita Federal › Receita Saúde ; avec un CNPJ, émettez la facture de service.",
 "Com valor a receber": "Avec montant à recevoir",
 "Com vencimento": "Avec échéance",
 "Combinado": "Ça marche",
 "Combinado 👍": "Ça marche 👍",
 "Combustível": "Carburant",
 "Comece cadastrando as contas fixas do mês (aluguel, luz, internet) e o seu cartão. Eu aviso antes de cada vencimento.": "Commencez par ajouter les factures fixes du mois (loyer, électricité, internet) et votre carte. Je vous préviens avant chaque échéance.",
 "Comecei em": "Commencé le",
 "Comentários": "Commentaires",
 "Começa amanhã": "Commence demain",
 "Começa às {hora} (em {m} min)": "Commence à {hora} (dans {m} min)",
 "Começar": "Démarrer",
 "Começar com o modelo: café, lanche, almoço, lanche e jantar": "Commencer avec le modèle : petit-déjeuner, collation, déjeuner, collation et dîner",
 "Começar em": "Commencer à",
 "Começar o teste grátis": "Commencer l'essai gratuit",
 "Comi outros alimentos ou quantidades": "J'ai mangé d'autres aliments ou quantités",
 "Comida": "Nourriture",
 "Comidas e bebidas": "Nourriture et boissons",
 "Comido": "Mangé",
 "Comido / alterações": "Mangé / changements",
 "Comido conta as refeições marcadas como feitas (ou com alterações) até hoje.": "Mangé compte les repas marqués comme faits (ou avec changements) jusqu'à aujourd'hui.",
 "Comigo": "Chez moi",
 "Comissão da plataforma": "Commission de la plateforme",
 "Como apagar a sua conta e os seus dados": "Comment supprimer votre compte et vos données",
 "Como chegar": "Itinéraire",
 "Como ela está": "Comment elle va",
 "Como estou comparado ao mês passado?": "Où en suis-je par rapport au mois dernier ?",
 "Como funciona": "Comment ça marche",
 "Como planejado": "Comme prévu",
 "Compartilhado no grupo": "Partagé dans le groupe",
 "Compartilhado no grupo · só leitura": "Partagé dans le groupe · lecture seule",
 "Compartilhamento indisponível neste dispositivo.": "Partage indisponible sur cet appareil.",
 "Compartilhar": "Partager",
 "Compartilhar PDF": "Partager le PDF",
 "Compartilhar a limpeza": "Partager le ménage",
 "Compartilhar os dados": "Partager les données",
 "Compartilhar os dados com a equipe": "Partager les données avec l'équipe",
 "Compartilhar os dados com o grupo?": "Partager les données avec le groupe ?",
 "Compartilhar texto": "Partager le texte",
 "Competência (mês de referência)": "Période (mois de référence)",
 "Competência {d}": "Période {d}",
 "Complemento": "Complément d'adresse",
 "Complete seus dados": "Complétez vos informations",
 "Compra": "Achat",
 "Compra e venda de imóveis, veículos e ações, recibos dedutíveis e o calendário do imposto.": "Achats et ventes de biens immobiliers, véhicules et actions, reçus déductibles et calendrier fiscal.",
 "Compra feita": "Achat fait",
 "Compra no cartão": "Achat par carte",
 "Compras": "Achats",
 "Compras da semana": "Courses de la semaine",
 "Comprimir": "Compresser",
 "Compromisso": "Rendez-vous",
 "Compromisso da escola": "Rendez-vous scolaire",
 "Comprovante": "Justificatif",
 "Comprovante guardado": "Justificatif enregistré",
 "Comprovantes": "Justificatifs",
 "Computador": "Ordinateur",
 "Comédia": "Comédie",
 "Concedi": "J'ai prêté",
 "Concluir": "Terminer",
 "Concluir (esquerda)": "Terminer (gauche)",
 "Concluída": "Terminée",
 "Concluído": "Terminé",
 "Concluído (%)": "Avancement (%)",
 "Concluído!": "Terminé !",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "J'accepte que mon nom, mon CPF et mon e-mail soient utilisés uniquement pour identifier mon compte, et que mes tâches et notes y soient conservées. Je peux supprimer le compte et toutes les données à tout moment dans Réglages › Sécurité.",
 "Concordo que meu nome, CPF e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes.": "J'accepte que mon nom, mon CPF et mon e-mail soient utilisés uniquement pour identifier mon compte, et que mes tâches et notes y soient conservées. Je peux supprimer le compte et toutes les données à tout moment dans Réglages.",
 "Concordo que meu nome, documento e e-mail sejam usados apenas para identificar minha conta, e que minhas tarefas e anotações fiquem guardadas nela. Posso apagar a conta e todos os dados a qualquer momento em Ajustes › Segurança.": "J'accepte que mon nom, mon document et mon e-mail soient utilisés uniquement pour identifier mon compte, et que mes tâches et notes y soient conservées. Je peux supprimer le compte et toutes les données à tout moment dans Réglages › Sécurité.",
 "Concursos": "Concours",
 "Condicionador": "Après-shampoing",
 "Condomínio": "Charges de copropriété",
 "Condomínio e IPTU": "Charges et taxe foncière",
 "Conectado": "Connecté",
 "Conectando...": "Connexion...",
 "Conectar": "Connecter",
 "Conectar navegador": "Connecter le navigateur",
 "Conectar o {nome}": "Connecter {nome}",
 "Conectar relógio ou app de saúde": "Connecter une montre ou une app santé",
 "Conectar {nome}": "Connecter {nome}",
 "Conecte o {nome} em Ajustes › Google Drive e OneDrive.": "Connectez {nome} dans Réglages › Google Drive et OneDrive.",
 "Conferindo...": "Vérification...",
 "Conferir controles, chaves e Wi-Fi": "Vérifier télécommandes, clés et Wi-Fi",
 "Conferir o prazo no sistema oficial": "Vérifier le délai dans le système officiel",
 "Confete": "Confettis",
 "Configuração geral": "Réglages généraux",
 "Confira a senha da sua conta e tente de novo.": "Vérifiez le mot de passe de votre compte et réessayez.",
 "Confira as datas oficiais no site da Receita Federal e ajuste se precisar.": "Vérifiez les dates officielles sur le site de la Receita Federal et ajustez si besoin.",
 "Confira o código. Ele tem 6 letras e números.": "Vérifiez le code. Il contient 6 lettres et chiffres.",
 "Confira o e-mail ou deixe em branco.": "Vérifiez l'e-mail ou laissez vide.",
 "Confira o e-mail.": "Vérifiez l'e-mail.",
 "Confira o prazo no sistema oficial.": "Vérifiez le délai dans le système officiel.",
 "Confira os 11 números.": "Vérifiez les 11 chiffres.",
 "Confira os campos antes de salvar.": "Vérifiez les champs avant d'enregistrer.",
 "Confira se a sua conta Google está adicionada no celular e com a agenda sincronizando.": "Vérifiez que votre compte Google est ajouté sur le téléphone et que l'agenda se synchronise.",
 "Confirmada": "Confirmée",
 "Confirmado": "Confirmé",
 "Confirmar": "Confirmer",
 "Confirme a declaração sobre a empresa.": "Confirmez la déclaration concernant l'entreprise.",
 "Confirme o seu celular": "Confirmez votre téléphone",
 "Confirme para ativar a biometria": "Confirmez pour activer la biométrie",
 "Confirme para excluir": "Confirmez pour supprimer",
 "Confirme sua senha para sincronizar": "Confirmez votre mot de passe pour synchroniser",
 "Confraternização": "Fête",
 "Confraternização Universal": "Jour de l'An",
 "Conselho": "Ordre professionnel",
 "Consignado": "Prêt sur salaire",
 "Consulta": "Consultation",
 "Consulta ou vacina": "Consultation ou vaccin",
 "Consultas": "Consultations",
 "Consultório": "Cabinet",
 "Consumo médio: {v} km/L": "Consommation moyenne : {v} km/L",
 "Conta": "Compte",
 "Conta a pagar": "Facture à payer",
 "Conta a receber": "Somme à recevoir",
 "Conta de consumo ou tributo": "Facture de services ou impôt",
 "Conta os dias em que cada item estava previsto (pelos dias da semana dele) e os que foram marcados como feitos.": "Compte les jours où chaque élément était prévu (selon ses jours de la semaine) et ceux où il a été marqué comme fait.",
 "Conta paga": "Facture payée",
 "Conta recebida": "Somme reçue",
 "Conta vence hoje": "Facture due aujourd'hui",
 "Conta vencendo": "Facture bientôt due",
 "Contabilidade": "Comptabilité",
 "Contando os acompanhantes. Toque no status do convidado para mudar.": "Accompagnants compris. Touchez le statut d'un invité pour le changer.",
 "Contando: {cliente}": "En cours : {cliente}",
 "Contas": "Factures",
 "Contas a pagar": "Factures à payer",
 "Contas a pagar e a receber, gastos do mês, aviso de vencimento e controle do MEI (Mestre Achado).": "Factures à payer et à recevoir, dépenses du mois, alertes d'échéance et suivi MEI (Mestre Achado).",
 "Contas a receber": "Sommes à recevoir",
 "Contas fixas": "Factures fixes",
 "Contato": "Contact",
 "Contato de emergência": "Contact d'urgence",
 "Contato do encarregado de dados:": "Contact du délégué à la protection des données :",
 "Conte a sua ideia para o app ficar melhor.": "Partagez votre idée pour améliorer l'app.",
 "Conte o que está difícil ou não funciona como deveria.": "Dites-nous ce qui est difficile ou ne fonctionne pas comme prévu.",
 "Conte o que você fez, o que esperava e o que apareceu. Se tiver uma mensagem de erro, copie aqui.": "Décrivez ce que vous avez fait, ce que vous attendiez et ce qui s'est affiché. S'il y a un message d'erreur, copiez-le ici.",
 "Conte para a gente problemas, erros e ideias de melhoria. Sua mensagem vai direto para a equipe do My Planner.": "Signalez-nous problèmes, bugs et idées d'amélioration. Votre message va directement à l'équipe de My Planner.",
 "Conteúdo": "Contenu",
 "Conteúdo que você cria: tarefas, anotações, finanças, documentos, fotos, anexos e dados das abas.": "Contenu que vous créez : tâches, notes, finances, documents, photos, pièces jointes et données des onglets.",
 "Conteúdo, matéria, tarefa de casa...": "Contenu, matière, devoirs...",
 "Continuar": "Continuer",
 "Continue usando o My Planner e as Anotações por {preco} por ano. Seus dados continuam guardados.": "Continuez à utiliser My Planner et Notes pour {preco} par an. Vos données restent conservées.",
 "Contratado": "Engagé",
 "Contratado: {v}": "Engagé : {v}",
 "Contrato": "Contrat",
 "Conversa": "Discussion",
 "Conversa do grupo": "Discussion du groupe",
 "Conversar": "Discuter",
 "Conversar com o Mestre (precisa da sua IA)": "Discuter avec le Mestre (nécessite votre IA)",
 "Converse com amigos e grupos, e faça chamadas de áudio e vídeo.": "Discutez avec vos amis et vos groupes, et passez des appels audio et vidéo.",
 "Converter de PDF": "Convertir depuis PDF",
 "Converter para PDF": "Convertir en PDF",
 "Convidado": "Invité",
 "Convidados": "Invités",
 "Convidados com confirmação de presença, fornecedores e o cronograma do grande dia.": "Invités avec confirmation de présence, prestataires et planning du grand jour.",
 "Convidados e cronograma do dia, sem os valores.": "Invités et programme de la journée, sans les montants.",
 "Convidar": "Inviter",
 "Convidar pelo WhatsApp": "Inviter via WhatsApp",
 "Convite": "Invitation",
 "Convite copiado. Cole onde quiser enviar.": "Invitation copiée. Collez-la où vous voulez l'envoyer.",
 "Convite inválido ou trocado pelo administrador. Peça um link novo.": "Invitation invalide ou changée par l'administrateur. Demandez un nouveau lien.",
 "Convite para o My Planner": "Invitation à My Planner",
 "Convênio": "Mutuelle",
 "Copiar": "Copier",
 "Copiar a lista para uma tarefa": "Copier la liste dans une tâche",
 "Copiar o código": "Copier le code",
 "Copiar para hoje": "Copier à aujourd'hui",
 "Copo de outro tamanho": "Verre d’une autre taille",
 "Copo {n}": "Verre {n}",
 "Cor": "Couleur",
 "Cor do fichário": "Couleur du classeur",
 "Cor do tema": "Couleur du thème",
 "Cor do tema de cada aba": "Couleur du thème de chaque onglet",
 "Coração": "Cœur",
 "Corações": "Cœurs",
 "Cores das abas": "Couleurs des onglets",
 "Cores das conversas": "Couleurs des discussions",
 "Cores e opções desta aba": "Couleurs et options de cet onglet",
 "Corpo": "Corps",
 "Corporativo": "Entreprise",
 "Corpus Christi": "Fête-Dieu",
 "Corredor": "Couloir",
 "Correia dentada": "Courroie de distribution",
 "Corrida": "Course à pied",
 "Corta as bordas em branco ou partes da página.": "Coupe les bords blancs ou des parties de la page.",
 "Cortesia": "Offert",
 "Coxa e sobrecoxa": "Cuisse de poulet",
 "Cozinha": "Cuisine",
 "Creatina": "Créatine",
 "Criada em {data}": "Créée le {data}",
 "Criado com": "Créé avec",
 "Criado em": "Créé le",
 "Criança": "Enfant",
 "Crianças": "Enfants",
 "Criar": "Créer",
 "Criar animada": "Créer animé",
 "Criar conta": "Créer un compte",
 "Criar do zero": "Partir de zéro",
 "Criar documento, planilha ou apresentação": "Créer un document, un tableur ou une présentation",
 "Criar em outro app": "Créer dans une autre app",
 "Criar escritório": "Créer le bureau",
 "Criar fichário": "Créer un classeur",
 "Criar figurinha": "Créer un sticker",
 "Criar grupo": "Créer un groupe",
 "Criar grupo e convidar pessoas": "Créer un groupe et inviter",
 "Criar minha chave de API": "Créer ma clé API",
 "Criar o cofre": "Créer le coffre",
 "Criar o grupo e convidar": "Créer le groupe et inviter",
 "Criar os prazos do IR de {ano}": "Créer les échéances de l'IR {ano}",
 "Criar uma meta (viagem, reserva, carro...)": "Créer un objectif (voyage, réserve, voiture...)",
 "Criar uma senha nova": "Créer un nouveau mot de passe",
 "Criar {n} tarefa(s)": "Créer {n} tâche(s)",
 "Criação do Estado de MS": "Création de l'État du MS",
 "Crie a mudança e o app já monta a lista de transferências (luz, água, internet...). Depois cadastre as caixas por cômodo, as vistorias e o cronograma dos dias.": "Créez le déménagement et l'app prépare la liste des transferts (électricité, eau, internet...). Ajoutez ensuite les cartons par pièce, les états des lieux et le planning des jours.",
 "Crie a pasta de cada cliente, convide o cliente pelo link (ele só vê a pasta dele) e troquem documentos nos dois sentidos: notas, guias, folha, extratos, contratos.": "Créez le dossier de chaque client, invitez-le par lien (il ne voit que son dossier) et échangez des documents dans les deux sens : factures, avis d'impôt, paie, relevés, contrats.",
 "Crie a turma (ou grupo de mentoria, treino, curso) e, dentro dela, os alunos, a chamada, as notas, os planos de aula, os materiais e as cobranças.": "Créez la classe (ou groupe de mentorat, entraînement, cours) et, dedans, les élèves, l'appel, les notes, les plans de cours, les supports et les paiements dus.",
 "Crie a turma e, dentro dela, os alunos, a chamada, as avaliações com notas e os planos de aula.": "Créez la classe puis, à l'intérieur, les élèves, l'appel, les évaluations avec notes et les plans de cours.",
 "Crie as tarefas da casa (limpar banheiro, trocar roupa de cama...) com a frequência. O app avisa quando estão atrasadas, sem encher o My Planner.": "Créez les tâches ménagères (nettoyer la salle de bain, changer les draps...) avec leur fréquence. L'app vous prévient quand elles sont en retard, sans encombrer My Planner.",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para arquivar.": "Créez des cartes avec checklist, liste, texte libre ou dessin pour cette matière. Glissez à droite pour supprimer et à gauche pour archiver.",
 "Crie o escritório, chame a equipe (amigos do app ou convite pelo link) e troquem mensagens e documentos, marquem reuniões e façam reunião de vídeo. Você, que administra, pode gravar as reuniões.": "Créez le bureau, invitez l'équipe (amis de l'app ou invitation par lien) et échangez messages et documents, planifiez des réunions et faites des réunions vidéo. En tant qu'administrateur, vous pouvez enregistrer les réunions.",
 "Crie o evento e, dentro dele, a lista de convidados com confirmação de presença, os fornecedores e o cronograma do dia.": "Créez l'événement puis, à l'intérieur, la liste des invités avec confirmation de présence, les prestataires et le planning du jour.",
 "Crie o grupo e mande o link: quem entrar recebe data, local, avisos e tudo o que você enviar, e aceita, edita ou recusa.": "Créez le groupe et envoyez le lien : qui le rejoint reçoit la date, le lieu, les avis et tout ce que vous envoyez, et peut accepter, modifier ou refuser.",
 "Crie o grupo e mande o link: quem entrar vê e participa conforme o papel que você escolher. Só quem administra coloca ou tira pessoas.": "Créez le groupe et envoyez le lien : qui le rejoint voit et participe selon le rôle que vous choisissez. Seuls les administrateurs ajoutent ou retirent des personnes.",
 "Crie o grupo e mande o link: quem entrar vê tudo o que está aqui dentro e participa (inclui, edita, põe fotos). Só quem administra coloca ou tira pessoas.": "Créez le groupe et envoyez le lien : qui le rejoint voit tout ce qui se trouve ici et participe (ajoute, modifie, met des photos). Seuls les administrateurs ajoutent ou retirent des personnes.",
 "Crie sua conta. Seus dados ficam salvos na nuvem e neste dispositivo.": "Créez votre compte. Vos données sont enregistrées dans le cloud et sur cet appareil.",
 "Crie um fichário (ex.: Doutorado, Inglês, Concurso) e dentro dele as matérias e páginas.": "Créez un classeur (ex. : Doctorat, Anglais, Concours) et, à l'intérieur, les matières et les pages.",
 "Crie um grupo (turma, pacientes, equipe, convidados, clientes), mande o link de convite e envie compromissos, materiais e avisos. Cada pessoa aceita, edita ou recusa o que recebe.": "Créez un groupe (classe, patients, équipe, invités, clients), partagez le lien d'invitation et envoyez rendez-vous, documents et annonces. Chacun accepte, modifie ou refuse ce qu'il reçoit.",
 "Crie um perfil com nome e, se for advogado, a OAB.": "Créez un profil avec un nom et, si vous êtes avocat, l'OAB.",
 "Criptografado no cofre, só neste dispositivo": "Chiffré dans le coffre, sur cet appareil uniquement",
 "Criptomoedas": "Cryptomonnaies",
 "Cronograma": "Planning",
 "Cronograma alimentar, cuidados pessoais com passo a passo e água do dia.": "Programme alimentaire, soins personnels étape par étape et eau du jour.",
 "Cronograma do dia": "Planning du jour",
 "Cronograma físico-financeiro": "Planning physico-financier",
 "Cronograma físico-financeiro por etapa, diário da obra com antes e depois, profissionais e entregas.": "Planning physico-financier par étape, journal de chantier avec avant et après, artisans et livraisons.",
 "Cronômetro de horas": "Chronomètre d'heures",
 "Crédito empresarial": "Crédit professionnel",
 "Créditos": "Crédits",
 "Cuida das reservas, da limpeza e das despesas.": "Gère les réservations, le ménage et les dépenses.",
 "Cuidado": "Soin",
 "Cuidado pessoal": "Soin personnel",
 "Cuidados": "Soins",
 "Cupom do mercado": "Ticket de caisse",
 "Cupom do mercado (foto)": "Ticket de caisse (photo)",
 "Cupom lançado": "Ticket ajouté",
 "Curitiba": "Curitiba",
 "Curitiba (PR)": "Curitiba (PR)",
 "Curso": "Formation",
 "Cursos": "Formations",
 "Cursos livres e certificações": "Formations courtes et certifications",
 "Cuscuz": "Couscous de maïs",
 "CÓDIGO PARA PAGAR": "CODE DE PAIEMENT",
 "CÔMODOS": "PIÈCES",
 "Câmera": "Appareil photo",
 "Câmera e galeria": "Appareil photo et galerie",
 "Câmera não liberada": "Appareil photo non autorisé",
 "Código IBGE do município": "Code IBGE de la commune",
 "Código IBGE do município (7 números)": "Code IBGE de la commune (7 chiffres)",
 "Código NBS (9 números, opcional)": "Code NBS (9 chiffres, facultatif)",
 "Código copiado": "Code copié",
 "Código da reserva (localizador)": "Code de réservation",
 "Código de barras, linha digitável ou Pix copia e cola (opcional)": "Code-barres, ligne numérique ou Pix copier-coller (facultatif)",
 "Código de indicação": "Code de parrainage",
 "Código de indicação (opcional)": "Code de parrainage (facultatif)",
 "Código de quem convidou você": "Code de la personne qui vous a invité",
 "Código de tributação nacional (6 números)": "Code fiscal national (6 chiffres)",
 "Código de tributação nacional (6 números, ex.: 171901)": "Code fiscal national (6 chiffres, ex. : 171901)",
 "Código do amigo": "Code de l'ami",
 "Código do convite": "Code d'invitation",
 "Código do procedimento (TUSS ou do plano)": "Code de l'acte (TUSS ou de la mutuelle)",
 "Código errado. Confira e tente de novo.": "Code incorrect. Vérifiez et réessayez.",
 "Código não encontrado. Confira as letras e os números.": "Code introuvable. Vérifiez les lettres et les chiffres.",
 "Código não reconhecido. Confira os números (boleto: 47 ou 48 números).": "Code non reconnu. Vérifiez les chiffres (boleto : 47 ou 48 chiffres).",
 "Código: {c}": "Code : {c}",
 "Cópia automática toda semana": "Sauvegarde automatique chaque semaine",
 "Cópia criada.": "Copie créée.",
 "Cópia de segurança": "Copie de sauvegarde",
 "Cópia feita": "Sauvegarde effectuée",
 "Cópia restaurada.": "Sauvegarde restaurée.",
 "Cômodo": "Pièce",
 "Cômodo ou quarto": "Pièce ou chambre",
 "Cômodos da casa e as tarefas de cada um.": "Les pièces de la maison et les tâches de chacune.",
 "DAS de {mes} pago": "DAS de {mes} payé",
 "DAS de {mes}: vence dia {dia}": "DAS de {mes} : échéance le {dia}",
 "DAS do MEI": "DAS du MEI",
 "DECLARAÇÃO DE ATENDIMENTO": "ATTESTATION DE CONSULTATION",
 "DICA DO MESTRE ACHADO": "LE CONSEIL DU MESTRE ACHADO",
 "DPS nº {n}, série {s}": "DPS n° {n}, série {s}",
 "Da galeria ou dos arquivos": "Depuis la galerie ou les fichiers",
 "Da meta de passos": "De l'objectif de pas",
 "Dados compartilhados": "Données partagées",
 "Dados compartilhados com o grupo": "Données partagées avec le groupe",
 "Dados compartilhados · seu papel: {p}": "Données partagées · votre rôle : {p}",
 "Dados de saúde que você mesmo registra são tratados só para você e para quem você compartilhar, com o seu consentimento (art. 11, I).": "Les données de santé que vous saisissez vous-même sont traitées uniquement pour vous et pour les personnes avec qui vous les partagez, avec votre consentement (art. 11, I).",
 "Dados do dispositivo: idioma, país e fuso horário (para datas, feriados e moeda), modelo do dispositivo e o código para avisos no celular.": "Données de l'appareil : langue, pays et fuseau horaire (pour les dates, jours fériés et la devise), modèle de l'appareil et identifiant pour les notifications.",
 "Dados do relógio e de saúde não são usados para publicidade nem repassados a ninguém. Você pode desconectar e revogar a permissão a qualquer momento.": "Les données de la montre et de santé ne sont jamais utilisées pour la publicité ni partagées avec qui que ce soit. Vous pouvez vous déconnecter et révoquer l'autorisation à tout moment.",
 "Dança": "Danse",
 "Dar ciência": "Prendre connaissance",
 "Dar ciência da operação?": "Prendre connaissance de l'opération ?",
 "Data": "Date",
 "Data (embarque ou check-in)": "Date (départ ou arrivée)",
 "Data agendada": "Date prévue",
 "Data da aplicação": "Date d'administration",
 "Data da compra": "Date d'achat",
 "Data da entrega": "Date de livraison",
 "Data da venda": "Date de vente",
 "Data de nascimento": "Date de naissance",
 "Data do empréstimo": "Date du prêt",
 "Data do pagamento": "Date du paiement",
 "Data em que foi feita": "Date de réalisation",
 "Data sugerida com 2 dias úteis de folga. Confira no sistema oficial.": "Date suggérée avec 2 jours ouvrés de marge. Vérifiez dans le système officiel.",
 "De": "Du",
 "De uma foto": "À partir d'une photo",
 "De {de} para {para} ({p}% menor).": "De {de} à {para} ({p} % plus léger).",
 "Declaração": "Déclaration",
 "Declaração de atendimento": "Attestation de consultation",
 "Declaração para reembolso (PDF)": "Attestation pour remboursement (PDF)",
 "Declaro que esta empresa é minha ou de cliente que autorizou o acompanhamento.": "Je déclare que cette entreprise m'appartient ou appartient à un client qui a autorisé le suivi.",
 "Declaro, para fins de reembolso{conv}, que o(a) paciente {nome}{cpf}{cart} foi atendido(a) por mim em {data}{hora}, em {tipo}.": "J'atteste, aux fins de remboursement{conv}, avoir reçu le(la) patient(e) {nome}{cpf}{cart} le {data}{hora}, pour {tipo}.",
 "Defina a meta de aulas por dia ou por semana em Editar.": "Définissez l'objectif de cours par jour ou par semaine dans Modifier.",
 "Defina a meta de páginas por dia em Editar.": "Définissez l'objectif de pages par jour dans Modifier.",
 "Defina um horário": "Définissez une heure",
 "Defina um horário para usar pausas.": "Définissez une heure pour utiliser les pauses.",
 "Demaquilante ou água micelar": "Démaquillant ou eau micellaire",
 "Demolição": "Démolition",
 "Demonstração": "Démonstration",
 "Dentista": "Dentiste",
 "Dependentes": "Personnes à charge",
 "Depois": "Après",
 "Depois da aula": "Après le cours",
 "Depois de apagadas, as tarefas não voltam. Digite a senha da sua conta para confirmar.": "Une fois supprimées, les tâches ne reviennent pas. Saisissez le mot de passe de votre compte pour confirmer.",
 "Depois de baixar, abra o arquivo e toque em Instalar. Se o celular pedir, permita instalar apps desta fonte.": "Après le téléchargement, ouvrez le fichier et touchez Installer. Si le téléphone le demande, autorisez l'installation d'apps depuis cette source.",
 "Depois de criar": "Après la création",
 "Depois de {nome}. Toque para pular.": "Après {nome}. Touchez pour passer.",
 "Depois é só ajustar horários e o que comer em cada um.": "Il suffit ensuite d'ajuster les horaires et ce que vous mangez à chacun.",
 "Desarquivar": "Désarchiver",
 "Desbloquear": "Déverrouiller",
 "Desbloquear com": "Déverrouiller avec",
 "Desbloquear com biometria": "Déverrouiller par biométrie",
 "Desbloquear o My Planner": "Déverrouiller My Planner",
 "Desbloqueio do app": "Déverrouillage de l'app",
 "Descanso": "Repos",
 "Descartadas": "Écartées",
 "Descartar": "Écarter",
 "Descartar este tempo?": "Abandonner ce temps ?",
 "Descobrir lugares em {d}": "Découvrir des lieux à {d}",
 "Desconectar": "Déconnecter",
 "Desconectar o {nome}?": "Déconnecter {nome} ?",
 "Desconto": "Remise",
 "Desconto de {v}": "Remise de {v}",
 "Descontos obtidos": "Remises obtenues",
 "Descrição": "Description",
 "Descrição (cliente, nota fiscal...)": "Description (client, facture...)",
 "Descrição do serviço (sai na nota)": "Description du service (figure sur la facture)",
 "Descrição que sai na nota": "Description qui figure sur la facture",
 "Desenhar a assinatura": "Dessiner la signature",
 "Desenhar com caneta ou dedo": "Dessiner au stylet ou au doigt",
 "Desenhe a assinatura e escolha a página e o lugar.": "Dessinez la signature et choisissez la page et l'emplacement.",
 "Desenhe a assinatura primeiro.": "Dessinez d'abord la signature.",
 "Desenhe com o dedo ou com a caneta (S Pen, Apple Pencil ou caneta de tablet).": "Dessinez avec le doigt ou un stylet (S Pen, Apple Pencil ou stylet de tablette).",
 "Desenhe com o dedo ou com a caneta. Para rolar o quadro, toque em Mover.": "Dessinez avec le doigt ou le stylet. Pour faire défiler le tableau, touchez Déplacer.",
 "Desenhe de novo para confirmar.": "Dessinez à nouveau pour confirmer.",
 "Desenhe o seu padrão": "Dessinez votre schéma",
 "Desenhe pelo menos uma tarja.": "Dessinez au moins une bande.",
 "Desenhe um padrão ligando pelo menos 4 pontos.": "Dessinez un schéma reliant au moins 4 points.",
 "Desenho": "Dessin",
 "Desenho com caneta ou dedo": "Dessin au stylet ou au doigt",
 "Desenho incorreto": "Schéma incorrect",
 "Desenho padrão": "Schéma",
 "Desenho padrão salvo.": "Schéma enregistré.",
 "Desenvolvimento": "Développé épaules",
 "Desfazer": "Annuler",
 "Desfazer amizade": "Retirer des amis",
 "Desligar": "Désactiver",
 "Desligar a sincronização?": "Désactiver la synchronisation ?",
 "Deslize para os lados para ver outros dias (até 60 dias à frente). Toque numa refeição para planejar o cardápio só daquele dia. Arraste para a direita para excluir.": "Balayez sur les côtés pour voir d’autres jours (jusqu’à 60 jours à l’avance). Touchez un repas pour planifier le menu de ce jour uniquement. Glissez vers la droite pour supprimer.",
 "Desmarcado": "Annulé",
 "Desmarcar como recebida": "Marquer comme non reçue",
 "Desmarcar feita hoje": "Décocher fait aujourd'hui",
 "Desmarcar grupo": "Désélectionner le groupe",
 "Desmarcar pagamento": "Annuler le paiement",
 "Desodorante": "Déodorant",
 "Despensa": "Garde-manger",
 "Despesa": "Dépense",
 "Despesas": "Dépenses",
 "Destino": "Destination",
 "Detalhes": "Détails",
 "Devolver até": "À rendre avant le",
 "Devolver: {i} ({p})": "À rendre : {i} ({p})",
 "Devolvido": "Rendu",
 "Devolvidos": "Rendus",
 "Dia": "Jour",
 "Dia a dia": "Au quotidien",
 "Dia da mudança": "Jour du déménagement",
 "Dia de vencimento do DAS": "Jour d'échéance du DAS",
 "Dia do Trabalho": "Fête du Travail",
 "Dia do vencimento": "Jour d'échéance",
 "Dia em que a fatura fecha": "Jour de clôture du relevé",
 "Dia planejado": "Jour prévu",
 "Dia {d} de {total}": "Jour {d} sur {total}",
 "Diagnóstico": "Diagnostic",
 "Dias e horários": "Jours et horaires",
 "Dias específicos": "Jours précis",
 "Dias úteis": "Jours ouvrés",
 "Dias: {dias}": "Jours : {dias}",
 "Dicas e observações": "Conseils et remarques",
 "Diesel": "Diesel",
 "Diferença": "Différence",
 "Digitado": "Saisi",
 "Digitar": "Saisir",
 "Digitar à mão": "Saisir manuellement",
 "Digite a senha do cofre. Ele fecha sozinho depois de 5 minutos sem uso.": "Saisissez le mot de passe du coffre. Il se ferme seul après 5 minutes d'inactivité.",
 "Digite em minutos (90) ou em horas e minutos (1:30 ou 01:30) e toque em OK.": "Saisissez des minutes (90) ou des heures et minutes (1:30 ou 01:30) puis touchez OK.",
 "Digite no formato HH:MM, por exemplo 13:30.": "Saisissez au format HH:MM, par exemple 13:30.",
 "Digite o código e ganhe 10 dias com todas as abas liberadas. Se não tiver, deixe em branco.": "Saisissez le code et profitez de 10 jours avec tous les onglets débloqués. Sinon, laissez vide.",
 "Digite o nome da tarefa.": "Saisissez le nom de la tâche.",
 "Dinheiro": "Argent",
 "Dinheiro e documentos": "Argent et papiers",
 "Direita": "Droite",
 "Direito": "Droit",
 "Direito Administrativo": "Droit administratif",
 "Direito Civil": "Droit civil",
 "Direito Constitucional": "Droit constitutionnel",
 "Direito Empresarial": "Droit des affaires",
 "Direito Penal": "Droit pénal",
 "Direito Tributário": "Droit fiscal",
 "Direito do Trabalho": "Droit du travail",
 "Direto": "En direct",
 "Disciplina": "Matière",
 "Dispensar": "Ignorer",
 "Dispensar o aviso": "Ignorer l'alerte",
 "Dispensar todas": "Tout ignorer",
 "Disponibilizada em": "Mise à disposition le",
 "Disponível no app novo": "Disponible dans la nouvelle app",
 "Distância": "Distance",
 "Divida o curso em matérias ou módulos. Em cada uma, marque em que aula parou e crie cards de anotações.": "Divisez le cours en matières ou modules. Dans chacun, indiquez le cours où vous vous êtes arrêté et créez des cartes de notes.",
 "Dividir": "Diviser",
 "Dividir entre (nenhum marcado = todos)": "Partager entre (aucun coché = tous)",
 "Divisão das despesas": "Partage des dépenses",
 "Diária": "Prix par nuit",
 "Diária padrão": "Prix par nuit standard",
 "Diário": "Journal",
 "Diários municipais": "Journaux municipaux",
 "Do celular, do Google Drive ou do OneDrive": "Du téléphone, de Google Drive ou de OneDrive",
 "Do cliente": "Du client",
 "Do escritório": "Du cabinet",
 "Doações": "Dons",
 "Docs": "Docs",
 "Documento": "Document",
 "Documento (fundo branco)": "Document (fond blanc)",
 "Documento do veículo (CRLV)": "Carte grise (CRLV)",
 "Documento pessoal": "Document personnel",
 "Documento vence hoje": "Le document expire aujourd'hui",
 "Documento vencendo": "Document bientôt expiré",
 "Documento: {o}": "Document : {o}",
 "Documentos": "Documents",
 "Documentos (contrato, nota, recibo...)": "Documents (contrat, facture, reçu...)",
 "Documentos (passaporte, identidade, carteira de motorista)": "Papiers (passeport, carte d'identité, permis de conduire)",
 "Documentos e autorização das crianças": "Papiers et autorisation des enfants",
 "Documentos protegidos, exames, histórico de saúde e outros campos com 🔒 são criptografados aqui no aparelho (AES-256) com a senha do cofre. Nem o suporte consegue ler. Sem a senha, esses dados não podem ser recuperados.": "Les documents protégés, examens, antécédents médicaux et autres champs marqués 🔒 sont chiffrés ici sur l'appareil (AES-256) avec le mot de passe du coffre. Même le support ne peut pas les lire. Sans le mot de passe, ces données sont irrécupérables.",
 "Documentos, recibos, cadernos e quadros, com várias páginas": "Documents, reçus, cahiers et tableaux, sur plusieurs pages",
 "Documentos, reuniões e gravações são apagados para todos. A conversa continua no Mensagens.": "Les documents, réunions et enregistrements sont supprimés pour tous. La conversation reste dans Messages.",
 "Documentário": "Documentaire",
 "Doenças, cirurgias e observações": "Maladies, chirurgies et remarques",
 "Dois dedos ou toque duplo para ampliar": "Pincez ou touchez deux fois pour agrandir",
 "Domingo": "Dimanche",
 "Dono da obra": "Maître d'ouvrage",
 "Dose": "Dose",
 "Dose (ex.: 1 cápsula, 5 g)": "Dose (ex. : 1 gélule, 5 g)",
 "Dose única": "Dose unique",
 "Drama": "Drame",
 "Duplicar": "Dupliquer",
 "Duplicar tarefa": "Dupliquer la tâche",
 "Duração": "Durée",
 "Duração de cada sessão": "Durée de chaque séance",
 "Duração {dur}": "Durée {dur}",
 "Dá para comprar algo de 3 mil em 10 vezes?": "Puis-je acheter quelque chose à 3 000 en 10 fois ?",
 "Débito automático": "Prélèvement automatique",
 "Débito, Pix ou dinheiro": "Débit, Pix ou espèces",
 "Dê um nome ao cartão.": "Donnez un nom à la carte.",
 "Dê um nome ao cuidado.": "Donnez un nom au soin.",
 "Dê um nome ao cômodo.": "Donnez un nom à la pièce.",
 "Dê um nome ao fichário.": "Donnez un nom au classeur.",
 "Dê um nome ao grupo.": "Donnez un nom au groupe.",
 "Dê um nome ao suplemento.": "Donnez un nom au complément.",
 "Dê um nome ao treino.": "Donnez un nom à la séance.",
 "Dê um nome à conta.": "Donnez un nom à la facture.",
 "Dê um nome à matéria.": "Donnez un nom à la matière.",
 "Dê um nome à meta.": "Donnez un nom à l'objectif.",
 "Dê um nome à refeição.": "Donnez un nom au repas.",
 "Dê um nome à tarefa.": "Donnez un nom à la tâche.",
 "E-MAIL (OPCIONAL)": "E-MAIL (FACULTATIF)",
 "E-mail": "E-mail",
 "E-mail (recebe a nota)": "E-mail (reçoit la facture)",
 "E-mail de contato": "E-mail de contact",
 "E-mail do responsável": "E-mail du responsable légal",
 "E-mail inválido": "E-mail invalide",
 "E-mail inválido.": "E-mail invalide.",
 "E-mail ou WhatsApp para resposta (opcional)": "E-mail ou WhatsApp pour la réponse (facultatif)",
 "E-mail para contato (opcional)": "E-mail de contact (facultatif)",
 "E-mail salvo.": "E-mail enregistré.",
 "EM ATRASO": "EN RETARD",
 "ENTRAR COM UM CÓDIGO": "REJOINDRE AVEC UN CODE",
 "ENVIADOS": "ENVOYÉS",
 "ESCOLHA AS ATIVIDADES": "CHOISISSEZ LES ACTIVITÉS",
 "ESTA SEMANA": "CETTE SEMAINE",
 "EXERCÍCIO FÍSICO": "ACTIVITÉ PHYSIQUE",
 "Economia": "Économie",
 "Edita tudo": "Modifie tout",
 "Edita tudo: etapas, orçamento, diário e entregas.": "Modifie tout : étapes, budget, journal et livraisons.",
 "Editar": "Modifier",
 "Editar cartão": "Modifier la carte",
 "Editar compra": "Modifier l'achat",
 "Editar cômodo": "Modifier la pièce",
 "Editar desenho": "Modifier le dessin",
 "Editar documento": "Modifier le document",
 "Editar fichário": "Modifier le classeur",
 "Editar garantia": "Modifier la garantie",
 "Editar matéria": "Modifier la matière",
 "Editar meta": "Modifier l'objectif",
 "Editar perfil": "Modifier le profil",
 "Editar tarefa": "Modifier la tâche",
 "Editar {nome}": "Modifier {nome}",
 "Educação": "Éducation",
 "Educação Física": "Éducation physique",
 "Efeito de scanner": "Effet scanner",
 "Ela sai da lista e dos Recebidos da equipe.": "Elle disparaît de la liste et des Reçus de l'équipe.",
 "Ela também fica guardada em \"Minhas figurinhas\" para mandar de novo.": "Il est aussi enregistré dans \"Mes stickers\" pour le renvoyer.",
 "Ela vem da aba Empréstimos & Financiamentos. Marque aqui como paga ou abra a aba para ver o contrato.": "Elle vient de l'onglet Prêts & Financements. Marquez-la comme payée ici ou ouvrez l'onglet pour voir le contrat.",
 "Ela vem da aba Notas Fiscais. Marque como recebida quando o dinheiro entrar.": "Elle vient de l'onglet Factures. Marquez-la comme reçue quand l'argent arrive.",
 "Eleitorais": "Électoraux",
 "Eletrodoméstico": "Électroménager",
 "Eletrodomésticos": "Électroménager",
 "Eletrodomésticos, eletrônicos e móveis: nota fiscal, assistência técnica e aviso 15 dias antes de a garantia acabar.": "Électroménager, électronique et meubles : facture, SAV et rappel 15 jours avant la fin de la garantie.",
 "Eletrônico": "Électronique",
 "Elétrica": "Électricité",
 "Elétrico": "Électrique",
 "Em Editar, cole o link do calendário (iCal) do anúncio. No Airbnb: Calendário › Disponibilidade › Conectar calendários › Exportar calendário. No Booking: Tarifas e disponibilidade › Sincronizar calendários.": "Dans Modifier, collez le lien du calendrier (iCal) de l'annonce. Sur Airbnb : Calendrier › Disponibilités › Connecter des calendriers › Exporter le calendrier. Sur Booking : Tarifs et disponibilités › Synchroniser les calendriers.",
 "Em aberto": "En attente",
 "Em alta": "Tendances",
 "Em andamento": "En cours",
 "Em atraso": "En retard",
 "Em branco": "Vierge",
 "Em casa": "À la maison",
 "Em cima": "En haut",
 "Em construção": "En construction",
 "Em dia. As melhorias chegam sozinhas quando o app abre.": "À jour. Les améliorations arrivent toutes seules à l'ouverture de l'app.",
 "Em limpeza": "Ménage en cours",
 "Em quais páginas": "Sur quelles pages",
 "Em qual agenda criar os eventos:": "Agenda où créer les événements :",
 "Em qual página e onde": "Sur quelle page et où",
 "Em tratamento": "En traitement",
 "Em um horário específico": "À une heure précise",
 "Em uso: {ia}": "Utilisé : {ia}",
 "Em {n} dia(s)": "Dans {n} jour(s)",
 "Embaixo": "En bas",
 "Embaixo à esquerda": "En bas à gauche",
 "Emissão": "Délivrance",
 "Emissão +": "Délivrance +",
 "Emissão: {data}": "Délivré le : {data}",
 "Emitida": "Émise",
 "Emitida em {data}": "Émise le {data}",
 "Emitida ou recebida": "Émise ou reçue",
 "Emitidas": "Émises",
 "Emitidas: {v} · Recebidas: {r} · {n} nota(s)": "Émises : {v} · Reçues : {r} · {n} facture(s)",
 "Emitir": "Émettre",
 "Emitir NFS-e": "Émettre une NFS-e",
 "Emitir NFS-e pelo Padrão Nacional com o certificado A1, buscar as notas emitidas e recebidas e exportar XML, planilha e PDF.": "Émettez des NFS-e via le Padrão Nacional avec le certificat A1, recherchez les factures émises et reçues et exportez XML, tableur et PDF.",
 "Emitir a nota de verdade?": "Émettre la facture pour de vrai ?",
 "Emitir no ambiente de teste?": "Émettre dans l'environnement de test ?",
 "Emojis": "Emojis",
 "Emojis animados": "Emojis animés",
 "Emojis animados: Noto, do Google (CC BY 4.0).": "Emojis animés : Noto, de Google (CC BY 4.0).",
 "Emojis, GIFs e figurinhas": "Emojis, GIF et stickers",
 "Empresa": "Entreprise",
 "Empresa de mudança": "Société de déménagement",
 "Empresa ou pessoa": "Entreprise ou personne",
 "Empresa, hotel ou voo": "Société, hôtel ou vol",
 "Empresas": "Entreprises",
 "Emprestei": "J'ai prêté",
 "Empréstimo": "Prêt",
 "Empréstimo entre pessoas": "Prêt entre particuliers",
 "Empréstimo pessoal": "Prêt personnel",
 "Empréstimos": "Prêts",
 "Empréstimos & Financiamentos": "Prêts & Financements",
 "Encaminhada para {nome}.": "Transféré à {nome}.",
 "Encaminhar": "Transférer",
 "Encaminhar para": "Transférer à",
 "Encerrar e salvar": "Terminer et enregistrer",
 "Encontrada para {perfil}": "Trouvée pour {perfil}",
 "Endereço": "Adresse",
 "Endereço (opcional)": "Adresse (facultatif)",
 "Endereço (se for presencial)": "Adresse (si en présentiel)",
 "Endereço atual": "Adresse actuelle",
 "Endereço da escola": "Adresse de l'école",
 "Endereço da oficina": "Adresse du garage",
 "Endereço de quem está com o item": "Adresse de la personne qui a l'objet",
 "Endereço do consultório": "Adresse du cabinet",
 "Endereço do imóvel": "Adresse du logement",
 "Endereço do laboratório": "Adresse du laboratoire",
 "Endereço do veterinário": "Adresse du vétérinaire",
 "Endereço no trabalho e na escola": "Adresse au travail et à l'école",
 "Endereço nos Correios e entregas": "Adresse à la Poste et pour les livraisons",
 "Endereço nos bancos e cartões": "Adresse auprès des banques et cartes",
 "Endereço novo": "Nouvelle adresse",
 "Endereço ou nome do lugar": "Adresse ou nom du lieu",
 "Endereço ou terminal": "Adresse ou terminal",
 "Energia": "Énergie",
 "Enfermeiro": "Infirmier",
 "Engenharia": "Ingénierie",
 "Engenheiro ou arquiteto": "Ingénieur ou architecte",
 "Enquadre o documento e toque no botão": "Cadrez le document et touchez le bouton",
 "Enquadre o rosto e toque no botão. 🔄 vira a câmera.": "Cadrez votre visage et touchez le bouton. 🔄 retourne la caméra.",
 "Ensino Fundamental": "École primaire et collège",
 "Ensino Médio e ENEM": "Lycée et ENEM",
 "Entendi e concordo em usar o monitor nessas condições.": "J'ai compris et j'accepte d'utiliser le suivi dans ces conditions.",
 "Entra direto no Planner, com horário, dias e a lista de itens. Se o horário já estiver ocupado, você escolhe: substituir, manter as duas ou cancelar.": "Ajouté directement au Planner, avec l’heure, les jours et la liste des éléments. Si le créneau est déjà pris, vous choisissez : remplacer, garder les deux ou annuler.",
 "Entrada": "Entrée",
 "Entrada (imóvel novo)": "Entrée (nouveau logement)",
 "Entrada de dinheiro": "Entrée d'argent",
 "Entrando...": "Connexion...",
 "Entrar": "Se connecter",
 "Entrar com CPF e senha": "Se connecter avec CPF et mot de passe",
 "Entrar com outra conta": "Se connecter avec un autre compte",
 "Entrar de novo": "Se reconnecter",
 "Entrar na chamada": "Rejoindre l'appel",
 "Entrar na reunião": "Rejoindre la réunion",
 "Entrar na sala online": "Rejoindre la salle en ligne",
 "Entrar no grupo": "Rejoindre le groupe",
 "Entrar no navegador?": "Se connecter dans le navigateur ?",
 "Entre com seu CPF e sua senha.": "Connectez-vous avec votre CPF et votre mot de passe.",
 "Entre com seu e-mail e sua senha.": "Connectez-vous avec votre e-mail et votre mot de passe.",
 "Entre na sua conta de novo.": "Reconnectez-vous.",
 "Entre na sua conta para usar as notas fiscais.": "Connectez-vous à votre compte pour utiliser les factures.",
 "Entre no app com o seu e-mail e a senha nova.": "Connectez-vous à l'app avec votre e-mail et le nouveau mot de passe.",
 "Entrega de material": "Livraison de matériaux",
 "Entrega prevista": "Livraison prévue",
 "Entregas": "Livraisons",
 "Entregue": "Livré",
 "Entrou": "Entrées",
 "Entrou no total da semana.": "Ajouté au total de la semaine.",
 "Enviada": "Envoyée",
 "Enviado": "Envoyé",
 "Enviado para o Planner": "Envoyé au Planner",
 "Enviado pelo cliente": "Envoyé par le client",
 "Enviado pelo escritório": "Envoyé par le cabinet",
 "Enviado por {quem} no grupo {g}": "Envoyé par {quem} dans le groupe {g}",
 "Enviando {f} de {n}...": "Envoi {f} sur {n}...",
 "Enviando...": "Envoi...",
 "Enviar": "Envoyer",
 "Enviar \"{nome}\"": "Envoyer \"{nome}\"",
 "Enviar \"{nome}\" para…": "Envoyer « {nome} » vers…",
 "Enviar \"{titulo}\" para": "Envoyer « {titulo} » vers",
 "Enviar ao grupo": "Envoyer au groupe",
 "Enviar convite": "Envoyer l'invitation",
 "Enviar convite para {nome}": "Envoyer l'invitation à {nome}",
 "Enviar convite pelo WhatsApp": "Envoyer l'invitation par WhatsApp",
 "Enviar documento": "Envoyer un document",
 "Enviar instruções ao hóspede": "Envoyer les consignes au voyageur",
 "Enviar o convite": "Envoyer l'invitation",
 "Enviar ou copiar o código": "Envoyer ou copier le code",
 "Enviar ou imprimir a etiqueta": "Envoyer ou imprimer l'étiquette",
 "Enviar para Estudos": "Envoyer vers Études",
 "Enviar para My Planner": "Envoyer vers My Planner",
 "Enviar para a equipe": "Envoyer à l'équipe",
 "Enviar para o My Planner": "Envoyer vers My Planner",
 "Enviar para o Planner": "Envoyer au Planner",
 "Enviar para o grupo": "Envoyer au groupe",
 "Enviar para o grupo de estudos": "Envoyer au groupe d'étude",
 "Enviar para o {nome} os {n} arquivo(s) deste dispositivo": "Envoyer vers {nome} les {n} fichier(s) de cet appareil",
 "Enviar para um grupo": "Envoyer à un groupe",
 "Enviar para {g}": "Envoyer à {g}",
 "Enviar para…": "Envoyer vers…",
 "Enviar por e-mail": "Envoyer par e-mail",
 "Enviar relatório": "Envoyer le rapport",
 "Enviar relatório para a equipe": "Envoyer le rapport à l'équipe",
 "Enviar também as tarefas que já existem (de hoje em diante)": "Envoyer aussi les tâches existantes (à partir d'aujourd'hui)",
 "Enviar tarefas do My Planner para a agenda": "Envoyer les tâches de My Planner vers l'agenda",
 "Envie guias, notas e relatórios para o cliente, ou veja o que ele mandou. Cada documento aceita fotos, PDFs e links.": "Envoyez avis d'impôt, factures et rapports au client, ou voyez ce qu'il a envoyé. Chaque document accepte photos, PDF et liens.",
 "Enxaguante": "Bain de bouche",
 "Episódio": "Épisode",
 "Equipe": "Équipe",
 "Equipe ({n})": "Équipe ({n})",
 "Equipe de limpeza": "Équipe de ménage",
 "Equipe do consultório": "Équipe du cabinet",
 "Equipe do imóvel (limpeza e co-anfitrião)": "Équipe du logement (ménage et co-hôte)",
 "Erro": "Bug",
 "Erro na emissão": "Erreur d'émission",
 "Erro: {erro}": "Erreur : {erro}",
 "Erros registrados neste dispositivo ({n})": "Erreurs enregistrées sur cet appareil ({n})",
 "Escanear documento": "Numériser un document",
 "Escanear o verso": "Scanner le verso",
 "Escanear para PDF": "Scanner en PDF",
 "Escaneie documentos, recibos, cadernos e quadros: bordas e sombras corrigidas, várias páginas, identidade frente e verso, assinatura e PDF guardado no celular, no Google Drive ou no OneDrive.": "Numérisez documents, reçus, cahiers et tableaux : bords et ombres corrigés, plusieurs pages, pièce d'identité recto verso, signature et PDF enregistré sur le téléphone, dans Google Drive ou dans OneDrive.",
 "Escaneie, deixe a imagem mais clara, organize em pastas e mande o PDF por WhatsApp, e-mail ou Drive. Com a sua IA ligada, o app lê o texto, resume e responde perguntas sobre o documento.": "Numérisez, éclaircissez l'image, rangez dans des dossiers et envoyez le PDF par WhatsApp, e-mail ou Drive. Avec votre IA activée, l'app lit le texte, le résume et répond à vos questions sur le document.",
 "Escola": "École",
 "Escolha a aba:": "Choisissez l'onglet :",
 "Escolha a data do compromisso.": "Choisissez la date du rendez-vous.",
 "Escolha a imagem.": "Choisissez l'image.",
 "Escolha a matéria": "Choisissez la matière",
 "Escolha a pasta do celular (ex.: Documentos). O app guarda lá sozinho.": "Choisissez le dossier du téléphone (ex. : Documents). L'app y enregistre automatiquement.",
 "Escolha a página": "Choisissez la page",
 "Escolha ao menos um tribunal ou marque \"Todos os tribunais\".": "Choisissez au moins un tribunal ou cochez « Tous les tribunaux ».",
 "Escolha ao menos uma agenda.": "Choisissez au moins un agenda.",
 "Escolha o PDF": "Choisissez le PDF",
 "Escolha o arquivo .pfx (ou .p12) do certificado A1 da empresa e digite a senha dele. Ele fica criptografado no seu cofre.": "Choisissez le fichier .pfx (ou .p12) du certificat A1 de l'entreprise et saisissez son mot de passe. Il est chiffré dans votre coffre.",
 "Escolha o arquivo .xml da NFS-e, NF-e ou CT-e.": "Choisissez le fichier .xml de la NFS-e, NF-e ou CT-e.",
 "Escolha o fichário": "Choisissez le classeur",
 "Escolha o grupo para enviar: {t}": "Choisissez le groupe destinataire : {t}",
 "Escolha os PDFs": "Choisissez les PDF",
 "Escolha os arquivos.": "Choisissez les fichiers.",
 "Escolha os feriados que aparecem no Planner e no botão 🎉 Feriados.": "Choisissez les jours fériés affichés dans le Planner et dans le bouton 🎉 Jours fériés.",
 "Escolha para quem enviar.": "Choisissez à qui envoyer.",
 "Escolha pelo menos um dia.": "Choisissez au moins un jour.",
 "Escolha pelo menos uma página que exista no PDF (ex.: 1-3, 5).": "Choisissez au moins une page qui existe dans le PDF (ex. : 1-3, 5).",
 "Escolha quem participa:": "Choisissez les participants :",
 "Escolher": "Choisir",
 "Escolher a imagem": "Choisir l'image",
 "Escolher a pasta": "Choisir le dossier",
 "Escolher agendas": "Choisir des agendas",
 "Escolher alimento": "Choisir un aliment",
 "Escolher arquivo": "Choisir un fichier",
 "Escolher arquivos": "Choisir des fichiers",
 "Escolher arquivos do Drive ou do OneDrive": "Choisir des fichiers dans Drive ou OneDrive",
 "Escolher as imagens e criar o PDF": "Choisir les images et créer le PDF",
 "Escolher da galeria": "Choisir dans la galerie",
 "Escolher da galeria ou arquivo (foto ou PDF)": "Choisir dans la galerie ou un fichier (photo ou PDF)",
 "Escolher data": "Choisir une date",
 "Escolher fuso": "Choisir le fuseau",
 "Escolher hora": "Choisir l'heure",
 "Escolher horário": "Choisir une heure",
 "Escolher o certificado": "Choisir le certificat",
 "Escolher outro": "Choisir un autre",
 "Escolher pessoas": "Choisir des personnes",
 "Escolher tribunais": "Choisir les tribunaux",
 "Escolher ícone": "Choisir une icône",
 "Esconder da equipe (só administradores)": "Masquer à l'équipe (admins uniquement)",
 "Esconder detalhes": "Masquer les détails",
 "Esconder o texto completo": "Masquer le texte complet",
 "Escondido de {n} pessoa(s)": "Masqué pour {n} personne(s)",
 "Escondido de: {n}": "Masqué pour : {n}",
 "Escondidos no Planner.": "Masqués dans le Planner.",
 "Escova e pasta de dente": "Brosse à dents et dentifrice",
 "Escovar os dentes": "Se brosser les dents",
 "Escreva aqui": "Écrivez ici",
 "Escreva e dê Enter (ex.: lavar a máquina)": "Écrivez et appuyez sur Entrée (ex. : lancer une lessive)",
 "Escreva em uma ou em todas as páginas.": "Écrivez sur une page ou sur toutes.",
 "Escreva o motivo em \"Motivo do cancelamento\" na ficha da nota (pelo menos 15 letras) e toque aqui de novo.": "Écrivez le motif dans « Motif d'annulation » sur la fiche de la facture (au moins 15 lettres) et touchez ici à nouveau.",
 "Escreva o resumo, tópicos, dúvidas...": "Écrivez le résumé, les points clés, les questions...",
 "Escreva o texto da marca d'água.": "Saisissez le texte du filigrane.",
 "Escreva o texto.": "Saisissez le texte.",
 "Escreva o título.": "Saisissez le titre.",
 "Escreva ou cole o texto. Linha começando com \"# \" vira título.": "Saisissez ou collez le texte. Une ligne commençant par \"# \" devient un titre.",
 "Escreva ou cole um texto e gere o PDF.": "Saisissez ou collez un texte et créez le PDF.",
 "Escritório": "Bureau",
 "Escritório: documentos e reuniões da equipe. Só o administrador do escritório pode gravar uma reunião, e todos na reunião veem o aviso \"Gravando\" enquanto ela é gravada. A gravação fica nos documentos do escritório, visível só para o administrador até ele liberar para a equipe.": "Bureau : documents et réunions de l'équipe. Seul l'administrateur du bureau peut enregistrer une réunion, et tous les participants voient l'avis « Enregistrement » pendant l'enregistrement. L'enregistrement est conservé dans les documents du bureau, visible uniquement par l'administrateur jusqu'à ce qu'il le partage avec l'équipe.",
 "Escuro": "Sombre",
 "Espanhol": "Espagnol",
 "Espaço": "Espace",
 "Espaço livre, dados de cada aba e anexos": "Espace libre, données par onglet et pièces jointes",
 "Especialidade": "Spécialité",
 "Espécie": "Espèce",
 "Esquadro": "Équerre",
 "Esqueci a senha": "Mot de passe oublié",
 "Esquerda": "Gauche",
 "Esse código é o seu.": "Ce code est le vôtre.",
 "Esse código é o seu. Use o código de quem indicou o app para você.": "C'est votre propre code. Utilisez le code de la personne qui vous a recommandé l'app.",
 "Esse endereço não respondeu como servidor de notas. Confira e tente de novo.": "Cette adresse n'a pas répondu comme un serveur de factures. Vérifiez-la et réessayez.",
 "Esta aba ainda não está no seu plano.": "Cet onglet n'est pas encore dans votre forfait.",
 "Esta e todas as futuras": "Celle-ci et toutes les suivantes",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou instale o APK novo.": "Cet outil doit voir les pages du PDF, ce qui arrive avec la nouvelle app (version 0.50). Utilisez le navigateur ou installez le nouvel APK.",
 "Esta imagem foi guardada em outro dispositivo.": "Cette image a été enregistrée sur un autre appareil.",
 "Esta janela pode ser fechada.": "Vous pouvez fermer cette fenêtre.",
 "Esta pessoa ainda não preencheu o cartão de contato.": "Cette personne n'a pas encore rempli sa fiche contact.",
 "Esta semana: {a} de {m} aulas ({p}%)": "Cette semaine : {a} sur {m} cours ({p}%)",
 "Esta senha é de outra conta.": "Ce mot de passe appartient à un autre compte.",
 "Esta tarefa não tem horário: \"No início\" e \"Antes do início\" não se aplicam. Use \"Em um horário específico\".": "Cette tâche n'a pas d'heure : « Au début » et « Avant le début » ne s'appliquent pas. Utilisez « À une heure précise ».",
 "Esta tarefa se repete. O que excluir?": "Cette tâche se répète. Que supprimer ?",
 "Esta tela teve um problema": "Cet écran a rencontré un problème",
 "Estado (UF) do registro": "État (UF) d'inscription",
 "Estado de Mato Grosso do Sul": "État du Mato Grosso do Sul",
 "Estado de São Paulo": "État de São Paulo",
 "Estado do Paraná": "État du Paraná",
 "Estados": "États",
 "Estaduais": "D'État",
 "Estadual": "État",
 "Estas abas aparecem na barra de baixo, nesta ordem. My Planner, Abas e Ajustes ficam sempre. As outras continuam aqui na tela Abas.": "Ces onglets apparaissent dans la barre du bas, dans cet ordre. My Planner, Onglets et Réglages y restent toujours. Les autres restent ici, dans l'écran Onglets.",
 "Estatística": "Statistiques",
 "Este CPF já tem cadastro. Use \"Entrar\".": "Ce CPF est déjà inscrit. Utilisez « Se connecter ».",
 "Este PDF está no dispositivo onde foi aberto.": "Ce PDF est sur l'appareil où il a été ouvert.",
 "Este PDF está no dispositivo onde foi aberto. Abra por lá, ou abra de novo a cópia guardada no Drive ou no OneDrive.": "Ce PDF est sur l'appareil où il a été ouvert. Ouvrez-le là-bas, ou rouvrez la copie enregistrée sur Drive ou OneDrive.",
 "Este PDF está protegido com senha. Tire a senha no programa onde ele foi criado e tente de novo.": "Ce PDF est protégé par mot de passe. Retirez le mot de passe dans le logiciel où il a été créé et réessayez.",
 "Este PDF não tem campos de formulário. Use \"Adicionar texto\" para escrever nele.": "Ce PDF n'a pas de champs de formulaire. Utilisez \"Ajouter du texte\" pour écrire dessus.",
 "Este ano": "Cette année",
 "Este dispositivo": "Cet appareil",
 "Este dispositivo não consegue abrir o arquivo.": "Cet appareil ne peut pas ouvrir le fichier.",
 "Este dispositivo não consegue compartilhar arquivos.": "Cet appareil ne peut pas partager de fichiers.",
 "Este dispositivo não tem dados de saúde. Dá para digitar à mão.": "Cet appareil n'a pas de données de santé. Vous pouvez les saisir manuellement.",
 "Este arquivo foi guardado em outro dispositivo.": "Ce fichier a été enregistré sur un autre appareil.",
 "Este arquivo foi guardado no celular. Abra pelo app no celular.": "Ce fichier a été enregistré sur le téléphone. Ouvrez-le depuis l'app sur le téléphone.",
 "Este arquivo não é um backup do My Planner.": "Ce fichier n'est pas une sauvegarde de My Planner.",
 "Este celular ainda não recebe avisos com o app fechado. Instale o app {v} ou mais novo (APK com os avisos do servidor). Com o app aberto, os avisos já funcionam.": "Ce téléphone ne reçoit pas encore de notifications quand l'app est fermée. Installez l'app {v} ou plus récente (APK avec les notifications du serveur). Avec l'app ouverte, les notifications fonctionnent déjà.",
 "Este certificado é de {doc}, diferente do CNPJ/CPF da empresa ({emp}).": "Ce certificat appartient à {doc}, différent du CNPJ/CPF de l'entreprise ({emp}).",
 "Este fichário ainda não tem matérias.": "Ce classeur n'a pas encore de matières.",
 "Este grupo já está cheio.": "Ce groupe est déjà complet.",
 "Este mês": "Ce mois-ci",
 "Este mês: emitidas {e} · recebidas {r}": "Ce mois-ci : émises {e} · reçues {r}",
 "Este mês: {h}": "Ce mois-ci : {h}",
 "Este navegador": "Ce navigateur",
 "Este país só tem feriados nacionais.": "Ce pays n'a que des jours fériés nationaux.",
 "Esteira": "Tapis de course",
 "Esteticista": "Esthéticienne",
 "Estou usando o My Planner para organizar a agenda, as finanças e muito mais. Baixe o app e, ao criar a sua conta, use o meu código {codigo} para ganhar 10 dias com todas as abas liberadas.": "J'utilise My Planner pour organiser mon agenda, mes finances et bien plus. Téléchargez l'app et, en créant votre compte, utilisez mon code {codigo} pour profiter de 10 jours avec tous les onglets débloqués.",
 "Estratégia": "Stratégie",
 "Estrela": "Étoile",
 "Estudando": "En cours d'étude",
 "Estudar agora": "Étudier maintenant",
 "Estudar {nome}": "Étudier {nome}",
 "Estudar: {c}": "Étudier : {c}",
 "Estudo": "Étude",
 "Estudos": "Études",
 "Estudos e exatas": "Études et sciences",
 "Estudos, lazer e viagens": "Études, loisirs et voyages",
 "Está em Patrimônio & IR › Recibos dedutíveis. Abra lá para anexar a foto do recibo e o CPF ou CNPJ de quem recebeu.": "C'est dans Patrimoine & Impôt sur le revenu › Reçus déductibles. Ouvrez-le là pour joindre la photo du reçu et le CPF ou CNPJ du bénéficiaire.",
 "Está na página \"{titulo}\" e em \"Ver arquivos\".": "Il se trouve sur la page \"{titulo}\" et dans \"Voir les fichiers\".",
 "Etanol": "Éthanol",
 "Etapa": "Étape",
 "Etapa do cronograma": "Étape du planning",
 "Etapas": "Étapes",
 "Evento": "Événement",
 "Eventos": "Événements",
 "Eventos & Celebrações": "Événements & Fêtes",
 "Evolução (no cofre)": "Évolution (dans le coffre)",
 "Ex.: 08:00 e 20:00": "Ex. : 08:00 et 20:00",
 "Ex.: 08:00, 14:00 e 20:00": "Ex. : 08:00, 14:00 et 20:00",
 "Ex.: 09/2026": "Ex. : 09/2026",
 "Ex.: 1 comprimido": "Ex. : 1 comprimé",
 "Ex.: 1-3, 4-10, 11-": "Ex. : 1-3, 4-10, 11-",
 "Ex.: 1-3, 5, 8-10": "Ex. : 1-3, 5, 8-10",
 "Ex.: 171901 (consultoria), 010101 (programação)": "Ex. : 171901 (conseil), 010101 (programmation)",
 "Ex.: 40 sacos de cimento": "Ex. : 40 sacs de ciment",
 "Ex.: 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)": "Ex. : 4106902 (Curitiba), 5002704 (Campo Grande), 3550308 (São Paulo)",
 "Ex.: 8º ano B": "Ex. : 4e B",
 "Ex.: Alongamento lombar, Dieta 1.800 kcal": "Ex. : Étirements lombaires, Régime 1 800 kcal",
 "Ex.: Aniversário de 30 anos da Ana": "Ex. : Les 30 ans d'Ana",
 "Ex.: Apartamento da praia, Suíte 1, Edícula": "Ex. : Appartement à la plage, Suite 1, Dépendance",
 "Ex.: Apartamento na Rua X, 100 ações PETR4": "Ex. : Appartement rue X, 100 actions PETR4",
 "Ex.: Aula de revisão, Consulta de retorno": "Ex. : Cours de révision, Consultation de suivi",
 "Ex.: Buffet, DJ, decoração, fotógrafo": "Ex. : Traiteur, DJ, déco, photographe",
 "Ex.: CONFIDENCIAL, CÓPIA, RASCUNHO": "Ex. : CONFIDENTIEL, COPIE, BROUILLON",
 "Ex.: Cardiologista": "Ex. : Cardiologue",
 "Ex.: Consultoria mensal": "Ex. : Conseil mensuel",
 "Ex.: Costela-de-adão da sala": "Ex. : Monstera du salon",
 "Ex.: DAS de setembro, Extrato do Itaú": "Ex. : DAS de septembre, Relevé Itaú",
 "Ex.: Desmontar os móveis do quarto": "Ex. : Démonter les meubles de la chambre",
 "Ex.: Disponível · Em aula até 18h · Bora viajar!": "Ex. : Disponible · En cours jusqu'à 18 h · En route pour le voyage !",
 "Ex.: Eletricista, loja de material": "Ex. : Électricien, magasin de bricolage",
 "Ex.: Entrada dos noivos": "Ex. : Entrée des mariés",
 "Ex.: Financiamento do carro": "Ex. : Crédit auto",
 "Ex.: Fisioterapeuta, Nutricionista, Cardiologista": "Ex. : Kinésithérapeute, Nutritionniste, Cardiologue",
 "Ex.: Furadeira, livro, R$ 200": "Ex. : Perceuse, livre, 200 €",
 "Ex.: Hemograma": "Ex. : Hémogramme",
 "Ex.: IPVA 2027, parcela 1": "Ex. : IPVA 2027, échéance 1",
 "Ex.: Lisboa, Portugal": "Ex. : Lisbonne, Portugal",
 "Ex.: Mala da Ana": "Ex. : Valise d'Ana",
 "Ex.: Mensalidade de outubro, material": "Ex. : Mensualité d'octobre, fournitures",
 "Ex.: Netflix, cinema": "Ex. : Netflix, cinéma",
 "Ex.: Notas de compra de setembro": "Ex. : Factures d'achat de septembre",
 "Ex.: Onix 2022": "Ex. : Clio 2022",
 "Ex.: Prova 1, Trabalho em grupo": "Ex. : Contrôle 1, travail de groupe",
 "Ex.: Prova de matemática": "Ex. : Contrôle de maths",
 "Ex.: Pôr do sol no Tejo": "Ex. : Coucher de soleil sur le Tage",
 "Ex.: Reforma da cozinha": "Ex. : Rénovation de la cuisine",
 "Ex.: TAP TP 108": "Ex. : TAP TP 108",
 "Ex.: Torre de Belém": "Ex. : Tour de Belém",
 "Ex.: Troca da fiação da sala": "Ex. : Refaire l'électricité du salon",
 "Ex.: V10, antirrábica": "Ex. : CHPPiL, antirabique",
 "Ex.: Visita ao Mosteiro dos Jerónimos": "Ex. : Visite du monastère des Hiéronymites",
 "Ex.: cerâmica 30 cm": "Ex. : carrelage 30 cm",
 "Ex.: kg, pacotes, latas": "Ex. : kg, paquets, boîtes",
 "Ex.: seg e qua, 07:30": "Ex. : lun et mer, 07:30",
 "Ex.: troquei o arroz por batata doce": "Ex. : j'ai remplacé le riz par de la patate douce",
 "Ex.: varanda, sala": "Ex. : balcon, salon",
 "Exame": "Examen",
 "Exame da OAB": "Examen de l'OAB",
 "Exames": "Examens",
 "Excel": "Excel",
 "Excluir": "Supprimer",
 "Excluir \"{nome}\"?": "Supprimer « {nome} » ?",
 "Excluir \"{titulo}\"?": "Supprimer « {titulo} » ?",
 "Excluir a caixa?": "Supprimer la boîte ?",
 "Excluir a compra": "Supprimer l'achat",
 "Excluir a compra?": "Supprimer l'achat ?",
 "Excluir a meta \"{m}\"?": "Supprimer l'objectif « {m} » ?",
 "Excluir cartão": "Supprimer la carte",
 "Excluir conta": "Supprimer la facture",
 "Excluir cuidado": "Supprimer le soin",
 "Excluir cômodo": "Supprimer la pièce",
 "Excluir esta página?": "Supprimer cette page ?",
 "Excluir fichário": "Supprimer le classeur",
 "Excluir matéria": "Supprimer la matière",
 "Excluir o cartão \"{c}\"?": "Supprimer la carte « {c} » ?",
 "Excluir o documento": "Supprimer le document",
 "Excluir o fichário {nome}": "Supprimer le classeur {nome}",
 "Excluir página": "Supprimer la page",
 "Excluir refeição": "Supprimer le repas",
 "Excluir suplemento": "Supprimer le complément",
 "Excluir tarefa": "Supprimer la tâche",
 "Excluir tarefa repetida": "Supprimer la tâche récurrente",
 "Excluir tarefa?": "Supprimer la tâche ?",
 "Excluir treino": "Supprimer la séance",
 "Excluir {nome}?": "Supprimer {nome} ?",
 "Excluídas em definitivo 30 dias depois do descarte.": "Supprimées définitivement 30 jours après leur mise au rebut.",
 "Executivo e profissional": "Cadre et professionnel",
 "Execução do contrato (art. 7º, V), para entregar o serviço; consentimento (art. 7º, I), para câmera, galeria, microfone e localização; cumprimento de obrigação legal (art. 7º, II); e legítimo interesse (art. 7º, IX), para segurança e prevenção de fraudes.": "Exécution du contrat (art. 7º, V), pour fournir le service ; consentement (art. 7º, I), pour l'appareil photo, la galerie, le micro et la localisation ; respect d'une obligation légale (art. 7º, II) ; et intérêt légitime (art. 7º, IX), pour la sécurité et la prévention des fraudes.",
 "Exemplos: 13:30, 1330, 9:05": "Exemples : 13:30, 1330, 9:05",
 "Exercício": "Exercice",
 "Exercício físico": "Activité physique",
 "Experimente grátis por {n} dias": "Essayez gratuitement pendant {n} jours",
 "Explique o motivo (para cancelar)": "Expliquez le motif (pour annuler)",
 "Exportar arquivo": "Exporter un fichier",
 "Exportar para o contador": "Exporter pour le comptable",
 "Extrair páginas": "Extraire des pages",
 "Extras (pet, check-in tardio...)": "Suppléments (animal, arrivée tardive...)",
 "Extrato": "Relevé bancaire",
 "Extrato bancário": "Relevé bancaire",
 "Extrato do banco (foto ou PDF)": "Relevé bancaire (photo ou PDF)",
 "Extrato importado": "Relevé importé",
 "Extrato por foto": "Relevé par photo",
 "FRASE": "STATUT",
 "FRÁGIL": "FRAGILE",
 "Fabricante ou estendida: {n} meses": "Fabricant ou extension : {n} mois",
 "Facultativo": "Facultatif",
 "Falar com a limpeza": "Contacter le ménage",
 "Fale conosco": "Nous contacter",
 "Falta": "Absent",
 "Falta XML": "XML manquant",
 "Falta ligar o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar.": "Le serveur de factures n'est pas encore lancé : sur l'ordinateur, double-cliquez sur 13-LIGAR-NOTAS.bat et collez ici l'adresse qu'il affiche.",
 "Falta o Health Connect, o app do Google que junta os dados dos relógios e apps de saúde.": "Health Connect est absent : c'est l'app de Google qui regroupe les données des montres et des apps santé.",
 "Faltam": "À voir",
 "Faltam {ml} ({n} copo(s))": "Encore {ml} ({n} verre(s))",
 "Faltam {n} dia(s) do seu período grátis": "Il reste {n} jour(s) de votre période gratuite",
 "Faltam {n} dias": "Encore {n} jours",
 "Faltou": "Absent",
 "Família": "Famille",
 "Fantasia": "Fantasy",
 "Fatura": "Relevé",
 "Fatura com vencimento em {d}.": "Relevé à échéance le {d}.",
 "Fatura de {mes}": "Relevé de {mes}",
 "Fatura de {mes}: vence {data}": "Relevé de {mes} : échéance le {data}",
 "Fatura do cartão (foto ou PDF)": "Relevé de carte (photo ou PDF)",
 "Fatura importada": "Relevé importé",
 "Fatura paga (toque para desfazer)": "Relevé payé (touchez pour annuler)",
 "Fatura {c}": "Relevé {c}",
 "Faturamento em {ano}: {v} de {lim}": "Chiffre d'affaires {ano} : {v} sur {lim}",
 "Faturas dos cartões": "Relevés des cartes",
 "Fazer agora, passo a passo": "Faire maintenant, étape par étape",
 "Fazer com este PDF": "Que faire avec ce PDF",
 "Fazer cópia agora": "Sauvegarder maintenant",
 "Fecha dia {f} · vence dia {v}": "Clôture le {f} · échéance le {v}",
 "Fecha {f} · vence {v}": "Clôture {f} · échéance {v}",
 "Fechar": "Fermer",
 "Fechar o cofre": "Fermer le coffre",
 "Feche e abra o app de novo": "Fermez puis rouvrez l'app",
 "Federais": "Fédéraux",
 "Feijão": "Haricots",
 "Feita em {data}": "Faite le {data}",
 "Feita hoje": "Faite aujourd'hui",
 "Feitas": "Faites",
 "Feitas (não se repetem) · {n}": "Faites (non récurrentes) · {n}",
 "Feito": "Fait",
 "Feito!": "Fait !",
 "Feliz aniversário": "Joyeux anniversaire",
 "Feminino": "Féminin",
 "Feminino e suave": "Féminin et doux",
 "Feriado escolar": "Vacances scolaires",
 "Feriado estadual": "Jour férié d'État",
 "Feriado estadual: {nome}": "Jour férié de l'État : {nome}",
 "Feriado municipal": "Jour férié municipal",
 "Feriado municipal: {nome}": "Jour férié municipal : {nome}",
 "Feriado nacional": "Jour férié national",
 "Feriado nacional: {nome}": "Jour férié national : {nome}",
 "Feriado regional": "Jour férié régional",
 "Feriado regional: {nome}": "Jour férié régional : {nome}",
 "Feriados": "Jours fériés",
 "Feriados nacionais": "Jours fériés nationaux",
 "Feriados no planner": "Jours fériés dans le planner",
 "Feriados, cotações, sugestões da inteligência artificial e leituras automáticas de boletos e notas podem ter erros. Confira antes de usar.": "Les jours fériés, les cours de change, les suggestions de l'intelligence artificielle et la lecture automatique des boletos et des factures peuvent contenir des erreurs. Vérifiez avant de les utiliser.",
 "Ferramenta": "Outil",
 "Ferramentas": "Outils",
 "Ficha de cada planta, replantio e calendário de rega e adubo na agenda.": "Fiche de chaque plante, rempotage et calendrier d'arrosage et d'engrais dans l'agenda.",
 "Ficha preenchida": "Fiche remplie",
 "Fichários, matérias e páginas, cronômetro de estudo e metas por semana.": "Classeurs, matières et pages, chronomètre d'étude et objectifs hebdomadaires.",
 "Ficção": "Fiction",
 "Figurinha": "Sticker",
 "Figurinhas": "Stickers",
 "Filme": "Film",
 "Filme ou série": "Film ou série",
 "Filmes e séries": "Films et séries",
 "Filosofia": "Philosophie",
 "Filtros": "Filtres",
 "Fim": "Fin",
 "Fim (vazio = uso contínuo)": "Fin (vide = traitement continu)",
 "Fim da garantia": "Fin de la garantie",
 "Fim da garantia:": "Fin de la garantie :",
 "Fim da pausa. Continue: {tarefa}": "Fin de la pause. Reprenez : {tarefa}",
 "Fim de semana": "Week-end",
 "Fim previsto": "Fin prévue",
 "Fina": "Fin",
 "Finados": "Jour des Morts",
 "Finalizador": "Produit de finition",
 "Financeiro": "Finances",
 "Financeiro: {gasto} de {orcado} ({p}%)": "Financier : {gasto} sur {orcado} ({p} %)",
 "Financiamento": "Financement",
 "Financiamento de veículo": "Crédit auto",
 "Financiamento imobiliário": "Crédit immobilier",
 "Financiamentos": "Financements",
 "Financiamentos e empréstimos": "Financements et prêts",
 "Financiamentos e empréstimos com parcelas, juros, saldo devedor e comprovantes; objetos emprestados com foto e aviso da devolução.": "Financements et prêts avec échéances, intérêts, capital restant dû et justificatifs ; objets prêtés avec photo et rappel de retour.",
 "Finanças": "Finance",
 "Finanças {p}": "Finance {p}",
 "Finanças · {p}": "Finance · {p}",
 "Fins de semana": "Week-ends",
 "Fio dental": "Fil dentaire",
 "Flex": "Flex",
 "Flexão de braço": "Pompes",
 "Flor": "Fleur",
 "Flutua": "Flotte",
 "Foguete": "Fusée",
 "Fogão": "Cuisinière",
 "Foi no cartão de crédito? Lançar como compra no cartão": "C'était par carte de crédit ? L'ajouter comme achat par carte",
 "Foi para {destino}.": "Envoyé vers {destino}.",
 "Foi para {destino}. Quer tirar daqui?": "Envoyé vers {destino}. Le retirer d'ici ?",
 "Folha de pagamento": "Paie",
 "Fone": "Écouteur",
 "Fone de ouvido": "Écouteurs",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados e das leis de cada estado. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no aparelho.": "Sources : Brésil, calculé dans l'app à partir de l'arrêté fédéral sur les jours fériés et des lois de chaque État. Autres pays : base publique Nager.Date (date.nager.at), téléchargée par internet et conservée sur l'appareil.",
 "Fontes: Brasil, calculado no app a partir da portaria federal de feriados, das leis de cada estado e dos calendários oficiais das capitais. Outros países: base pública Nager.Date (date.nager.at), baixada pela internet e guardada no dispositivo.": "Sources : Brésil, calculé dans l'app à partir de l'arrêté fédéral sur les jours fériés, des lois de chaque État et des calendriers officiels des capitales. Autres pays : base publique Nager.Date (date.nager.at), téléchargée par internet et conservée sur l'appareil.",
 "Forma": "Mode",
 "Forma das parcelas": "Type d'échéances",
 "Forma de pagamento": "Mode de paiement",
 "Forma de pagamento: {f}.": "Mode de paiement : {f}.",
 "Formas": "Formes",
 "Formato": "Format",
 "Formatos": "Formats",
 "Formatura": "Remise de diplôme",
 "Fornecedor": "Prestataire",
 "Fornecedores": "Prestataires",
 "Forte": "Forte",
 "Foto": "Photo",
 "Foto da galeria": "Photo de la galerie",
 "Foto do contato": "Photo du contact",
 "Foto inteira": "Photo entière",
 "Foto ou PDF (lido pela sua IA)": "Photo ou PDF (lu par votre IA)",
 "Fotografe cada cômodo na vistoria de saída e na de entrada. As fotos protegem você na hora de devolver o imóvel.": "Photographiez chaque pièce lors de l'état des lieux de sortie et d'entrée. Les photos vous protègent au moment de rendre le logement.",
 "Fotografe cada recibo de médico, dentista, escola e previdência assim que pagar. No fim do ano está tudo pronto.": "Photographiez chaque reçu de médecin, dentiste, école et retraite dès le paiement. En fin d'année, tout est prêt.",
 "Fotos": "Photos",
 "Fotos JPG, PNG e outras viram um PDF.": "Les photos JPG, PNG et autres deviennent un PDF.",
 "Fotos de {d}": "Photos du {d}",
 "Fotos do espaço pronto": "Photos du logement prêt",
 "Fotos e arquivos desta ficha também vão para a pasta do grupo, para quem participa abrir.": "Les photos et fichiers de cette fiche vont aussi dans le dossier du groupe, pour que les participants puissent les ouvrir.",
 "Fotos e arquivos ficam guardados só neste dispositivo. Os dados do documento vão para a sua conta, protegidos.": "Les photos et fichiers restent uniquement sur cet appareil. Les données du document sont enregistrées sur votre compte, protégées.",
 "Fotos e arquivos ficam neste dispositivo (e no seu Drive ou OneDrive, se estiver ligado em Ajustes).": "Les photos et fichiers restent sur cet appareil (et dans votre Drive ou OneDrive, s'il est activé dans Réglages).",
 "Fotos e notas": "Photos et notes",
 "Fotos e vídeos": "Photos et vidéos",
 "Fotos, arquivos e links": "Photos, fichiers et liens",
 "Fraldas e lenços": "Couches et lingettes",
 "Francês": "Français",
 "Frango com osso": "Poulet avec os",
 "Frango sem osso": "Poulet désossé",
 "Frase (opcional, ex.: Bom dia!)": "Phrase (facultatif, ex. : Bonjour !)",
 "Freelancer & Projetos": "Freelance & Projets",
 "Freezer": "Congélateur",
 "Freios": "Freins",
 "Frente": "Recto",
 "Frente do documento": "Recto du document",
 "Frente e verso na mesma folha": "Recto verso sur la même feuille",
 "Frente pronta": "Recto terminé",
 "Frequência": "Fréquence",
 "Frio": "Froid",
 "Fruta": "Fruit",
 "Frágil": "Fragile",
 "Fundação e estrutura": "Fondations et structure",
 "Fundo": "Fond",
 "Fundos e renda fixa": "Fonds et obligations",
 "Fuso": "Fuseau",
 "Fuso horário": "Fuseau horaire",
 "Fuso horário do destino": "Fuseau horaire de la destination",
 "Futebol": "Football",
 "Física": "Physique",
 "Físico (obra pronta): {p}%": "Physique (avancement) : {p} %",
 "GASTOS POR CATEGORIA": "DÉPENSES PAR CATÉGORIE",
 "GIF guardado nos seus GIFs.": "GIF enregistré dans vos GIF.",
 "Garagem": "Garage",
 "Garantia": "Garantie",
 "Garantia até {data}.": "Garantie jusqu'au {data}.",
 "Garantia legal": "Garantie légale",
 "Garantia vencendo": "Garantie bientôt expirée",
 "Garantias": "Garanties",
 "Garrafa de água": "Gourde",
 "Gasolina": "Essence",
 "Gasto": "Dépense",
 "Gasto até agora": "Dépensé jusqu'ici",
 "Gasto de {v} lançado. {n} preço(s) guardado(s) para a sua lista de compras.": "Dépense de {v} ajoutée. {n} prix enregistré(s) pour votre liste de courses.",
 "Gasto neste mês: {v}": "Dépensé ce mois-ci : {v}",
 "Gasto: {v}": "Dépensé : {v}",
 "Gastos": "Dépenses",
 "Gastos por categoria": "Dépenses par catégorie",
 "Gato": "Chat",
 "Geladeira": "Réfrigérateur",
 "Geografia": "Géographie",
 "Gerado por": "Produit par",
 "Gerando QR Code...": "Génération du QR code...",
 "Gerar PDF": "Générer le PDF",
 "Gerar as cobranças do mês": "Créer les paiements du mois",
 "Gerar as parcelas": "Créer les échéances",
 "Gerar lista da mala": "Générer la liste de la valise",
 "Gerar pelo cardápio e pela despensa": "Générer depuis le menu et le garde-manger",
 "Gesso e forro": "Plâtre et faux plafond",
 "Gira todas as páginas ou só as escolhidas.": "Fait pivoter toutes les pages ou seulement celles choisies.",
 "Girar": "Pivoter",
 "Google Drive e OneDrive": "Google Drive et OneDrive",
 "Google Drive, OneDrive e agenda do Google: só se você conectar, e só para guardar os seus arquivos e eventos.": "Google Drive, OneDrive et Google Agenda : seulement si vous les connectez, et uniquement pour conserver vos fichiers et événements.",
 "Gorro, cachecol e luvas": "Bonnet, écharpe et gants",
 "Gota": "Goutte",
 "Graduação e Pós": "Licence et Master",
 "Grande": "Grande",
 "Gravando": "Enregistrement",
 "Gravar lembretes e anotações por voz quando você pedir. O microfone só liga com o seu toque.": "Enregistrer des rappels et des notes vocales quand vous le demandez. Le micro ne s'active que sur votre action.",
 "Gravar reunião": "Enregistrer la réunion",
 "Gravação de áudio": "Enregistrement audio",
 "Gravações das reuniões": "Enregistrements des réunions",
 "Grossa": "Épais",
 "Grupo": "Groupe",
 "Grupo com convite (turma, equipe, convidados)": "Groupe sur invitation (classe, équipe, invités)",
 "Grupo criado": "Groupe créé",
 "Grupo da família": "Groupe de la famille",
 "Grupo da mudança (família e ajudantes)": "Groupe du déménagement (famille et aides)",
 "Grupo da obra (equipe)": "Groupe du chantier (équipe)",
 "Grupo da turma (convidar alunos)": "Groupe de la classe (inviter les élèves)",
 "Grupo da viagem (convidar quem vai)": "Groupe du voyage (inviter les participants)",
 "Grupo de cuidado (família ou profissional)": "Groupe de soins (famille ou professionnel)",
 "Grupo de estudos (convidar colegas)": "Groupe d'étude (inviter des camarades)",
 "Grupo de leitura (convidar)": "Groupe de lecture (inviter)",
 "Grupo do cliente": "Groupe du client",
 "Grupo do evento (convidar)": "Groupe de l'événement (inviter)",
 "Grupos": "Groupes",
 "Grupos de estudo": "Groupes d'étude",
 "Grupos de {aba}": "Groupes de {aba}",
 "Grupos desta aba: {n}": "Groupes de cet onglet : {n}",
 "Grupos e convites": "Groupes et invitations",
 "Grátis no lançamento": "Gratuit au lancement",
 "Guarda-chuva": "Parapluie",
 "Guardada nas suas figurinhas.": "Enregistré dans vos stickers.",
 "Guardado": "Épargné",
 "Guardado até agora: {v}": "Épargné jusqu'ici : {v}",
 "Guardado em outro dispositivo": "Enregistré sur un autre appareil",
 "Guardado na pasta \"{pasta}\" do celular.": "Enregistré dans le dossier \"{pasta}\" du téléphone.",
 "Guardado no cofre, com criptografia de ponta a ponta.": "Rangé dans le coffre, avec chiffrement de bout en bout.",
 "Guardado no {nome}.": "Enregistré sur {nome}.",
 "Guardado {onde} em {quando}": "Enregistré {onde} le {quando}",
 "Guardando...": "Enregistrement...",
 "Guardar": "Épargner",
 "Guardar como recibo do IR": "Enregistrer comme reçu d'impôt (IR)",
 "Guardar dinheiro": "Épargner",
 "Guardar e enviar": "Enregistrer et envoyer",
 "Guardar na meta": "Verser dans l'objectif",
 "Guardar nas minhas figurinhas": "Enregistrer dans mes stickers",
 "Guardar nos meus GIFs": "Enregistrer dans mes GIF",
 "Guardar o PDF {onde}": "Enregistrer le PDF {onde}",
 "Guardar os PDFs em": "Enregistrer les PDF dans",
 "Guardar os arquivos prontos em": "Enregistrer les fichiers terminés dans",
 "Guardar sozinho cada arquivo pronto": "Enregistrer automatiquement chaque fichier terminé",
 "Guarde as prescrições e orientações que você usa sempre. No atendimento, toque em ⋮ › Usar modelo.": "Enregistrez les prescriptions et consignes que vous utilisez souvent. Dans le rendez-vous, touchez ⋮ › Utiliser un modèle.",
 "Guarde seus documentos num lugar só": "Rangez tous vos documents au même endroit",
 "Guarde {v} por mês até {d}": "Épargnez {v} par mois jusqu'au {d}",
 "Guardou": "Épargne",
 "Guia de imposto": "Avis de paiement d'impôt",
 "Gás": "Gaz",
 "Gênero ou categoria": "Genre ou catégorie",
 "HISTÓRICO DOS DADOS": "HISTORIQUE DES DONNÉES",
 "HOJE": "AUJOURD'HUI",
 "Hall de entrada": "Entrée",
 "Halteres": "Haltères",
 "Hexágono": "Hexagone",
 "Hidratante": "Hydratant",
 "Hidratante labial": "Baume à lèvres",
 "Hidráulica": "Plomberie",
 "Higiene bucal": "Hygiène bucco-dentaire",
 "Higienizar": "Nettoyer",
 "História": "Histoire",
 "Histórico": "Historique",
 "Histórico da família, exames protegidos, vacinas, consultas e alarme dos remédios na linha do tempo.": "Antécédents familiaux, examens protégés, vaccins, consultations et alarme des médicaments dans la chronologie.",
 "Hmm...": "Hmm...",
 "Hoje": "Aujourd'hui",
 "Hoje: {a} de {m} aulas ({p}%)": "Aujourd'hui : {a} sur {m} cours ({p}%)",
 "Hoje: {n} página(s)": "Aujourd'hui : {n} page(s)",
 "Hora": "Heure",
 "Hora da pausa": "C'est l'heure de la pause",
 "Hora de voltar": "C'est l'heure de reprendre",
 "Hora de voltar!": "C'est l'heure de reprendre !",
 "Hora do check-in": "Heure d'arrivée",
 "Hora do check-out": "Heure de départ",
 "Horas": "Heures",
 "Horas de sono": "Heures de sommeil",
 "Horário": "Heure",
 "Horário de check-in": "Horaire d'arrivée",
 "Horário de check-out": "Horaire de départ",
 "Horário do lembrete": "Heure du rappel",
 "Horário inválido": "Heure invalide",
 "Horário ocupado": "Créneau occupé",
 "Horários": "Horaires",
 "Horários (remédio diário)": "Horaires (médicament quotidien)",
 "Hospedados agora": "Sur place",
 "Hospedagem": "Hébergement",
 "Hospital ou pronto-socorro de referência": "Hôpital ou urgences de référence",
 "Hotel": "Hôtel",
 "Há uma versão nova do My Planner Web. Recarregue para usar.": "Une nouvelle version de My Planner Web est disponible. Rechargez pour l'utiliser.",
 "Híbrido": "Hybride",
 "Hóspede": "Voyageur",
 "Hóspede ({c})": "Voyageur ({c})",
 "Hóspedes (máximo)": "Voyageurs (max.)",
 "IA ligada": "IA activée",
 "IA não ligada": "IA non activée",
 "IA não ligada. Ligue em Ajustes › Inteligência artificial.": "IA non activée. Activez-la dans Réglages › Intelligence artificielle.",
 "IPVA": "IPVA",
 "ISS": "ISS",
 "ISS %": "ISS %",
 "ISS retido pelo tomador": "ISS retenu par le client",
 "Ida": "Aller",
 "Identidade": "Pièce d'identité",
 "Idioma": "Langue",
 "Idiomas": "Langues",
 "Ilimitados": "Illimités",
 "Imagem": "Image",
 "Imagem escolhida (trocar)": "Image choisie (changer)",
 "Imagem guardada no {nome}. Toque para abrir.": "Image enregistrée sur {nome}. Touchez pour l'ouvrir.",
 "Imagens para PDF": "Images en PDF",
 "Imagens {data}": "Images {data}",
 "Imperdíveis": "Incontournables",
 "Imperdível": "Incontournable",
 "Importar": "Importer",
 "Importar XML de nota": "Importer le XML d'une facture",
 "Importar arquivo": "Importer un fichier",
 "Importar backup?": "Importer la sauvegarde ?",
 "Importar extrato": "Importer un relevé",
 "Importar extrato do banco (OFX ou CSV)": "Importer un relevé bancaire (OFX ou CSV)",
 "Importar fatura": "Importer un relevé",
 "Importar fotos": "Importer des photos",
 "Importar reservas do Airbnb, Booking...": "Importer les réservations Airbnb, Booking...",
 "Importar {n} lançamento(s)": "Importer {n} écriture(s)",
 "Imóveis e espaços": "Logements et espaces",
 "Imóvel": "Bien immobilier",
 "Imóvel inteiro": "Logement entier",
 "Imóvel inteiro ou por cômodo: reservas do Airbnb, Booking ou direto, limpeza no check-out, despesas, ocupação e lucro do mês.": "Logement entier ou par chambre : réservations Airbnb, Booking ou en direct, ménage au départ, dépenses, occupation et bénéfice du mois.",
 "Inclui {v} das notas fiscais emitidas na aba Notas Fiscais.": "Inclut {v} des factures émises dans l'onglet Factures.",
 "Independência do Brasil": "Indépendance du Brésil",
 "Indicação": "Recommandation",
 "Indique e ganhe": "Parrainez et gagnez",
 "Indique o My Planner para amigos e família. Quem criar a conta com o seu código ganha 10 dias com todas as abas liberadas.": "Recommandez My Planner à vos amis et à votre famille. Toute personne qui crée un compte avec votre code profite de 10 jours avec tous les onglets débloqués.",
 "Infantil": "Jeunesse",
 "Informações do PDF": "Infos du PDF",
 "Informe a descrição e o valor.": "Indiquez la description et le montant.",
 "Informe de quantos em quantos dias regar ou adubar.": "Indiquez tous les combien de jours arroser ou mettre de l'engrais.",
 "Informe o nome do produto.": "Indiquez le nom du produit.",
 "Informe o rótulo e o nome.": "Indiquez le libellé et le nom.",
 "Informe o total de aulas da matéria em Editar.": "Indiquez le nombre total de cours de la matière dans Modifier.",
 "Informe o valor.": "Indiquez le montant.",
 "Informe os horários": "Indiquez les horaires",
 "Informe quanto quer juntar.": "Indiquez combien vous voulez mettre de côté.",
 "Informe seu nome.": "Indiquez votre nom.",
 "Informática": "Informatique",
 "Inglês": "Anglais",
 "Ingredientes (um por linha)": "Ingrédients (un par ligne)",
 "Inscrição municipal (se tiver)": "Immatriculation municipale (le cas échéant)",
 "Inspeção": "Contrôle technique",
 "Instalar ou atualizar o Health Connect": "Installer ou mettre à jour Health Connect",
 "Instruções, receita, observações...": "Instructions, recette, remarques...",
 "Insumos (papel, sabonete, café)": "Consommables (papier, savon, café)",
 "Inteligência artificial": "Intelligence artificielle",
 "Inteligência artificial (Claude, ChatGPT ou Gemini): só se você ligar, com a sua própria chave, que fica apenas no dispositivo. O texto da pergunta vai direto para o serviço escolhido.": "Intelligence artificielle (Claude, ChatGPT ou Gemini) : seulement si vous l'activez, avec votre propre clé, qui reste uniquement sur l'appareil. Le texte de la question est envoyé directement au service choisi.",
 "Intensidade": "Intensité",
 "Internação": "Hospitalisation",
 "Internet": "Internet",
 "Intimação": "Notification judiciaire",
 "Intimação com prazo": "Notification avec délai",
 "Investimento": "Investissement",
 "Investimentos": "Investissements",
 "Início": "Début",
 "Início {ini} · Fim {fim} · Duração {dur}": "Début {ini} · Fin {fim} · Durée {dur}",
 "Iogurte": "Yaourt",
 "Ir para Ajustes (exportar meus dados)": "Aller aux Réglages (exporter mes données)",
 "Ir para hoje": "Aller à aujourd'hui",
 "Ir para o My Planner Web": "Aller sur My Planner Web",
 "Italiano": "Italien",
 "Item": "Élément",
 "Item da despensa": "Article du garde-manger",
 "Item protegido: fotos e arquivos ficam criptografados no cofre, só neste dispositivo (não vão para o Drive ou OneDrive).": "Élément protégé : les photos et fichiers sont chiffrés dans le coffre, sur cet appareil uniquement (ils ne vont pas sur Drive ni OneDrive).",
 "Itens": "Articles",
 "Itens de higiene (xampu, sabonete)": "Produits d'hygiène (shampoing, savon)",
 "Jantar": "Dîner",
 "Japonês": "Japonais",
 "Jaqueta impermeável": "Veste imperméable",
 "Jogo": "Jeu",
 "Jovem e divertido": "Jeune et fun",
 "Juntar PDFs": "Fusionner des PDF",
 "Juros": "Intérêts",
 "Juros ainda por vir: {v}": "Intérêts restants : {v}",
 "Juros ao mês": "Taux mensuel",
 "JÁ RESPONDIDOS": "DÉJÀ RÉPONDUS",
 "Já aberta na casa nova": "Déjà ouvert dans le nouveau logement",
 "Já enviado para a turma": "Déjà envoyé à la classe",
 "Já está compacto": "Déjà compact",
 "Já está no Planner": "Déjà dans le Planner",
 "Já está pago": "Déjà payé",
 "Já há horários deste item no My Planner": "Cet élément a déjà des horaires dans My Planner",
 "Já pago: {v}": "Déjà payé : {v}",
 "Já tenho o app: abrir nele": "J'ai déjà l'app : l'ouvrir",
 "Já tenho o app: abrir o convite nele": "J'ai déjà l'app : y ouvrir l'invitation",
 "Já visitei": "Déjà visité",
 "Kit de primeiros socorros": "Trousse de premiers secours",
 "Kkkk": "Mdr",
 "Kkkkk": "Mdrrr",
 "Km de hoje no painel": "Km au compteur aujourd'hui",
 "Km no dia": "Km ce jour-là",
 "Km no painel": "Km au compteur",
 "LANÇAMENTOS": "ÉCRITURES",
 "LINHA DO TEMPO": "CHRONOLOGIE",
 "Laboratório": "Laboratoire",
 "Lanche": "Collation",
 "Lanche da manhã": "Collation du matin",
 "Lanche da tarde": "Goûter",
 "Lanches e água": "En-cas et eau",
 "Lançamentos": "Opérations",
 "Lavanderia": "Buanderie",
 "Lavanderia, insumos, manutenção, contas e taxas. Entram no lucro do mês.": "Blanchisserie, consommables, entretien, factures et frais. Ils comptent dans le bénéfice du mois.",
 "Lavar o rosto com sabonete facial": "Se laver le visage avec un nettoyant",
 "Lazer": "Loisirs",
 "Leg press": "Presse à cuisses",
 "Legenda": "Légende",
 "Legislação Específica": "Législation spécifique",
 "Legumes": "Légumes",
 "Leia hoje para começar uma sequência": "Lisez aujourd'hui pour démarrer une série",
 "Leite": "Lait",
 "Leitura": "Lecture",
 "Leitura automática do texto": "Lecture automatique du texte",
 "Leitura da IA": "Lecture par l'IA",
 "Leitura, Cursos & Mídia": "Lecture, Formations & Médias",
 "Lembrete": "Rappel",
 "Lembrete de hoje": "Rappel du jour",
 "Lembrete de renovação no Planner": "Rappel de renouvellement dans le Planner",
 "Lembrete no Planner": "Rappel dans le Planner",
 "Lembrete no planner": "Rappel dans le planner",
 "Lembrete pelo WhatsApp": "Rappel par WhatsApp",
 "Lembrete: começa às {hora}": "Rappel : commence à {hora}",
 "Lemos todas as mensagens. Se precisar, respondemos pelo seu e-mail.": "Nous lisons tous les messages. Si nécessaire, nous vous répondons par e-mail.",
 "Lendo": "En lecture",
 "Lendo a fatura...": "Lecture du relevé...",
 "Lendo a página": "Lecture de la page",
 "Lendo o boleto...": "Lecture du boleto...",
 "Lendo o cupom...": "Lecture du ticket...",
 "Lendo o documento...": "Lecture du document...",
 "Lendo o extrato...": "Lecture du relevé bancaire...",
 "Lendo o relógio...": "Lecture de la montre...",
 "Lendo o texto": "Lecture du texte",
 "Ler a fatura": "Lire le relevé",
 "Ler a publicação inteira": "Lire la publication entière",
 "Ler com a minha IA": "Lire avec mon IA",
 "Ler de novo": "Relire",
 "Ler de novo agora": "Relire maintenant",
 "Ler o texto": "Lire le texte",
 "Ler o texto completo": "Lire le texte complet",
 "Ler publicação inteira": "Lire la publication entière",
 "Ler sozinho as publicações novas": "Lire automatiquement les nouvelles publications",
 "Leve": "Légère",
 "Leve (sem perder qualidade)": "Léger (sans perte de qualité)",
 "Li e aceito os termos e a política de privacidade": "J'ai lu et j'accepte les conditions et la politique de confidentialité",
 "Li mais {n} páginas": "J'ai lu {n} pages de plus",
 "Liberada pelo suporte": "Débloqué par le support",
 "Liberar para a equipe": "Partager avec l'équipe",
 "Liberar para a turma em": "Publier pour la classe le",
 "Liberar para o grupo": "Débloquer pour le groupe",
 "Liberações e créditos são vinculados ao seu CPF. Atualiza ao sincronizar.": "Les déblocages et crédits sont liés à votre CPF. Mis à jour lors de la synchronisation.",
 "Libere a câmera para o My Planner nas configurações do celular para ler o QR Code.": "Autorisez l'appareil photo pour My Planner dans les réglages du téléphone pour lire le QR code.",
 "Libere a câmera para o My Planner nas configurações do celular.": "Autorisez l'accès à l'appareil photo pour My Planner dans les réglages du téléphone.",
 "Libere outras abas em Ajustes › Compras.": "Débloquez d'autres onglets dans Réglages › Achats.",
 "Licenciamento": "Immatriculation",
 "Lidas hoje": "Lues aujourd'hui",
 "Lido": "Lu",
 "Ligando. Toque para atender.": "Appel en cours. Touchez pour répondre.",
 "Ligar": "Appeler",
 "Ligar certificado": "Connecter le certificat",
 "Ligar para a assistência": "Appeler le SAV",
 "Ligar para {nome}": "Appeler {nome}",
 "Ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini) para usar esta ferramenta.": "Activez votre IA dans Réglages › Intelligence artificielle (Claude, ChatGPT ou Gemini) pour utiliser cet outil.",
 "Ligue a sua IA em Ajustes › Inteligência artificial para ler o texto, resumir e perguntar sobre o documento.": "Activez votre IA dans Réglages › Intelligence artificielle pour lire le texte, le résumer et poser des questions sur le document.",
 "Ligue a sua IA em Ajustes › Inteligência artificial.": "Activez votre IA dans Réglages › Intelligence artificielle.",
 "Ligue o certificado A1 da empresa primeiro.": "Connectez d'abord le certificat A1 de l'entreprise.",
 "Ligue o seu Google Drive ou OneDrive para guardar fotos e arquivos (que passam a abrir em qualquer dispositivo) e para ter cópias de segurança completas.": "Connectez votre Google Drive ou OneDrive pour stocker photos et fichiers (accessibles ensuite sur n'importe quel appareil) et disposer de sauvegardes complètes.",
 "Ligue para o grupo trabalhar nos mesmos dados (obra, viagem, turma, imóvel, consultório), cada pessoa com o seu papel.": "Activez-le pour que le groupe travaille sur les mêmes données (chantier, voyage, classe, logement, cabinet), chacun avec son rôle.",
 "Ligue pelo menos 4 pontos.": "Reliez au moins 4 points.",
 "Limite anual editável em Ajustes › Abas › Aba Finanças. Confira sempre com o seu contador.": "Plafond annuel modifiable dans Réglages › Onglets › Onglet Finance. Vérifiez toujours avec votre comptable.",
 "Limite de consultas atingido. Tente de novo em 1 minuto.": "Limite de requêtes atteinte. Réessayez dans 1 minute.",
 "Limite de energia por dia": "Limite d'énergie par jour",
 "Limite de faturamento anual do MEI (confira o valor vigente com o seu contador).": "Plafond de chiffre d'affaires annuel du MEI (vérifiez le montant en vigueur avec votre comptable).",
 "Limite de mensagens por hoje atingido. Tente amanhã.": "Limite de messages atteinte pour aujourd'hui. Réessayez demain.",
 "Limite diário": "Limite quotidienne",
 "Limite livre: {v} de {l}": "Plafond disponible : {v} sur {l}",
 "Limite total (opcional)": "Plafond total (facultatif)",
 "Limpar": "Effacer",
 "Limpar a agenda": "Vider l'agenda",
 "Limpar banheiro": "Nettoyer la salle de bain",
 "Limpar cozinha e louça": "Nettoyer cuisine et vaisselle",
 "Limpar feitos": "Effacer les terminés",
 "Limpeza": "Ménage",
 "Limpeza após {h}": "Ménage après {h}",
 "Limpeza final": "Nettoyage final",
 "Limpeza · {e}": "Ménage · {e}",
 "Limpeza: {e}": "Ménage : {e}",
 "Limpezas": "Ménages",
 "Linha do tempo, tarefas, energia e alertas.": "Chronologie, tâches, énergie et alertes.",
 "Link": "Lien",
 "Link (Drive, OneDrive, Dropbox)": "Lien (Drive, OneDrive, Dropbox)",
 "Link copiado. Cole onde quiser enviar.": "Lien copié. Collez-le où vous voulez l'envoyer.",
 "Link da aula ou reunião online (opcional)": "Lien du cours ou de la réunion en ligne (facultatif)",
 "Link da nota fiscal (Drive ou OneDrive)": "Lien de la facture (Drive ou OneDrive)",
 "Link da pasta no Drive ou OneDrive (opcional)": "Lien du dossier Drive ou OneDrive (facultatif)",
 "Link da reserva": "Lien de la réservation",
 "Link da sala online (Meet, Zoom...)": "Lien de la salle en ligne (Meet, Zoom...)",
 "Link de outro calendário (iCal)": "Lien d'un autre calendrier (iCal)",
 "Link do calendário do Airbnb (iCal)": "Lien du calendrier Airbnb (iCal)",
 "Link do calendário do Booking (iCal)": "Lien du calendrier Booking (iCal)",
 "Link inválido": "Lien invalide",
 "Links de materiais (Drive, vídeos, PDFs), um por linha": "Liens des documents (Drive, vidéos, PDF), un par ligne",
 "Links: {n}": "Liens : {n}",
 "Lista": "Liste",
 "Lista da mala": "Liste de la valise",
 "Lista de compras": "Liste de courses",
 "Lista de exercícios": "Feuille d'exercices",
 "Lista rápida": "Liste rapide",
 "Listas rápidas e caixas que viram tarefa ou vão para outra aba.": "Listes rapides et boîtes qui deviennent des tâches ou vont vers un autre onglet.",
 "Literatura": "Littérature",
 "Litros": "Litres",
 "Livre": "Libre",
 "Livro": "Livre",
 "Livros": "Livres",
 "Local": "Lieu",
 "Local ou endereço": "Lieu ou adresse",
 "Local: {l}": "Lieu : {l}",
 "Localização (país e fuso horário)": "Localisation (pays et fuseau horaire)",
 "Logo, foto ou rubrica nas páginas.": "Logo, photo ou paraphe sur les pages.",
 "Loja (opcional)": "Magasin (facultatif)",
 "Lote": "Lot",
 "Lua": "Lune",
 "Lugar": "Lieu",
 "Lugar para visitar": "Lieu à visiter",
 "Lugares": "Lieux",
 "Luz": "Électricité",
 "Luz indireta": "Lumière indirecte",
 "Luz, água, gás e internet": "Électricité, eau, gaz et internet",
 "Lápis": "Crayon",
 "Língua Portuguesa": "Langue portugaise",
 "MAIS ADIANTE": "PLUS TARD",
 "MAIS USADOS": "LES PLUS UTILISÉS",
 "ME ou EPP do Simples": "ME ou EPP du Simples",
 "MEI": "MEI",
 "MEI: faturamento em {ano} de {v} (limite {l}).": "MEI : chiffre d'affaires {ano} de {v} (plafond {l}).",
 "MEMBROS ({n})": "MEMBRES ({n})",
 "METAS": "OBJECTIFS",
 "MS": "MS",
 "Mais": "Plus",
 "Mais abas": "Plus d'onglets",
 "Mais cidades entram nas próximas versões.": "D'autres villes arriveront dans les prochaines versions.",
 "Mais emojis": "Plus d'emojis",
 "Mais ferramentas": "Plus d'outils",
 "Mais figurinhas animadas (KLIPY)": "Plus de stickers animés (KLIPY)",
 "Mais opções desta aba chegam nas próximas versões.": "D'autres options pour cet onglet arriveront dans les prochaines versions.",
 "Mais uma": "Une de plus",
 "Mala": "Valise",
 "Mala ({clima}, {n} dias)": "Valise ({clima}, {n} jours)",
 "Mamadeiras e leite": "Biberons et lait",
 "Mandamos um código de 6 números no WhatsApp do número {tel}.": "Nous avons envoyé un code à 6 chiffres sur le WhatsApp du numéro {tel}.",
 "Mandar as orientações pelo WhatsApp": "Envoyer les consignes par WhatsApp",
 "Mandar de novo": "Renvoyer",
 "Mandar e-mail": "Envoyer un e-mail",
 "Mandar lembrete": "Envoyer un rappel",
 "Mandar meu código": "Envoyer mon code",
 "Mandar o acerto para o grupo": "Envoyer l'équilibrage au groupe",
 "Mandar para quem limpa (WhatsApp)": "Envoyer à la personne du ménage (WhatsApp)",
 "Mandarim": "Mandarin",
 "Mande um e-mail pedindo a exclusão, com o CPF da conta. Respondemos em até 15 dias.": "Envoyez un e-mail demandant la suppression, avec le numéro d'identité du compte. Nous répondons sous 15 jours.",
 "Manter": "Conserver",
 "Manter ambas": "Garder les deux",
 "Manter ambos": "Garder les deux",
 "Manter aqui também": "Le garder ici aussi",
 "Manter tarefas": "Garder les tâches",
 "Manutenção": "Entretien",
 "Manutenções": "Entretiens",
 "Mapas (Apple)": "Plans (Apple)",
 "Marca d'água": "Filigrane",
 "Marca-texto": "Surligneur",
 "Marcado": "Coché",
 "Marcado como feito hoje.": "Marqué comme fait aujourd'hui.",
 "Marcar como concluída ({dia})": "Marquer comme terminée ({dia})",
 "Marcar como devolvido": "Marquer comme rendu",
 "Marcar como feita hoje": "Marquer comme faite aujourd'hui",
 "Marcar como lido": "Marquer comme lu",
 "Marcar como paga": "Marquer comme payée",
 "Marcar como pago": "Marquer comme payé",
 "Marcar como quitado": "Marquer comme soldé",
 "Marcar como recebida": "Marquer comme reçue",
 "Marcar como recebida?": "Marquer comme reçue ?",
 "Marcar como recebido": "Marquer comme reçu",
 "Marcar como visto": "Marquer comme vu",
 "Marcar e avisar a equipe": "Planifier et prévenir l'équipe",
 "Marcar esta conta como paga?": "Marquer cette facture comme payée ?",
 "Marcar fatura como paga": "Marquer le relevé comme payé",
 "Marcar grupo": "Sélectionner le groupe",
 "Marcar reunião": "Planifier une réunion",
 "Marcenaria": "Menuiserie",
 "Margem": "Marge",
 "Marketing": "Marketing",
 "Marque as fotos do diário como Antes ou Depois para montar a galeria.": "Marquez les photos du journal Avant ou Après pour créer la galerie.",
 "Marque os dias em que você estuda e o horário de cada dia. Cada dia vira uma tarefa que se repete toda semana, ligada a este item.": "Cochez les jours où vous étudiez et l'horaire de chaque jour. Chaque jour devient une tâche qui se répète chaque semaine, liée à cet élément.",
 "Marque um ou mais estados.": "Cochez un ou plusieurs États.",
 "Martelo": "Marteau",
 "Masculino": "Masculin",
 "Masculino e minimalista": "Masculin et minimaliste",
 "Matemática": "Mathématiques",
 "Materiais": "Supports",
 "Material": "Matériaux",
 "Matrícula, placa, código ou CNPJ": "Numéro cadastral, plaque, code ou CNPJ",
 "Matéria ou material": "Matière ou document",
 "Matéria ou módulo": "Matière ou module",
 "Matérias": "Matières",
 "Meia-sombra": "Mi-ombre",
 "Melhorando a imagem...": "Amélioration de l'image...",
 "Melhorias novas já foram baixadas. Leva só alguns segundos e seus dados continuam.": "Les nouvelles améliorations sont téléchargées. Cela ne prend que quelques secondes et vos données sont conservées.",
 "Membros": "Membres",
 "Menos de 1 minuto": "Moins d'une minute",
 "Mensagem": "Message",
 "Mensagem apagada": "Message supprimé",
 "Mensagem enviada. Obrigado!": "Message envoyé. Merci !",
 "Mensagem ou observações": "Message ou remarques",
 "Mensagens": "Messages",
 "Mensagens que você envia em Fale conosco.": "Messages que vous envoyez via Nous contacter.",
 "Mensagens: a sua lista de amigos, as conversas, as fotos e os arquivos enviados ficam guardados no servidor para chegar aos outros dispositivos. As chamadas de áudio e vídeo não são gravadas.": "Messages : votre liste d'amis, vos discussions, ainsi que les photos et fichiers envoyés sont stockés sur le serveur pour parvenir aux autres appareils. Les appels audio et vidéo ne sont pas enregistrés.",
 "Mensalidade de {m}": "Mensualité de {m}",
 "Mensalidade ou valor por aluno": "Mensualité ou tarif par élève",
 "Mensalidades, aulas avulsas e materiais. Em ⋮ da turma, \"Gerar as cobranças do mês\" cria uma para cada aluno.": "Mensualités, cours à l'unité et supports. Dans ⋮ de la classe, « Créer les paiements du mois » en crée un par élève.",
 "Mercado": "Courses",
 "Mesa flexora": "Leg curl allongé",
 "Mestre Achado": "Mestre Achado",
 "Mestre de obras": "Chef de chantier",
 "Meta": "Objectif",
 "Meta 100% batida": "Objectif atteint à 100 %",
 "Meta atingida": "Objectif atteint",
 "Meta atingida!": "Objectif atteint !",
 "Meta da semana: {dur}": "Objectif de la semaine : {dur}",
 "Meta de aulas": "Objectif de cours",
 "Meta de aulas batida": "Objectif de cours atteint",
 "Meta de copos por dia": "Objectif de verres par jour",
 "Meta de páginas por dia": "Objectif de pages par jour",
 "Meta de páginas, progresso e resumos dos livros, filmes e séries para ver e aulas dos cursos.": "Objectif de pages, progression et résumés des livres, films et séries à voir et cours des formations.",
 "Meta diária": "Objectif quotidien",
 "Meta por dia": "Objectif quotidien",
 "Meta por semana:": "Objectif par semaine :",
 "Meta {meta} · copo de {copo} · {n} copos": "Objectif {meta} · verre de {copo} · {n} verres",
 "Metas": "Objectifs",
 "Metodologia Científica": "Méthodologie scientifique",
 "Meu caderno": "Mon carnet",
 "Meu cartão de contato": "Ma fiche contact",
 "Meu plano": "Mon forfait",
 "Meus GIFs ({n})": "Mes GIF ({n})",
 "Meus PDFs": "Mes PDF",
 "Meus dados": "Mes informations",
 "Meus dados profissionais": "Mes informations professionnelles",
 "Microchip": "Puce électronique",
 "Microfone": "Micro",
 "Microscópio": "Microscope",
 "Militares estaduais": "Militaires d'État",
 "Minha Casa": "Ma Maison",
 "Minha conta": "Mon compte",
 "Minhas anotações do livro": "Mes notes du livre",
 "Minhas figurinhas": "Mes stickers",
 "Minutos": "Minutes",
 "Minutos de exercício": "Minutes d'exercice",
 "Mirante": "Point de vue",
 "Mirantes": "Points de vue",
 "Modelo": "Modèle",
 "Modelo de prescrição": "Modèle de prescription",
 "Modelos": "Modèles",
 "Modificado em": "Modifié le",
 "Modo": "Mode",
 "Modo de preparo": "Préparation",
 "Modo seguro: tarefas automáticas desligadas até abrir o app de novo": "Mode sans échec : tâches automatiques désactivées jusqu'à la réouverture de l'app",
 "Moeda": "Devise",
 "Moeda: {m}": "Devise : {m}",
 "Moedas": "Pièces",
 "Momento do evento": "Moment de l'événement",
 "Monitor do Diário de Justiça Eletrônico (DJEN) por nome e OAB.": "Suivi du Journal de justice électronique (DJEN) par nom et OAB.",
 "Monitor ou co-professor": "Assistant ou co-enseignant",
 "Montando o PDF: página {n} de {total}...": "Création du PDF : page {n} sur {total}...",
 "Montar a mala pelo clima ({n} dias)": "Préparer la valise selon la météo ({n} jours)",
 "Monte o cronograma alimentar para ver o relatório.": "Créez votre planning de repas pour voir le rapport.",
 "Monte o roteiro dia a dia. No período da viagem, ele aparece na linha do tempo do My Planner.": "Construisez l'itinéraire jour par jour. Pendant le voyage, il apparaît dans la chronologie de My Planner.",
 "Monte seu cronograma alimentar e seus cuidados abaixo. O que for de hoje aparece aqui para marcar.": "Créez ci-dessous votre programme alimentaire et vos soins. Ce qui est prévu aujourd'hui apparaît ici pour être coché.",
 "Monte seu cronograma alimentar, cuidados, treinos e suplementos abaixo. O que for de hoje aparece aqui para marcar.": "Créez ci-dessous votre planning de repas, vos soins, vos séances et vos compléments. Ce qui est prévu aujourd'hui apparaît ici pour être coché.",
 "Monte seus treinos com atividades prontas: aparelhos da academia, exercícios em casa, caminhada, corrida, yoga, pilates...": "Composez vos séances avec des activités toutes prêtes : machines de musculation, exercices à la maison, marche, course, yoga, pilates...",
 "Mostrando as 120 mais recentes.": "Affichage des 120 plus récentes.",
 "Mostrando só o roteiro. {n} tarefa(s) do dia escondida(s).": "Seul l'itinéraire est affiché. {n} tâche(s) du jour masquée(s).",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. Não usamos o GPS.": "Afficher les dates, heures, la devise et les jours fériés corrects là où vous êtes. Nous n'utilisons pas le GPS.",
 "Mostrar menos": "Afficher moins",
 "Mostrar só o roteiro durante a viagem": "N'afficher que l'itinéraire pendant le voyage",
 "Motivo do cancelamento": "Motif d'annulation",
 "Moto": "Moto",
 "Mover": "Déplacer",
 "Mover para hoje": "Déplacer à aujourd'hui",
 "Mudança": "Déménagement",
 "Mudança: {para}": "Déménagement : {para}",
 "Mudanças": "Déménagements",
 "Mudar e-mail": "Changer d'e-mail",
 "Mudar o nome": "Renommer",
 "Mudar senha": "Changer le mot de passe",
 "Mudo": "Muet",
 "Muitas tentativas": "Trop de tentatives",
 "Muitas tentativas erradas. Tente de novo em {s} segundos.": "Trop de tentatives incorrectes. Réessayez dans {s} secondes.",
 "Muitas tentativas. Aguarde alguns minutos.": "Trop de tentatives. Patientez quelques minutes.",
 "Muito bem: já guardou {v} este mês. Constância vale mais que valor alto.": "Bravo : vous avez déjà épargné {v} ce mois-ci. La régularité compte plus qu'un gros montant.",
 "Multa": "Amende",
 "Multa e juros": "Pénalités et intérêts",
 "Multa e juros de {v}": "Pénalités et intérêts de {v}",
 "Multa e juros estimados: {v}": "Pénalité et intérêts estimés : {v}",
 "Multas e juros pagos": "Pénalités et intérêts payés",
 "Mundo": "Monde",
 "Municipal": "Municipal",
 "Município da prestação (IBGE), se for outro": "Commune de la prestation (IBGE), si différente",
 "Município da prestação (código IBGE, 7 números)": "Commune de la prestation (code IBGE, 7 chiffres)",
 "Mural": "Annonce",
 "Museu": "Musée",
 "Museus": "Musées",
 "My Planner (vira tarefa)": "My Planner (devient une tâche)",
 "My Planner bloqueado": "My Planner verrouillé",
 "Máxima": "Maximale",
 "Média": "Moyenne",
 "Média para aprovação": "Moyenne pour réussir",
 "Média · repouso {n}": "Moyenne · repos {n}",
 "Médico": "Médecin",
 "Médico ou clínica": "Médecin ou clinique",
 "Médio": "Moyen",
 "Mês": "Mois",
 "Mês a mês": "Mois par mois",
 "Mês atual": "Mois en cours",
 "Mês passado": "Mois dernier",
 "Móveis e enxoval": "Meubles et linge",
 "Móvel": "Meuble",
 "Música": "Musique",
 "NAS ABAS": "DANS LES ONGLETS",
 "NF-e: a SEFAZ pede 1 hora entre as buscas. Próxima a partir das {h}.": "NF-e : la SEFAZ exige 1 heure entre les recherches. Prochaine à partir de {h}.",
 "NF-e: informe a UF da empresa para buscar as notas de produtos.": "NF-e : indiquez l'État (UF) de l'entreprise pour rechercher les factures de produits.",
 "NFS-e emitida": "NFS-e émise",
 "NFS-e: {m}": "NFS-e : {m}",
 "Na (opcional):": "Le (facultatif) :",
 "Na agenda": "À l'agenda",
 "Na agenda em {data}": "À l'agenda le {data}",
 "Na barra": "Dans la barre",
 "Na demonstração não há servidor de notas. Use o app com a sua conta.": "La démo n'a pas de serveur de factures. Utilisez l'app avec votre compte.",
 "Na hora": "Immédiatement",
 "Na hora da pausa aparece um aviso grande na tela, com contagem regressiva.": "À l'heure de la pause, un grand avis s'affiche à l'écran, avec un compte à rebours.",
 "Na linha do tempo, tocar no temporizador também abre esta página.": "Dans la chronologie, toucher le minuteur ouvre aussi cette page.",
 "Na pasta \"{pasta}\" do celular. Cada arquivo pronto vai para lá.": "Dans le dossier \"{pasta}\" du téléphone. Chaque fichier terminé y va.",
 "Na pasta \"{pasta}\" do celular. Cada documento novo vai para lá quando você sai dele.": "Dans le dossier \"{pasta}\" du téléphone. Chaque nouveau document y part quand vous le quittez.",
 "Na prévia de demonstração não há chamadas de verdade.": "Il n'y a pas de vrais appels dans l'aperçu de démonstration.",
 "Na prévia de demonstração não há gravação de verdade.": "Il n'y a pas de vrai enregistrement dans l'aperçu de démonstration.",
 "Na prévia de demonstração os arquivos não abrem.": "Les fichiers ne s'ouvrent pas dans l'aperçu de démonstration.",
 "Na versão das lojas, a compra será pela Google Play ou pela App Store. Por enquanto a chave simula a assinatura para testes.": "Dans la version des stores, l'achat se fera via Google Play ou l'App Store. Pour l'instant, l'interrupteur simule l'abonnement pour les tests.",
 "Na versão das lojas, este botão abre a compra da Google Play ou da App Store.": "Dans la version des stores, ce bouton ouvre l'achat sur Google Play ou l'App Store.",
 "Nacional": "National",
 "Nada a gerar": "Rien à créer",
 "Nada encontrado.": "Aucun résultat.",
 "Nada entra na agenda de ninguém sem autorização: cada pessoa aceita, edita ou recusa.": "Rien n'entre dans l'agenda de personne sans autorisation : chacun accepte, modifie ou refuse.",
 "Nada foi registrado.": "Rien n'a été enregistré.",
 "Nada lançado neste mês.": "Rien d'enregistré ce mois-ci.",
 "Nada no mês": "Rien ce mois-ci",
 "Nada no roteiro deste dia.": "Rien dans l'itinéraire ce jour-là.",
 "Nada para apagar com esse filtro.": "Rien à supprimer avec ce filtre.",
 "Nada para comprar": "Rien à acheter",
 "Nada para enviar.": "Rien à envoyer.",
 "Nada planejado para este dia": "Rien de prévu ce jour-là",
 "Nada planejado para hoje. Bom dia!": "Rien de prévu aujourd'hui. Bonne journée !",
 "Nada por aqui.": "Rien ici.",
 "Nada recebido ainda.": "Rien reçu pour l'instant.",
 "Nas conversas, cada pessoa vê o seu nome e o que você manda ali. Você pode apagar uma mensagem para todos, sair de um grupo ou bloquear alguém.": "Dans les discussions, chaque personne voit votre nom et ce que vous y envoyez. Vous pouvez supprimer un message pour tous, quitter un groupe ou bloquer quelqu'un.",
 "Nascimento": "Naissance",
 "Natal": "Noël",
 "Natação": "Natation",
 "Navegador conectado": "Navigateur connecté",
 "Negrito": "Gras",
 "Negócios": "Affaires",
 "Nenhum": "Aucun",
 "Nenhum XML neste período (ou foram guardados em outro dispositivo).": "Aucun XML sur cette période (ou ils ont été enregistrés sur un autre appareil).",
 "Nenhum amigo para adicionar. Convide pelo WhatsApp ou adicione amigos no Mensagens (código do amigo).": "Aucun ami à ajouter. Invitez via WhatsApp ou ajoutez des amis dans Messages (code ami).",
 "Nenhum arquivo, imagem ou link nas páginas desta matéria.": "Aucun fichier, image ou lien dans les pages de cette matière.",
 "Nenhum arquivo.": "Aucun fichier.",
 "Nenhum atendimento pago neste mês.": "Aucun rendez-vous payé ce mois-ci.",
 "Nenhum cartão": "Aucune carte",
 "Nenhum comprovante guardado ainda. Ao pagar uma conta, toque nela e anexe a foto, o PDF ou o print do comprovante.": "Aucun justificatif enregistré pour l'instant. Quand vous payez une facture, touchez-la et joignez la photo, le PDF ou la capture d'écran du justificatif.",
 "Nenhum cômodo ainda": "Aucune pièce pour l'instant",
 "Nenhum dia": "Aucun jour",
 "Nenhum documento ainda.": "Aucun document pour l'instant.",
 "Nenhum documento neste filtro.": "Aucun document dans ce filtre.",
 "Nenhum e-mail cadastrado": "Aucun e-mail enregistré",
 "Nenhum erro registrado. Se o app fechar sozinho ou uma tela der problema, o erro aparece aqui para você mandar para a equipe.": "Aucune erreur enregistrée. Si l'app se ferme toute seule ou si un écran pose problème, l'erreur apparaît ici pour que vous l'envoyiez à l'équipe.",
 "Nenhum feriado neste ano.": "Aucun jour férié cette année.",
 "Nenhum fichário ainda": "Aucun classeur pour l'instant",
 "Nenhum grupo ainda.": "Aucun groupe pour l'instant.",
 "Nenhum item em {nome}": "Aucun élément dans {nome}",
 "Nenhum lançamento encontrado": "Aucune écriture trouvée",
 "Nenhum país encontrado.": "Aucun pays trouvé.",
 "Nenhum selecionado": "Aucune sélection",
 "Nenhuma (plano gratuito)": "Aucune (forfait gratuit)",
 "Nenhuma aba encontrada.": "Aucun onglet trouvé.",
 "Nenhuma aba fixada além do My Planner.": "Aucun onglet épinglé à part My Planner.",
 "Nenhuma aba liberada para receber": "Aucun onglet débloqué ne peut le recevoir",
 "Nenhuma agenda encontrada": "Aucun agenda trouvé",
 "Nenhuma agenda para trazer": "Aucun agenda à importer",
 "Nenhuma audiência ou prazo encontrado nesta publicação.": "Aucune audience ni délai trouvé dans cette publication.",
 "Nenhuma caixa arquivada. Arraste uma caixa para a esquerda para arquivar.": "Aucune boîte archivée. Faites glisser une boîte vers la gauche pour l'archiver.",
 "Nenhuma compra encontrada": "Aucun achat trouvé",
 "Nenhuma compra nesta fatura.": "Aucun achat sur ce relevé.",
 "Nenhuma conta a pagar cadastrada.": "Aucune facture à payer ajoutée.",
 "Nenhuma conta a receber cadastrada.": "Aucune somme à recevoir ajoutée.",
 "Nenhuma conta neste mês. Toque em + para cadastrar (aluguel, luz, cartão...).": "Aucune facture ce mois-ci. Touchez + pour en ajouter (loyer, électricité, carte...).",
 "Nenhuma cópia de segurança ainda.": "Aucune sauvegarde pour l'instant.",
 "Nenhuma cópia encontrada.": "Aucune sauvegarde trouvée.",
 "Nenhuma garantia ativa. Cadastre com o +.": "Aucune garantie active. Ajoutez-en une avec le +.",
 "Nenhuma garantia vencida.": "Aucune garantie expirée.",
 "Nenhuma mensagem ainda. Diga oi! 👋": "Aucun message pour l'instant. Dites bonjour ! 👋",
 "Nenhuma nota neste período.": "Aucune facture sur cette période.",
 "Nenhuma opção ainda.": "Aucune option pour l'instant.",
 "Nenhuma publicação nova.": "Aucune nouvelle publication.",
 "Nenhuma refeição neste dia.": "Aucun repas ce jour-là.",
 "Nenhuma reunião marcada.": "Aucune réunion planifiée.",
 "Nesse ritmo, termina em {d}": "À ce rythme, vous finirez le {d}",
 "Nesta fase de lançamento, todas as abas estão liberadas e grátis.": "Pendant cette phase de lancement, tous les onglets sont débloqués et gratuits.",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF ou e-mail.": "Pendant cette phase de test, le mot de passe est réinitialisé par le support. Écrivez à {email} en indiquant votre CPF ou votre e-mail.",
 "Nesta fase de testes, a senha é redefinida pelo suporte. Escreva para {email} informando seu CPF.": "Pendant cette phase de test, le mot de passe est réinitialisé par le support. Écrivez à {email} en indiquant votre CPF.",
 "Neve": "Neige",
 "Ninguém deve nada a ninguém.": "Personne ne doit rien à personne.",
 "Ninguém entrou ainda. Envie o convite.": "Personne n'a encore rejoint. Envoyez l'invitation.",
 "Ninguém usou o seu código ainda.": "Personne n'a encore utilisé votre code.",
 "No Android, o app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "Sur Android, l'app garde seulement un raccourci vers le fichier choisi : il reste où il est (Drive, OneDrive, Téléchargements) et s'ouvre dans l'app du téléphone. Rien n'est copié. Cette option s'applique aux photos prises avec l'appareil photo.",
 "No Google Drive ou OneDrive: {n}": "Sur Google Drive ou OneDrive : {n}",
 "No Google Drive, o app só enxerga os arquivos que ele mesmo criou na pasta My Planner. O uso das informações recebidas das APIs do Google segue a Política de Dados do Usuário dos Serviços de API do Google, inclusive as regras de Uso Limitado: nada é vendido, usado para publicidade ou lido por pessoas, salvo com a sua autorização ou por obrigação legal.": "Dans Google Drive, l'appli ne voit que les fichiers qu'elle a elle-même créés dans le dossier My Planner. L'utilisation des informations reçues des API Google respecte le Règlement sur les données utilisateur des services d'API Google, y compris les exigences d'utilisation limitée : rien n'est vendu, utilisé à des fins publicitaires ni lu par des personnes, sauf avec votre autorisation ou en cas d'obligation légale.",
 "No app do seu relógio (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), ligue a opção \"Health Connect\" ou \"Sincronizar com o Health Connect\".": "Dans l'app de votre montre (Samsung Health, Garmin Connect, Mi Fitness, Zepp, Fitbit, Amazfit, Google Fit...), activez l'option \"Health Connect\" ou \"Synchroniser avec Health Connect\".",
 "No app novo (versão 0.49), o celular acha as bordas da folha sozinho. Nesta versão, ajuste os 4 cantos com o dedo.": "Dans la nouvelle app (version 0.49), le téléphone trouve seul les bords de la feuille. Dans cette version, ajustez les 4 coins avec le doigt.",
 "No centro": "Au centre",
 "No computador, abra {url}, toque no botão acima e aponte a câmera para o QR Code da tela.": "Sur l'ordinateur, ouvrez {url}, touchez le bouton ci-dessus et pointez l'appareil photo vers le QR code à l'écran.",
 "No dia (opcional):": "Le jour (facultatif) :",
 "No iPhone, o app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "Sur iPhone, l'app ouvre \"Enregistrer dans Fichiers\" pour que vous choisissiez le dossier (iCloud Drive possible).",
 "No início": "Au début",
 "No modo seguro o app abre sem as tarefas automáticas (avisos, agenda do Google, publicações, mensagens e relógio). Os seus dados não mudam e tudo volta ao normal na próxima vez que abrir.": "En mode sans échec, l'app s'ouvre sans les tâches automatiques (alertes, Google Agenda, publications, messages et montre). Vos données ne changent pas et tout redevient normal à la prochaine ouverture.",
 "No navegador, as páginas ficam só enquanto esta página estiver aberta.": "Dans le navigateur, les pages ne restent que tant que cette page est ouverte.",
 "No navegador, cole o link do arquivo do Drive, OneDrive ou Dropbox (em Estudos ou Documentos, opção Link). No celular, o botão de arquivo já mostra o Drive e o OneDrive.": "Dans le navigateur, collez le lien du fichier Drive, OneDrive ou Dropbox (dans Études ou Documents, option Lien). Sur le téléphone, le bouton fichier affiche déjà Drive et OneDrive.",
 "No navegador, o PDF é baixado para o computador.": "Dans le navigateur, le PDF est téléchargé sur l'ordinateur.",
 "No navegador, só dá para guardar imagens pequenas (até 200 KB). Para outros arquivos, adicione um link do Drive, OneDrive ou Dropbox, ou use o app no celular.": "Dans le navigateur, seules les petites images (jusqu'à 200 Ko) peuvent être enregistrées. Pour les autres fichiers, ajoutez un lien Drive, OneDrive ou Dropbox, ou utilisez l'app sur le téléphone.",
 "No outro app, copie o link do arquivo (Compartilhar › Copiar link) e cole no bloco de link que ficou nesta página.": "Dans l'autre app, copiez le lien du fichier (Partager › Copier le lien) et collez-le dans le bloc de lien ajouté à cette page.",
 "No ritmo atual, o ano fecha em {v}.": "Au rythme actuel, l'année se terminera à {v}.",
 "No seu fuso: {hora}{dia}": "Dans votre fuseau : {hora}{dia}",
 "Nome": "Nom",
 "Nome (cliente ou fornecedor)": "Nom (client ou fournisseur)",
 "Nome (ex.: 8º ano B, Pacientes da clínica, Aniversário da Ana)": "Nom (ex. : 4e B, Patients du cabinet, Anniversaire d'Ana)",
 "Nome (ex.: Almoço)": "Nom (ex. : Déjeuner)",
 "Nome (ex.: Aluguel recebido, Cliente X)": "Nom (ex. : Loyer reçu, Client X)",
 "Nome (ex.: Aluguel, Luz, Internet)": "Nom (ex. : Loyer, Électricité, Internet)",
 "Nome (ex.: Doutorado UFPR)": "Nom (ex. : Doctorat UFPR)",
 "Nome (ex.: Nubank, Itaú Visa)": "Nom (ex. : Nubank, Itaú Visa)",
 "Nome (ex.: Skincare da noite)": "Nom (ex. : Skincare du soir)",
 "Nome (ex.: Treino A)": "Nom (ex. : Séance A)",
 "Nome (ex.: Viagem de férias, Reserva de emergência)": "Nom (ex. : Voyage de vacances, Épargne de précaution)",
 "Nome (ex.: Vitamina C)": "Nom (ex. : Vitamine C)",
 "Nome (opcional)": "Nom (facultatif)",
 "Nome (opcional, ex.: CNH do Walter)": "Nom (facultatif, ex. : Permis de Walter)",
 "Nome (pode editar, ex.: \"Suco de uva\")": "Nom (modifiable, ex. : « Jus de raisin »)",
 "Nome completo": "Nom complet",
 "Nome curto": "Nom court",
 "Nome da lista": "Nom de la liste",
 "Nome da matéria": "Nom de la matière",
 "Nome da obra": "Nom du chantier",
 "Nome da pasta (ex.: Recibos, Contratos)": "Nom du dossier (ex. : Reçus, Contrats)",
 "Nome da tarefa": "Nom de la tâche",
 "Nome da tarefa (ex.: Academia)": "Nom de la tâche (ex. : Salle de sport)",
 "Nome da tarefa (ex.: Limpar o banheiro)": "Nom de la tâche (ex. : Nettoyer la salle de bain)",
 "Nome do PDF (opcional)": "Nom du PDF (facultatif)",
 "Nome do conselho": "Nom de l'ordre",
 "Nome do cômodo": "Nom de la pièce",
 "Nome do documento": "Nom du document",
 "Nome do escritório (ex.: Ravasco Contabilidade)": "Nom du bureau (ex. : Ravasco Contabilidade)",
 "Nome do evento": "Nom de l'événement",
 "Nome do grupo (ex.: Família)": "Nom du groupe (ex. : Famille)",
 "Nome do modelo": "Nom du modèle",
 "Nome ou modelo": "Nom ou modèle",
 "Nome ou razão social": "Nom ou raison sociale",
 "Nome, subtarefa ou anotação": "Nom, sous-tâche ou note",
 "Nos grupos, cada pessoa responde pelo que inclui. Quem administra o grupo decide quem participa.": "Dans les groupes, chacun est responsable de ce qu'il ajoute. L'administrateur du groupe décide qui y participe.",
 "Nossa Senhora Aparecida": "Notre-Dame d'Aparecida",
 "Nossa Senhora da Luz dos Pinhais": "Notre-Dame da Luz dos Pinhais",
 "Nota cancelada": "Facture annulée",
 "Nota fiscal": "Facture",
 "Nota fiscal emitida": "Facture émise",
 "Nota fiscal, certificado de garantia e fotos": "Facture, certificat de garantie et photos",
 "Nota importada": "Facture importée",
 "Notas": "Factures",
 "Notas Fiscais": "Factures",
 "Notebook e carregador": "Ordinateur portable et chargeur",
 "Nova avaliação": "Nouvelle évaluation",
 "Nova caixa (ex.: Compras, Ideias)": "Nouvelle boîte (ex. : Courses, Idées)",
 "Nova conversa": "Nouvelle discussion",
 "Nova garantia": "Nouvelle garantie",
 "Nova matéria": "Nouvelle matière",
 "Nova meta": "Nouvel objectif",
 "Nova pasta": "Nouveau dossier",
 "Nova página": "Nouvelle page",
 "Nova página com esta caixa": "Nouvelle page avec cette boîte",
 "Nova refeição": "Nouveau repas",
 "Nova tarefa": "Nouvelle tâche",
 "Nova tarefa da casa": "Nouvelle tâche ménagère",
 "Nova tarefa neste cômodo": "Nouvelle tâche dans cette pièce",
 "Novas": "Nouvelles",
 "Novo": "Nouveau",
 "Novo alerta:": "Nouvelle alerte :",
 "Novo cartão": "Nouvelle carte",
 "Novo cartão de crédito": "Nouvelle carte de crédit",
 "Novo cuidado": "Nouveau soin",
 "Novo documento": "Nouveau document",
 "Novo e-mail": "Nouvel e-mail",
 "Novo fichário": "Nouveau classeur",
 "Novo grupo": "Nouveau groupe",
 "Novo item": "Nouvel élément",
 "Novo perfil": "Nouveau profil",
 "Novo suplemento": "Nouveau complément",
 "Novo treino": "Nouvelle séance",
 "Novo: {nome}": "Nouveau : {nome}",
 "Novos": "Nouveaux",
 "Num período": "Sur une période",
 "Numere cada caixa e diga o cômodo e o conteúdo. Use a busca para achar onde está cada coisa.": "Numérotez chaque carton et indiquez la pièce et le contenu. Utilisez la recherche pour retrouver où est chaque chose.",
 "Nº": "N°",
 "Não": "Non",
 "Não achei o total no cupom. Tente uma foto mais nítida.": "Je n'ai pas trouvé le total sur le ticket. Essayez une photo plus nette.",
 "Não consegue entrar?": "Impossible de vous connecter ?",
 "Não consegui abrir \"{nome}\". Tente a ferramenta Reparar PDF.": "Impossible d'ouvrir \"{nome}\". Essayez l'outil Réparer le PDF.",
 "Não consegui conectar a chamada. Confira a internet e tente de novo.": "Impossible de connecter l'appel. Vérifiez votre connexion internet et réessayez.",
 "Não deu certo: {msg}": "Échec : {msg}",
 "Não deu para diminuir mais este PDF ({tam}).": "Impossible de réduire davantage ce PDF ({tam}).",
 "Não dá para tirar todas as páginas.": "Impossible de retirer toutes les pages.",
 "Não encontrei texto neste PDF.": "Aucun texte trouvé dans ce PDF.",
 "Não encontrei texto neste documento.": "Aucun texte trouvé dans ce document.",
 "Não foi possível": "Impossible",
 "Não foi possível abrir": "Impossible d'ouvrir",
 "Não foi possível abrir o certificado guardado. Ligue o certificado de novo.": "Impossible d'ouvrir le certificat enregistré. Connectez à nouveau le certificat.",
 "Não foi possível abrir.": "Impossible d'ouvrir.",
 "Não foi possível baixar os feriados deste país. Confira a internet.": "Impossible de télécharger les jours fériés de ce pays. Vérifiez votre connexion internet.",
 "Não foi possível conectar": "Connexion impossible",
 "Não foi possível conectar o {nome}": "Impossible de connecter {nome}",
 "Não foi possível consultar o DJEN agora.": "Impossible de consulter le DJEN pour le moment.",
 "Não foi possível continuar": "Impossible de continuer",
 "Não foi possível criar um evento na agenda: {msg}": "Impossible de créer un événement dans l'agenda : {msg}",
 "Não foi possível entrar.": "Connexion impossible.",
 "Não foi possível enviar": "Envoi impossible",
 "Não foi possível enviar.": "Envoi impossible.",
 "Não foi possível guardar: {erro}": "Impossible d'enregistrer : {erro}",
 "Não foi possível ler o arquivo.": "Impossible de lire le fichier.",
 "Não foi possível ler o calendário. Confira o link em Editar.": "Impossible de lire le calendrier. Vérifiez le lien dans Modifier.",
 "Não foi possível procurar agora. Tenta de novo sozinho mais tarde.": "Recherche impossible pour le moment. Nouvel essai automatique plus tard.",
 "Não foi possível reiniciar sozinho.": "Impossible de redémarrer automatiquement.",
 "Não foi possível sincronizar com a agenda: {msg}": "Impossible de synchroniser avec l'agenda : {msg}",
 "Não foi possível trocar a foto": "Impossible de changer la photo",
 "Não há garantia de aviso com o app fechado. A verificação ocorre ao abrir o app (a cada 6 horas) ou em \"Verificar agora\".": "Aucune notification garantie quand l'app est fermée. La vérification a lieu à l'ouverture de l'app (toutes les 6 heures) ou via « Vérifier maintenant ».",
 "Não identificado": "Non identifié",
 "Não marcada como feita": "Non marquée comme faite",
 "Não optante pelo Simples": "Non adhérent au Simples",
 "Não se repete": "Ne se répète pas",
 "Não use o app para atividades ilegais, para guardar conteúdo de terceiros sem autorização ou para tentar acessar dados de outras pessoas.": "N'utilisez pas l'app pour des activités illégales, pour stocker du contenu de tiers sans autorisation ou pour tenter d'accéder aux données d'autres personnes.",
 "Não vai": "Ne vient pas",
 "Não vence": "N'expire pas",
 "Não vendemos seus dados e não usamos o seu conteúdo para publicidade.": "Nous ne vendons pas vos données et n'utilisons pas votre contenu à des fins publicitaires.",
 "Não é possível adicionar esta pessoa.": "Impossible d'ajouter cette personne.",
 "Não é um XML de nota fiscal": "Ce n'est pas un XML de facture",
 "Número": "Numéro",
 "Número (opcional)": "Numéro (facultatif)",
 "Número da OAB": "Numéro OAB",
 "Número da caixa": "Numéro du carton",
 "Número da carteirinha": "Numéro de carte",
 "Número da guia do convênio": "Numéro de prise en charge",
 "Número da parcela": "Numéro d'échéance",
 "Número de hóspedes": "Nombre de voyageurs",
 "Número de parcelas": "Nombre d'échéances",
 "Número do contrato": "Numéro de contrat",
 "Número do registro": "Numéro d'inscription",
 "Número na chamada": "Numéro d'appel",
 "Número {n}. O XML ficou guardado na nota. Toque nela para ver o PDF.": "Numéro {n}. Le XML a été enregistré avec la facture. Touchez-la pour voir le PDF.",
 "Número, órgão emissor e observações ficam criptografados (AES-256) no aparelho antes de ir para a nuvem.": "Le numéro, l'organisme émetteur et les remarques sont chiffrés (AES-256) sur l'appareil avant d'aller dans le cloud.",
 "Número, órgão emissor, observações, fotos e PDFs ficam criptografados (AES-256) no dispositivo. Os arquivos protegidos ficam só neste dispositivo.": "Le numéro, l'organisme émetteur, les notes, les photos et les PDF sont chiffrés (AES-256) sur l'appareil. Les fichiers protégés restent uniquement sur cet appareil.",
 "Número: {n}": "Numéro : {n}",
 "Números de página": "Numéros de page",
 "O ChatGPT não lê PDF por aqui. Tire uma foto ou um print da página, ou use o Claude ou o Gemini em Ajustes › Inteligência artificial.": "ChatGPT ne lit pas les PDF ici. Prenez une photo ou une capture de la page, ou utilisez Claude ou Gemini dans Réglages › Intelligence artificielle.",
 "O DAS vence dia {dia}. Marque como pago em Finanças.": "Le DAS est dû le {dia}. Marquez-le comme payé dans Finance.",
 "O Escritório ainda não foi ligado no servidor. No computador, rode o 29-SERVIDOR-0.45.bat (uma vez só).": "Le Bureau n'est pas encore activé sur le serveur. Sur l'ordinateur, lancez 29-SERVIDOR-0.45.bat (une seule fois).",
 "O Mestre Achado cuida do seu dinheiro: contas, cartões e faturas, orçamento por categoria, metas, extrato e cupom pela foto, relatório e MEI.": "Le Mestre Achado s'occupe de votre argent : factures, cartes et relevés, budget par catégorie, objectifs, relevé bancaire et ticket par photo, rapport et MEI.",
 "O Mestre está pensando...": "Le Mestre réfléchit...",
 "O My Planner cria a pasta \"My Planner\" no seu Drive e só enxerga o que ele mesmo guardou lá.": "My Planner crée le dossier « My Planner » dans votre Drive et ne voit que ce qu'il y a lui-même enregistré.",
 "O My Planner já abriu no computador, com os seus dados.": "My Planner s'est ouvert sur l'ordinateur, avec vos données.",
 "O My Planner lê os dados do relógio pelo {fonte}, onde o relógio e os apps de saúde e de exercício guardam tudo.": "My Planner lit les données de la montre via {fonte}, où la montre et les apps de santé et de sport enregistrent tout.",
 "O My Planner organiza a sua agenda, tarefas, finanças, documentos e outras áreas da vida. É oferecido por Walter Ravasco da Costa, que é o controlador dos dados pessoais tratados no app.": "My Planner organise votre agenda, vos tâches, vos finances, vos documents et d'autres aspects de votre vie. Il est proposé par Walter Ravasco da Costa, responsable du traitement des données personnelles traitées dans l'app.",
 "O My Planner usa só a pasta Aplicativos › My Planner do seu OneDrive.": "My Planner utilise uniquement le dossier Applications › My Planner de votre OneDrive.",
 "O PDF e as imagens saem deste dispositivo e da nuvem.": "Le PDF et les images seront supprimés de cet appareil et du cloud.",
 "O PDF passou de 15 MB. Se o WhatsApp ou o e-mail recusar, ligue \"Arquivo menor\".": "Le PDF dépasse 15 Mo. Si WhatsApp ou l'e-mail le refuse, activez \"Fichier plus léger\".",
 "O QUE COMER": "AU MENU",
 "O QUE OS MEMBROS PODEM": "CE QUE LES MEMBRES PEUVENT FAIRE",
 "O QUE VOCÊ MANDA": "CE QUE VOUS ENVOYEZ",
 "O QUE VOCÊ RECEBE": "CE QUE VOUS RECEVEZ",
 "O acesso continua sendo pelo CPF. O e-mail serve para o suporte falar com você.": "La connexion se fait toujours avec le CPF. L'e-mail permet au support de vous contacter.",
 "O administrador do grupo poderá enviar compromissos, materiais e avisos. Nada entra na sua agenda sem você aceitar.": "L'administrateur du groupe pourra envoyer des rendez-vous, documents et annonces. Rien n'entre dans votre agenda sans votre accord.",
 "O alarme toca de novo a cada 2 minutos (até 4 vezes) enquanto o remédio não for marcado como tomado.": "L'alarme sonne à nouveau toutes les 2 minutes (jusqu'à 4 fois) tant que le médicament n'est pas marqué comme pris.",
 "O app ajuda a organizar, mas não substitui orientação de médicos, advogados, contadores ou outros profissionais. Confira prazos, valores e datas importantes.": "L'app aide à s'organiser, mais ne remplace pas l'avis de médecins, d'avocats, de comptables ou d'autres professionnels. Vérifiez les délais, montants et dates importants.",
 "O app avisa 3 dias antes e no dia do vencimento, às 9h.": "L'app vous alerte 3 jours avant et le jour de l'échéance, à 9 h.",
 "O app consulta o serviço público do CNJ (DJEN) com os nomes e a OAB que você cadastrar. Esses dados são enviados a esse serviço a cada verificação.": "L'app consulte le service public du CNJ (DJEN) avec les noms et l'OAB que vous enregistrez. Ces données sont envoyées à ce service à chaque vérification.",
 "O app e o servidor do My Planner consultam o serviço público do CNJ (DJEN) com os nomes e as OABs que você cadastrar e, se você marcar, o Querido Diário (diários oficiais municipais). Esses dados são enviados a esses serviços a cada verificação.": "L'app et le serveur My Planner interrogent le service public du CNJ (DJEN) avec les noms et les numéros OAB que vous enregistrez et, si vous cochez la case, Querido Diário (journaux officiels municipaux). Ces données sont envoyées à ces services à chaque vérification.",
 "O app fechou sozinho {n} vezes seguidas": "L'app s'est fermée toute seule {n} fois de suite",
 "O app instalado neste aparelho é a versão {v}. Para fazer chamadas de áudio e vídeo, instale o app 0.35 ou mais novo (APK novo). As mensagens já funcionam.": "L'app installée sur cet appareil est la version {v}. Pour passer des appels audio et vidéo, installez l'app 0.35 ou plus récente (nouvel APK). Les messages fonctionnent déjà.",
 "O app não fechou e os seus dados continuam salvos. Tente de novo ou mande o relatório para a equipe corrigir.": "L'app ne s'est pas fermée et vos données sont toujours enregistrées. Réessayez ou envoyez le rapport pour que l'équipe corrige.",
 "O app pede o desbloqueio ao abrir e ao voltar do segundo plano.": "L'app demande le déverrouillage à l'ouverture et au retour de l'arrière-plan.",
 "O app pede o desbloqueio ao abrir. Trocar de app ou de tela rapidinho não pede de novo; se o celular ficar travado ou o app ficar fora da tela por mais tempo que o prazo abaixo, pede.": "L'app demande le déverrouillage à l'ouverture. Changer rapidement d'app ou d'écran ne le redemande pas ; si le téléphone est verrouillé ou si l'app reste hors de l'écran plus longtemps que le délai ci-dessous, il est redemandé.",
 "O app só lê (passos, distância, calorias, exercício, batimentos e sono) e nunca altera os seus dados de saúde. Os totais de cada dia ficam na sua conta para aparecer também no site e no outro celular.": "L'app se contente de lire (pas, distance, calories, exercice, fréquence cardiaque et sommeil) et ne modifie jamais vos données de santé. Les totaux de chaque jour sont enregistrés dans votre compte pour apparaître aussi sur le site et sur l'autre téléphone.",
 "O app volta a pedir a senha para desbloquear.": "L'app redemandera le mot de passe pour déverrouiller.",
 "O app é feito para maiores de 18 anos. Dados de crianças só podem ser registrados pelos pais ou responsáveis.": "L'app est destinée aux personnes de plus de 18 ans. Les données d'enfants ne peuvent être saisies que par les parents ou responsables légaux.",
 "O arquivo ficou só neste dispositivo. Não foi possível guardar no {nome}: {erro}": "Le fichier est resté uniquement sur cet appareil. Impossible de l'enregistrer sur {nome} : {erro}",
 "O arquivo não está mais nesse lugar (foi apagado ou movido).": "Le fichier n'est plus à cet endroit (supprimé ou déplacé).",
 "O arquivo não está mais nesse lugar (foi apagado, movido ou o app dele tirou a permissão). Anexe de novo.": "Le fichier n'est plus à cet endroit (supprimé, déplacé ou son app a retiré l'autorisation). Joignez-le à nouveau.",
 "O arquivo passa de 15 MB.": "Le fichier dépasse 15 Mo.",
 "O arquivo passa de 15 MB. Ligue \"Arquivo menor\" e tente de novo.": "Le fichier dépasse 15 Mo. Activez \"Fichier plus léger\" et réessayez.",
 "O arquivo passa de 25 MB.": "Le fichier dépasse 25 Mo.",
 "O arquivo passa de 50 MB.": "Le fichier dépasse 50 Mo.",
 "O arquivo sai deste celular. As cópias que você salvou no Drive, OneDrive ou mandou para alguém continuam lá.": "Le fichier quitte ce téléphone. Les copies enregistrées sur Drive, OneDrive ou envoyées restent là-bas.",
 "O arquivo sai do escritório para todos.": "Le fichier est retiré du bureau pour tout le monde.",
 "O aviso chega às 9h, e de novo no dia do vencimento.": "Le rappel arrive à 9 h, puis à nouveau le jour de l'expiration.",
 "O banco ainda não foi preparado. Rode o arquivo supabase/schema.sql no Supabase.": "La base de données n'est pas encore prête. Exécutez le fichier supabase/schema.sql dans Supabase.",
 "O cartão {c} está com {p}% do limite tomado. Evite parcelar coisa nova nele por enquanto.": "La carte {c} a atteint {p} % de son plafond. Évitez les nouveaux achats en plusieurs fois pour le moment.",
 "O celular não avisa o app quando a tela é travada, por isso o app conta o tempo fora. Com 1 minuto, travar o celular e voltar depois pede a biometria; responder uma mensagem rápida, não.": "Le téléphone ne prévient pas l'app quand l'écran est verrouillé, c'est pourquoi l'app compte le temps passé hors de l'écran. Avec 1 minute, verrouiller le téléphone et revenir plus tard demande la biométrie ; répondre vite à un message, non.",
 "O celular serve só para confirmar que a conta é sua (código pelo WhatsApp no cadastro e ao trocar de número). Um número por conta.": "Le téléphone sert uniquement à confirmer que le compte est bien le vôtre (code par WhatsApp à l’inscription et au changement de numéro). Un numéro par compte.",
 "O compartilhamento ainda não foi ligado no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 12-LIGAR-COMPARTILHAMENTO.bat (uma vez só).": "Le partage n'a pas encore été activé sur le serveur. Sur l'ordinateur, ouvrez le dossier C:\\MyPlanner et double-cliquez sur 12-LIGAR-COMPARTILHAMENTO.bat (une seule fois).",
 "O computador vai abrir o My Planner com a sua conta. Faça isso só em computadores de confiança.": "L'ordinateur va ouvrir My Planner avec votre compte. Faites-le uniquement sur des ordinateurs de confiance.",
 "O convite leva o link do app e do APK mais recente. Quem entra pelo link cai direto no escritório.": "L'invitation contient le lien de l'app et du dernier APK. Qui rejoint par le lien arrive directement dans le bureau.",
 "O código de indicação vale só nos primeiros 30 dias da conta.": "Le code de parrainage n'est valable que pendant les 30 premiers jours du compte.",
 "O desenho fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o desenho.": "Le schéma est conservé uniquement sur cet appareil, protégé. Le mot de passe reste valable si vous oubliez le schéma.",
 "O dinheiro gasto está à frente do andamento da obra.": "Les dépenses sont en avance sur l'avancement du chantier.",
 "O documento não tem páginas.": "Le document n'a aucune page.",
 "O extrato é lido aqui no aparelho. Contas a pagar com o mesmo valor e data próxima recebem baixa automática.": "Le relevé est lu ici, sur l'appareil. Les factures à payer de même montant et de date proche sont marquées comme payées automatiquement.",
 "O extrato é lido aqui no dispositivo. Contas a pagar com o mesmo valor e data próxima recebem baixa automática. O pagamento da fatura do cartão não conta duas vezes.": "Le relevé est lu ici sur l'appareil. Les factures à payer de même montant et à date proche sont soldées automatiquement. Le paiement du relevé de carte n'est pas compté deux fois.",
 "O governo recusou a nota": "Le gouvernement a refusé la facture",
 "O governo recusou a nota.": "Le gouvernement a refusé la facture.",
 "O idioma vale para este dispositivo. Os dados que você digitou não são traduzidos.": "La langue s'applique à cet appareil. Les données que vous avez saisies ne sont pas traduites.",
 "O item vinculado foi apagado ou movido.": "L'élément lié a été supprimé ou déplacé.",
 "O item vinculado foi apagado ou movido. Edite a tarefa para escolher outro.": "L'élément lié a été supprimé ou déplacé. Modifiez la tâche pour en choisir un autre.",
 "O link antigo deixa de funcionar.": "L'ancien lien ne fonctionnera plus.",
 "O link antigo deixa de funcionar. Quem já está no grupo continua.": "L'ancien lien ne fonctionne plus. Les personnes déjà dans le groupe y restent.",
 "O link deve começar com https://": "Le lien doit commencer par https://",
 "O navegador não deixa ler o calendário das plataformas. Importe pelo app no celular.": "Le navigateur ne peut pas lire le calendrier des plateformes. Importez depuis l'app sur le téléphone.",
 "O plano básico e os períodos de teste das abas seguem as regras mostradas em Ajustes > Compras. Benefícios de indicação valem uma vez por conta.": "La formule de base et les périodes d'essai des onglets suivent les règles indiquées dans Réglages > Achats. Les avantages de parrainage ne s'appliquent qu'une fois par compte.",
 "O que acontece": "Ce qui se passe",
 "O que apagar": "Que supprimer",
 "O que comprou": "Ce que vous avez acheté",
 "O que fazer": "Que faire",
 "O que foi comido:": "Ce qui a été mangé :",
 "O que foi feito": "Ce qui a été fait",
 "O que foi visto": "Ce qui a été vu",
 "O que funcionou, o que ajustar, metodologias, resumos...": "Ce qui a marché, quoi ajuster, méthodes, résumés...",
 "O que já foi guardado continua nos lançamentos como investimento.": "Ce qui a déjà été épargné reste dans les opérations comme investissement.",
 "O que levar ou estudar": "À apporter ou à réviser",
 "O que o app pode usar": "Ce que l'app peut utiliser",
 "O que o médico disse": "Ce qu'a dit le médecin",
 "O que os seus grupos enviaram. Compromissos aceitos vão para o My Planner; materiais e avisos vão para as Anotações.": "Ce que vos groupes ont envoyé. Les rendez-vous acceptés vont dans My Planner ; les documents et annonces vont dans Notes.",
 "O que precisa": "Ce qu'il faut",
 "O que tem dentro": "Contenu du carton",
 "O que você emprestou ou pegou emprestado: foto, com quem está e aviso da devolução.": "Ce que vous avez prêté ou emprunté : photo, qui l'a et rappel du retour.",
 "O que é apagado": "Ce qui est supprimé",
 "O quê": "Quoi",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O app guarda só o atalho: o arquivo continua onde está e abre no app do celular.": "Le sélecteur affiche Google Drive, OneDrive et Dropbox quand ces apps sont installées sur le téléphone. L'app garde seulement un raccourci : le fichier reste où il est et s'ouvre dans l'app du téléphone.",
 "O seletor mostra o Google Drive, o OneDrive e o Dropbox quando esses apps estão instalados no celular. O arquivo escolhido fica guardado neste dispositivo.": "Le sélecteur affiche Google Drive, OneDrive et Dropbox lorsque ces apps sont installées sur le téléphone. Le fichier choisi est enregistré sur cet appareil.",
 "O servidor ainda não buscou para os seus perfis.": "Le serveur n’a pas encore effectué de recherche pour vos profils.",
 "O servidor ainda não está preparado para as mensagens. Rode o 17-LIGAR-MENSAGENS.bat.": "Le serveur n'est pas encore prêt pour les messages. Lancez 17-LIGAR-MENSAGENS.bat.",
 "O servidor ainda não está preparado para indicações. Tente de novo mais tarde.": "Le serveur n'est pas encore prêt pour le parrainage. Réessayez plus tard.",
 "O servidor ainda não está preparado para o cartão de contato. Rode o 19-LIGAR-CONTATO.bat.": "Le serveur n'est pas encore prêt pour la fiche contact. Lancez 19-LIGAR-CONTATO.bat.",
 "O servidor ainda não foi preparado para dados compartilhados. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "Le serveur n'est pas encore prêt pour les données partagées. Sur l'ordinateur, ouvrez le dossier C:\\MyPlanner et double-cliquez sur 15-LIGAR-GRUPOS-COLABORATIVOS.bat (une seule fois).",
 "O servidor ainda não foi preparado para o Drive e o OneDrive (veja COMO RODAR, versão 0.14).": "Le serveur n'est pas encore prêt pour Drive et OneDrive (voir COMO RODAR, version 0.14).",
 "O servidor ainda não foi preparado para o acesso pela web (rode supabase/migracao-0.6.sql).": "Le serveur n'est pas encore prêt pour l'accès web (exécutez supabase/migracao-0.6.sql).",
 "O servidor ainda não tem a função \"qr-login\". Veja o passo da versão 0.6 no COMO RODAR.": "Le serveur n'a pas encore la fonction « qr-login ». Voir l'étape de la version 0.6 dans COMO RODAR.",
 "O servidor de chamadas recusou a chave do LiveKit. No computador do administrador, rode o 30-CONSERTAR-CHAMADAS.bat.": "Le serveur d'appels a refusé la clé LiveKit. Sur l'ordinateur de l'administrateur, lancez 30-CONSERTAR-CHAMADAS.bat.",
 "O servidor de notas respondeu algo inesperado (HTTP {s}). Confira o endereço.": "Le serveur de factures a renvoyé une réponse inattendue (HTTP {s}). Vérifiez l'adresse.",
 "O servidor faz a captura automática de 2 em 2 horas, das 08h às 20h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "Le serveur effectue la capture automatique toutes les 2 heures, de 08h à 20h (heure de Brasília), même avec l’app fermée. Les publications capturées apparaissent quand vous ouvrez l’app. Vous pouvez aussi utiliser « Vérifier maintenant ».",
 "O servidor faz a captura automática todos os dias às 08h e 12h (horário de Brasília), mesmo com o app fechado. As publicações capturadas aparecem quando você abre o app. Também dá para usar \"Verificar agora\".": "Le serveur effectue la capture automatique tous les jours à 8 h et 12 h (heure de Brasília), même lorsque l'app est fermée. Les publications capturées apparaissent à l'ouverture de l'app. Vous pouvez aussi utiliser « Vérifier maintenant ».",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 32-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "Le serveur a refusé l'accès : dans la fonction « nuvem » de Supabase, désactivez « Verify JWT » (32-LIGAR-DRIVE-ONEDRIVE.bat le fait déjà).",
 "O servidor recusou o acesso: na função \"nuvem\" do Supabase, desligue \"Verify JWT\" (o 9-LIGAR-DRIVE-ONEDRIVE.bat já faz isso).": "Le serveur a refusé l'accès : dans la fonction « nuvem » de Supabase, désactivez « Verify JWT » (9-LIGAR-DRIVE-ONEDRIVE.bat le fait déjà).",
 "O seu papel no grupo não permite incluir aqui.": "Votre rôle dans le groupe ne permet pas d'ajouter ici.",
 "O site deve começar com https://": "Le site doit commencer par https://",
 "O tamanho padrão do copo ({copo}) muda em Ajustar, no quadro da água.": "La taille par défaut du verre ({copo}) se modifie dans Ajuster, dans le cadre de l’eau.",
 "O tema muda as cores das abas (os ícones continuam os mesmos) e vale nos modos claro e escuro. Depois você ainda pode trocar a cor de uma aba em Ajustes > Abas.": "Le thème change les couleurs des onglets (les icônes restent les mêmes) et s'applique aux modes clair et sombre. Vous pourrez ensuite changer la couleur d'un onglet dans Réglages > Onglets.",
 "O temporizador se enche de cor conforme o tempo da tarefa passa. Tocar nele abre o vínculo da tarefa.": "Le minuteur se remplit de couleur à mesure que le temps de la tâche passe. Le toucher ouvre le lien de la tâche.",
 "O teste grátis terminou": "L'essai gratuit est terminé",
 "O texto": "Le texte",
 "O texto do PDF num arquivo .docx para editar.": "Le texte du PDF dans un fichier .docx à modifier.",
 "O texto também vai escondido dentro do PDF: dá para buscar e copiar no leitor de PDF.": "Le texte est aussi caché dans le PDF : vous pouvez le rechercher et le copier dans votre lecteur PDF.",
 "O tom escolhido fica para os próximos emojis.": "Le teint choisi est conservé pour les prochains emojis.",
 "O total aparece no topo do My Planner. Se passar do limite, o raio fica vermelho. Tarefas \"Relaxar\" valem 0.": "Le total apparaît en haut de My Planner. Au-delà de la limite, l'éclair devient rouge. Les tâches « Détente » valent 0.",
 "OAB (opcional, para advogados)": "OAB (facultatif, pour les avocats)",
 "OBS": "REMARQUES",
 "OCR: texto pesquisável": "OCR : texte consultable",
 "OK": "OK",
 "OU ESCOLHER CÔMODO…": "OU CHOISIR UNE PIÈCE…",
 "Objetivos": "Objectifs",
 "Objeto": "Objet",
 "Objetos": "Objets",
 "Objetos e valores": "Objets et sommes",
 "Obra": "Chantier",
 "Obras": "Chantiers",
 "Obras & Reformas": "Travaux & Rénovations",
 "Obrigado": "Merci",
 "Obrigado!": "Merci !",
 "Observações": "Remarques",
 "Observações (alergias, ração...)": "Remarques (allergies, croquettes...)",
 "Observações (chave Pix, conta para depósito...)": "Remarques (clé Pix, compte pour le dépôt...)",
 "Observações (código de barras, chave Pix...)": "Remarques (code-barres, clé Pix...)",
 "Observações (dados bancários, PIX...)": "Remarques (coordonnées bancaires, PIX...)",
 "Observações (estado do item...)": "Remarques (état de l'objet...)",
 "Observações (garantia, seguro, CET...)": "Remarques (garantie, assurance, TAEG...)",
 "Observações (nº de série, modelo...)": "Remarques (nº de série, modèle...)",
 "Observações (onde está o original, categoria da CNH...)": "Remarques (où se trouve l'original, catégorie du permis...)",
 "Observações (recibo de entrega, número...)": "Remarques (bon de livraison, numéro...)",
 "Observações (restrição alimentar...)": "Remarques (restriction alimentaire...)",
 "Ocultar texto (tarja)": "Masquer du texte (bande)",
 "Ocupado": "Occupé",
 "Oficina": "Garage auto",
 "Ofício": "Légal",
 "Oi!": "Coucou !",
 "Oi! Tudo certo para sábado?": "Salut ! Tout est prêt pour samedi ?",
 "Oi, {pessoa}! Ainda estou com o(a) {coisa} que você me emprestou. Quando fica bom para eu devolver?": "Salut {pessoa} ! J'ai toujours le/la {coisa} que tu m'as prêté(e). Quand est-ce que je peux te le/la rendre ?",
 "Oi, {pessoa}! Tudo bem? Passando para lembrar do(a) {coisa} que te emprestei em {data}. Consegue devolver {quando}?": "Salut {pessoa} ! Ça va ? Petit rappel pour le/la {coisa} que je t'ai prêté(e) le {data}. Tu peux me le/la rendre {quando} ?",
 "Oi?!": "Quoi ?!",
 "Olá!": "Bonjour !",
 "Olá! Eu sou o Mestre Achado. Pergunte sobre os seus gastos, contas, cartões e metas: eu respondo com os seus números.": "Bonjour ! Je suis le Mestre Achado. Posez-moi vos questions sur vos dépenses, factures, cartes et objectifs : je réponds avec vos chiffres.",
 "Olá! Passando para lembrar do pagamento de {ref} ({v}), com vencimento em {d}. Obrigado(a)!": "Bonjour ! Petit rappel pour le paiement de {ref} ({v}), à régler le {d}. Merci !",
 "Olá! Preciso de assistência técnica para: {item}": "Bonjour ! J'ai besoin d'une assistance technique pour : {item}",
 "Olá, {nome}!": "Bonjour {nome} !",
 "Olá, {nome}! Seja bem-vindo(a).": "Bonjour {nome} ! Bienvenue.",
 "Ombros: girar para trás": "Épaules : rouler vers l'arrière",
 "Omelete": "Omelette",
 "Onde": "Où",
 "Onde a IA ajuda: Publicações (audiências e prazos), Documentos (preencher a ficha pela foto) e Anotações (transformar uma caixa em tarefas).": "Où l'IA aide : Publications (audiences et délais), Documents (remplir la fiche à partir de la photo) et Notes (transformer une boîte en tâches).",
 "Onde assistir": "Où regarder",
 "Onde eu mais gastei este mês?": "Où ai-je le plus dépensé ce mois-ci ?",
 "Onde fica": "Emplacement",
 "Onde guardar fotos e arquivos novos": "Où enregistrer les nouvelles photos et nouveaux fichiers",
 "Onde na página": "Où sur la page",
 "Ontem": "Hier",
 "Organizar": "Organiser",
 "Organizar barra": "Organiser la barre",
 "Organizar com IA": "Organiser avec l'IA",
 "Organizar com IA (vira tarefas)": "Organiser avec l'IA (devient des tâches)",
 "Organizar páginas": "Organiser les pages",
 "Orgulho e vibrante": "Fierté et éclatant",
 "Origem": "Origine",
 "Origem da reserva": "Provenance de la réservation",
 "Original": "Original",
 "Orquídeas": "Orchidées",
 "Orçado": "Budgété",
 "Orçamento": "Budget",
 "Orçamento do mês": "Budget du mois",
 "Orçamento por categoria": "Budget par catégorie",
 "Orçamento total": "Budget total",
 "Orçamento: {v}": "Budget : {v}",
 "Os alertas precisam de um horário.": "Les alertes nécessitent une heure.",
 "Os anexos que ficam só no dispositivo não aparecem nos outros dispositivos e se perdem se o celular for trocado. Ligue o Google Drive ou o OneDrive em Ajustes para guardar uma cópia.": "Les pièces jointes stockées uniquement sur l'appareil n'apparaissent pas sur vos autres appareils et sont perdues si vous changez de téléphone. Activez Google Drive ou OneDrive dans Réglages pour en garder une copie.",
 "Os arquivos e cópias que já estão lá continuam lá. O My Planner só deixa de guardar coisas novas.": "Les fichiers et sauvegardes déjà présents y restent. My Planner arrête simplement d'enregistrer de nouveaux éléments.",
 "Os arquivos guardados neste dispositivo também serão apagados.": "Les fichiers enregistrés sur cet appareil seront aussi supprimés.",
 "Os arquivos que estão no seu Google Drive, OneDrive ou no celular continuam com você. Registros que a lei obriga a guardar (como os de acesso) podem ficar guardados pelo prazo legal e depois são apagados.": "Les fichiers de votre Google Drive, OneDrive ou téléphone restent chez vous. Les enregistrements que la loi oblige à conserver (comme les journaux d'accès) peuvent être conservés pendant la durée légale puis supprimés.",
 "Os avisos do grupo ainda não foram ligados no servidor. No computador, dê dois cliques em 15-LIGAR-GRUPOS-COLABORATIVOS.bat (uma vez só).": "Les avis du groupe ne sont pas encore activés sur le serveur. Sur l'ordinateur, double-cliquez sur 15-LIGAR-GRUPOS-COLABORATIVOS.bat (une seule fois).",
 "Os avisos estão desligados para o My Planner. Toque em Abrir configurações e ligue as notificações.": "Les notifications sont désactivées pour My Planner. Touchez Ouvrir les réglages et activez les notifications.",
 "Os avisos no celular funcionam no app instalado (Android ou iPhone).": "Les notifications sur le téléphone fonctionnent dans l'app installée (Android ou iPhone).",
 "Os campos do formulário viram parte da página.": "Les champs du formulaire font désormais partie de la page.",
 "Os dados atuais serão substituídos pelos do arquivo, aqui e na nuvem.": "Les données actuelles seront remplacées par celles du fichier, ici et dans le cloud.",
 "Os dados continuam salvos na nuvem.": "Les données restent enregistrées dans le cloud.",
 "Os dados da aba ainda são só seus": "Les données de l'onglet ne sont encore qu'à vous",
 "Os dados da aba {aba} passam a ser vistos pela equipe, cada pessoa conforme o papel que você escolher.": "Les données de l'onglet {aba} deviennent visibles par l'équipe, chacun selon le rôle que vous choisissez.",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo abrir o My Planner atualizado: o app libera sozinho.": "Les données de ce groupe ne sont pas encore débloquées. Demandez à la personne qui a créé le groupe d'ouvrir My Planner à jour : l'app les débloque toute seule.",
 "Os dados deste grupo ainda não foram liberados. Peça para quem criou o grupo atualizar o My Planner e abrir o grupo: lá aparece o botão para liberar.": "Les données de ce groupe n'ont pas encore été débloquées. Demandez à la personne qui a créé le groupe de mettre à jour My Planner et d'ouvrir le groupe : le bouton pour débloquer y apparaît.",
 "Os dados do cofre são criptografados aqui no dispositivo (AES-256) antes de ir para a nuvem. Nem o suporte consegue ler. Se esquecer a senha do cofre, esses dados não podem ser recuperados.": "Les données du coffre sont chiffrées ici sur l'appareil (AES-256) avant d'aller dans le cloud. Même le support ne peut pas les lire. Si vous oubliez le mot de passe du coffre, ces données sont irrécupérables.",
 "Os dados ficam guardados enquanto a conta existir. Ao apagar a conta, os dados são apagados, salvo o que a lei obrigar a manter.": "Les données sont conservées tant que le compte existe. À la suppression du compte, les données sont effacées, sauf ce que la loi oblige à conserver.",
 "Os desenhos não conferem. Comece de novo.": "Les schémas ne correspondent pas. Recommencez.",
 "Os dias estão no app ou na fatura do banco. Compras feitas depois do fechamento caem na fatura seguinte.": "Les jours figurent dans l'app ou sur le relevé de la banque. Les achats faits après la clôture passent sur le relevé suivant.",
 "Os emojis que você usar aparecem aqui.": "Les emojis que vous utilisez apparaissent ici.",
 "Os grupos ainda não foram ligados no servidor. No computador, abra a pasta C:\\MyPlanner e dê dois cliques em 11-LIGAR-GRUPOS.bat (uma vez só).": "Les groupes ne sont pas encore activés sur le serveur. Sur l'ordinateur, ouvrez le dossier C:\\MyPlanner et double-cliquez sur 11-LIGAR-GRUPOS.bat (une seule fois).",
 "Os grupos ainda não foram ligados no servidor. Rode o supabase\\migracao-0.21.sql no Supabase (veja o COMO RODAR).": "Les groupes ne sont pas encore activés sur le serveur. Exécutez supabase\\migracao-0.21.sql dans Supabase (voir COMO RODAR).",
 "Os lugares abrem no Google Maps, no Waze ou no Mapas, como escolhido em Ajustes.": "Les lieux s'ouvrent dans Google Maps, Waze ou Plans, selon votre choix dans Réglages.",
 "Os membros sempre veem os administradores e só recebem o que foi enviado para eles.": "Les membres voient toujours les administrateurs et ne reçoivent que ce qui leur a été envoyé.",
 "Os outros membros deixam de ver os dados (a cópia some do dispositivo deles). Tudo continua com você.": "Les autres membres ne voient plus les données (la copie disparaît de leurs appareils). Tout reste chez vous.",
 "Os perfis e os resultados ficam na sua conta do My Planner.": "Les profils et les résultats restent dans votre compte My Planner.",
 "Os perfis, as OABs e os tribunais ficam dentro da aba Publicações. A busca automática roda no servidor às 08h e às 12h (horário de Brasília).": "Les profils, les numéros OAB et les tribunaux se trouvent dans l'onglet Publications. La recherche automatique s'exécute sur le serveur à 08h et à 12h (heure de Brasília).",
 "Os preços ficam guardados e aparecem na lista de Compras da aba Alimentação & Despensa como o preço da última compra.": "Les prix sont enregistrés et apparaissent dans la liste d'Achats de l'onglet Alimentation & Garde-manger comme prix du dernier achat.",
 "Os resultados deste perfil também serão apagados.": "Les résultats de ce profil seront aussi supprimés.",
 "Os termos foram atualizados": "Les conditions ont été mises à jour",
 "Ou digite (ex.: 2 ovos mexidos)": "Ou saisissez (ex. : 2 œufs brouillés)",
 "Ou escreva o prato": "Ou écrivez le plat",
 "Ou escreva o seu": "Ou écrivez le vôtre",
 "Outra": "Autre",
 "Outra aba…": "Un autre onglet…",
 "Outra atividade (digite e dê Enter)": "Autre activité (saisissez puis Entrée)",
 "Outro": "Autre",
 "Outro (ml)": "Autre (ml)",
 "Outro valor": "Autre montant",
 "Outros": "Autres",
 "Outros países": "Autres pays",
 "Outros relógios (Garmin, Samsung, Xiaomi, Amazfit...): no app do relógio, ligue a opção de enviar os dados para o app Saúde (Apple Health).": "Autres montres (Garmin, Samsung, Xiaomi, Amazfit...) : dans l'app de la montre, activez l'option d'envoi des données vers l'app Santé (Apple Santé).",
 "Ovo": "Œuf",
 "PAGO, RECEBIDO, CONFIDENCIAL, APROVADO ou o seu texto, com a data.": "PAYÉ, REÇU, CONFIDENTIEL, APPROUVÉ ou votre texte, avec la date.",
 "PARA ACERTAR": "À ÉQUILIBRER",
 "PARA QUEM": "DESTINATAIRES",
 "PARA {refeicao}": "POUR {refeicao}",
 "PASSO A PASSO": "ÉTAPE PAR ÉTAPE",
 "PASSO {n}": "ÉTAPE {n}",
 "PDF": "PDF",
 "PDF Edit": "PDF Edit",
 "PDF com texto digital: sai na hora no navegador. PDF escaneado (foto): a sua IA lê cada página.": "PDF avec texte numérique : instantané dans le navigateur. PDF scanné (photo) : votre IA lit chaque page.",
 "PDF grande": "PDF volumineux",
 "PDF guardado na pasta \"{pasta}\" do celular.": "PDF enregistré dans le dossier \"{pasta}\" du téléphone.",
 "PDF guardado no {nome}.": "PDF enregistré dans {nome}.",
 "PDF numa página só": "PDF sur une seule page",
 "PDF para Word": "PDF en Word",
 "PDF para imagens": "PDF en images",
 "PDF para texto": "PDF en texte",
 "PDFs arquivados ({n})": "PDF archivés ({n})",
 "PDFs juntados {data}": "PDF fusionnés {data}",
 "PEDIDOS RECEBIDOS": "DEMANDES REÇUES",
 "PIX": "PIX",
 "PIX COPIA E COLA": "PIX COPIER-COLLER",
 "PRÓXIMAS FATURAS (JÁ COMPROMETIDO)": "PROCHAINS RELEVÉS (DÉJÀ ENGAGÉ)",
 "Paciente": "Patient",
 "Paciente ou aluno": "Patient ou élève",
 "Pacientes": "Patients",
 "Padrão": "Par défaut",
 "Padrão da aba": "Par défaut de l'onglet",
 "Paga": "Payée",
 "Paga (toque para desfazer)": "Payée (touchez pour annuler)",
 "Pagador": "Payeur",
 "Pagamento já contado": "Paiement déjà compté",
 "Pagar": "Payer",
 "Pagar parcela {n}/{t} · {c}": "Payer l'échéance {n}/{t} · {c}",
 "Pagas": "Payées",
 "Pago": "Payé",
 "Pago com": "Payé avec",
 "Pago: {p} · Falta pagar: {f}": "Payé : {p} · Reste à payer : {f}",
 "Pagos": "Payés",
 "Pagou {v}? Se teve desconto, multa ou juros, informe o valor pago. Quer guardar o comprovante agora?": "Vous avez payé {v} ? En cas de remise, de pénalités ou d'intérêts, indiquez le montant payé. Enregistrer le justificatif maintenant ?",
 "Paguei outro valor (desconto, multa ou juros)": "J'ai payé un autre montant (remise, pénalités ou intérêts)",
 "Paixão de Cristo": "Vendredi saint",
 "Palavras-chave (separe com vírgula)": "Mots-clés (séparés par des virgules)",
 "Para a meta \"{m}\" chegar no prazo, seriam {v} por mês. Vale esticar o prazo ou começar com um valor menor.": "Pour atteindre l'objectif « {m} » à temps, il faudrait {v} par mois. Pensez à allonger le délai ou à commencer avec un montant plus petit.",
 "Para clareza, firmo o presente.": "En foi de quoi, je signe la présente.",
 "Para comprar": "À acheter",
 "Para continuar, digite a senha do app.": "Pour continuer, saisissez le mot de passe de l'app.",
 "Para conversar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "Pour discuter, activez votre IA dans Réglages › Intelligence artificielle (Claude, ChatGPT ou Gemini).",
 "Para dividir as despesas, escreva em \"Quem vai\" os nomes separados por vírgula (edite a viagem).": "Pour partager les dépenses, écrivez dans « Qui vient » les noms séparés par des virgules (modifiez le voyage).",
 "Para emitir e buscar notas, ligue uma vez o servidor de notas: no computador, dê dois cliques em 13-LIGAR-NOTAS.bat e cole aqui o endereço que ele mostrar (termina em .netlify.app).": "Pour émettre et rechercher des factures, lancez une fois le serveur de factures : sur l'ordinateur, double-cliquez sur 13-LIGAR-NOTAS.bat et collez ici l'adresse qu'il affiche (elle se termine par .netlify.app).",
 "Para exercer seus direitos, use Fale conosco no app ou escreva para o e-mail abaixo. Respondemos em até 15 dias.": "Pour exercer vos droits, utilisez Nous contacter dans l'app ou écrivez à l'adresse e-mail ci-dessous. Nous répondons sous 15 jours.",
 "Para fazer chamadas de áudio e vídeo, instale a versão nova do app (0.35). As mensagens já funcionam.": "Pour passer des appels audio et vidéo, installez la nouvelle version de l'app (0.35). Les messages fonctionnent déjà.",
 "Para fazer o app funcionar: guardar e sincronizar seus dados entre dispositivos, mandar alertas, compartilhar com os grupos que você escolheu e dar suporte.": "Pour faire fonctionner l'app : conserver et synchroniser vos données entre appareils, envoyer des alertes, partager avec les groupes que vous avez choisis et fournir l'assistance.",
 "Para guardar os PDFs no {nome}, conecte a sua conta em Ajustes › Google Drive e OneDrive.": "Pour enregistrer les PDF dans {nome}, connectez votre compte dans Réglages › Google Drive et OneDrive.",
 "Para hoje": "Pour aujourd'hui",
 "Para ler foto ou PDF, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini). O extrato em OFX ou CSV funciona sem IA.": "Pour lire une photo ou un PDF, activez votre IA dans Réglages › Intelligence artificielle (Claude, ChatGPT ou Gemini). Le relevé en OFX ou CSV fonctionne sans IA.",
 "Para ler o relógio automaticamente, instale a versão nova do app (0.33). Enquanto isso, dá para digitar à mão.": "Pour lire la montre automatiquement, installez la nouvelle version de l'app (0.33). En attendant, vous pouvez saisir les données manuellement.",
 "Para ler o relógio, conecte pelo app no celular. Os números aparecem aqui também.": "Pour lire la montre, connectez-la depuis l'app sur le téléphone. Les chiffres apparaissent aussi ici.",
 "Para ler o relógio, libere os dados de atividade para o My Planner.": "Pour lire la montre, autorisez My Planner à accéder aux données d'activité.",
 "Para ler o texto, resumir e perguntar, ligue a sua IA em Ajustes › Inteligência artificial (Claude, ChatGPT ou Gemini).": "Pour lire le texte, résumer et poser des questions, activez votre IA dans Réglages › Intelligence artificielle (Claude, ChatGPT ou Gemini).",
 "Para ligar, use o app no celular (Ajustes > Agenda do Google). Depois, tudo aparece aqui também.": "Pour l'activer, utilisez l'app sur le téléphone (Réglages > Google Agenda). Ensuite, tout apparaîtra aussi ici.",
 "Para ligar, use o app no celular (Ajustes › Configuração geral › Agenda do Google). Depois, tudo aparece aqui também.": "Pour l'activer, utilisez l'app sur le téléphone (Réglages › Réglages généraux › Google Agenda). Ensuite, tout apparaîtra aussi ici.",
 "Para monitorar a OAB, informe o número e a UF.": "Pour suivre l'OAB, indiquez le numéro et l'État (UF).",
 "Para não perguntar mais, escolha o app em Ajustes › Configuração geral.": "Pour ne plus demander, choisissez l'app dans Réglages › Réglages généraux.",
 "Para profissionais de saúde: pacientes, evolução no cofre, prescrições com modelos, financeiro, recibo e declaração para reembolso em PDF.": "Pour les professionnels de santé : patients, évolution dans le coffre, prescriptions avec modèles, finances, reçu et attestation de remboursement en PDF.",
 "Para profissionais de saúde: pacientes, evolução, prescrições com modelos, financeiro com convênio, recibo e declaração para reembolso.": "Pour les professionnels de santé : patients, évolution, prescriptions avec modèles, finances avec mutuelle, reçu et attestation de remboursement.",
 "Para proteger a sua conta, confirmamos o seu celular uma vez, com um código pelo WhatsApp. Ele só é pedido de novo se você trocar de número.": "Pour protéger votre compte, nous confirmons votre téléphone une seule fois, avec un code par WhatsApp. Il n’est redemandé que si vous changez de numéro.",
 "Para quem aluga o imóvel ou um cômodo por temporada (Airbnb, Booking ou direto): reservas, limpeza, despesas e o lucro de cada mês.": "Pour ceux qui louent leur logement ou une chambre en courte durée (Airbnb, Booking ou en direct) : réservations, ménage, dépenses et bénéfice de chaque mois.",
 "Para receber a agenda, o local e os avisos do evento no celular, entre no grupo: {link}": "Pour recevoir le programme, le lieu et les avis de l'événement sur votre téléphone, rejoignez le groupe : {link}",
 "Para sincronizar, libere o acesso à agenda para o My Planner nas configurações do celular.": "Pour synchroniser, autorisez My Planner à accéder à l'agenda dans les réglages du téléphone.",
 "Para tirar uma permissão que você já deu ao sistema (câmera, fotos, microfone), use também os ajustes do celular.": "Pour retirer une autorisation déjà accordée au système (appareil photo, photos, micro), utilisez aussi les réglages du téléphone.",
 "Para uma leitura mais completa, ligue a sua IA em Ajustes › Inteligência artificial.": "Pour une lecture plus complète, activez votre IA dans Réglages › Intelligence artificielle.",
 "Parabéns": "Bravo",
 "Parabéns!": "Félicitations !",
 "Parada": "Immobile",
 "Parar": "Arrêter",
 "Parar de compartilhar?": "Arrêter le partage ?",
 "Parar e salvar": "Arrêter et enregistrer",
 "Parar gravação": "Arrêter l'enregistrement",
 "Parcela": "Échéance",
 "Parcela de financiamento": "Échéance de financement",
 "Parcela {n}/{t}": "Échéance {n}/{t}",
 "Parcela {n}/{t} · {c}": "Échéance {n}/{t} · {c}",
 "Parcelas": "Échéances",
 "Parcelas a pagar nos próximos meses": "Échéances à payer dans les prochains mois",
 "Parcelas recalculadas": "Échéances recalculées",
 "Parece que foi impresso e escaneado.": "Comme s'il avait été imprimé puis scanné.",
 "Parei": "Abandonné",
 "Parei na aula": "Arrêté au cours",
 "Parei na aula...": "Arrêté au cours...",
 "Pares de meia": "Paires de chaussettes",
 "Parque ou natureza": "Parc ou nature",
 "Parques": "Parcs",
 "Parte": "Partie",
 "Partes": "Parties",
 "Participa": "Participant",
 "Participantes": "Participants",
 "Participação em empresa": "Parts de société",
 "Passa do limite do MEI: fale com seu contador.": "Dépasse le plafond du MEI : parlez-en à votre comptable.",
 "Passaporte": "Passeport",
 "Passe o dedo sobre o desenho para apagar só aquele pedaço.": "Passez le doigt sur le dessin pour effacer seulement cette partie.",
 "Passeio": "Sortie",
 "Passeios": "Sorties",
 "Passo a passo": "Étape par étape",
 "Passos": "Pas",
 "Passos, exercício, calorias, batimentos e sono": "Pas, exercice, calories, fréquence cardiaque et sommeil",
 "Passou do orçamento": "Budget dépassé",
 "Passou do orçamento em {v}": "Budget dépassé de {v}",
 "Pasta": "Dossier",
 "Patrimônio": "Patrimoine",
 "Patrimônio & Imposto de Renda": "Patrimoine & Impôt sur le revenu",
 "Patrimônio pelo valor de compra: {v}": "Patrimoine au prix d'achat : {v}",
 "Pausa (s)": "Repos (s)",
 "Pausa de {m} min": "Pause de {m} min",
 "Pausado": "En pause",
 "Pausar": "Pause",
 "Pausas": "Pauses",
 "Pausas de estudo": "Pauses d'étude",
 "Pauta (opcional)": "Ordre du jour (facultatif)",
 "Paz": "Paix",
 "Pediatra": "Pédiatre",
 "Pedido": "Demande",
 "Pedido enviado para {nome}. Quando aceitar, vocês já podem conversar.": "Demande envoyée à {nome}. Dès qu'elle sera acceptée, vous pourrez discuter.",
 "Pedido enviado. Quando a pessoa aceitar, vocês já podem conversar.": "Demande envoyée. Dès que la personne l'acceptera, vous pourrez discuter.",
 "Pedidos de documentos": "Demandes de documents",
 "Pedir de novo depois de": "Redemander après",
 "Peguei emprestado": "J'ai emprunté",
 "Peito de frango": "Blanc de poulet",
 "Peixe": "Poisson",
 "Pela última compra: cerca de {v}": "D'après le dernier achat : environ {v}",
 "Pelas contas que ainda vencem este mês, vão faltar {v}. Veja o que dá para adiar ou cortar antes de assumir gasto novo.": "Avec les factures qui arrivent encore à échéance ce mois-ci, il vous manquera {v}. Voyez ce que vous pouvez reporter ou réduire avant toute nouvelle dépense.",
 "Pendente": "En attente",
 "Pensão alimentícia": "Pension alimentaire",
 "Pequena": "Petite",
 "Pequeno": "Petit",
 "Percentual de tributos do Simples (para sair na nota)": "Pourcentage d'impôts du Simples (à afficher sur la facture)",
 "Perguntar ao Mestre": "Demander au Mestre",
 "Perguntar sempre": "Toujours demander",
 "Pergunte ao Mestre...": "Demandez au Mestre...",
 "Pergunte sobre o documento (ex.: qual o prazo?)": "Posez une question sur le document (ex. : quel est le délai ?)",
 "Permissões": "Autorisations",
 "Personalizado": "Personnalisé",
 "Perto do limite do orçamento": "Proche de la limite du budget",
 "Período": "Période",
 "Período da meta": "Période de l'objectif",
 "Pescoço: inclinar para os lados": "Cou : incliner sur les côtés",
 "Peso": "Poids",
 "Peso na média": "Coefficient",
 "Pesquisar no mapa": "Rechercher sur la carte",
 "Pessoa": "Personne",
 "Pessoa de contato": "Personne à contacter",
 "Pessoas dos seus grupos veem só o que for compartilhado no grupo.": "Les membres de vos groupes ne voient que ce qui est partagé dans le groupe.",
 "Pet": "Animal",
 "Pet & Família": "Animaux & Famille",
 "Pet shop": "Toilettage",
 "Pet shop ou clínica": "Toiletteur ou clinique",
 "Pets": "Animaux",
 "Peça documentos ao cliente com prazo. Ele recebe, anexa e marca como entregue.": "Demandez des documents au client avec un délai. Il reçoit la demande, joint les fichiers et la marque comme livrée.",
 "Pijamas": "Pyjamas",
 "Pilates": "Pilates",
 "Pintura": "Peinture",
 "Pix copia e cola": "Pix copier-coller",
 "Placa": "Plaque",
 "Planejado": "Prévu",
 "Planejado e comido": "Prévu et mangé",
 "Planilha": "Tableur",
 "Planilha (Excel)": "Tableur (Excel)",
 "Planilha do mês para o Receita Saúde": "Tableau du mois pour Receita Saúde",
 "Planner": "Planner",
 "Plano básico: My Planner + Anotações": "Forfait de base : My Planner + Notes",
 "Plano de aula": "Plan de cours",
 "Plano de saúde": "Mutuelle santé",
 "Planos de aula": "Plans de cours",
 "Planta": "Plante",
 "Plantas": "Plantes",
 "Plantas & Jardim": "Plantes & Jardin",
 "Plataforma ou escola": "Plateforme ou école",
 "Pneus novos": "Pneus neufs",
 "Podcast": "Podcast",
 "Pode confirmar sua presença respondendo esta mensagem?": "Pouvez-vous confirmer votre présence en répondant à ce message ?",
 "Polichinelo": "Jumping jacks",
 "Polo ativo": "Partie demanderesse",
 "Polo passivo": "Partie défenderesse",
 "Política de privacidade (LGPD)": "Politique de confidentialité (LGPD)",
 "Política de privacidade, LGPD e permissões": "Politique de confidentialité, LGPD et autorisations",
 "Política de privacidade, LGPD e termos": "Politique de confidentialité, LGPD et conditions",
 "Ponha aqui as fotos e os vídeos da viagem. No grupo, todos veem e todos podem pôr as suas.": "Mettez ici les photos et vidéos du voyage. Dans le groupe, tout le monde les voit et chacun peut ajouter les siennes.",
 "Ponte de glúteos": "Pont fessier",
 "Ponto facultativo": "Jour chômé facultatif",
 "Ponto facultativo: {nome}": "Jour chômé facultatif : {nome}",
 "Ponto turístico": "Site touristique",
 "Pontos turísticos": "Sites touristiques",
 "Por dia": "Par jour",
 "Por faixas": "Par plages",
 "Por mês": "Par mois",
 "Por nome": "Par nom",
 "Por semana": "Par semaine",
 "Portal": "Portail",
 "Portal do Cliente": "Portail client",
 "Portal do cliente (convidar o cliente)": "Portail client (inviter le client)",
 "Português": "Portugais",
 "Porão": "Sous-sol",
 "Porções": "Portions",
 "Pouco espaço livre: fotos e anexos novos podem não ser salvos. Libere espaço ou guarde os anexos no Google Drive ou OneDrive.": "Peu d'espace libre : les nouvelles photos et pièces jointes risquent de ne pas être enregistrées. Libérez de l'espace ou stockez-les sur Google Drive ou OneDrive.",
 "Praia": "Plage",
 "Prancha": "Gainage",
 "Prato do cardápio": "Plat du menu",
 "Prato principal": "Plat principal",
 "Prazo": "Délai",
 "Prazo (pagamento ou entrega)": "Échéance (paiement ou livraison)",
 "Prazo até {fim} · fazer em {dia}": "Délai jusqu'au {fim} · à faire le {dia}",
 "Prazo final: {fim}": "Délai final : {fim}",
 "Prazo: {d}": "Échéance : {d}",
 "Prazo: {t}": "Échéance : {t}",
 "Prazos criados": "Échéances créées",
 "Precisa da sua IA": "Nécessite votre IA",
 "Preencha a descrição, o código de tributação nacional (6 números) e o valor.": "Remplissez la description, le code fiscal national (6 chiffres) et le montant.",
 "Preenche os campos do PDF e, se quiser, trava.": "Remplit les champs du PDF et, si vous voulez, les verrouille.",
 "Preencher formulário": "Remplir un formulaire",
 "Preencher pela foto com a minha IA": "Remplir à partir de la photo avec mon IA",
 "Preencher pela nota fiscal com a minha IA": "Remplir avec la facture grâce à mon IA",
 "Preparando a conversa da equipe...": "Préparation de la conversation d'équipe...",
 "Preparando a página {n} de {total}...": "Préparation de la page {n} sur {total}...",
 "Preparando o arquivo": "Préparation du fichier",
 "Prescrição, conduta e orientações": "Prescription, conduite et consignes",
 "Presente": "Présent",
 "Presença": "Présence",
 "Pressione e segure o código para copiar, ou toque em Enviar e escolha \"Copiar\".": "Appuyez longuement sur le code pour le copier, ou touchez Envoyer et choisissez « Copier ».",
 "Pressione e segure o código para copiar.": "Appuyez longuement sur le code pour le copier.",
 "Pressione e segure um lançamento para apagar.": "Appuyez longuement sur une écriture pour la supprimer.",
 "Pressione e segure um perfil para removê-lo.": "Appuyez longuement sur un profil pour le supprimer.",
 "Preto e branco": "Noir et blanc",
 "Previdência privada": "Retraite complémentaire",
 "Preço ou ingresso": "Prix ou billet",
 "Price": "Annuités constantes (Price)",
 "Primeira": "Première",
 "Primeira cota ou cota única do IR": "Premier versement ou versement unique de l'IR",
 "Primeira parcela na fatura de {mes}, que vence {data}.": "Première échéance sur le relevé de {mes}, à payer le {data}.",
 "Prioridade": "Priorité",
 "Privacidade": "Confidentialité",
 "Privacidade e termos": "Confidentialité et conditions",
 "Privacidade: o texto ou a imagem analisada vai direto deste dispositivo para a empresa da IA escolhida, com a sua chave. O My Planner não guarda cópia.": "Confidentialité : le texte ou l'image analysé va directement de cet appareil à l'entreprise de l'IA choisie, avec votre clé. My Planner n'en garde aucune copie.",
 "Problema": "Problème",
 "Problemas, erros e sugestões": "Problèmes, bugs et suggestions",
 "Procedimento": "Acte",
 "Procedimento: {c}": "Acte : {c}",
 "Processo": "Procédure",
 "Processo Civil": "Procédure civile",
 "Processo Penal": "Procédure pénale",
 "Processo do Trabalho": "Procédure prud'homale",
 "Processo não informado": "Procédure non indiquée",
 "Proclamação da República": "Proclamation de la République",
 "Procurando a folha...": "Recherche de la feuille...",
 "Procurando atualização...": "Recherche de mise à jour...",
 "Procurar aba": "Rechercher un onglet",
 "Procurar atualização agora": "Rechercher une mise à jour",
 "Procurar documento": "Rechercher un document",
 "Procurar ferramenta (ex.: juntar, assinar, comprimir)": "Chercher un outil (ex. : fusionner, signer, compresser)",
 "Produto": "Produit",
 "Produto (ex.: Geladeira)": "Produit (ex. : Réfrigérateur)",
 "Produtos, notas fiscais, assistência técnica e aviso antes de vencer.": "Produits, factures, SAV et alerte avant l'expiration.",
 "Produção (vale de verdade)": "Production (valeur légale)",
 "Produção restrita (teste)": "Production restreinte (test)",
 "Produção restrita (teste, não vale)": "Production restreinte (test, sans valeur)",
 "Produção restrita: ambiente de teste do governo. As notas não valem. Teste tudo aqui antes de mudar para Produção (em Editar).": "Production restreinte : environnement de test du gouvernement. Les factures n'ont pas de valeur. Testez tout ici avant de passer en Production (dans Modifier).",
 "Produção: as notas emitidas valem de verdade e vão para a prefeitura e a Receita.": "Production : les factures émises ont une valeur légale et sont transmises à la mairie et à la Receita Federal.",
 "Produção: vale de verdade": "Production : valeur légale",
 "Professor": "Enseignant",
 "Professor & Mentoria": "Enseignant & Mentorat",
 "Professor(a)": "Enseignant(e)",
 "Profissionais": "Artisans",
 "Profissional": "Artisan",
 "Profissional assistente": "Professionnel assistant",
 "Profissional ou fornecedor": "Artisan ou fournisseur",
 "Profissional ou local": "Professionnel ou lieu",
 "Profissão ou especialidade": "Profession ou spécialité",
 "Profissões": "Métiers",
 "Programação": "Programmation",
 "Progresso geral": "Progression globale",
 "Projeto e licenças": "Projet et permis",
 "Projetos": "Projets",
 "Prontas": "Prêts",
 "Pronto": "Terminé",
 "Pronto! Todas as abas estão liberadas até {data}.": "C'est fait ! Tous les onglets sont débloqués jusqu'au {data}.",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer com som.": "C’est fait. Verrouillez l’écran et attendez 1 minute : l’alerte doit apparaître avec du son.",
 "Prontuário, evolução e prescrições, sem o financeiro.": "Dossier médical, suivi et prescriptions, sans la partie financière.",
 "Protegendo a chave...": "Protection de la clé...",
 "Proteger no cofre": "Protéger dans le coffre",
 "Protegido": "Protégé",
 "Protegido no cofre": "Protégé dans le coffre",
 "Protegidos pelo cofre: {n}": "Protégés par le coffre : {n}",
 "Protetor solar": "Écran solaire",
 "Protocolo": "Numéro de dossier",
 "Prova": "Contrôle",
 "Próxima": "Prochaine",
 "Próxima até a data": "Prochaine avant le",
 "Próxima com quantos km": "Prochaine à combien de km",
 "Próxima dose": "Prochaine dose",
 "Próxima: {data}": "Prochaine : {data}",
 "Próxima: {d} · {v}": "Prochaine : {d} · {v}",
 "Próximas": "À venir",
 "Próximo": "Suivant",
 "Próximo ano": "Année suivante",
 "Próximo número da DPS": "Prochain numéro de DPS",
 "Próximos 7 dias": "7 prochains jours",
 "Próximos vencimentos ({n})": "Prochaines échéances ({n})",
 "Publicação": "Publication",
 "Publicações": "Publications",
 "Pula": "Saute",
 "Pulsa": "Pulse",
 "Punho": "Poing",
 "Puxada frontal": "Tirage vertical",
 "PÁGINAS": "PAGES",
 "PÔR NA BARRA": "ÉPINGLER À LA BARRE",
 "Pág. {n}": "P. {n}",
 "Página": "Page",
 "Página 1": "Page 1",
 "Página 1 de 10": "Page 1 sur 10",
 "Página em branco no fim": "Page blanche à la fin",
 "Página em que estou": "Page où j'en suis",
 "Página escaneada": "Page numérisée",
 "Página inteira": "Page entière",
 "Página {a} de {n}": "Page {a} sur {n}",
 "Página {n}": "Page {n}",
 "Página {n} de {total}": "Page {n} sur {total}",
 "Página: {titulo}": "Page : {titulo}",
 "Páginas": "Pages",
 "Páginas, tamanho, autor, datas e campos.": "Pages, taille, auteur, dates et champs.",
 "Pássaro": "Oiseau",
 "Pão francês": "Petit pain",
 "Pão integral": "Pain complet",
 "Pôr a data de hoje": "Ajouter la date du jour",
 "Pôr as parcelas no My Planner": "Ajouter les échéances à My Planner",
 "Pôr na barra": "Épingler à la barre",
 "Pôr no roteiro da viagem": "Ajouter à l'itinéraire du voyage",
 "Pôr uma foto": "Ajouter une photo",
 "Quadro": "Tableau",
 "Quadro Kanban, cronômetro de horas por cliente e prazos no My Planner.": "Tableau Kanban, chronomètre d'heures par client et échéances dans My Planner.",
 "Quais contas vencem nos próximos dias?": "Quelles factures arrivent à échéance dans les prochains jours ?",
 "Quais páginas ficam no PDF novo": "Pages à garder dans le nouveau PDF",
 "Quais páginas sair": "Pages à retirer",
 "Qual IA": "Quelle IA",
 "Qualidade alta": "Haute qualité",
 "Qualidade boa (menor)": "Bonne qualité (plus léger)",
 "Quantidade": "Quantité",
 "Quanto cortar de cada lado (% da página)": "Combien couper de chaque côté (% de la page)",
 "Quanto já tem guardado (opcional)": "Montant déjà épargné (facultatif)",
 "Quanto paga por limpeza": "Tarif par ménage",
 "Quanto preciso guardar por mês para as minhas metas?": "Combien dois-je épargner par mois pour mes objectifs ?",
 "Quanto quer juntar": "Montant à atteindre",
 "Quanto você quer gastar, no máximo, em cada categoria por mês. Deixe em branco para não controlar.": "Le maximum que vous voulez dépenser dans chaque catégorie par mois. Laissez vide pour ne pas la suivre.",
 "Quarta": "Mercredi",
 "Quarta-feira de Cinzas (até 14h)": "Mercredi des Cendres (jusqu'à 14 h)",
 "Quarto": "Chambre",
 "Quarto das crianças": "Chambre des enfants",
 "Quarto de casal": "Chambre parentale",
 "Quarto de hóspedes": "Chambre d'amis",
 "Quarto infantil": "Chambre d'enfant",
 "Queijo": "Fromage",
 "Queixa principal": "Motif de consultation",
 "Quem abrir o link baixa o My Planner (ou usa no navegador), entra na conta e passa a fazer parte do grupo.": "Quiconque ouvre le lien télécharge My Planner (ou l'utilise dans le navigateur), se connecte et rejoint le groupe.",
 "Quem criar a conta com o seu código já vira seu amigo aqui, sem precisar pedir.": "Toute personne qui crée son compte avec votre code devient directement votre ami ici, sans demande.",
 "Quem enviou": "Expéditeur",
 "Quem está num grupo do app com você (turma, família, viagem...) já pode conversar sem ser amigo. Segure um amigo para desfazer a amizade ou bloquear.": "Les personnes qui sont dans un groupe de l'app avec vous (classe, famille, voyage...) peuvent déjà discuter sans être amies. Appuyez longuement sur un ami pour le retirer ou le bloquer.",
 "Quem faz a limpeza": "Qui fait le ménage",
 "Quem paga, se não for o paciente (mãe, pai, responsável)": "Qui paie, si ce n'est pas le patient (mère, père, responsable)",
 "Quem pagou": "Qui a payé",
 "Quem recebeu (médico, escola...)": "Bénéficiaire (médecin, école...)",
 "Quem vai": "Qui vient",
 "Quem vai limpar": "Qui fera le ménage",
 "Quem vê: só quem conversa com você, os seus amigos e quem está num grupo do app com você. Deixe em branco o que não quiser mostrar.": "Qui la voit : seulement les personnes qui discutent avec vous, vos amis et ceux qui sont dans un groupe de l'app avec vous. Laissez vide ce que vous ne voulez pas montrer.",
 "Quente": "Chaud",
 "Quer escanear mais uma página?": "Numériser une autre page ?",
 "Quer guardar o comprovante agora? Foto, PDF ou print do Pix.": "Enregistrer le justificatif maintenant ? Photo, PDF ou capture d'écran du Pix.",
 "Quer mandar um print da tela? Envie por e-mail e anexe a imagem.": "Vous voulez envoyer une capture d'écran ? Envoyez-la par e-mail en pièce jointe.",
 "Quer trocar pelos novos ou manter os dois?": "Remplacer par les nouveaux ou garder les deux ?",
 "Quero assistir": "À voir",
 "Quero ir": "Envie d'y aller",
 "Quero ler": "À lire",
 "Quero ver": "À voir",
 "Quilometragem atual": "Kilométrage actuel",
 "Quilometragem: {km}": "Kilométrage : {km}",
 "Quinta": "Jeudi",
 "Quintal": "Jardin",
 "Quitado": "Soldé",
 "Quitados": "Soldés",
 "Química": "Chimie",
 "RECIBO": "REÇU",
 "RG / Carteira de identidade": "Carte d'identité (RG)",
 "RG, CNH, passaporte, contratos e certidões, com aviso antes de vencer e envio com um toque.": "Identité, permis, passeport, contrats et certificats, avec rappel avant expiration et envoi en un geste.",
 "Raciocínio Lógico": "Raisonnement logique",
 "Razão social ou nome": "Raison sociale ou nom",
 "Razão social ou nome do consultório": "Raison sociale ou nom du cabinet",
 "Razão social ou nome fantasia": "Raison sociale ou nom commercial",
 "Raça": "Race",
 "Realizado": "Effectué",
 "Recado": "Message",
 "Recalcular": "Recalculer",
 "Recalcular as parcelas em aberto": "Recalculer les échéances restantes",
 "Recalcular as parcelas?": "Recalculer les échéances ?",
 "Receber": "Recevoir",
 "Receber de volta: {i} ({p})": "À récupérer : {i} ({p})",
 "Receber o código no WhatsApp": "Recevoir le code sur WhatsApp",
 "Receber parcela {n}/{t} · {c}": "Recevoir l'échéance {n}/{t} · {c}",
 "Recebeu um convite?": "Vous avez reçu une invitation ?",
 "Recebeu um código?": "Vous avez reçu un code ?",
 "Recebi de {pagador}{doc}, a quantia de {valor}{extenso}, referente a {tipo} realizado(a) em {data}{paciente}.": "J'ai reçu de {pagador}{doc} la somme de {valor}{extenso}, au titre de {tipo} effectué(e) le {data}{paciente}.",
 "Recebi outro valor": "J'ai reçu un autre montant",
 "Recebida": "Reçue",
 "Recebida (toque para desfazer)": "Reçue (touchez pour annuler)",
 "Recebidas": "Reçues",
 "Recebido": "Reçu",
 "Recebido: {v}": "Reçu : {v}",
 "Recebidos": "Reçus",
 "Recebidos dos grupos": "Reçus des groupes",
 "Recebimento": "Encaissement",
 "Receita": "Recette",
 "Receitas": "Recettes",
 "Recibo": "Reçu",
 "Recibo em PDF": "Reçu en PDF",
 "Recibo emitido": "Reçu émis",
 "Recibo guardado": "Reçu enregistré",
 "Recibos dedutíveis": "Reçus déductibles",
 "Recomendada": "Recommandée",
 "Recomeçar": "Recommencer",
 "Recortar": "Recadrer",
 "Recortar margens": "Rogner les marges",
 "Recortar, girar e os filtros chegam com o app novo (versão 0.49).": "Le recadrage, la rotation et les filtres arrivent avec la nouvelle app (version 0.49).",
 "Recusada": "Refusée",
 "Recusado": "Refusé",
 "Recusar": "Refuser",
 "Redação": "Rédaction",
 "Refazer": "Refaire",
 "Refeição": "Repas",
 "Refeições, exercícios, cuidados e suplementos marcados para hoje": "Repas, exercices, soins et compléments prévus aujourd’hui",
 "Referente a": "Objet",
 "Referência": "Référence",
 "Reforço": "Rappel",
 "Regar a cada quantos dias": "Arrosage tous les combien de jours",
 "Regar hoje": "Arroser aujourd'hui",
 "Regar: {p}": "Arroser : {p}",
 "Regional": "Régional",
 "Registra o diário, as etapas e as entregas, sem ver os valores.": "Remplit le journal, les étapes et les livraisons, sans voir les montants.",
 "Registrar venda/serviço do MEI": "Enregistrer une vente/prestation MEI",
 "Registre cada atendimento: a evolução fica no cofre, com criptografia. A prescrição pode vir de um modelo.": "Enregistrez chaque rendez-vous : l'évolution reste dans le coffre, chiffrée. La prescription peut venir d'un modèle.",
 "Registre compras e vendas de imóveis, veículos e investimentos com os comprovantes. Ajuda muito na hora do imposto.": "Enregistrez les achats et ventes de biens immobiliers, véhicules et placements avec les justificatifs. Très utile au moment de l'impôt.",
 "Registre o que foi diferente do cronograma (trocou um alimento, mudou a refeição). Entra no relatório da semana.": "Notez ce qui a changé par rapport au planning (aliment remplacé, repas modifié). C'est inclus dans le rapport de la semaine.",
 "Registro": "Entrée",
 "Registro clínico": "Dossier médical",
 "Registro de horas": "Relevé d'heures",
 "Registro do diário": "Entrée du journal",
 "Regiões com feriado próprio (marque as suas):": "Régions avec leurs propres jours fériés (cochez les vôtres) :",
 "Regras da casa": "Règlement intérieur",
 "Regras da casa:": "Règlement intérieur :",
 "Reguei": "Arrosé",
 "Reguei hoje": "Arrosé aujourd'hui",
 "Reiniciar": "Redémarrer",
 "Reiniciar o app": "Redémarrer l'app",
 "Relatório": "Rapport",
 "Relatório da semana": "Rapport de la semaine",
 "Relatório em PDF ou Excel": "Rapport PDF ou Excel",
 "Relatório enviado. Obrigado!": "Rapport envoyé. Merci !",
 "Relatórios": "Rapports",
 "Relatórios do Bem-Estar": "Rapports Bien-être",
 "Relatórios gerados ({n})": "Rapports générés ({n})",
 "Relaxar": "Détente",
 "Religião": "Religion",
 "Relógio": "Horloge",
 "Relógio e apps de saúde": "Montre et apps santé",
 "Remada baixa": "Tirage horizontal",
 "Remover": "Retirer",
 "Remover \"{nome}\"?": "Retirer « {nome} » ?",
 "Remover anotações": "Supprimer les annotations",
 "Remover este bloco?": "Retirer ce bloc ?",
 "Remover páginas": "Supprimer des pages",
 "Remover vínculo": "Retirer le lien",
 "Remover {nome}?": "Retirer {nome} ?",
 "Remédio": "Médicament",
 "Remédio contínuo": "Traitement continu",
 "Remédio na linha do tempo": "Médicament dans la chronologie",
 "Remédios": "Médicaments",
 "Remédios de uso contínuo": "Médicaments au long cours",
 "Renavam ou chassi": "Renavam ou numéro de châssis",
 "Renegociado": "Renégocié",
 "Renomear": "Renommer",
 "Renomear com IA": "Renommer avec l'IA",
 "Renomear ou trocar ícone": "Renommer ou changer d'icône",
 "Renomear pasta": "Renommer le dossier",
 "Renomear, ícone ou cor": "Nom, icône ou couleur",
 "Renovar: {nome}": "Renouveler : {nome}",
 "Reorganiza o arquivo por dentro. Ajuda pouco em PDFs com fotos.": "Réorganise le fichier en interne. Aide peu pour les PDF avec photos.",
 "Reparar PDF": "Réparer le PDF",
 "Repelente": "Anti-moustiques",
 "Repete": "Répétition",
 "Repetir a cada quantos dias": "Répéter tous les combien de jours",
 "Repetições": "Répétitions",
 "Repita a senha": "Répétez le mot de passe",
 "Repita a senha do cofre": "Répétez le mot de passe du coffre",
 "Repita a senha nova": "Répétez le nouveau mot de passe",
 "Replantio": "Rempotage",
 "Replantios": "Rempotages",
 "Repor papel higiênico, sabonete e café": "Réapprovisionner papier toilette, savon et café",
 "Representatividade": "Diversité",
 "Reserva": "Réservation",
 "Reservas": "Réservations",
 "Reservas, limpeza, receitas e despesas na aba Aluguel & Hospedagem": "Réservations, ménage, recettes et dépenses dans l'onglet Location & Hébergement",
 "Respirar fundo 5 vezes": "Respirer profondément 5 fois",
 "Respondendo a {nome}": "Réponse à {nome}",
 "Responder": "Répondre",
 "Responsável": "Responsable",
 "Responsável (imobiliária, vistoriador)": "Responsable (agence, expert)",
 "Resposta da SEFAZ": "Réponse de la SEFAZ",
 "Resta {tempo}": "Reste {tempo}",
 "Restam {ml} = {n} copo(s) de {copo}": "Reste {ml} = {n} verre(s) de {copo}",
 "Restaurante": "Restaurant",
 "Restaurantes": "Restaurants",
 "Restaurar": "Restaurer",
 "Restaurar esta cópia?": "Restaurer cette sauvegarde ?",
 "Restaurar troca TODOS os dados atuais pelos da cópia, aqui e na sua conta.": "La restauration remplace TOUTES les données actuelles par celles de la sauvegarde, ici et dans votre compte.",
 "Restaurar uma cópia": "Restaurer une sauvegarde",
 "Resultado": "Résultat",
 "Resultado nas vendas: {v}": "Résultat des ventes : {v}",
 "Resumir": "Résumer",
 "Resumir e perguntar": "Résumer et demander",
 "Resumo": "Résumé",
 "Resumo (falta o XML completo)": "Résumé (XML complet manquant)",
 "Resumo da manhã": "Résumé du matin",
 "Resumo da pasta": "Résumé du dossier",
 "Resumo e opinião": "Résumé et avis",
 "Resumo, gastos por categoria, contas, faturas, metas e todos os lançamentos. Bom para mandar ao contador ou guardar para o IR.": "Résumé, dépenses par catégorie, factures, relevés, objectifs et toutes les opérations. Pratique à envoyer au comptable ou à garder pour l'impôt (IR).",
 "Retirar": "Retirer",
 "Retirar da meta": "Retirer de l'objectif",
 "Retorno": "Visite de contrôle",
 "Reunião": "Réunion",
 "Reunião agora": "Réunion immédiate",
 "Reunião de equipe": "Réunion d'équipe",
 "Reuniões": "Réunions",
 "Revestimento e pisos": "Revêtements et sols",
 "Revisão": "Révision",
 "Revolução Constitucionalista": "Révolution constitutionnaliste",
 "Rico em matéria orgânica": "Riche en matière organique",
 "Rodízio de pneus": "Permutation des pneus",
 "Roedor": "Rongeur",
 "Romance": "Romance",
 "Rosca direta": "Curl biceps à la barre",
 "Rota": "Itinéraire",
 "Rota passando pelos {n} lugares que faltam": "Itinéraire par les {n} lieux restants",
 "Rotas e mapas": "Itinéraires et cartes",
 "Roteiro": "Itinéraire",
 "Roteiro por dia que entra na linha do tempo durante a viagem, mala pelo clima, reservas e fusos.": "Itinéraire jour par jour dans la chronologie pendant le voyage, valise selon la météo, réservations et fuseaux horaires.",
 "Rotina": "Routine",
 "Rotinas com passo a passo: skincare, alongamento, cabelo... Toque em \"+ Cuidado\" para escolher um modelo ou criar o seu.": "Routines étape par étape : skincare, étirements, cheveux... Touchez « + Soin » pour choisir un modèle ou créer le vôtre.",
 "Roupa": "Vêtement",
 "Roupa social": "Tenue habillée",
 "Roupas de banho": "Maillots de bain",
 "Roupas extras das crianças": "Vêtements de rechange des enfants",
 "Roupas íntimas": "Sous-vêtements",
 "Rua": "Rue",
 "Rua, número, bairro, cidade (ou o nome do lugar)": "Rue, numéro, quartier, ville (ou nom du lieu)",
 "Régua": "Règle",
 "Réptil": "Reptile",
 "Rótulo (ex.: Meu nome, Empresa do cliente)": "Libellé (ex. : Mon nom, Entreprise du client)",
 "SAC": "Amortissement constant (SAC)",
 "SEM HORÁRIO": "SANS HEURE",
 "SEU MÊS EM NÚMEROS": "VOTRE MOIS EN CHIFFRES",
 "SEU TREINO": "VOTRE SÉANCE",
 "SEUS GRUPOS DO APP": "VOS GROUPES DE L'APP",
 "SP": "SP",
 "SUBTAREFA": "SOUS-TÂCHE",
 "SUBTAREFAS": "SOUS-TÂCHES",
 "SUPLEMENTAÇÃO": "COMPLÉMENTS",
 "Sabonete facial": "Nettoyant visage",
 "Sabão para lavar roupa": "Lessive",
 "Sacada": "Balcon",
 "Sai só da lista deste app. A cópia guardada no Drive, no OneDrive ou na pasta do celular continua lá.": "Le retire seulement de la liste de cette app. La copie enregistrée sur Drive, OneDrive ou dans le dossier du téléphone reste en place.",
 "Sai só da lista. O arquivo continua onde foi salvo.": "Retiré de la liste seulement. Le fichier reste là où il a été enregistré.",
 "Sair": "Se déconnecter",
 "Sair da conta?": "Se déconnecter ?",
 "Sair do escritório": "Quitter le bureau",
 "Sair do escritório?": "Quitter le bureau ?",
 "Sair do grupo": "Quitter le groupe",
 "Sair do grupo?": "Quitter le groupe ?",
 "Sair sem baixar": "Quitter sans télécharger",
 "Saiu": "Sorties",
 "Sala": "Salle",
 "Sala de estar": "Salon",
 "Sala de jantar": "Salle à manger",
 "Sala virtual": "Salle virtuelle",
 "Salada": "Salade",
 "Saldo": "Solde",
 "Saldo depois desta parcela": "Capital restant après cette échéance",
 "Saldo devedor: {v}": "Capital restant dû : {v}",
 "Saldo do mês": "Solde du mois",
 "Salvar": "Enregistrer",
 "Salvar backup do My Planner": "Enregistrer la sauvegarde de My Planner",
 "Salvar cuidado": "Enregistrer le soin",
 "Salvar cômodo": "Enregistrer la pièce",
 "Salvar e colocar no My Planner": "Enregistrer et mettre dans My Planner",
 "Salvar e sincronizar": "Enregistrer et synchroniser",
 "Salvar e testar": "Enregistrer et tester",
 "Salvar endereço": "Enregistrer l'adresse",
 "Salvar no My Planner": "Enregistrer dans My Planner",
 "Salvar refeição": "Enregistrer le repas",
 "Salvar suplemento": "Enregistrer le complément",
 "Salvar tarefa": "Enregistrer la tâche",
 "Salvar treino": "Enregistrer la séance",
 "Sanduíche natural": "Sandwich léger",
 "Santo Antônio": "Saint Antoine",
 "Sapato confortável": "Chaussures confortables",
 "Saudade": "Tu me manques",
 "Saída (imóvel antigo)": "Sortie (ancien logement)",
 "Saída de praia": "Paréo",
 "Saúde": "Santé",
 "Saúde & Prontuário": "Santé & Dossier médical",
 "Saúde (médicos, dentistas, exames, plano)": "Santé (médecins, dentistes, examens, mutuelle)",
 "Saúde e bem-estar": "Santé et bien-être",
 "Scanner": "Scanner",
 "Scanner PDF": "Scanner PDF",
 "Sci-Fi": "Science-fiction",
 "Se alguma coisa não responder, reinicie o app. Os seus dados estão salvos.": "Si quelque chose ne répond pas, redémarrez l'app. Vos données sont enregistrées.",
 "Se der tempo": "Si on a le temps",
 "Se esta política mudar de forma importante, o app avisa e pede o seu aceite de novo.": "Si cette politique change de façon importante, l'app vous prévient et vous demande à nouveau votre accord.",
 "Se este aviso apareceu, os alertas dos compromissos estão funcionando.": "Si cette alerte s’est affichée, les alertes des rendez-vous fonctionnent.",
 "Se existir uma conta com {email}, enviamos um link para criar uma senha nova. Confira também o spam.": "Si un compte existe avec {email}, nous avons envoyé un lien pour créer un nouveau mot de passe. Vérifiez aussi les spams.",
 "Se o alerta atrasar ou não aparecer: nas configurações do app, deixe as notificações ligadas, a bateria \"sem restrição\" e permita \"Alarmes e lembretes\".": "Si l’alerte est en retard ou n’apparaît pas : dans les paramètres de l’app, laissez les notifications activées, la batterie sur « Non restreinte » et autorisez « Alarmes et rappels ».",
 "Se o relógio estiver conectado, os números dele entram por cima dos digitados quando ele tiver o dado.": "Si la montre est connectée, ses chiffres remplacent ceux saisis manuellement dès qu'elle a la donnée.",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect (Android) ou do app Saúde (iPhone). O app só lê e nunca altera esses dados.": "Si vous connectez la montre : totaux quotidiens de pas, distance, calories, exercice, fréquence cardiaque et sommeil, lus depuis Health Connect (Android) ou l'app Santé (iPhone). L'app se contente de lire et ne modifie jamais ces données.",
 "Se você já usou esta aba, nada foi apagado: tudo volta como estava ao assinar.": "Si vous avez déjà utilisé cet onglet, rien n'a été supprimé : tout revient comme avant lors de l'abonnement.",
 "Secretária ou recepção": "Secrétariat ou accueil",
 "Seg a sex": "Lun à ven",
 "Seguir": "Continuer",
 "Segunda": "Lundi",
 "Segurança": "Sécurité",
 "Segure e arraste para mudar a ordem. ↻ gira, ⧉ duplica e ✕ tira a página.": "Maintenez et glissez pour changer l'ordre. ↻ fait pivoter, ⧉ duplique et ✕ retire la page.",
 "Segure um GIF numa conversa e toque em \"Guardar\" para ele aparecer aqui.": "Appuyez longuement sur un GIF dans une discussion et touchez \"Enregistrer\" pour qu'il apparaisse ici.",
 "Segure um cômodo para mudar de lugar. Com o cômodo aberto, segure uma tarefa e solte em outro cômodo para levá-la.": "Maintenez une pièce pour la déplacer. Pièce ouverte, maintenez une tâche et déposez-la sur une autre pièce pour l'y déplacer.",
 "Segure um fichário, uma matéria ou uma página para mudar a ordem. Solte uma matéria em outro fichário para levá-la para lá.": "Maintenez un classeur, une matière ou une page pour changer l'ordre. Déposez une matière sur un autre classeur pour l'y déplacer.",
 "Segure uma conversa para silenciar ou arquivar. Arquivada continua recebendo e enviando, mas sem aviso.": "Appuyez longuement sur une discussion pour la mettre en sourdine ou l’archiver. Archivée, elle continue de recevoir et d’envoyer, mais sans notification.",
 "Seguro": "Assurance",
 "Seguro da casa": "Assurance habitation",
 "Seguro viagem": "Assurance voyage",
 "Selecionar": "Sélectionner",
 "Sem": "Aucun",
 "Sem alerta": "Sans alerte",
 "Sem categoria": "Sans catégorie",
 "Sem comprovante": "Sans justificatif",
 "Sem conexão com o servidor de notas. Confira a internet e o endereço do servidor.": "Pas de connexion au serveur de factures. Vérifiez Internet et l'adresse du serveur.",
 "Sem conexão com o servidor. Confira a internet.": "Pas de connexion au serveur. Vérifiez Internet.",
 "Sem conexão com os GIFs agora.": "Pas de connexion aux GIF pour le moment.",
 "Sem cômodo": "Sans pièce",
 "Sem data de fim": "Sans date de fin",
 "Sem exercícios": "Aucun exercice",
 "Sem fatura em {mes}": "Pas de relevé en {mes}",
 "Sem fim": "Sans fin",
 "Sem horário": "Sans heure",
 "Sem internet ou servidor ainda não preparado.": "Pas d'internet ou serveur pas encore prêt.",
 "Sem internet. Envia quando voltar.": "Pas d'Internet. Envoi au retour de la connexion.",
 "Sem internet. Tente de novo.": "Pas de connexion internet. Réessayez.",
 "Sem isso, a tarja só cobre: o texto por baixo continua no arquivo e dá para copiar.": "Sans cela, la bande ne fait que couvrir : le texte dessous reste dans le fichier et peut être copié.",
 "Sem itens": "Aucun élément",
 "Sem juros": "Sans intérêts",
 "Sem limite": "Sans limite",
 "Sem link de calendário": "Pas de lien de calendrier",
 "Sem margem": "Sans marge",
 "Sem nome": "Sans nom",
 "Sem número na primeira página (capa)": "Pas de numéro sur la première page (couverture)",
 "Sem pasta": "Sans dossier",
 "Sem pausas": "Sans pauses",
 "Sem permissão": "Pas d'autorisation",
 "Sem prazo": "Sans échéance",
 "Sem recibo": "Sans reçu",
 "Sem tarefas": "Aucune tâche",
 "Sem texto.": "Aucun texte.",
 "Sem tomador identificado": "Aucun client identifié",
 "Sem título": "Sans titre",
 "Sem validade": "Sans expiration",
 "Semana": "Semaine",
 "Semana completa": "Semaine complète",
 "Semana de {de} a {ate}": "Semaine du {de} au {ate}",
 "Semanal": "Hebdomadaire",
 "Semanal · dias úteis": "Hebdomadaire · jours ouvrés",
 "Semanal · todos os dias": "Hebdomadaire · tous les jours",
 "Semanal · {dias}": "Hebdomadaire · {dias}",
 "Sempre aparecem, junto com os pontos facultativos (Carnaval, Quarta-feira de Cinzas e Corpus Christi).": "Toujours affichés, avec les jours chômés facultatifs (Carnaval, mercredi des Cendres et Fête-Dieu).",
 "Senha": "Mot de passe",
 "Senha (8 caracteres ou mais)": "Mot de passe (8 caractères ou plus)",
 "Senha alterada.": "Mot de passe modifié.",
 "Senha atual": "Mot de passe actuel",
 "Senha atual do cofre": "Mot de passe actuel du coffre",
 "Senha da conta": "Mot de passe du compte",
 "Senha do certificado": "Mot de passe du certificat",
 "Senha do cofre": "Mot de passe du coffre",
 "Senha do cofre alterada.": "Mot de passe du coffre modifié.",
 "Senha do cofre incorreta.": "Mot de passe du coffre incorrect.",
 "Senha incorreta": "Mot de passe incorrect",
 "Senha incorreta.": "Mot de passe incorrect.",
 "Senha nova (8 caracteres ou mais)": "Nouveau mot de passe (8 caractères ou plus)",
 "Senha nova do cofre (6 caracteres ou mais)": "Nouveau mot de passe du coffre (6 caractères ou plus)",
 "Senha, biometria, bloqueio e privacidade": "Mot de passe, biométrie, verrouillage et confidentialité",
 "Senha, e-mail e formas de desbloquear": "Mot de passe, e-mail et modes de déverrouillage",
 "Separar informes de rendimentos (bancos, empregador, corretoras)": "Rassembler les relevés de revenus (banques, employeur, courtiers)",
 "Servidor de notas": "Serveur de factures",
 "Servidor não configurado (lib/config.ts).": "Serveur non configuré (lib/config.ts).",
 "Servidor não configurado.": "Serveur non configuré.",
 "Servidor não configurado: faltam os dados do Supabase em lib/config.ts.": "Serveur non configuré : les données Supabase manquent dans lib/config.ts.",
 "Serviço": "Service",
 "Serviço não prestado": "Service non fourni",
 "Serviços": "Services",
 "Será excluída em 1 dia": "Sera supprimée dans 1 jour",
 "Será excluída em {n} dias": "Sera supprimée dans {n} jours",
 "Será excluída hoje": "Sera supprimée aujourd'hui",
 "Sessão": "Séance",
 "Seu acesso ainda precisa ser liberado. Tente entrar em alguns instantes.": "Votre accès doit encore être activé. Réessayez de vous connecter dans quelques instants.",
 "Seu código": "Votre code",
 "Seu código de amigo": "Votre code ami",
 "Seu código para amigos ganharem 10 dias com todas as abas": "Votre code pour offrir à vos amis 10 jours avec tous les onglets",
 "Seu nome": "Votre nom",
 "Seu papel: {p}": "Votre rôle : {p}",
 "Seu papel: {p}. {d}": "Votre rôle : {p}. {d}",
 "Seu scanner de bolso": "Votre scanner de poche",
 "Seus dados continuam salvos na nuvem.": "Vos données restent enregistrées dans le cloud.",
 "Seus dados na nuvem do My Planner": "Vos données dans le cloud My Planner",
 "Seus dados são seus: não vendemos e não usamos para publicidade. Você pode exportar ou apagar tudo quando quiser.": "Vos données vous appartiennent : nous ne les vendons pas et ne les utilisons pas pour la publicité. Vous pouvez tout exporter ou tout supprimer quand vous voulez.",
 "Seus {n} meses grátis terminaram": "Vos {n} mois gratuits sont terminés",
 "Sexta": "Vendredi",
 "Sextou": "Vendredi",
 "Sextou!": "Enfin vendredi !",
 "Shampoo": "Shampoing",
 "Show ou passeio": "Spectacle ou excursion",
 "Silenciar avisos": "Désactiver les notifications",
 "Sim": "Oui",
 "Simples Nacional": "Simples Nacional",
 "Sincronizado em {data}": "Synchronisé le {data}",
 "Sincronizando pelo dispositivo {nome}": "Synchronisation via l'appareil {nome}",
 "Sincronizando...": "Synchronisation...",
 "Sincronizar agora": "Synchroniser maintenant",
 "Sincronização parada: confirme sua senha. Nada se perde.": "Synchronisation en pause : confirmez votre mot de passe. Rien n'est perdu.",
 "Site da assistência": "Site du SAV",
 "Site da assistência (https://...)": "Site du SAV (https://...)",
 "Site ou ingresso online": "Site web ou billet en ligne",
 "Situação": "Statut",
 "Situação agora": "Situation actuelle",
 "Skincare da manhã": "Skincare du matin",
 "Skincare da noite": "Skincare du soir",
 "Slides": "Diapos",
 "Smileys e pessoas": "Smileys et personnes",
 "Sobremesa": "Dessert",
 "Sobrou no mês": "Reste du mois",
 "Sociologia": "Sociologie",
 "Sofá": "Canapé",
 "Sol": "Soleil",
 "Sol pleno": "Plein soleil",
 "Solo ou substrato": "Sol ou substrat",
 "Solte numa matéria para mover a página para lá:": "Déposez sur une matière pour y déplacer la page :",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia. Avisa 15 e 3 dias antes.": "Additionne la garantie légale et celle du fabricant. Vérifiez sur le certificat de garantie. Alerte 15 et 3 jours avant.",
 "Sombra": "Ombre",
 "Somente esta tarefa": "Cette tâche uniquement",
 "Sono": "Sommeil",
 "Sono da noite": "Sommeil de la nuit",
 "Sopa": "Soupe",
 "Sou MEI": "Je suis MEI",
 "Status": "Statut",
 "Sua conexão com a nuvem venceu (acontece quando o app fica muito tempo sem abrir ou a senha foi trocada em outro dispositivo). Nada se perde: o que está aqui é enviado assim que você confirmar.": "Votre connexion au cloud a expiré (cela arrive quand l'app n'a pas été ouverte depuis longtemps ou que le mot de passe a été changé sur un autre appareil). Rien n'est perdu : ce qui est ici sera envoyé dès que vous confirmerez.",
 "Sua equipe num lugar só: conversa, documentos, reuniões de vídeo com gravação e convite pelo link.": "Votre équipe au même endroit : conversation, documents, réunions vidéo enregistrées et invitation par lien.",
 "Sua rotina em um só lugar": "Votre quotidien en un seul endroit",
 "Sua senha": "Votre mot de passe",
 "Suas abas": "Vos onglets",
 "Substituir": "Remplacer",
 "Substrato usado": "Substrat utilisé",
 "Subtarefa {n}": "Sous-tâche {n}",
 "Suco": "Jus",
 "Sugerir nome": "Suggérer un nom",
 "Sugestão": "Suggestion",
 "Sugestões de {categoria}": "Suggestions : {categoria}",
 "Supabase: guarda a conta e os dados sincronizados, como operador. Os servidores podem ficar fora do Brasil, com as garantias do art. 33 da LGPD.": "Supabase : conserve le compte et les données synchronisées, en tant que sous-traitant. Les serveurs peuvent se trouver hors du Brésil, avec les garanties de l'art. 33 de la LGPD.",
 "Superiores": "Supérieurs",
 "Supino reto": "Développé couché",
 "Suplemento": "Complément",
 "Suspense": "Suspense",
 "Suíte": "Suite parentale",
 "Sábado": "Samedi",
 "São Paulo": "São Paulo",
 "São Paulo (SP)": "São Paulo (SP)",
 "São mais de 60 arquivos. Use \"A cada N páginas\".": "Cela fait plus de 60 fichiers. Utilisez \"Toutes les N pages\".",
 "Série": "Série",
 "Série da DPS": "Série de la DPS",
 "Série e turma": "Niveau et classe",
 "Séries": "Séries",
 "Sérum": "Sérum",
 "Símbolos": "Symboles",
 "Só a equipe do escritório vê. Até 50 MB por arquivo.": "Visible uniquement par l'équipe du bureau. Jusqu'à 50 Mo par fichier.",
 "Só acompanha": "Suit seulement",
 "Só acompanha, sem valores": "Suit seulement, sans montants",
 "Só administradores": "Admins uniquement",
 "Só em {data}": "Seulement le {data}",
 "Só leitura": "Lecture seule",
 "Só mandar para a aba Estudos (sem escolher página)": "Envoyer seulement vers l'onglet Études (sans choisir de page)",
 "Só neste dispositivo": "Sur cet appareil uniquement",
 "Só neste dispositivo: {n}": "Uniquement sur cet appareil : {n}",
 "Só o código": "Code seul",
 "Só o dia {data}": "Seulement le {data}",
 "Só os dados (texto)": "Données seules (texte)",
 "Só os totais das Finanças vão para a sua IA. Não é recomendação de investimento.": "Seuls les totaux de Finance sont envoyés à votre IA. Ce n'est pas un conseil en investissement.",
 "Só seu: estudos, estratégias pedagógicas e o que funcionou ou não em cada aula. Os alunos não veem.": "Rien qu'à vous : études, stratégies pédagogiques et ce qui a marché ou non à chaque cours. Les élèves ne le voient pas.",
 "Só um celular sincroniza com a agenda. Para passar para este, toque abaixo.": "Un seul téléphone se synchronise avec l'agenda. Pour passer à celui-ci, touchez ci-dessous.",
 "Só uma vez": "Une seule fois",
 "Só uma vez (abrir a ficha da tarefa)": "Une seule fois (ouvrir la fiche de la tâche)",
 "Só áudio": "Audio seul",
 "Sótão": "Grenier",
 "TAREFAS DA CASA": "TÂCHES MÉNAGÈRES",
 "TELEFONE (OPCIONAL)": "TÉLÉPHONE (FACULTATIF)",
 "TRAZER PARA O MY PLANNER": "IMPORTER DANS MY PLANNER",
 "TV por assinatura": "Télévision payante",
 "Tabela": "Tableau",
 "Talvez": "Peut-être",
 "Tamanho": "Taille",
 "Tamanho da foto": "Taille de la photo",
 "Tamanho da página": "Taille de page",
 "Tamanho das páginas": "Taille des pages",
 "Tamanho do arquivo": "Taille du fichier",
 "Tamanho do copo": "Taille du verre",
 "Também procurar nos Diários Oficiais dos municípios": "Rechercher aussi dans les Journaux officiels des communes",
 "Também serão excluídos {n} item(ns) dentro dele.": "{n} élément(s) qu'il contient seront aussi supprimés.",
 "Tapioca": "Crêpe de tapioca",
 "Tarefa": "Tâche",
 "Tarefa da casa": "Tâche ménagère",
 "Tarefa de casa": "Devoirs",
 "Tarefa duplicada": "Tâche dupliquée",
 "Tarefa ou entrega": "Tâche ou livrable",
 "Tarefa para {nome}": "Tâche pour {nome}",
 "Tarefas da casa": "Tâches ménagères",
 "Tarefas e itens de todas as abas": "Tâches et éléments de tous les onglets",
 "Tarefas novas do My Planner vão para: {agenda}": "Les nouvelles tâches de My Planner vont dans : {agenda}",
 "Tarefas que se repetem e passam do período continuam nos outros dias; só os dias escolhidos saem.": "Les tâches récurrentes qui dépassent la période continuent les autres jours ; seuls les jours choisis sont supprimés.",
 "Tarjas pretas sobre CPF, valores e nomes. Apaga de verdade.": "Bandes noires sur CPF, montants et noms. Efface vraiment.",
 "Tartaruga": "Tortue",
 "Taxa de limpeza": "Frais de ménage",
 "Taxa de limpeza cobrada do hóspede": "Frais de ménage facturés au voyageur",
 "Taxas e anúncios": "Frais et annonces",
 "Te amo": "Je t'aime",
 "Tecnologia": "Technologie",
 "Tela cheia": "Plein écran",
 "Teleconsulta": "Téléconsultation",
 "Telefone": "Téléphone",
 "Telefone da assistência": "Téléphone du SAV",
 "Telefone da empresa": "Téléphone de la société",
 "Telefone da escola": "Téléphone de l'école",
 "Telefone da limpeza": "Téléphone du ménage",
 "Telefone de emergência": "Téléphone d'urgence",
 "Telefone do veterinário": "Téléphone du vétérinaire",
 "Telhado": "Toiture",
 "Tem anexos": "Contient des pièces jointes",
 "Tem certeza?": "Vous êtes sûr ?",
 "Tem {n} conta(s) em atraso somando {v}. Pague primeiro as que cobram juros mais altos, como o cartão e o cheque especial.": "Vous avez {n} facture(s) en retard pour un total de {v}. Payez d'abord celles aux intérêts les plus élevés, comme la carte et le découvert.",
 "Tema": "Thème",
 "Tempo de preparo": "Temps de préparation",
 "Temporada": "Saison",
 "Temporizador (direita)": "Minuteur (droite)",
 "Tenta consertar um PDF que não abre direito.": "Tente de réparer un PDF qui ne s'ouvre pas bien.",
 "Tentar de novo": "Réessayer",
 "Tente uma foto mais nítida, com a página inteira.": "Essayez une photo plus nette, avec la page entière.",
 "Termina às {hora}": "Se termine à {hora}",
 "Terminar até": "Terminer avant le",
 "Terminei em": "Terminé le",
 "Terminou": "Terminé",
 "Terminou em {data}. Nada foi apagado: tudo volta como estava ao assinar.": "Terminé le {data}. Rien n'a été supprimé : tout revient comme avant dès l'abonnement.",
 "Termos de uso": "Conditions d'utilisation",
 "Termos de uso e privacidade": "Conditions d'utilisation et confidentialité",
 "Terror": "Horreur",
 "Terça": "Mardi",
 "Testando...": "Test...",
 "Testar alerta (1 minuto)": "Tester l’alerte (1 minute)",
 "Testar aviso": "Tester la notification",
 "Teste de alerta do Planner": "Test d’alerte du Planner",
 "Teste grátis até {data} ({n} dia(s))": "Essai gratuit jusqu'au {data} ({n} jour(s))",
 "Teste grátis: {n} dia(s)": "Essai gratuit : {n} jour(s)",
 "Teste terminado": "Essai terminé",
 "Teste terminou em {data}": "Essai terminé le {data}",
 "Teste: aviso feito pelo próprio celular.": "Test : notification créée par le téléphone lui-même.",
 "Texto": "Texte",
 "Texto completo": "Texte complet",
 "Texto copiado. Cole onde quiser enviar.": "Texte copié. Collez-le où vous voulez l'envoyer.",
 "Texto do documento": "Texte du document",
 "Texto extra do convite (traje, presentes...)": "Texte en plus dans l'invitation (tenue, cadeaux...)",
 "Texto livre": "Texte libre",
 "Texto ou recado": "Texte ou message",
 "Texto para PDF": "Texte en PDF",
 "Texto {data}": "Texte {data}",
 "Tipo": "Type",
 "Tipo sanguíneo": "Groupe sanguin",
 "Tira as páginas que você não quer.": "Retire les pages dont vous ne voulez pas.",
 "Tira autor, programas, comandos escondidos e anexos.": "Retire auteur, logiciels, commandes cachées et pièces jointes.",
 "Tira comentários, destaques e desenhos de outros programas.": "Retire commentaires, surlignages et dessins d'autres logiciels.",
 "Tira o texto do PDF (arquivo .txt).": "Extrait le texte du PDF (fichier .txt).",
 "Tiradentes": "Tiradentes",
 "Tirar": "Retirer",
 "Tirar a assinatura": "Retirer la signature",
 "Tirar a foto": "Supprimer la photo",
 "Tirar a foto agora": "Prendre la photo maintenant",
 "Tirar admin": "Retirer admin",
 "Tirar alarmes do My Planner": "Retirer les alarmes de My Planner",
 "Tirar arquivos anexados": "Retirer les fichiers joints",
 "Tirar comentários, destaques e links": "Retirer commentaires, surlignages et liens",
 "Tirar da agenda": "Retirer de l'agenda",
 "Tirar da barra": "Retirer de la barre",
 "Tirar daqui": "Retirer d'ici",
 "Tirar das minhas figurinhas?": "Retirer de mes stickers ?",
 "Tirar de administrador": "Retirer des admins",
 "Tirar do escritório": "Retirer du bureau",
 "Tirar dos meus GIFs?": "Retirer de mes GIF ?",
 "Tirar este copo": "Retirer ce verre",
 "Tirar foto": "Prendre une photo",
 "Tirar fotos de boletos, cupons e documentos e escolher fotos e vídeos da galeria.": "Photographier des boletos, tickets et documents, et choisir des photos et vidéos dans la galerie.",
 "Tirar o desenho padrão?": "Retirer le schéma ?",
 "Tirar o lixo": "Sortir les poubelles",
 "Tire a foto e a sua IA preenche a ficha": "Prenez la photo et votre IA remplit la fiche",
 "Titular (de quem é o documento)": "Titulaire (à qui appartient le document)",
 "Titular: {nome}": "Titulaire : {nome}",
 "Toalha de praia": "Serviette de plage",
 "Tocar os pés": "Toucher ses pieds",
 "Toda a agenda": "Tout l'agenda",
 "Toda semana": "Chaque semaine",
 "Todas": "Toutes",
 "Todas (passadas, esta e futuras)": "Toutes (passées, celle-ci et suivantes)",
 "Todas ({n})": "Toutes ({n})",
 "Todas as abas liberadas até {data}.": "Tous les onglets sont débloqués jusqu'au {data}.",
 "Todas as capitais. Marque uma ou mais cidades.": "Toutes les capitales. Cochez une ou plusieurs villes.",
 "Todas as ferramentas de PDF: juntar, dividir, organizar, assinar, carimbo, tarja, números de página, formulários, comprimir, converter, OCR e IA. Guarda no celular, no Google Drive ou no OneDrive.": "Tous les outils PDF : fusionner, diviser, organiser, signer, tampon, caviardage, numéros de page, formulaires, compresser, convertir, OCR et IA. Enregistre sur le téléphone, Google Drive ou OneDrive.",
 "Todas as ferramentas ficam na tela da aba.": "Tous les outils sont sur l'écran de l'onglet.",
 "Todas as fotos da viagem ficam aqui: as que você puser no álbum e as do roteiro, dos lugares e das reservas.": "Toutes les photos du voyage sont ici : celles que vous ajoutez à l'album et celles de l'itinéraire, des lieux et des réservations.",
 "Todas as plantas estão regadas.": "Toutes les plantes sont arrosées.",
 "Todas as páginas, uma embaixo da outra.": "Toutes les pages, l'une sous l'autre.",
 "Todo ano": "Chaque année",
 "Todo dia": "Chaque jour",
 "Todo dia no horário escolhido: quantas tarefas o dia tem, a primeira e a energia total.": "Chaque jour à l'heure choisie : le nombre de tâches du jour, la première et l'énergie totale.",
 "Todo mês": "Chaque mois",
 "Todo mês · dia {d}": "Chaque mois · le {d}",
 "Todo o histórico": "Tout l'historique",
 "Todos": "Tous",
 "Todos ({n})": "Tous ({n})",
 "Todos do grupo": "Tout le groupe",
 "Todos do grupo veem": "Visible par tout le groupe",
 "Todos na reunião veem o aviso \"Gravando\". O arquivo vai para os Documentos do escritório, visível só para você até você liberar para a equipe.": "Tous les participants voient l'avis \"Enregistrement\". Le fichier va dans les Documents du bureau, visible uniquement par vous jusqu'à ce que vous le partagiez avec l'équipe.",
 "Todos os cuidados": "Tous les soins",
 "Todos os dias": "Tous les jours",
 "Todos os suplementos": "Tous les compléments",
 "Todos os treinos": "Tous les entraînements",
 "Todos os tribunais": "Tous les tribunaux",
 "Todos presentes": "Tous présents",
 "Todos saem do grupo. O que cada pessoa já aceitou continua na agenda dela.": "Tout le monde quitte le groupe. Ce que chacun a déjà accepté reste dans son agenda.",
 "Todos trabalham nos mesmos dados, cada um conforme o papel. Toque no papel de cada pessoa em Membros para trocar.": "Tout le monde travaille sur les mêmes données, chacun selon son rôle. Touchez le rôle de chaque personne dans Membres pour le changer.",
 "Tomador": "Client",
 "Tomador (quem contratou)": "Client (qui a commandé)",
 "Tomadores": "Clients",
 "Tomei": "J'ai emprunté",
 "Toque aqui ou no + para criar uma tarefa": "Touchez ici ou le + pour créer une tâche",
 "Toque em \"Apagar minha conta e todos os dados\" e confirme.": "Touchez « Supprimer mon compte et toutes les données » et confirmez.",
 "Toque em + › Novo cartão de crédito e informe os dias de fechamento e de vencimento.": "Touchez + › Nouvelle carte de crédit et indiquez les jours de clôture et d'échéance.",
 "Toque em Ajustes e depois em Segurança.": "Touchez Réglages, puis Sécurité.",
 "Toque em Conectar e, na tela da Apple, ligue os itens que o My Planner pode ler.": "Touchez Connecter puis, sur l'écran d'Apple, activez les éléments que My Planner peut lire.",
 "Toque em Conectar e, na tela do Health Connect, permita que o My Planner leia os dados.": "Touchez Connecter puis, sur l'écran de Health Connect, autorisez My Planner à lire les données.",
 "Toque em quem NÃO deve ver esta ficha (e o que está dentro dela). Ex.: o presente surpresa.": "Touchez qui ne doit PAS voir cette fiche (ni son contenu). Ex. : le cadeau surprise.",
 "Toque em uma aba para abrir. As bloqueadas mostram como assinar.": "Touchez un onglet pour l'ouvrir. Les onglets verrouillés indiquent comment s'abonner.",
 "Toque em uma aba para abrir. Cada aba extra pode ser testada de graça por 10 dias.": "Touchez un onglet pour l'ouvrir. Chaque onglet supplémentaire peut être essayé gratuitement pendant 10 jours.",
 "Toque em uma aba para abrir. Toque em 📌 para pôr ou tirar a aba da barra de baixo. Cada aba extra pode ser testada de graça por 10 dias.": "Touchez un onglet pour l'ouvrir. Touchez 📌 pour épingler l'onglet à la barre du bas ou l'en retirer. Chaque onglet supplémentaire peut être essayé gratuitement pendant 10 jours.",
 "Toque em uma área para abrir. As bloqueadas mostram como assinar.": "Touchez une zone pour l'ouvrir. Les zones verrouillées indiquent comment s'abonner.",
 "Toque no desenho para continuar desenhando.": "Touchez le dessin pour continuer à dessiner.",
 "Toque no que este grupo vai compartilhar. Tudo o que está dentro (roteiro, fotos, reservas...) vai junto e todos participam.": "Touchez ce que ce groupe va partager. Tout ce qu'il contient (itinéraire, photos, réservations...) est inclus et tout le monde participe.",
 "Toque nos PDFs na ordem em que devem ficar.": "Touchez les PDF dans l'ordre où ils doivent être.",
 "Toque num copo para mudar o volume; segure o + para um copo de outro tamanho.": "Touchez un verre pour changer son volume ; maintenez + pour un verre d’une autre taille.",
 "Toque num feriado para adicioná-lo ao Planner.": "Touchez un jour férié pour l'ajouter au Planner.",
 "Toque num lançamento para trocar a categoria, guardar o recibo no IR ou apagar.": "Touchez une opération pour changer la catégorie, enregistrer le reçu pour l'impôt (IR) ou la supprimer.",
 "Toque num lançamento para trocar a categoria. Pressione e segure para apagar.": "Touchez une écriture pour changer sa catégorie. Appuyez longuement pour la supprimer.",
 "Toque num perfil para editar. Pressione e segure para removê-lo.": "Touchez un profil pour le modifier. Appuyez longuement pour le supprimer.",
 "Toque num texto, desenho ou checklist e arraste para qualquer lugar da folha.": "Touchez un texte, un dessin ou une checklist et faites-le glisser n'importe où sur la feuille.",
 "Toque numa página para recortar, girar ou mudar o filtro. Segure e arraste para mudar a ordem.": "Touchez une page pour la recadrer, la faire pivoter ou changer le filtre. Maintenez et faites glisser pour changer l'ordre.",
 "Toque numa tarefa para copiar ou mover para hoje.": "Touchez une tâche pour la copier ou la déplacer à aujourd'hui.",
 "Toque onde quer a checklist.": "Touchez l'endroit où placer la checklist.",
 "Toque onde quer escrever.": "Touchez l'endroit où écrire.",
 "Toque para abrir": "Touchez pour ouvrir",
 "Toque para abrir no app do celular. Arraste para a direita para tirar da lista.": "Touchez pour ouvrir dans l'app du téléphone. Glissez à droite pour retirer de la liste.",
 "Toque para abrir, segure para mudar o nome. Arraste para a esquerda para arquivar ou para a direita para excluir.": "Touchez pour ouvrir, appuyez longuement pour renommer. Balayez vers la gauche pour archiver ou vers la droite pour supprimer.",
 "Toque para abrir. Arraste para a direita para tirar da lista.": "Touchez pour ouvrir. Glissez vers la droite pour retirer de la liste.",
 "Toque para aceitar ou recusar.": "Touchez pour accepter ou refuser.",
 "Toque para aceitar, editar ou recusar.": "Touchez pour accepter, modifier ou refuser.",
 "Toque para aplicar agora. Ou ela entra sozinha ao reabrir o app.": "Touchez pour l'appliquer maintenant. Sinon, elle s'applique à la réouverture de l'app.",
 "Toque para baixar e instalar por cima. Seus dados continuam.": "Touchez pour télécharger et installer par-dessus. Vos données sont conservées.",
 "Toque para conversar": "Touchez pour discuter",
 "Toque para enviar o emoji animado": "Touchez pour envoyer l'emoji animé",
 "Toque para enviar. Segure para guardar ou tirar das suas.": "Touchez pour envoyer. Appuyez longuement pour enregistrer ou retirer des vôtres.",
 "Toque para escolher": "Touchez pour choisir",
 "Toque para fechar": "Touchez pour fermer",
 "Toque para gerar um novo QR Code": "Touchez pour générer un nouveau QR code",
 "Tornar admin": "Nommer admin",
 "Tornar administrador": "Nommer administrateur",
 "Tosa": "Toilettage",
 "Totais por alimento": "Totaux par aliment",
 "Total": "Total",
 "Total bruto": "Total brut",
 "Total das reservas: {v}": "Total des réservations : {v}",
 "Total de aulas": "Nombre total de cours",
 "Total de capítulos": "Nombre de chapitres",
 "Total de módulos": "Nombre de modules",
 "Total de páginas": "Nombre total de pages",
 "Total de recibos: {v}": "Total des reçus : {v}",
 "Total: {n}. Cada aba pode ter até {lim} de texto (fotos e arquivos não contam: ficam no dispositivo ou no seu Drive).": "Total : {n}. Chaque onglet peut contenir jusqu'à {lim} de texte (photos et fichiers non compris : ils restent sur l'appareil ou dans votre Drive).",
 "Total: {v}": "Total : {v}",
 "Trabalhando...": "Traitement...",
 "Trabalho": "Travail",
 "Traga os compromissos da sua agenda do Google para o My Planner e edite por aqui: as mudanças voltam para a agenda.": "Importez les événements de votre Google Agenda dans My Planner et modifiez-les ici : les changements sont renvoyés à l'agenda.",
 "Trans": "Trans",
 "Transferir: {s}": "Transférer : {s}",
 "Transferência": "Transfert",
 "Transferências": "Transferts",
 "Transporte": "Transport",
 "Tratamento": "Traitement",
 "Travar depois de preencher": "Verrouiller après remplissage",
 "Trazer todas para hoje": "Tout ramener à aujourd'hui",
 "Trazer tudo para hoje?": "Tout ramener à aujourd'hui ?",
 "Trecho ou ideia": "Extrait ou idée",
 "Treino": "Séance",
 "Trem ou ônibus": "Train ou bus",
 "Treme": "Tremble",
 "Tribunais": "Tribunaux",
 "Trilha": "Randonnée",
 "Triste": "Triste",
 "Triângulo": "Triangle",
 "Troca de óleo": "Vidange",
 "Troca de óleo, rodízio de pneus, revisões por km, IPVA, licenciamento e seguro.": "Vidange, permutation des pneus, révisions au km, IPVA, immatriculation et assurance.",
 "Trocador portátil": "Matelas à langer nomade",
 "Trocar": "Changer",
 "Trocar a categoria": "Changer la catégorie",
 "Trocar a foto": "Changer la photo",
 "Trocar a pasta": "Changer de dossier",
 "Trocar a senha do cofre": "Changer le mot de passe du coffre",
 "Trocar número": "Changer de numéro",
 "Trocar o certificado": "Changer de certificat",
 "Trocar o código": "Changer le code",
 "Trocar o código?": "Changer le code ?",
 "Trocar o desenho": "Changer le schéma",
 "Trocar o emoji": "Changer l'emoji",
 "Trocar o modelo": "Changer de modèle",
 "Trocar o número": "Changer le numéro",
 "Trocar o número do celular": "Changer le numéro de téléphone",
 "Trocar por:": "Remplacer par :",
 "Trocar roupa de cama e toalhas": "Changer draps et serviettes",
 "Tríceps na polia": "Extension triceps à la poulie",
 "Tubo de ensaio": "Éprouvette",
 "Tudo": "Tout",
 "Tudo certo": "Tout est en ordre",
 "Tudo em dia por aqui. Lance os gastos do dia a dia para eu enxergar para onde o dinheiro vai.": "Tout est à jour ici. Saisissez vos dépenses du quotidien pour que je voie où va l'argent.",
 "Tudo já fica salvo na sua conta. O arquivo é uma cópia extra que você guarda onde quiser.": "Tout est déjà enregistré dans votre compte. Le fichier est une copie supplémentaire à conserver où vous voulez.",
 "Tudo o que está dentro de \"{nome}\" passa a ser visto pelo grupo, cada pessoa conforme o papel que você escolher (quem entra começa com o papel mais limitado).": "Tout ce qui se trouve dans \"{nome}\" devient visible par le groupe, chacun selon le rôle que vous choisissez (les nouveaux venus commencent avec le rôle le plus limité).",
 "Tudo! Já comprei os ingressos.": "Oui ! J'ai déjà acheté les billets.",
 "Turma": "Classe",
 "Turma (opcional)": "Classe (facultatif)",
 "Turmas": "Classes",
 "Turmas e grupos (aulas, mentoria, treino): alunos, chamada, notas, planos, materiais, cobranças e o seu caderno.": "Classes et groupes (cours, mentorat, entraînement) : élèves, appel, notes, plans, supports, paiements dus et votre carnet.",
 "Turmas, alunos, chamada, notas e planos de aula.": "Classes, élèves, appel, notes et plans de cours.",
 "Turmas, pacientes, equipes e convidados": "Classes, patients, équipes et invités",
 "Técnico": "Technique",
 "Título": "Titre",
 "Título (ex.: Capítulo 3)": "Titre (ex. : Chapitre 3)",
 "Título (opcional)": "Titre (facultatif)",
 "Título da caixa": "Titre de la boîte",
 "Título de eleitor": "Carte d'électeur",
 "Título, autor, assunto e palavras-chave.": "Titre, auteur, sujet et mots-clés.",
 "Tô chegando": "J'arrive",
 "Tônico": "Tonique",
 "UF": "UF",
 "Uau": "Waouh",
 "Uhuul!": "Youpi !",
 "Um PDF novo só com as páginas escolhidas.": "Un nouveau PDF avec seulement les pages choisies.",
 "Um texto clarinho na diagonal de todas as páginas.": "Un texte léger en diagonale sur toutes les pages.",
 "Uma pasta para cada cliente: vocês trocam documentos nos dois sentidos e cada cliente só vê a pasta dele.": "Un dossier pour chaque client : vous échangez des documents dans les deux sens et chaque client ne voit que son dossier.",
 "Uma página por arquivo": "Une page par fichier",
 "Uma página por arquivo, a cada N páginas ou por faixas.": "Une page par fichier, toutes les N pages ou par plages.",
 "Unicórnio": "Licorne",
 "Unidade": "Unité",
 "Universal": "Universel",
 "União": "Union",
 "Usa a conta Google que já está no celular. Nenhuma senha do Google é pedida pelo My Planner.": "Utilise le compte Google déjà présent sur le téléphone. My Planner ne demande jamais votre mot de passe Google.",
 "Usado: {u} · livre: {v} · limite {l}": "Utilisé : {u} · disponible : {v} · plafond {l}",
 "Usar": "Utiliser",
 "Usar \"{nome}\"": "Utiliser « {nome} »",
 "Usar biometria": "Utiliser la biométrie",
 "Usar desenho padrão": "Utiliser un schéma",
 "Usar este celular": "Utiliser ce téléphone",
 "Usar este nome": "Utiliser ce nom",
 "Usar modelo: {m}": "Utiliser le modèle : {m}",
 "Usar no navegador (My Planner Web)": "Utiliser dans le navigateur (My Planner Web)",
 "Usar o arquivo já anexado ({nome})": "Utiliser le fichier déjà joint ({nome})",
 "Usar o código": "Utiliser le code",
 "Usar senha": "Utiliser le mot de passe",
 "Usar {ia}": "Utiliser {ia}",
 "Use a senha nova da próxima vez que entrar, aqui e no My Planner Web.": "Utilisez le nouveau mot de passe à votre prochaine connexion, ici et sur My Planner Web.",
 "Use a senha para desbloquear.": "Utilisez le mot de passe pour déverrouiller.",
 "Use a sua própria IA para ler publicações, documentos e anotações e sugerir agendamentos. Você sempre confirma antes de qualquer coisa entrar no Planner.": "Utilisez votre propre IA pour lire publications, documents et notes et suggérer des rendez-vous. Vous confirmez toujours avant que quoi que ce soit n'entre dans le Planner.",
 "Use este código ao criar a sua conta e ganhe 10 dias com todas as abas liberadas.": "Utilisez ce code en créant votre compte et profitez de 10 jours avec tous les onglets débloqués.",
 "Use o extrato em OFX (o mais indicado) ou CSV, baixado no app ou site do seu banco.": "Utilisez le relevé en OFX (recommandé) ou CSV, téléchargé dans l'app ou sur le site de votre banque.",
 "Use o seu planner no computador, sincronizado com o celular.": "Utilisez votre planner sur l'ordinateur, synchronisé avec le téléphone.",
 "Use um link https do Google Drive, Google Docs, OneDrive ou SharePoint.": "Utilisez un lien https de Google Drive, Google Docs, OneDrive ou SharePoint.",
 "Uso": "Utilisation",
 "Uso próprio": "Usage personnel",
 "VRBO": "VRBO",
 "Vacina": "Vaccin",
 "Vacina {nome}: {pet}": "Vaccin {nome} : {pet}",
 "Vacina: {nome}": "Vaccin : {nome}",
 "Vacinas": "Vaccins",
 "Vacinas e remédios dos pets, pet shop e a rotina da escola e da saúde das crianças.": "Vaccins et médicaments des animaux, toilettage et suivi de l'école et de la santé des enfants.",
 "Vai na viagem": "Part en voyage",
 "Vale até {d}": "Valable jusqu'au {d}",
 "Vale para Estudos e Documentos. Na nuvem, o arquivo abre em qualquer dispositivo e no My Planner Web (até 15 MB por arquivo).": "S'applique à Études et Documents. Dans le cloud, le fichier s'ouvre sur n'importe quel appareil et dans My Planner Web (jusqu'à 15 Mo par fichier).",
 "Vale quantos pontos": "Nombre de points",
 "Vale só para você. No máximo um aviso a cada 3 minutos por pessoa, mesmo que ela inclua várias coisas.": "Ne s'applique qu'à vous. Au maximum un avis toutes les 3 minutes par personne, même si elle ajoute plusieurs choses.",
 "Vale uma vez, nos primeiros 30 dias da sua conta.": "Valable une fois, pendant les 30 premiers jours de votre compte.",
 "Validade": "Expiration",
 "Validade do certificado A1": "Validité du certificat A1",
 "Validade: {data}": "Expire le : {data}",
 "Valor": "Montant",
 "Valor ({m})": "Montant ({m})",
 "Valor a pagar": "Montant à payer",
 "Valor combinado": "Montant convenu",
 "Valor combinado por atendimento": "Tarif convenu par rendez-vous",
 "Valor da hora": "Taux horaire",
 "Valor da parcela (1ª)": "Montant de l'échéance (1re)",
 "Valor da venda": "Prix de vente",
 "Valor de costume": "Montant habituel",
 "Valor do atendimento: {v}{pago}.": "Montant de la consultation : {v}{pago}.",
 "Valor emprestado ou financiado": "Montant prêté ou financé",
 "Valor final definido pela Google Play ou pela App Store, já na moeda do seu país.": "Prix final fixé par Google Play ou l'App Store, dans la devise de votre pays.",
 "Valor maior que o guardado nesta meta.": "Montant supérieur à ce qui est épargné dans cet objectif.",
 "Valor padrão da consulta ou sessão": "Tarif standard de la consultation ou séance",
 "Valor pago": "Montant payé",
 "Valor pago (com multa ou desconto)": "Montant payé (avec pénalité ou remise)",
 "Valor pago (opcional)": "Montant payé (facultatif)",
 "Valor pago: {v}": "Montant payé : {v}",
 "Valor que este aluno paga (se for diferente)": "Montant payé par cet élève (s'il est différent)",
 "Valor recebido": "Montant reçu",
 "Valor recebido: {v}": "Montant reçu : {v}",
 "Valor total da compra": "Montant total de l'achat",
 "Valores e dados clínicos só aparecem para quem o papel permitir. Você pode desligar quando quiser: os dados continuam com você.": "Les montants et les données cliniques n'apparaissent qu'aux rôles qui le permettent. Vous pouvez désactiver quand vous voulez : les données restent chez vous.",
 "Valores para conferir com o seu contador. As regras de dedução mudam a cada ano.": "Montants à vérifier avec votre comptable. Les règles de déduction changent chaque année.",
 "Vamos conversar pelo My Planner? Me adicione como amigo com o código {codigo} (aba Mensagens > Amigos).": "On discute sur My Planner ? Ajoute-moi en ami avec le code {codigo} (onglet Messages > Amis).",
 "Vaso": "Pot",
 "Veja os planos em Ajustes › Compras.": "Consultez les forfaits dans Réglages › Achats.",
 "Vem da aba Empréstimos & Financiamentos": "Vient de l'onglet Prêts & Financements",
 "Vence em {data}.": "Expire le {data}.",
 "Vence em {fim} (data informada na publicação).": "Échéance le {fim} (date indiquée dans la publication).",
 "Vence em {n} dia(s)": "Expire dans {n} jour(s)",
 "Vence hoje": "Expire aujourd'hui",
 "Vence {data}": "Échéance {data}",
 "Vencendo": "Bientôt expirés",
 "Venceu há {n} dia(s)": "Expirée depuis {n} jour(s)",
 "Vencidas": "Expirées",
 "Vencidos": "Expirés",
 "Vencimento": "Échéance",
 "Vencimento (guias e boletos)": "Échéance (avis d'impôt et boletos)",
 "Vencimento da 1ª parcela": "Échéance de la 1re mensualité",
 "Vencimentos": "Échéances",
 "Venda": "Vente",
 "Venda/serviço do MEI": "Vente/prestation MEI",
 "Vendidos": "Vendus",
 "Ver": "Voir",
 "Ver a lista de membros": "Voir la liste des membres",
 "Ver a rota": "Voir l'itinéraire",
 "Ver arquivos": "Voir les fichiers",
 "Ver detalhes do erro": "Voir les détails de l'erreur",
 "Ver e editar": "Voir et modifier",
 "Ver em Compras": "Voir dans Achats",
 "Ver mais": "Voir plus",
 "Ver mais páginas": "Voir plus de pages",
 "Ver no My Planner": "Voir dans My Planner",
 "Ver o dia": "Voir le jour",
 "Ver os feriados do ano": "Voir les jours fériés de l'année",
 "Ver participantes": "Voir les participants",
 "Ver páginas": "Voir les pages",
 "Ver todos": "Tout voir",
 "Ver todos ({n})": "Tout voir ({n})",
 "Ver {nome}": "Voir {nome}",
 "Verificar agora": "Vérifier maintenant",
 "Vermífugo": "Vermifuge",
 "Vermífugo ou remédio": "Vermifuge ou médicament",
 "Vermífugos e remédios": "Vermifuges et médicaments",
 "Verso": "Verso",
 "Verso do documento": "Verso du document",
 "Versão do PDF": "Version du PDF",
 "Versão instalada": "Version installée",
 "Versão {versao} disponível": "Version {versao} disponible",
 "Versão {v}": "Version {v}",
 "Veterinário": "Vétérinaire",
 "Veterinário ou clínica": "Vétérinaire ou clinique",
 "Veículo": "Véhicule",
 "Veículo e acessórios": "Véhicule et accessoires",
 "Veículos": "Véhicules",
 "Veículos & Manutenção": "Véhicules & Entretien",
 "Vi mais um episódio": "J'ai vu un épisode de plus",
 "Viagem": "Voyage",
 "Viagens": "Voyages",
 "Viagens & Lazer": "Voyages & Loisirs",
 "Viagens e lugares": "Voyages et lieux",
 "Vida noturna": "Vie nocturne",
 "Vidros e esquadrias": "Vitres et menuiseries",
 "Vigente": "En cours",
 "Vigentes": "En cours",
 "Virar": "Retourner",
 "Virar a câmera": "Retourner la caméra",
 "Virar tarefa (levar à assistência)": "Créer une tâche (porter au SAV)",
 "Visita domiciliar": "Visite à domicile",
 "Visitados": "Visités",
 "Visto": "Vu",
 "Vistoria": "État des lieux",
 "Vistoria: {i}": "État des lieux : {i}",
 "Vistorias": "États des lieux",
 "Visualizar feriados": "Voir les jours fériés",
 "Vitamina": "Vitamine",
 "Vitamina D": "Vitamine D",
 "Vitaminas, whey, creatina... com a frequência de cada um. O que for de hoje aparece em \"Hoje\" para marcar.": "Vitamines, whey, créatine... chacun avec sa fréquence. Ce qui est prévu aujourd'hui apparaît dans « Aujourd'hui » pour être coché.",
 "Você": "Vous",
 "Você aceitou os termos em {data}.": "Vous avez accepté les conditions le {data}.",
 "Você ainda não tem amigos no app. Adicione pelo código.": "Vous n'avez pas encore d'amis dans l'app. Ajoutez-en avec leur code.",
 "Você ainda não tem fichários. Crie um na aba Estudos.": "Vous n'avez pas encore de classeur. Créez-en un dans l'onglet Études.",
 "Você deixa de ver a conversa, os documentos e as reuniões.": "Vous ne verrez plus la conversation, les documents ni les réunions.",
 "Você deve: {v}": "Vous devez : {v}",
 "Você entrou no grupo": "Vous avez rejoint le groupe",
 "Você entrou no grupo \"{nome}\".": "Vous avez rejoint le groupe \"{nome}\".",
 "Você está convidado(a) para: {evento}": "Vous êtes invité(e) à : {evento}",
 "Você foi convidado para o My Planner": "Vous avez été invité sur My Planner",
 "Você foi convidado para o grupo": "Vous êtes invité dans le groupe",
 "Você juntou {v} para \"{m}\".": "Vous avez mis de côté {v} pour « {m} ».",
 "Você já tem todas as abas.": "Vous avez déjà tous les onglets.",
 "Você já usou um código de indicação nesta conta.": "Vous avez déjà utilisé un code de parrainage sur ce compte.",
 "Você ligou": "Vous avez appelé",
 "Você mesmo pode apagar a conta a qualquer momento, pelo app no celular ou pelo site:": "Vous pouvez supprimer votre compte à tout moment, dans l'app du téléphone ou sur le site :",
 "Você não tem permissão para isso neste grupo.": "Vous n'avez pas l'autorisation de faire cela dans ce groupe.",
 "Você não vê os outros membros deste grupo.": "Vous ne voyez pas les autres membres de ce groupe.",
 "Você pode apagar a conta a qualquer momento em Ajustes > Segurança. Isso apaga para sempre os dados na nuvem e no dispositivo.": "Vous pouvez supprimer votre compte à tout moment dans Réglages > Sécurité. Cela efface définitivement les données dans le cloud et sur l'appareil.",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (exportar o arquivo em Ajustes > Configuração geral), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "Vous pouvez : confirmer que nous traitons vos données, y accéder, les corriger, demander leur portabilité (exporter le fichier dans Réglages > Réglages généraux), demander leur suppression, savoir avec qui nous les partageons, retirer votre consentement et déposer une réclamation auprès de l'ANPD.",
 "Você recebe (líquido)": "Vous recevez (net)",
 "Você é responsável pela sua senha e pelo que é feito na sua conta. Use dados verdadeiros no cadastro.": "Vous êtes responsable de votre mot de passe et de ce qui est fait sur votre compte. Utilisez des informations exactes lors de l'inscription.",
 "Volta": "Retour",
 "Volta ou check-out": "Retour ou départ",
 "Volta às {hora}": "Reprise à {hora}",
 "Voltar": "Retour",
 "Voltar ao cardápio da semana neste dia": "Revenir au menu de la semaine ce jour-là",
 "Voltar ao cálculo": "Retour au calcul",
 "Voltar ao foco": "Retour à la concentration",
 "Voltar ao padrão": "Rétablir par défaut",
 "Voltar ao planejado": "Revenir au prévu",
 "Voltar para Anotações": "Retour aux Notes",
 "Voltar para as cores do My Planner": "Revenir aux couleurs de My Planner",
 "Voltar para novas": "Retour aux nouvelles",
 "Voltar para o QR Code": "Retour au QR code",
 "Volte para o app My Planner no celular. A tela de Ajustes atualiza sozinha.": "Revenez dans l'app My Planner sur le téléphone. L'écran Réglages se met à jour tout seul.",
 "Voo": "Vol",
 "Voos, hotéis, carro e passeios num lugar só, com o código e o comprovante.": "Vols, hôtels, voiture et sorties au même endroit, avec le code et le justificatif.",
 "Vá em Ajustes e toque em \"Conectar navegador\".": "Allez dans Réglages et touchez « Connecter le navigateur ».",
 "Vá em Ajustes › Configuração geral e toque em \"Conectar navegador\".": "Allez dans Réglages › Réglages généraux et touchez « Connecter le navigateur ».",
 "Várias páginas por folha": "Plusieurs pages par feuille",
 "Vários PDFs num só, na ordem que você escolher.": "Plusieurs PDF en un seul, dans l'ordre de votre choix.",
 "Vê as aulas e os materiais liberados.": "Voit les cours et les supports publiés.",
 "Vê as etapas e registra o diário.": "Voit les étapes et remplit le journal.",
 "Vê e altera tudo, inclusive os valores.": "Voit et modifie tout, y compris les montants.",
 "Vê e envia os documentos da própria pasta e responde aos pedidos.": "Voit et envoie les documents de son propre dossier et répond aux demandes.",
 "Vê o andamento, sem os valores e sem alterar.": "Voit l'avancement, sans les montants et sans modifier.",
 "Vê os check-ins e check-outs e marca a limpeza feita, sem valores.": "Voit les arrivées et départs et marque le ménage comme fait, sans montants.",
 "Vê tudo e lança gastos, lugares, roteiro e mala.": "Voit tout et ajoute dépenses, lieux, itinéraire et bagages.",
 "Vê tudo, inclui, edita, comenta e põe fotos. Só não coloca nem tira pessoas do grupo.": "Voit tout, ajoute, modifie, commente et met des photos. Ne peut simplement pas ajouter ni retirer des personnes du groupe.",
 "Vê tudo, inclusive os valores, sem alterar.": "Voit tout, y compris les montants, sans modifier.",
 "Vídeo": "Vidéo",
 "Vínculo": "Lien",
 "Vínculo perdido": "Lien perdu",
 "WhatsApp da assistência": "WhatsApp du SAV",
 "Whey": "Whey",
 "Wi-Fi (rede e senha)": "Wi-Fi (réseau et mot de passe)",
 "Yoga": "Yoga",
 "Zumbi e Consciência Negra": "Zumbi et Conscience noire",
 "Zzz": "Zzz",
 "a cada {n} dias": "tous les {n} jours",
 "a pagar": "à payer",
 "a receber": "à recevoir",
 "a receber {v}": "à recevoir {v}",
 "a reserva": "la réservation",
 "a última execução falhou; avise o suporte": "la dernière exécution a échoué ; prévenez le support",
 "abr": "avr.",
 "abril": "avril",
 "acabou": "épuisé",
 "achatado": "aplati",
 "administra": "admin",
 "ago": "août",
 "agosto": "août",
 "ajustado": "ajustée",
 "algo novo": "quelque chose de nouveau",
 "alterou": "a modifié",
 "amanhã": "demain",
 "anual": "annuel",
 "apagou": "a supprimé",
 "aplicada em {d}": "administré le {d}",
 "app {v} · atualização {p} de {data}": "app {v} · mise à jour {p} du {data}",
 "assinado": "signé",
 "atrasada": "en retard",
 "atrasada há {n} dia(s)": "en retard de {n} jour(s)",
 "até": "à",
 "até {data}": "jusqu'au {data}",
 "até {d}": "jusqu'au {d}",
 "aula {a} de {n}": "cours {a} sur {n}",
 "avisos silenciados": "notifications désactivées",
 "caixa": "boîte",
 "colher(es)": "cuillère(s)",
 "coluna": "colonne",
 "com anexos": "avec pièces jointes",
 "com imagem": "avec image",
 "com tarjas": "caviardé",
 "com texto": "avec texte",
 "com {p}": "chez {p}",
 "como planejado": "comme prévu",
 "comprado em {data}": "acheté le {data}",
 "comprado em {d} por {v}": "acheté le {d} pour {v}",
 "comprimido": "compressé",
 "comprovante": "justificatif",
 "concha(s)": "louche(s)",
 "confirmados": "confirmés",
 "consulta recusada": "consultation refusée",
 "contratado": "engagé",
 "contínuo": "continu",
 "copo(s)": "verre(s)",
 "corridos": "calendaires",
 "criou o grupo": "a créé le groupe",
 "de": "sur",
 "de Anotações": "des Notes",
 "de {meta} passos": "sur {meta} pas",
 "de {n}": "sur {n}",
 "de {p}": "de {p}",
 "dentro / fora do planejado": "dans / hors du plan",
 "desconto {v}": "remise {v}",
 "desfazer": "annuler",
 "destino": "destination",
 "deve {v}": "doit {v}",
 "devolvido em {d}": "rendu le {d}",
 "dez": "déc.",
 "dezembro": "décembre",
 "dia": "jour",
 "dias": "jours",
 "dias com a meta batida": "jours avec objectif atteint",
 "dias com a meta de passos": "jours avec l’objectif de pas",
 "digital": "empreinte digitale",
 "diária média": "prix moyen par nuit",
 "do cliente": "du client",
 "do escritório": "du cabinet",
 "dom": "dim.",
 "domingo": "dimanche",
 "e mais {n}": "et {n} de plus",
 "em aberto": "en cours",
 "em atraso": "en retard",
 "em {n} dias": "dans {n} jours",
 "emitida": "émise",
 "entregue": "livré",
 "entrou no escritório": "a rejoint le bureau",
 "enviado": "envoyé",
 "escaneado": "scanné",
 "escolha": "choisir",
 "este": "celui-ci",
 "este dispositivo": "cet appareil",
 "este item": "cet élément",
 "exercícios concluídos": "exercices terminés",
 "falta {v}": "reste {v}",
 "faltam {km}": "encore {km}",
 "fatia(s)": "tranche(s)",
 "faturamento": "chiffre d'affaires",
 "feita em {d}": "faite le {d}",
 "feito {dur}": "fait {dur}",
 "fev": "févr.",
 "fevereiro": "février",
 "frequência {p}%": "assiduité {p} %",
 "gasto {v}": "dépensé {v}",
 "girado": "pivoté",
 "guardado": "enregistré",
 "higienizado": "nettoyé",
 "hoje": "aujourd'hui",
 "hora fixa no dia": "heure fixe dans la journée",
 "há {n} dias": "il y a {n} jours",
 "iPhone ou computador: {link}": "iPhone ou ordinateur : {link}",
 "incluiu": "a ajouté",
 "jan": "janv.",
 "janeiro": "janvier",
 "jul": "juil.",
 "julho": "juillet",
 "jun": "juin",
 "junho": "juin",
 "já importado": "déjà importé",
 "liberar em {d}": "publier le {d}",
 "ligou o compartilhamento": "a activé le partage",
 "linha": "ligne",
 "lucro líquido": "bénéfice net",
 "mai": "mai",
 "maio": "mai",
 "mar": "mars",
 "marca d'água": "filigrane",
 "marcada por {nome}": "planifiée par {nome}",
 "março": "mars",
 "menos de 1 ano": "moins d'1 an",
 "mensalidade": "mensualité",
 "meta batida!": "objectif atteint !",
 "metadados": "métadonnées",
 "min": "min",
 "min antes": "min avant",
 "min antes do início": "min avant le début",
 "min · {de} às {ate}": "min · {de} à {ate}",
 "multa e juros {v}": "pénalités et intérêts {v}",
 "média {m}": "moyenne {m}",
 "mês(es)": "mois",
 "na nuvem": "dans le cloud",
 "na pasta \"{pasta}\"": "dans le dossier \"{pasta}\"",
 "na pasta escolhida": "dans le dossier choisi",
 "neste dispositivo": "sur cet appareil",
 "neste celular": "sur ce téléphone",
 "no Planner": "dans le Planner",
 "no {nome}": "dans {nome}",
 "nos próximos dias": "dans les prochains jours",
 "nov": "nov.",
 "novembro": "novembre",
 "numerado": "numéroté",
 "nunca verificado": "jamais vérifié",
 "não vão": "ne viennent pas",
 "o documento mudou depois disso: guarde de novo": "le document a changé depuis : enregistrez-le à nouveau",
 "ocupação": "occupation",
 "ontem": "hier",
 "organizado": "organisé",
 "orçando": "devis en cours",
 "out": "oct.",
 "outubro": "octobre",
 "paga": "payée",
 "paga em {d}": "payée le {d}",
 "pago": "payé",
 "pago em {d}": "payé le {d}",
 "pago por {p}": "payé par {p}",
 "pagou {v}": "a payé {v}",
 "parcela {a} de {n}": "échéance {a} sur {n}",
 "parece já lançado": "semble déjà saisi",
 "parte {n}": "partie {n}",
 "passos por dia (média)": "pas par jour (moyenne)",
 "passou {km}": "dépassé de {km}",
 "pausa {p}": "repos {p}",
 "pausado": "en pause",
 "peso {n}": "coefficient {n}",
 "pesquisável": "consultable",
 "por dia": "par jour",
 "por dia (média)": "par jour (moyenne)",
 "por dia disponível": "par jour disponible",
 "por semana": "par semaine",
 "por {p}": "par {p}",
 "porção(ões)": "portion(s)",
 "preenchido": "rempli",
 "primeira às {hora}: {tarefa}": "première à {hora} : {tarefa}",
 "produção": "production",
 "próxima em {data}": "prochaine le {data}",
 "próxima rega {d}": "prochain arrosage {d}",
 "publicação": "publication",
 "página de estudo": "page d'étude",
 "página única": "page unique",
 "páginas": "pages",
 "páginas {p}": "pages {p}",
 "qua": "mer.",
 "quarta": "mercredi",
 "quarta-feira": "mercredi",
 "qui": "jeu.",
 "quinta": "jeudi",
 "quinta-feira": "jeudi",
 "quitada": "réglée",
 "recebe {v}": "reçoit {v}",
 "recebida": "reçue",
 "reconhecimento facial": "reconnaissance faciale",
 "recortado": "rogné",
 "refeições feitas": "repas pris",
 "rega a cada {n} dias": "arrosage tous les {n} jours",
 "regar hoje": "arroser aujourd'hui",
 "reparado": "réparé",
 "retorno {d}": "contrôle {d}",
 "saldo {v}": "solde {v}",
 "seg": "lun.",
 "segunda": "lundi",
 "segunda-feira": "lundi",
 "sem anotações": "sans annotations",
 "sem as páginas {p}": "sans les pages {p}",
 "sem cliente": "sans client",
 "sem dias previstos": "aucun jour prévu",
 "sem horário": "sans heure",
 "sem meta": "sans objectif",
 "sem resposta": "sans réponse",
 "sem tempo": "sans temps",
 "semana(s)": "semaine(s)",
 "set": "sept.",
 "setembro": "septembre",
 "seu@email.com": "vous@email.com",
 "sex": "ven.",
 "sexta": "vendredi",
 "sexta-feira": "vendredi",
 "sáb": "sam.",
 "sábado": "samedi",
 "talvez": "peut-être",
 "tarefa da casa": "tâche ménagère",
 "tarefa: {t}": "tâche : {t}",
 "taxas e despesas": "frais et dépenses",
 "ter": "mar.",
 "termina em {d}": "se termine le {d}",
 "terça": "mardi",
 "terça-feira": "mardi",
 "teste": "test",
 "todas": "toutes",
 "todo ano em {d}": "chaque année le {d}",
 "todo dia {d}": "chaque mois le {d}",
 "todos": "tous",
 "toque para abrir": "touchez pour ouvrir",
 "toque para pausar": "touchez pour mettre en pause",
 "toque para ver o contato": "touchez pour voir le contact",
 "toque para voltar a hoje": "touchez pour revenir à aujourd’hui",
 "treinos concluídos": "entraînements terminés",
 "uma vez em {d}": "une fois le {d}",
 "unidade(s)": "unité(s)",
 "vale {n}": "vaut {n}",
 "vence em {n} dias": "échéance dans {n} jours",
 "vence {d}": "échéance {d}",
 "venceu em {data}": "expirée le {data}",
 "vencido": "en retard",
 "vendido com ganho de {v}": "vendu avec un gain de {v}",
 "vendido com perda de {v}": "vendu avec une perte de {v}",
 "verificado {quando}": "vérifié {quando}",
 "você": "vous",
 "você administra": "vous êtes admin",
 "xícara(s)": "tasse(s)",
 "{aba} bloqueada": "{aba} verrouillé",
 "{aba} está bloqueada": "{aba} est verrouillé",
 "{aba}, em \"Anotações recebidas\"": "{aba}, dans « Notes reçues »",
 "{a} aula(s) feita(s)": "{a} cours terminé(s)",
 "{a} de {n} aulas": "{a} sur {n} cours",
 "{c} chegou a {p}% do orçamento ({g} de {l}).": "{c} a atteint {p} % du budget ({g} sur {l}).",
 "{c} confirmados de {n} convidados": "{c} confirmés sur {n} invités",
 "{c} está em {p}% do orçamento do mês. Ainda faltam {dias} dia(s) para o mês acabar.": "{c} est à {p} % du budget du mois. Il reste encore {dias} jour(s) avant la fin du mois.",
 "{c} já está {v} acima do mês passado inteiro. Confira se foi algo fora do comum.": "{c} dépasse déjà de {v} tout le mois dernier. Vérifiez s'il s'agit d'une dépense inhabituelle.",
 "{c} já passou do orçamento: {g} de {l}. Segure esse gasto até o mês virar.": "{c} a déjà dépassé le budget : {g} sur {l}. Freinez cette dépense jusqu'au mois prochain.",
 "{c} passou do orçamento: {g} de {l}.": "{c} a dépassé le budget : {g} sur {l}.",
 "{de} paga {v} para {para}": "{de} paie {v} à {para}",
 "{de} às {ate}": "{de} à {ate}",
 "{dia}, {d} de {mes} de {a}": "{dia} {d} {mes} {a}",
 "{dia}, {d} {mes}": "{dia} {d} {mes}",
 "{dia}, {d}/{m}": "{dia} {d}/{m}",
 "{dur} na semana": "{dur} cette semaine",
 "{dur} registrados": "{dur} enregistrés",
 "{d}/{n} notas": "{d}/{n} notes",
 "{feito} de {meta}": "{feito} sur {meta}",
 "{fonte} · {data}": "{fonte} · {data}",
 "{f} de {n} feitas": "{f} sur {n} faites",
 "{f}/{n} transferências feitas": "{f}/{n} transferts faits",
 "{hora} em {fuso}": "{hora} à {fuso}",
 "{h} este mês": "{h} ce mois-ci",
 "{h} h": "{h} h",
 "{h} h {m} min": "{h} h {m} min",
 "{h} no seu relógio": "{h} à votre montre",
 "{ia} conectado. {n} modelo(s) disponível(is) na sua conta.": "{ia} connecté. {n} modèle(s) disponible(s) dans votre compte.",
 "{ia}: chave de API inválida ou sem permissão.": "{ia} : clé API invalide ou sans autorisation.",
 "{ia}: limite de uso atingido. Confira o saldo ou o limite da sua conta de API.": "{ia} : limite d'utilisation atteinte. Vérifiez le solde ou la limite de votre compte API.",
 "{item}: em {n} dias ({data}).": "{item} : dans {n} jours ({data}).",
 "{item}: hoje ({data}).": "{item} : aujourd'hui ({data}).",
 "{item}: termina em {n} dias ({data}).": "{item} : expire dans {n} jours ({data}).",
 "{item}: vence em {n} dias ({data}).": "{item} : expire dans {n} jours ({data}).",
 "{item}: vence hoje ({data}).": "{item} : expire aujourd'hui ({data}).",
 "{item}: venceu em {data} e ainda não foi marcado como feito.": "{item} : échu le {data} et pas encore marqué comme fait.",
 "{livre} livres de {total}": "{livre} libres sur {total}",
 "{m} min": "{m} min",
 "{nome} agora é seu amigo. Já podem conversar.": "{nome} est maintenant votre ami. Vous pouvez discuter.",
 "{nome} conectado!": "{nome} connecté !",
 "{nome} ligou": "{nome} a appelé",
 "{novas} nova(s), {atualizadas} atualizada(s), {enviadas} enviada(s), {removidas} removida(s)": "{novas} nouveau(x), {atualizadas} mis à jour, {enviadas} envoyé(s), {removidas} supprimé(s)",
 "{n} ITEM(NS)": "{n} ARTICLE(S)",
 "{n} aba(s) no seu plano · cores e opções de cada uma": "{n} onglet(s) dans votre forfait · couleurs et options de chacun",
 "{n} aba(s) para comprar": "{n} onglet(s) à acheter",
 "{n} adicionada(s)": "{n} ajoutée(s)",
 "{n} alerta(s) agendado(s) neste celular para os próximos dias.": "{n} alerte(s) programmée(s) sur ce téléphone pour les prochains jours.",
 "{n} aluno(s)": "{n} élève(s)",
 "{n} anexo(s)": "{n} pièce(s) jointe(s)",
 "{n} ano(s)": "{n} an(s)",
 "{n} arquivo(s)": "{n} fichier(s)",
 "{n} atendimento(s)": "{n} rendez-vous",
 "{n} atrasada(s)": "{n} en retard",
 "{n} atrasado(s)": "{n} en retard",
 "{n} caixa(s)": "{n} carton(s)",
 "{n} caixa(s) frágil(eis)": "{n} carton(s) fragile(s)",
 "{n} caixa(s) · {a} já aberta(s) na casa nova": "{n} carton(s) · {a} déjà ouvert(s) dans le nouveau logement",
 "{n} cancelada(s).": "{n} annulée(s).",
 "{n} cartão(ões) abertos": "{n} carte(s) ouverte(s)",
 "{n} cobrança(s) criada(s) com vencimento em {d}.": "{n} paiement(s) créé(s), échéance le {d}.",
 "{n} com vencimento": "{n} avec échéance",
 "{n} compra(s) no cartão {c}. As parcelas futuras já aparecem nas próximas faturas.": "{n} achat(s) sur la carte {c}. Les échéances futures apparaissent déjà sur les prochains relevés.",
 "{n} conta(s) marcada(s) como paga(s) automaticamente.": "{n} facture(s) marquée(s) comme payée(s) automatiquement.",
 "{n} copo(s), {ml} de {meta}": "{n} verre(s), {ml} sur {meta}",
 "{n} de {meta} copos": "{n} verres sur {meta}",
 "{n} de {total}": "{n} sur {total}",
 "{n} de {total} dias": "{n} sur {total} jours",
 "{n} de {total} hoje": "{n} sur {total} aujourd’hui",
 "{n} de {t} item(ns) com preço, dos cupons lidos em Finanças.": "{n} sur {t} article(s) avec un prix, issus des tickets lus dans Finance.",
 "{n} dia(s)": "{n} jour(s)",
 "{n} dia(s) seguido(s) lendo": "{n} jour(s) de lecture d'affilée",
 "{n} dia(s) tirado(s) de tarefas que se repetem": "{n} jour(s) retiré(s) de tâches récurrentes",
 "{n} dias": "{n} jours",
 "{n} dias grátis": "{n} jours gratuits",
 "{n} dias grátis para testar": "{n} jours gratuits pour essayer",
 "{n} dias {tipo}: publicada em {pub}, contagem a partir de {ini}, vence em {fim}.": "{n} jours {tipo} : publiée le {pub}, décompte à partir du {ini}, échéance le {fim}.",
 "{n} documento(s)": "{n} document(s)",
 "{n} em atraso": "{n} en retard",
 "{n} etapa(s) atrasada(s)": "{n} étape(s) en retard",
 "{n} exclusão(ões) esperando o celular sincronizar.": "{n} suppression(s) en attente de synchronisation du téléphone.",
 "{n} falta(s)": "{n} absence(s)",
 "{n} ficha(s) no grupo. Escolha o papel de cada pessoa em Membros.": "{n} fiche(s) dans le groupe. Choisissez le rôle de chaque personne dans Membres.",
 "{n} foto(s) e vídeo(s) da viagem, de todos do grupo. Fotos do roteiro, dos lugares e das reservas também aparecem aqui.": "{n} photo(s) et vidéo(s) du voyage, de tout le groupe. Les photos de l'itinéraire, des lieux et des réservations apparaissent aussi ici.",
 "{n} item(ns) adicionado(s).": "{n} élément(s) ajouté(s).",
 "{n} item(ns) com outras pessoas": "{n} élément(s) chez d'autres personnes",
 "{n} item(ns) no Planner.": "{n} élément(s) dans le Planner.",
 "{n} lançamento(s) encontrado(s)": "{n} écriture(s) trouvée(s)",
 "{n} lançamento(s) novo(s).": "{n} nouvelle(s) écriture(s).",
 "{n} lembrete(s) colocado(s) no My Planner.": "{n} rappel(s) ajouté(s) à My Planner.",
 "{n} livro(s) lido(s) este ano": "{n} livre(s) lu(s) cette année",
 "{n} marcado(s)": "{n} sélectionné(s)",
 "{n} matéria(s)": "{n} matière(s)",
 "{n} membro(s) · abrir a conversa do grupo": "{n} membre(s) · ouvrir la discussion du groupe",
 "{n} meses grátis a partir da criação da conta; depois {preco} por ano.": "{n} mois gratuits à partir de la création du compte ; ensuite {preco} par an.",
 "{n} min": "{n} min",
 "{n} min antes": "{n} min avant",
 "{n} módulo(s)": "{n} module(s)",
 "{n} noite(s)": "{n} nuit(s)",
 "{n} nota(s) nova(s).": "{n} nouvelle(s) facture(s).",
 "{n} nota(s) sem XML neste dispositivo ficaram de fora.": "{n} facture(s) sans XML sur cet appareil ont été exclues.",
 "{n} nota(s) · emitidas {e} · recebidas {r}": "{n} facture(s) · émises {e} · reçues {r}",
 "{n} nova(s)": "{n} nouvelle(s)",
 "{n} novo(s) do cliente": "{n} nouveau(x) du client",
 "{n} novo(s) para aceitar, editar ou recusar.": "{n} nouveau(x) à accepter, modifier ou refuser.",
 "{n} parcela(s) colocada(s) no My Planner.": "{n} échéance(s) ajoutée(s) à My Planner.",
 "{n} parcela(s) em aberto refeitas. As pagas ficaram como estavam.": "{n} échéance(s) restante(s) recalculée(s). Celles payées restent inchangées.",
 "{n} parcela(s) em atraso": "{n} échéance(s) en retard",
 "{n} parcela(s) em atraso: {v}": "{n} échéance(s) en retard : {v}",
 "{n} participantes · toque para ver": "{n} participants · touchez pour voir",
 "{n} passo(s)": "{n} étape(s)",
 "{n} pausa(s)": "{n} pause(s)",
 "{n} pedido(s) de amizade": "{n} demande(s) d'ami",
 "{n} pedido(s) em aberto": "{n} demande(s) en cours",
 "{n} pessoa(s)": "{n} personne(s)",
 "{n} pessoa(s) já entraram com o seu código.": "{n} personne(s) ont rejoint avec votre code.",
 "{n} pessoas": "{n} personnes",
 "{n} por folha": "{n} par feuille",
 "{n} porções": "{n} portions",
 "{n} publicação(ões) nova(s).": "{n} nouvelle(s) publication(s).",
 "{n} publicações novas": "{n} nouvelles publications",
 "{n} página(s)": "{n} page(s)",
 "{n} página(s) · {r} revisada(s)": "{n} page(s) · {r} révisée(s)",
 "{n} páginas": "{n} pages",
 "{n} recebido(s) dos seus grupos": "{n} reçu(s) de vos groupes",
 "{n} recebido(s) para responder": "{n} reçu(s) en attente de réponse",
 "{n} refeição(ões), com o cardápio daquele dia": "{n} repas, avec le menu de ce jour",
 "{n} reserva(s) nova(s) ou alterada(s).": "{n} réservation(s) nouvelle(s) ou modifiée(s).",
 "{n} resultado(s) em todas as publicações": "{n} résultat(s) dans toutes les publications",
 "{n} selecionado(s): {lista}": "{n} sélectionné(s) : {lista}",
 "{n} tarefa(s)": "{n} tâche(s)",
 "{n} tarefa(s) apagada(s) por inteiro": "{n} tâche(s) supprimée(s) entièrement",
 "{n} tarefa(s) criada(s)": "{n} tâche(s) créée(s)",
 "{n} tarefa(s) da casa saíram do My Planner e agora ficam só em Minha Casa. Para levar uma delas ao Planner, abra a tarefa e toque em \"Enviar para o My Planner\".": "{n} tâche(s) ménagère(s) ont quitté My Planner et se trouvent désormais seulement dans Ma Maison. Pour en remettre une dans le Planner, ouvrez la tâche et touchez « Envoyer vers My Planner ».",
 "{n} tarefa(s) de ontem sem concluir": "{n} tâche(s) d'hier non terminée(s)",
 "{n} tarefa(s) dos últimos dias sem concluir": "{n} tâche(s) des derniers jours non terminée(s)",
 "{n} tarefa(s) hoje": "{n} tâche(s) aujourd'hui",
 "{n} tarefa(s) pendente(s) vão para a lista de hoje.": "{n} tâche(s) en attente passeront dans la liste du jour.",
 "{n} tarjas no documento": "{n} bandes noires dans le document",
 "{n} treino(s), cada um nos dias dele": "{n} entraînement(s), chacun ses jours",
 "{n} tribunais": "{n} tribunaux",
 "{n}x de {v}": "{n} x {v}",
 "{n}º alerta": "{n}e alerte",
 "{n}× {item}": "{n}× {item}",
 "{ok} enviado(s), {falhas} com erro. Tente de novo mais tarde.": "{ok} envoyé(s), {falhas} en erreur. Réessayez plus tard.",
 "{ok} enviado(s).": "{ok} envoyé(s).",
 "{o} de {d} noites ocupadas. Reservas que passam de um mês para outro são divididas pelas noites.": "{o} nuits occupées sur {d}. Les réservations à cheval sur deux mois sont réparties par nuit.",
 "{preco} por ano": "{preco} par an",
 "{p} de {t} parcelas pagas ({pct}%)": "{p} échéances payées sur {t} ({pct} %)",
 "{p} presentes · {f} faltas": "{p} présents · {f} absences",
 "{p}% da meta de {m} páginas": "{p} % de l'objectif de {m} pages",
 "{p}% feito": "{p} % fait",
 "{p}% ocupado no mês": "{p} % occupé ce mois-ci",
 "{p}% pronta": "{p} % terminé",
 "{p}/{t} pagas": "{p}/{t} payées",
 "{quem} convidou você para o grupo \"{grupo}\" no My Planner. Toque no link para entrar (o app é gratuito para começar): {link}\nCódigo do convite: {codigo}": "{quem} vous a invité dans le groupe « {grupo} » sur My Planner. Touchez le lien pour rejoindre (l'app est gratuite pour commencer) : {link}\nCode d'invitation : {codigo}",
 "{quem} e outros incluíram {n} itens no grupo.": "{quem} et d'autres ont ajouté {n} éléments au groupe.",
 "{quem} incluiu {item} no grupo.": "{quem} a ajouté {item} au groupe.",
 "{servico} do veículo": "{servico} du véhicule",
 "{s} de {a}": "{s} sur {a}",
 "{tarefa}: volte às {hora}": "{tarefa} : reprenez à {hora}",
 "{tipo}: {p}": "{tipo} : {p}",
 "{titulo} (cópia)": "{titulo} (copie)",
 "{uso} usados de {total} reservados para o site": "{uso} utilisés sur {total} réservés au site",
 "{v} · atualização de {data}": "{v} · mise à jour du {data}",
 "{v}/hora": "{v}/heure",
 "À direita": "À droite",
 "À vista": "Comptant",
 "Às": "À",
 "Às {hora}": "À {hora}",
 "ÁGUA": "EAU",
 "Ácido": "Acide",
 "Água": "Eau",
 "Água hoje": "Eau aujourd'hui",
 "Área externa": "Extérieur",
 "Áreas": "Zones",
 "Áudio": "Audio",
 "É um auxílio e não substitui o acompanhamento das intimações nos canais oficiais. Prazos devem ser conferidos no sistema oficial.": "C'est une aide qui ne remplace pas le suivi des notifications judiciaires sur les canaux officiels. Les délais doivent être vérifiés dans le système officiel.",
 "Ética Profissional": "Déontologie",
 "Ícone e aba": "Icône et onglet",
 "Óculos de sol": "Lunettes de soleil",
 "Órgão emissor (ex.: DETRAN-MS, Polícia Federal)": "Autorité de délivrance (ex. : DETRAN-MS, Police fédérale)",
 "Órgão emissor: {nome}": "Délivré par : {nome}",
 "Ômega 3": "Oméga 3",
 "Última": "Dernière",
 "Última adubação": "Dernier apport d'engrais",
 "Última aplicação": "Dernière administration",
 "Última busca do servidor para você: {quando}": "Dernière recherche du serveur pour vous : {quando}",
 "Última cópia de segurança: {data}": "Dernière sauvegarde : {data}",
 "Última rega": "Dernier arrosage",
 "Última sincronização: {quando}": "Dernière synchronisation : {quando}",
 "Última: {data}": "Dernière : {data}",
 "Último dia para entregar a declaração do IR": "Date limite de la déclaration de l'IR",
 "Último erro: {m}": "Dernière erreur : {m}",
 "Últimos 30 dias": "30 derniers jours",
 "Últimos 7 dias": "7 derniers jours",
 "íris": "iris",
 "última vez em {data}": "dernière fois le {data}",
 "último em {d}": "dernier le {d}",
 "úteis": "ouvrés",
 "★ é a cor do My Planner. A escolha vale para todas as conversas deste dispositivo e da sua conta.": "★ est la couleur de My Planner. Le choix s'applique à toutes les discussions de cet appareil et de votre compte.",
 "🎥 {nome} está ligando (vídeo)": "🎥 {nome} vous appelle (vidéo)",
 "📆 Conectar a agenda deste celular": "📆 Connecter l'agenda de ce téléphone",
 "📞 {nome} está ligando (áudio)": "📞 {nome} vous appelle (audio)",
 "Link bloqueado por segurança.": "Lien bloqué par sécurité.",
 "Este arquivo não é uma imagem válida.": "Ce fichier n'est pas une image valide.",
 "A busca automática do servidor acompanha os 5 primeiros perfis. Os outros entram quando você toca em \"Verificar agora\".": "La recherche automatique du serveur suit les 5 premiers profils. Les autres sont vérifiés quand vous touchez « Vérifier maintenant ».",
 "Esta tela mostra a linha do tempo da viagem, com as atividades e os lugares que têm dia marcado. Para adicionar ou editar as informações completas de um lugar, use a aba Lugares.": "Cet écran affiche la chronologie du voyage, avec les activités et les lieux qui ont un jour défini. Pour ajouter ou modifier les informations complètes d'un lieu, utilisez l'onglet Lieux.",
 "Para a viagem {d}": "Pour le voyage {d}",
 "sem nome": "sans nom",
 "Foi para a viagem {d}.": "Déplacé vers le voyage {d}.",
 "Orçamento total (se não for detalhar)": "Budget total (si vous ne le détaillez pas)",
 "Monte o roteiro dia a dia. Os lugares com dia marcado entram aqui sozinhos. No período da viagem, o roteiro aparece na linha do tempo do My Planner.": "Construisez l'itinéraire jour par jour. Les lieux avec un jour défini apparaissent ici automatiquement. Pendant le voyage, l'itinéraire apparaît dans la chronologie de My Planner.",
 "Marque o dia e o horário no lugar para ele aparecer sozinho no Roteiro.": "Indiquez le jour et l'heure sur le lieu pour qu'il apparaisse automatiquement dans l'Itinéraire.",
 "No roteiro": "Dans l'itinéraire",
 "\"{nome}\" está no roteiro de {data}. Para mudar o dia ou o horário, edite o lugar.": "« {nome} » est dans l'itinéraire du {data}. Pour changer le jour ou l'heure, modifiez le lieu.",
 "Para o roteiro desta viagem": "Pour l'itinéraire de ce voyage",
 "Orçamento e gastos": "Budget et dépenses",
 "Parada (cidade)": "Étape (ville)",
 "Item da categoria": "Élément de la catégorie",
 "Orçamento da viagem inteira": "Budget de tout le voyage",
 "Orçamento geral da viagem": "Budget global du voyage",
 "Previsto {p} · gasto {g}": "Prévu {p} · dépensé {g}",
 "Aqui ficam os custos da viagem que não são de uma parada (ex.: passagens, seguro). Cada parada tem o seu orçamento.": "Ici figurent les coûts du voyage qui ne relèvent pas d'une étape (ex. : billets, assurance). Chaque étape a son propre budget.",
 "Coloque quanto pretende gastar em cada categoria. Ao lançar os gastos, o app mostra quanto já foi usado.": "Indiquez combien vous comptez dépenser dans chaque catégorie. En saisissant les dépenses, l'app montre ce qui a déjà été utilisé.",
 "Orçamento por parada": "Budget par étape",
 "Vai passar por mais de uma cidade? Cadastre as paradas (aba Paradas): cada uma ganha o seu orçamento e os gastos daquelas datas entram nela sozinhos.": "Vous passez par plusieurs villes ? Ajoutez les étapes (onglet Étapes) : chacune a son propre budget et les dépenses de ces dates y sont ajoutées automatiquement.",
 "Coloque o valor do gasto.": "Indiquez le montant de la dépense.",
 "Orçamento de {c}": "Budget {c}",
 "Lançar um gasto nesta parada": "Saisir une dépense pour cette étape",
 "Lançar gasto": "Saisir une dépense",
 "Orçamento e gastos da parada": "Budget et dépenses de l'étape",
 "Gastos lançados ({n})": "Dépenses saisies ({n})",
 "Para corrigir ou apagar um gasto, use a aba Orçamento e gastos da viagem.": "Pour corriger ou supprimer une dépense, utilisez l'onglet Budget et dépenses du voyage.",
 "Paradas": "Étapes",
 "Cidade ou lugar": "Ville ou lieu",
 "Ex.: Porto": "Ex. : Porto",
 "Chegada": "Arrivée",
 "Saída": "Départ",
 "Onde vai ficar": "Où vous logerez",
 "gasto {g} de {p}": "dépensé {g} sur {p}",
 "Vai passar por mais de uma cidade? Cadastre cada parada com as datas. Cada uma ganha o seu orçamento (hospedagem, refeições, transporte...) e os gastos daquelas datas entram nela sozinhos.": "Vous passez par plusieurs villes ? Ajoutez chaque étape avec ses dates. Chacune a son propre budget (hébergement, repas, transport...) et les dépenses de ces dates y sont ajoutées automatiquement.",
 "Café da tarde": "Goûter",
 "Outros / Lanches": "Autres / Collations",
 "Gasto {v}": "Dépensé {v}",
 "Gasto {g} de {p} · {a} acima": "Dépensé {g} sur {p} · {a} de dépassement",
 "Gasto {g} de {p}": "Dépensé {g} sur {p}",
 "Tirar \"{nome}\" do orçamento?": "Retirer « {nome} » du budget ?",
 "Os gastos já lançados nela continuam na lista de gastos.": "Les dépenses déjà saisies restent dans la liste des dépenses.",
 "Previsto para {nome}": "Prévu pour {nome}",
 "Tirar {nome}": "Retirer {nome}",
 "Nome do item (ex.: Jantar especial)": "Nom de l'élément (ex. : Dîner spécial)",
 "Adicionar item": "Ajouter un élément",
 "Detalhar em itens": "Détailler en éléments",
 "Nova categoria (ex.: Seguro, Presentes)": "Nouvelle catégorie (ex. : Assurance, Cadeaux)",
 "Voltar às categorias sugeridas?": "Revenir aux catégories suggérées ?",
 "Os valores previstos desta lista serão apagados. Os gastos lançados continuam.": "Les montants prévus de cette liste seront effacés. Les dépenses saisies sont conservées.",
 "Voltar às categorias sugeridas": "Revenir aux catégories suggérées",
 "Previsto": "Prévu",
 "Ainda pode gastar": "Reste à dépenser",
 "Passou do previsto": "Prévu dépassé",
 "Não foi possível buscar o câmbio": "Impossible d'obtenir le taux de change",
 "Sem internet ou a moeda {m} não está na tabela. Edite a viagem e coloque o câmbio à mão.": "Pas d'internet ou la devise {m} n'est pas dans la table. Modifiez le voyage et saisissez le taux à la main.",
 "Câmbio de {m} ainda não definido": "Taux de change {m} pas encore défini",
 "Câmbio de hoje": "Taux du jour",
 "Atualizado em {d}": "Mis à jour le {d}",
 "Valor em {m}": "Montant en {m}",
 "Moeda do destino": "Devise de la destination",
 "Câmbio: quanto vale 1 da moeda do destino na sua moeda": "Taux de change : combien vaut 1 unité de la devise de destination dans la vôtre",
 "Sem dia marcado": "Sans jour défini",
 "Valor na moeda do destino": "Montant en devise de destination",
 "Tirar só desta lista ou excluir de vez?": "Retirer seulement de cette liste ou supprimer définitivement ?",
 "Excluir de vez": "Supprimer définitivement",
 "Relatório da viagem (PDF)": "Rapport du voyage (PDF)",
 "Planilha da viagem (Excel)": "Tableur du voyage (Excel)",
 "Geral da viagem": "Voyage entier",
 "Viagem {d}": "Voyage {d}",
 "Quem vai: {p}": "Qui part : {p}",
 "Outros gastos": "Autres dépenses",
 "Orçamento · {n}": "Budget · {n}",
 "Código": "Code",
 "Pagou": "Payé par",
 "Permissão internacional para dirigir": "Permis de conduire international",
 "Vacina (certificado)": "Vaccin (certificat)",
 "Autorização de viagem de menor": "Autorisation de sortie du territoire pour mineur",
 "Vence antes da volta": "Expire avant le retour",
 "Vence menos de 6 meses depois da volta (muitos países não aceitam)": "Expire moins de 6 mois après le retour (de nombreux pays ne l'acceptent pas)",
 "A lista básica já está aqui.": "La liste de base est déjà là.",
 "{n} documento(s) com validade que pode atrapalhar a viagem": "{n} document(s) dont la validité peut gêner le voyage",
 "Lista básica: passaporte de cada um e seguro viagem": "Liste de base : passeport de chacun et assurance voyage",
 "Lista básica: identidade de cada um": "Liste de base : pièce d'identité de chacun",
 "Ponha a validade de cada documento: o app avisa antes de vencer e confere se o passaporte vale por 6 meses depois da volta. As fotos dos documentos ficam protegidas no cofre.": "Indiquez la validité de chaque document : l'app vous prévient avant l'expiration et vérifie que le passeport est valable 6 mois après le retour. Les photos des documents restent protégées dans le coffre.",
 "De quem": "À qui",
 "Número (protegido no cofre)": "Numéro (protégé dans le coffre)",
 "Está em mãos": "En main",
 "Válido até {d}": "Valable jusqu'au {d}",
 "Passaporte, visto, seguro viagem, vacina, autorização de menor... com a validade e a foto. Marque quando estiver em mãos.": "Passeport, visa, assurance voyage, vaccin, autorisation pour mineur... avec la validité et la photo. Cochez quand vous l'avez en main.",
 "acerto entre os viajantes (não entra no orçamento)": "remboursement entre voyageurs (hors budget)",
 "Só gastos": "Dépenses seulement",
 "Acertos": "Remboursements",
 "Marcar como pago?": "Marquer comme payé ?",
 "{de} já pagou {v} para {para}?": "{de} a déjà payé {v} à {para} ?",
 "Já pagou": "Déjà payé",
 "Acerto: {de} pagou {para}": "Remboursement : {de} a payé {para}",
 "Conferir minhas assinaturas": "Vérifier mes abonnements",
 "Gerenciar ou cancelar assinaturas na loja": "Gérer ou annuler les abonnements dans le store",
 "Restaurar compras": "Restaurer les achats",
 "Procurando...": "Recherche...",
 "{n} assinatura(s) encontrada(s) e liberada(s).": "{n} abonnement(s) trouvé(s) et débloqué(s).",
 "Assinatura anual, renova sozinha. Cancele quando quiser nas assinaturas da loja, até 24 horas antes da renovação.": "Abonnement annuel, renouvelé automatiquement. Annulez quand vous voulez dans les abonnements du store, jusqu'à 24 heures avant le renouvellement.",
 "Assinaturas da loja": "Abonnements du store",
 "Gerenciar assinaturas (App Store)": "Gérer les abonnements (App Store)",
 "Gerenciar assinaturas (Google Play)": "Gérer les abonnements (Google Play)",
 "A assinatura é feita no app do celular (Google Play ou App Store) e vale também aqui no site.": "L'abonnement se fait dans l'app mobile (Google Play ou App Store) et fonctionne aussi ici sur le site.",
 "Esta assinatura ainda não está disponível na loja. Tente de novo mais tarde.": "Cet abonnement n'est pas encore disponible dans le store. Réessayez plus tard.",
 "Assinatura feita": "Abonnement effectué",
 "Já assinei no celular: conferir": "Je me suis déjà abonné sur mon téléphone : vérifier",
 "Nenhuma assinatura encontrada nesta conta da loja.": "Aucun abonnement trouvé sur ce compte du store.",
 "Confira a internet e tente de novo. Nada foi cobrado.": "Vérifiez votre connexion et réessayez. Rien n'a été facturé.",
 "{aba} liberada. Vale também nos seus outros dispositivos e no site.": "{aba} débloqué. Fonctionne aussi sur vos autres appareils et sur le site.",
 "Para assinar, atualize o My Planner pela Google Play ou pela App Store.": "Pour vous abonner, mettez à jour My Planner via Google Play ou l'App Store.",
 "Assinada, renova em {data}": "Abonné, renouvellement le {data}",
 "Não deu para assinar agora": "Impossible de s'abonner pour le moment",
 "Assinar por {preco} por ano": "S'abonner pour {preco} par an",
 "\"{nome}\" foi para o Mural, em Conquistas.": "\"{nome}\" est allé sur le Mur, dans Réussites.",
 "\"{nome}\" já faz parte da sua rotina. Foi para o Mural, em Conquistas.": "\"{nome}\" fait déjà partie de votre routine. Il est allé sur le Mur, dans Réussites.",
 "\"{nome}\" voltou para o lugar.": "\"{nome}\" est revenu à sa place.",
 "1 ano": "1 an",
 "1 mês": "1 mois",
 "A IA não achou o valor no comprovante.": "L'IA n'a pas trouvé le montant sur le justificatif.",
 "A cada {n} dias": "Tous les {n} jours",
 "A carta está vazia": "La lettre est vide",
 "A carta fica trancada até {d}. Até lá não dá para reler nem editar. Para mudar algo, escreva outra carta.": "La lettre reste verrouillée jusqu'au {d}. D'ici là, impossible de la relire ou de la modifier. Pour changer quelque chose, écrivez une autre lettre.",
 "A lixeira está vazia.": "La corbeille est vide.",
 "A mesma do app e do celular": "Le même que l'app et le téléphone",
 "A mesma forma de desbloqueio do app e do celular": "Le même mode de déverrouillage que l'app et le téléphone",
 "A senha do diário precisa ter 6 caracteres ou mais.": "Le mot de passe du journal doit comporter au moins 6 caractères.",
 "A senha precisa ter 6 caracteres ou mais.": "Le mot de passe doit comporter au moins 6 caractères.",
 "A turma ainda não tem grupo": "La classe n'a pas encore de groupe",
 "AS 4 BOLINHAS DE COR": "LES 4 PASTILLES DE COULEUR",
 "Aberta em {d}": "Ouverte le {d}",
 "Abra a aba para poder restaurar": "Ouvrez l'onglet pour pouvoir restaurer",
 "Abra o diário primeiro": "Ouvrez d'abord le journal",
 "Abre com a biometria, o reconhecimento facial ou a senha do app. A senha do diário só é pedida na primeira vez em cada aparelho.": "S'ouvre avec la biométrie, la reconnaissance faciale ou le mot de passe de l'app. Le mot de passe du journal n'est demandé que la première fois sur chaque appareil.",
 "Abre em {d}": "S'ouvre le {d}",
 "Abrir carta para o futuro": "Ouvrir une lettre pour le futur",
 "Abrir em {aba}": "Ouvrir dans {aba}",
 "Abrir o Diário": "Ouvrir le Journal",
 "Abrir o diário": "Ouvrir le journal",
 "Abrir {aba}": "Ouvrir {aba}",
 "Acompanha o imóvel, as reservas, a ocupação, as despesas e o lucro, sem alterar nada.": "Suit le logement, les réservations, l'occupation, les dépenses et le bénéfice, sans rien modifier.",
 "Adicionar foto": "Ajouter une photo",
 "Apaga tudo o que está no quadro desta página.": "Efface tout ce qui se trouve sur le tableau de cette page.",
 "Apagar o desenho?": "Effacer le dessin ?",
 "Apagar o diário": "Supprimer le journal",
 "Apagar para todos?": "Supprimer pour tout le monde ?",
 "Aplicar a todas as páginas desta matéria": "Appliquer à toutes les pages de cette matière",
 "Aplicar a todas as páginas desta pasta": "Appliquer à toutes les pages de ce dossier",
 "Apostilas, listas, slides, vídeos, links e recados. Pelo ⋮ › Enviar para a turma, cada aluno recebe no app dele.": "Polycopiés, listes, diapos, vidéos, liens et messages. Via ⋮ › Envoyer à la classe, chaque élève le reçoit dans son app.",
 "Aquarela": "Aquarelle",
 "Aqui aparece, sem custo, o que os grupos compartilharam com você. Para usar a aba com os seus próprios dados, assine a aba.": "Ici apparaît, gratuitement, ce que les groupes ont partagé avec vous. Pour utiliser l'onglet avec vos propres données, abonnez-vous à l'onglet.",
 "Arquivados": "Archivés",
 "Arraste para a direita para excluir, ou para a esquerda para arquivar.": "Glissez à droite pour supprimer, ou à gauche pour archiver.",
 "As cobranças desta aula extra já existem.": "Les paiements dus de ce cours supplémentaire existent déjà.",
 "As notas vão só para cada aluno. Para isso, o nome da pessoa no grupo precisa ser igual ao nome do aluno ou do responsável no cadastro.": "Les notes sont envoyées à chaque élève uniquement. Pour cela, le nom de la personne dans le groupe doit être identique au nom de l'élève ou du responsable dans la fiche.",
 "Atestado": "Certificat médical",
 "Atestados": "Certificats médicaux",
 "Até quando (opcional)": "Jusqu'à quand (facultatif)",
 "Até {d}": "Jusqu'au {d}",
 "Aula extra": "Cours supplémentaire",
 "Aula extra (fora dos dias de aula)": "Cours supplémentaire (hors jours de cours)",
 "Aula extra de {d}": "Cours supplémentaire du {d}",
 "Avaliação de {d}": "Évaluation du {d}",
 "Avaliação salva": "Évaluation enregistrée",
 "Avançar": "Suivant",
 "Aviso da revisão do mês": "Rappel du bilan du mois",
 "Aviso no último dia do mês: \"Que tal revisar o seu mês? ✨\"": "Rappel le dernier jour du mois : \"Et si vous faisiez le bilan de votre mois ? ✨\"",
 "Aviso sem nenhum conteúdo do diário: \"Como foi o seu dia? ✍️\"": "Rappel sans aucun contenu du journal : \"Comment s'est passée votre journée ? ✍️\"",
 "Avulsa": "À l'unité",
 "Avulsas": "À l'unité",
 "Azul": "Bleu",
 "Baixar na App Store": "Télécharger dans l'App Store",
 "Baixar na Google Play": "Disponible sur Google Play",
 "Baixe o My Planner na loja: Android {android} · iPhone {iphone}": "Téléchargez My Planner sur le store : Android {android} · iPhone {iphone}",
 "Biometria, reconhecimento facial ou a senha do app. A senha do diário fica guardada para a primeira vez em cada aparelho.": "Biométrie, reconnaissance faciale ou mot de passe de l'app. Le mot de passe du journal est conservé pour la première fois sur chaque appareil.",
 "Branco": "Blanc",
 "Buscando o clima…": "Recherche de la météo…",
 "Básicas": "Basiques",
 "COMO ESTOU": "COMMENT JE VAIS",
 "COMO O DIÁRIO ABRE": "COMMENT LE JOURNAL S'OUVRE",
 "COR DA FOLHA": "COULEUR DE LA FEUILLE",
 "Caixinha no My Planner": "Cagnotte dans My Planner",
 "Caixinha {m}": "Cagnotte {m}",
 "Carta de {d}": "Lettre du {d}",
 "Carta guardada": "Lettre enregistrée",
 "Carta para o futuro": "Lettre pour le futur",
 "Carta trancada": "Lettre verrouillée",
 "Cartas abertas podem ser lidas, mas não editadas.": "Les lettres ouvertes peuvent être lues, mais pas modifiées.",
 "Cartas para o Futuro": "Lettres pour le Futur",
 "Cartões arquivados": "Cartes archivées",
 "Chegou uma carta da {nome} de {tempo} atrás 💌": "Une lettre de {nome} d'il y a {tempo} est arrivée 💌",
 "Chegou! Toque para abrir 💌": "Elle est arrivée ! Touchez pour ouvrir 💌",
 "Cinza-escuro": "Gris foncé",
 "Clara (segue o tema)": "Clair (suit le thème)",
 "Claras e pastel (boas para folha escura)": "Claires et pastel (idéales pour une feuille sombre)",
 "Clima (toque para preencher)": "Météo (touchez pour remplir)",
 "Clima automático": "Météo automatique",
 "Clima do dia": "Météo du jour",
 "Cobrar a aula extra": "Facturer le cours supplémentaire",
 "Cobrar a aula extra dos presentes": "Facturer le cours supplémentaire aux présents",
 "Cobrar a turma toda": "Facturer toute la classe",
 "Cole um link que comece com https://": "Collez un lien commençant par https://",
 "Coloque o valor da aula extra na turma (Editar).": "Indiquez le prix du cours supplémentaire dans la classe (Modifier).",
 "Coloque o valor.": "Indiquez le montant.",
 "Colunas": "Colonnes",
 "Com a sua IA ligada (Ajustes › Inteligência artificial), o app lê o valor, a data e a descrição pela foto.": "Avec votre IA activée (Réglages › Intelligence artificielle), l'app lit le montant, la date et la description sur la photo.",
 "Como cuidei de mim hoje?": "Comment ai-je pris soin de moi aujourd'hui ?",
 "Como foi o seu dia? ✍️": "Comment s'est passée votre journée ? ✍️",
 "Compartilhar este projeto (convidar)": "Partager ce projet (inviter)",
 "Compartilhar o texto": "Partager le texte",
 "Completa": "Complète",
 "Comprovante (foto, PDF ou print)": "Justificatif (photo, PDF ou capture)",
 "Comprovante anexado": "Justificatif joint",
 "Comprovante de pagamento (foto ou PDF)": "Justificatif de paiement (photo ou PDF)",
 "Concluído: hábito formado": "Terminé : habitude acquise",
 "Concluídos": "Terminés",
 "Configurar o Diário": "Configurer le Journal",
 "Confirmar pagamento": "Confirmer le paiement",
 "Confirmar recebimento": "Confirmer la réception",
 "Conquistas": "Réussites",
 "Contas arquivadas": "Factures archivées",
 "Continuar escrevendo": "Continuer à écrire",
 "Copiado ✓": "Copié ✓",
 "Copiar código": "Copier le code",
 "Copiar link": "Copier le lien",
 "Cor atual": "Couleur actuelle",
 "Cor {n}": "Couleur {n}",
 "Creme": "Crème",
 "Criada em {d}": "Créée le {d}",
 "Criar as cobranças": "Créer les paiements dus",
 "Criar o grupo da turma": "Créer le groupe de la classe",
 "Criar o meu diário": "Créer mon journal",
 "Crie a senha do diário (6 ou mais)": "Créez le mot de passe du journal (6 caractères ou plus)",
 "Crie o grupo da turma e mande o convite aos alunos. Depois, o envio vai direto para eles.": "Créez le groupe de la classe et envoyez l'invitation aux élèves. Ensuite, les envois leur arriveront directement.",
 "Crie sua primeira meta, objetivo ou sonho com o botão + abaixo.": "Créez votre premier objectif, but ou rêve avec le bouton + ci-dessous.",
 "Crie um projeto, convide quem participa e divida os passos. Cada pessoa marca o que fez.": "Créez un projet, invitez les participants et répartissez les étapes. Chacun coche ce qu'il a fait.",
 "Crie uma senha nova para começar.": "Créez un nouveau mot de passe pour commencer.",
 "Cuidados arquivados": "Soins archivés",
 "Cuidados pessoais do dia feitos (Bem-Estar)": "Soins personnels du jour faits (Bien-être)",
 "Curto prazo": "Court terme",
 "Custos": "Coûts",
 "Céu estrelado": "Ciel étoilé",
 "Círculo": "Cercle",
 "Cômodos arquivados": "Pièces archivées",
 "DIAS CUMPRIDOS": "JOURS RÉUSSIS",
 "Data (opcional)": "Date (facultatif)",
 "De {d}": "Du {d}",
 "Desafixar do topo": "Détacher du haut",
 "Desenho mais fraco ou mais forte": "Dessin plus clair ou plus foncé",
 "Desfazer \"Concluído\" ({d})": "Annuler « Terminé » ({d})",
 "Desligado": "Désactivé",
 "Desmarcar": "Décocher",
 "Desmarcar como paga?": "Marquer comme non payée ?",
 "Desmarcar como recebida?": "Marquer comme non reçue ?",
 "Desmarque o que você não usa: some da tela e deixa a aba mais simples. Dá para mudar depois em Ajustes › Abas › {aba} › Partes desta aba.": "Décochez ce que vous n'utilisez pas : cela disparaît de l'écran et simplifie l'onglet. Vous pourrez changer plus tard dans Réglages › Onglets › {aba} › Parties de cet onglet.",
 "Dias da semana": "Jours de la semaine",
 "Dias de aula": "Jours de cours",
 "Dias de aula: {d}": "Jours de cours : {d}",
 "Dias escritos": "Jours écrits",
 "Dica: desenhe a forma à mão e segure o dedo no fim do traço para ela ficar perfeita.": "Astuce : dessinez la forme à main levée et maintenez le doigt à la fin du trait pour qu'elle devienne parfaite.",
 "Ditado": "Dictée",
 "Ditar (falar para escrever)": "Dicter (parler pour écrire)",
 "Diário apagado": "Journal supprimé",
 "Diário protegido": "Journal protégé",
 "Dom": "Dim",
 "Dê um nome a ele na pasta Hábitos.": "Donnez-lui un nom dans le dossier Habitudes.",
 "EVOLUÇÃO": "ÉVOLUTION",
 "Editada em {d}": "Modifiée le {d}",
 "Ela abre em {d} ({n} dias). Até lá não dá para reler nem editar.": "Elle s'ouvre le {d} (dans {n} jours). D'ici là, impossible de la relire ou de la modifier.",
 "Ela abre em {d}. Você vai receber um aviso nesse dia.": "Elle s'ouvre le {d}. Vous recevrez une notification ce jour-là.",
 "Ela fica guardada com a data de hoje para comparar depois.": "Elle est conservée avec la date d'aujourd'hui pour comparer plus tard.",
 "Enorme": "Énorme",
 "Enviado ao paciente": "Envoyé au patient",
 "Enviado em": "Envoyé le",
 "Enviar \"{t}\" para todos do grupo {g}?": "Envoyer \"{t}\" à tous les membres du groupe {g} ?",
 "Enviar a nota para cada aluno": "Envoyer la note à chaque élève",
 "Enviar as notas": "Envoyer les notes",
 "Enviar o arquivo: {nome}": "Envoyer le fichier : {nome}",
 "Enviar o recado para a turma": "Envoyer le message à la classe",
 "Enviar o título para outra aba": "Envoyer le titre vers un autre onglet",
 "Enviar para a turma": "Envoyer à la classe",
 "Enviar para outra aba": "Envoyer vers un autre onglet",
 "Escolha a cor desta bolinha": "Choisissez la couleur de cette pastille",
 "Escolha uma data no futuro": "Choisissez une date dans le futur",
 "Escolher qualquer cor": "Choisir n'importe quelle couleur",
 "Esconder a barra": "Masquer la barre",
 "Escreva a frase": "Écrivez la phrase",
 "Escreva a que se refere a cobrança.": "Indiquez à quoi correspond le paiement dû.",
 "Escreva alguma coisa antes de guardar.": "Écrivez quelque chose avant d'enregistrer.",
 "Escreva alguma coisa antes de salvar.": "Écrivez quelque chose avant d'enregistrer.",
 "Escreva hoje, abra no futuro": "Écrivez aujourd'hui, ouvrez dans le futur",
 "Escreva o que você quer mudar a partir de hoje": "Écrivez ce que vous voulez changer à partir d'aujourd'hui",
 "Escreva para você do futuro. A carta fica trancada até o dia de abrir.": "Écrivez à votre futur vous. La lettre reste verrouillée jusqu'au jour de son ouverture.",
 "Escrever uma carta": "Écrire une lettre",
 "Escrita em {e} · abre em {a}": "Écrite le {e} · s'ouvre le {a}",
 "Escuras (boas para folha clara)": "Foncées (idéales pour une feuille claire)",
 "Esperado": "Prévu",
 "Esperado: {e} · Feito: {f} · Faltou: {fa}": "Prévu : {e} · Fait : {f} · Manqué : {fa}",
 "Esqueceu a senha do diário?": "Mot de passe du journal oublié ?",
 "Esqueci a senha do diário": "J'ai oublié le mot de passe du journal",
 "Esta semana": "Cette semaine",
 "Este lançamento vem de outra parte do app e não se apaga aqui.": "Cette opération vient d'une autre partie de l'app et ne peut pas être supprimée ici.",
 "Estudo: {h}": "Étude : {h}",
 "Esvaziar": "Vider",
 "Esvaziar a lixeira": "Vider la corbeille",
 "Esvaziar a lixeira?": "Vider la corbeille ?",
 "Ex.: Comer uma fruta por dia": "Ex. : Manger un fruit par jour",
 "Ex.: Exercícios para casa, Atestado de 2 dias": "Ex. : Exercices à la maison, Certificat médical de 2 jours",
 "Ex.: Reservar a pousada": "Ex. : Réserver la pension",
 "Ex.: Viagem em família, juntar para a festa": "Ex. : Voyage en famille, épargner pour la fête",
 "Excluir de vez?": "Supprimer définitivement ?",
 "Excluir esta avaliação?": "Supprimer cette évaluation ?",
 "Excluir este bloco?": "Supprimer ce bloc ?",
 "Excluir este desenho?": "Supprimer ce dessin ?",
 "Excluir este item?": "Supprimer cet élément ?",
 "Excluir {n} item(ns)?": "Supprimer {n} élément(s) ?",
 "Exportar como imagem": "Exporter en image",
 "Exportar em PDF": "Exporter en PDF",
 "FOTOS": "PHOTOS",
 "FRASE DO DIA": "PHRASE DU JOUR",
 "FREQUÊNCIA": "FRÉQUENCE",
 "Falta o valor": "Montant manquant",
 "Feriado": "Jour férié",
 "Feriado: {f}": "Jour férié : {f}",
 "Fica 30 dias na lixeira.": "Reste 30 jours dans la corbeille.",
 "Ficam 30 dias na lixeira.": "Restent 30 jours dans la corbeille.",
 "Fichários arquivados": "Classeurs archivés",
 "Fixar no topo": "Épingler en haut",
 "Floral": "Floral",
 "Folha": "Feuille",
 "Folha, tema e cores das páginas com escrita": "Feuille, thème et couleurs des pages d'écriture",
 "Folhas e plantas": "Feuilles et plantes",
 "Foto adicionada": "Photo ajoutée",
 "Foto do sonho": "Photo du rêve",
 "Fotos do dia": "Photos du jour",
 "Frase": "Phrase",
 "Frase do dia (aparece no topo do Meu Dia)": "Phrase du jour (apparaît en haut de Ma journée)",
 "Frases, textos, vídeos e fotos que motivam": "Phrases, textes, vidéos et photos qui motivent",
 "Geométrico": "Géométrique",
 "Gerar": "Générer",
 "Gravar lembretes e anotações por voz e ditar textos (🎤) quando você pedir. O microfone só liga com o seu toque, e o áudio do ditado não é guardado.": "Enregistrer des rappels et des notes à la voix et dicter des textes (🎤) quand vous le demandez. Le micro ne s'active que si vous le touchez, et l'audio de la dictée n'est pas conservé.",
 "Guardar e trancar": "Enregistrer et verrouiller",
 "Guardar e trancar?": "Enregistrer et verrouiller ?",
 "Guarde aqui o que te motiva: frases, textos seus, vídeos e fotos.": "Gardez ici ce qui vous motive : phrases, vos propres textes, vidéos et photos.",
 "Guarde bem esta senha: sem ela o diário não pode ser recuperado.": "Conservez bien ce mot de passe : sans lui, le journal ne peut pas être récupéré.",
 "Hoje é feriado: {f}. Registrar mesmo assim?": "Aujourd'hui est férié : {f}. Enregistrer quand même ?",
 "Humor do mês": "Humeur du mois",
 "Humor do período": "Humeur de la période",
 "HÁBITOS LIGADOS": "HABITUDES LIÉES",
 "Há itens grandes na seleção. Eles só podem ser excluídos um por um, com confirmação e senha.": "La sélection contient de gros éléments. Ils ne peuvent être supprimés qu'un par un, avec confirmation et mot de passe.",
 "Há um ano": "Il y a un an",
 "Há um mês": "Il y a un mois",
 "Hábito": "Habitude",
 "Hábito criado": "Habitude créée",
 "Hábitos": "Habitudes",
 "Hábitos cumpridos": "Habitudes réussies",
 "Hábitos cumpridos: {f} de {n}": "Habitudes réussies : {f} sur {n}",
 "Hábitos formados": "Habitudes acquises",
 "INSPIRAÇÃO": "INSPIRATION",
 "Imagem adicionada": "Image ajoutée",
 "Imagem não encontrada": "Image introuvable",
 "Incrível": "Incroyable",
 "Informação nutricional": "Informations nutritionnelles",
 "Inserir": "Insérer",
 "Inspiração": "Inspiration",
 "Item para o paciente": "Élément pour le patient",
 "Itens grandes só se excluem um por um.": "Les gros éléments ne se suppriment qu'un par un.",
 "Junte fotos do que você quer viver. Segure e arraste para organizar.": "Rassemblez des photos de ce que vous voulez vivre. Maintenez et faites glisser pour organiser.",
 "LIGAR A UM SONHO DO PROJETO DE VIDA (OPCIONAL)": "LIER À UN RÊVE DU PROJET DE VIE (FACULTATIF)",
 "LIGAR A UMA META (OPCIONAL)": "LIER À UN OBJECTIF (FACULTATIF)",
 "LINKS DE VÍDEO": "LIENS VIDÉO",
 "Lance as notas antes de enviar.": "Saisissez les notes avant d'envoyer.",
 "Lançamentos arquivados": "Opérations archivées",
 "Legenda (opcional)": "Légende (facultatif)",
 "Lembrete diário": "Rappel quotidien",
 "Lendo o comprovante...": "Lecture du justificatif...",
 "Ler o comprovante com a minha IA": "Lire le justificatif avec mon IA",
 "Ligado": "Activé",
 "Ligar um texto de motivação (Inspiração)": "Lier un texte de motivation (Inspiration)",
 "Lilás": "Lilas",
 "Limpar a folha inteira?": "Effacer toute la feuille ?",
 "Linha reta": "Ligne droite",
 "Linhas": "Lignes",
 "Link do vídeo (YouTube, Instagram...)": "Lien de la vidéo (YouTube, Instagram...)",
 "Lisa": "Unie",
 "Liste os passos do projeto e diga quem faz cada um.": "Listez les étapes du projet et indiquez qui fait chacune.",
 "Lixeira": "Corbeille",
 "Longo prazo": "Long terme",
 "MARCAR SOZINHO PELO BEM-ESTAR (OPCIONAL)": "COCHER AUTOMATIQUEMENT VIA BIEN-ÊTRE (FACULTATIF)",
 "META OU SONHO LIGADO (OPCIONAL)": "OBJECTIF OU RÊVE LIÉ (FACULTATIF)",
 "Mais opções": "Plus d'options",
 "Mal": "Mal",
 "Mandar ao paciente pelo WhatsApp": "Envoyer au patient par WhatsApp",
 "Marque o que fez em cada dia": "Cochez ce que vous avez fait chaque jour",
 "Marque os dias de aula na turma (Editar) para a chamada mostrar só esses dias.": "Cochez les jours de cours dans la classe (Modifier) pour que l'appel n'affiche que ces jours.",
 "Matérias arquivadas": "Matières archivées",
 "Mensalidade": "Mensualité",
 "Meta de água do Bem-Estar": "Objectif d'eau de Bien-être",
 "Metas arquivadas": "Objectifs archivés",
 "Metas e sonhos concluídos": "Objectifs et rêves accomplis",
 "Metas em andamento": "Objectifs en cours",
 "Metas que avançaram": "Objectifs qui ont avancé",
 "Metas, objetivos e sonhos, com passos e prazos": "Objectifs, buts et rêves, avec étapes et échéances",
 "Meu Dia": "Ma journée",
 "Meu Dia com página livre, projeto de vida, hábitos, quadro dos sonhos, roda da vida, cartas para o futuro e conquistas. Protegido com senha.": "Ma journée avec page libre, projet de vie, habitudes, tableau des rêves, roue de la vie, lettres pour le futur et réussites. Protégé par mot de passe.",
 "Minimalista": "Minimaliste",
 "Mostrar as contas antes do vencimento": "Afficher les factures avant l'échéance",
 "Mostrar datas, horários, moeda e feriados certos para onde você está. A localização aproximada do celular só é usada quando você pede o clima do dia no Diário, e não fica guardada.": "Afficher les dates, heures, devise et jours fériés adaptés à l'endroit où vous êtes. La position approximative du téléphone n'est utilisée que lorsque vous demandez la météo du jour dans le Journal, et n'est pas conservée.",
 "Muito bem": "Très bien",
 "Muito mal": "Très mal",
 "Mural de fotos dos seus sonhos": "Mur de photos de vos rêves",
 "Mural, relatório e revisão do mês": "Mur, rapport et bilan du mois",
 "Médio prazo": "Moyen terme",
 "N dias cumpridos no mês": "N jours réussis dans le mois",
 "N dias seguidos": "N jours d'affilée",
 "NESTE DIA": "CE JOUR-LÀ",
 "Nada a enviar": "Rien à envoyer",
 "Nenhum estudo registrado nesta semana.": "Aucune étude enregistrée cette semaine.",
 "Nenhum hábito ainda. Ex.: \"Comer uma fruta por dia\", \"Beber 2 L de água\", \"Não pular o café da manhã\".": "Aucune habitude pour l'instant. Ex. : \"Manger un fruit par jour\", \"Boire 2 L d'eau\", \"Ne pas sauter le petit-déjeuner\".",
 "Nenhum no período.": "Aucun sur la période.",
 "Nenhuma": "Aucune",
 "Nenhuma carta ainda.": "Aucune lettre pour l'instant.",
 "Nenhuma foto ainda.": "Aucune photo pour l'instant.",
 "Neutras e opacas": "Neutres et mates",
 "Ninguém encontrado no grupo": "Personne n'a été trouvé dans le groupe",
 "No computador: {link}": "Sur l'ordinateur : {link}",
 "No navegador, a senha do diário é pedida sempre.": "Dans le navigateur, le mot de passe du journal est toujours demandé.",
 "No último dia do mês: \"Que tal revisar o seu mês? ✨\"": "Le dernier jour du mois : \"Et si vous faisiez le bilan de votre mois ? ✨\"",
 "Nome da página (opcional)": "Nom de la page (facultatif)",
 "Nome de quem faz este passo": "Nom de la personne qui fait cette étape",
 "Nome do vídeo (opcional)": "Nom de la vidéo (facultatif)",
 "Normal": "Normal",
 "Nota de 0 a 10 para cada área da vida": "Note de 0 à 10 pour chaque domaine de la vie",
 "Nota: {a}": "Note : {a}",
 "Nova caixa": "Nouvelle boîte",
 "Nova carta": "Nouvelle lettre",
 "Nova meta, objetivo ou sonho": "Nouvel objectif, but ou rêve",
 "Nova senha (6 caracteres ou mais)": "Nouveau mot de passe (6 caractères ou plus)",
 "Nova área (ex.: Espiritualidade)": "Nouveau domaine (ex. : Spiritualité)",
 "Novo cômodo": "Nouvelle pièce",
 "Novo hábito": "Nouvelle habitude",
 "Não dá para excluir em grupo": "Suppression groupée impossible",
 "Não enviados": "Non envoyés",
 "Não estão no grupo (ou com outro nome): {l}": "Ne sont pas dans le groupe (ou sous un autre nom) : {l}",
 "Não foi possível exportar": "Impossible d'exporter",
 "Não foi possível ouvir agora ({erro}).": "Impossible d'écouter pour le moment ({erro}).",
 "Não pede a senha do diário. É a única parte que pode ser compartilhada.": "Ne demande pas le mot de passe du journal. C'est la seule partie qui peut être partagée.",
 "Não é dia de aula desta turma. A chamada fica como reposição ou aula extra.": "Ce n'est pas un jour de cours de cette classe. L'appel sera enregistré comme rattrapage ou cours supplémentaire.",
 "O app avisa {n} dia(s) antes e no dia do vencimento, às 9h. Dá para mudar em Ajustes › Abas › Finanças.": "L'app vous prévient {n} jour(s) avant et le jour de l'échéance, à 9 h. Modifiable dans Réglages › Onglets › Finance.",
 "O clima automático usa a localização do celular. Sem permissão, ele fica para preencher aqui.": "La météo automatique utilise la position du téléphone. Sans autorisation, elle reste à remplir ici.",
 "O conteúdo desta carta não foi encontrado.": "Le contenu de cette lettre est introuvable.",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja (ou instale o APK novo) para usar o microfone.": "La dictée arrive avec la nouvelle version de l'app. Mettez à jour My Planner depuis le store (ou installez le nouvel APK) pour utiliser le micro.",
 "O diário pede a senha sempre que você entra nele, mesmo com o app desbloqueado.": "Le journal demande le mot de passe chaque fois que vous y entrez, même avec l'app déverrouillée.",
 "O diário só abre com essa senha, sempre.": "Le journal ne s'ouvre qu'avec ce mot de passe, toujours.",
 "O diário é criptografado: sem a senha, ninguém consegue abrir, nem o suporte. Se quiser, dá para apagar o diário e começar um novo (os Projetos em Grupo continuam).": "Le journal est chiffré : sans le mot de passe, personne ne peut l'ouvrir, pas même le support. Si vous le souhaitez, vous pouvez supprimer le journal et en commencer un nouveau (les Projets de groupe sont conservés).",
 "O que aprendi hoje?": "Qu'ai-je appris aujourd'hui ?",
 "O que este mês te ensinou? O que quer levar para o próximo?": "Qu'est-ce que ce mois vous a appris ? Que voulez-vous garder pour le prochain ?",
 "O que fica desmarcado some da tela. Os dados continuam guardados.": "Ce qui reste décoché disparaît de l'écran. Les données restent enregistrées.",
 "O que foi bom hoje?": "Qu'est-ce qui a été bien aujourd'hui ?",
 "O que foi excluído nos últimos 30 dias": "Ce qui a été supprimé ces 30 derniers jours",
 "O que quero melhorar amanhã?": "Que veux-je améliorer demain ?",
 "O que quero mudar agora": "Ce que je veux changer maintenant",
 "O que você escreveu nesta carta vai se perder.": "Ce que vous avez écrit dans cette lettre sera perdu.",
 "O que você quer fazer com o arquivo?": "Que voulez-vous faire du fichier ?",
 "Objetivo": "But",
 "Oculta": "Masquée",
 "Orientação": "Consigne",
 "Orientações, receitas, atestados e materiais para entregar ao paciente, com arquivos. Só o que está aqui é enviado: o prontuário nunca sai por esta pasta.": "Consignes, ordonnances, certificats médicaux et documents à remettre au patient, avec fichiers. Seul ce qui est ici est envoyé : le dossier médical ne sort jamais par ce dossier.",
 "Os dias com página escrita ficam marcados. Toque num dia para abrir.": "Les jours avec une page écrite sont marqués. Touchez un jour pour l'ouvrir.",
 "Os itens saem de vez e não podem mais ser restaurados.": "Les éléments sont supprimés définitivement et ne peuvent plus être restaurés.",
 "Outra data": "Autre date",
 "Outras moedas": "Autres devises",
 "Ouvindo…": "Écoute…",
 "PASSOS": "ÉTAPES",
 "PDF com seus dados e assinatura": "PDF avec vos données et votre signature",
 "POR DIA": "PAR JOUR",
 "POR MATÉRIA": "PAR MATIÈRE",
 "PROGRESSO": "PROGRESSION",
 "Paciente: {nome}": "Patient : {nome}",
 "Para o paciente": "Pour le patient",
 "Para trocar a forma de abrir, entre no Diário com a senha dele e volte aqui.": "Pour changer le mode d'ouverture, entrez dans le Journal avec son mot de passe et revenez ici.",
 "Para {nome} de {tempo} depois": "Pour {nome} dans {tempo}",
 "Parar o ditado": "Arrêter la dictée",
 "Parcelado": "Échelonné",
 "Partes desta aba": "Parties de cet onglet",
 "Passo": "Étape",
 "Pastas arquivadas": "Dossiers archivés",
 "Pastas arquivadas ({n})": "Dossiers archivés ({n})",
 "Pautada": "Lignée",
 "Pautada com margem": "Lignée avec marge",
 "Pedido de exame": "Demande d'examen",
 "Pelo que sou grata hoje?": "Pour quoi suis-je reconnaissante aujourd'hui ?",
 "Permita o microfone e o reconhecimento de fala para o My Planner nos ajustes do celular.": "Autorisez le micro et la reconnaissance vocale pour My Planner dans les réglages du téléphone.",
 "Personalizar: tipo, cor e tema da folha e cores das bolinhas, só para esta aba": "Personnaliser : type, couleur et thème de la feuille et couleurs des pastilles, uniquement pour cet onglet",
 "Pontilhada": "Pointillée",
 "Posto": "Station-service",
 "Preenche o clima do Meu Dia pela localização do celular.": "Remplit la météo de Ma journée grâce à la position du téléphone.",
 "Preencher pela foto do comprovante": "Remplir à partir de la photo du justificatif",
 "Primeira vez neste aparelho: digite a senha do diário.": "Première fois sur cet appareil : saisissez le mot de passe du journal.",
 "Projeto": "Projet",
 "Projeto de Vida": "Projet de vie",
 "Projetos com amigos e família (compartilhados)": "Projets avec amis et famille (partagés)",
 "Projetos em Grupo": "Projets de groupe",
 "Proprietário / Locador": "Propriétaire / Bailleur",
 "Páginas arquivadas": "Pages archivées",
 "Páginas desta aba": "Pages de cet onglet",
 "QUANDO ELA ABRE": "QUAND ELLE S'OUVRE",
 "Qua": "Mer",
 "Quadriculada": "Quadrillée",
 "Quadro dos Sonhos": "Tableau des rêves",
 "Quais partes você vai usar?": "Quelles parties allez-vous utiliser ?",
 "Quando você concluir uma meta ou formar um hábito, ele aparece aqui para celebrar. 🎉": "Quand vous atteignez un objectif ou acquérez une habitude, il apparaît ici pour le célébrer. 🎉",
 "Quanto você pagou?": "Combien avez-vous payé ?",
 "Quanto você recebeu?": "Combien avez-vous reçu ?",
 "Que tal revisar o seu mês? ✨": "Et si vous faisiez le bilan de votre mois ? ✨",
 "Quem faz": "Qui fait",
 "Quem fez o meu dia melhor?": "Qui a rendu ma journée meilleure ?",
 "Quer guardar o comprovante agora?": "Voulez-vous enregistrer le justificatif maintenant ?",
 "Qui": "Jeu",
 "REFLEXÃO DO MÊS": "BILAN DU MOIS",
 "Recebeu {v} a mais": "Reçu {v} de plus",
 "Recebeu {v} a menos": "Reçu {v} de moins",
 "Receita médica": "Ordonnance",
 "Receitas médicas": "Ordonnances",
 "Recolher": "Replier",
 "Refeições arquivadas": "Repas archivés",
 "Refeições do cronograma feitas (Bem-Estar)": "Repas du planning effectués (Bien-être)",
 "Referente a (ex.: material, passeio, inscrição)": "Correspond à (ex. : fournitures, sortie, inscription)",
 "Registrar": "Enregistrer",
 "Relacionamentos": "Relations",
 "Relatório de estudos": "Rapport d'études",
 "Relatório de realizações": "Rapport des réalisations",
 "Relatório em PDF": "Rapport PDF",
 "Renomear, adicionar ou tirar áreas": "Renommer, ajouter ou retirer des domaines",
 "Reposição": "Rattrapage",
 "Restaurado": "Restauré",
 "Resumida": "Résumée",
 "Resumida: só uma linha com o total. Completa: mostra os itens do dia. Oculta: não aparece. Nada desta aba vira tarefa sozinho.": "Résumée : une seule ligne avec le total. Complète : affiche les éléments du jour. Masquée : n'apparaît pas. Rien dans cet onglet ne devient une tâche automatiquement.",
 "Resumo de {nome}": "Résumé de {nome}",
 "Resumo do dia": "Résumé du jour",
 "Retângulo": "Rectangle",
 "Revisar antes": "Vérifier avant",
 "Revisão do mês": "Bilan du mois",
 "Roda da Vida": "Roue de la vie",
 "Rosa": "Rose",
 "Sair sem guardar?": "Quitter sans enregistrer ?",
 "Salvar avaliação de hoje": "Enregistrer l'évaluation du jour",
 "Salvar ou enviar": "Enregistrer ou envoyer",
 "Seg": "Lun",
 "Segure e arraste as pastas para mudar a ordem. Arraste para a esquerda para arquivar.": "Maintenez et faites glisser les dossiers pour changer l'ordre. Glissez vers la gauche pour archiver.",
 "Sem chamada neste dia: cobra todos os alunos.": "Pas d'appel ce jour-là : facture tous les élèves.",
 "Sem ideia do que escrever? Toque numa pergunta:": "Pas d'idée de quoi écrire ? Touchez une question :",
 "Sem registros de humor.": "Aucune humeur enregistrée.",
 "Sem tema": "Sans thème",
 "Semana de {d}": "Semaine du {d}",
 "Senha atual do diário": "Mot de passe actuel du journal",
 "Senha do diário": "Mot de passe du journal",
 "Senha do diário incorreta.": "Mot de passe du journal incorrect.",
 "Senha do diário trocada": "Mot de passe du journal modifié",
 "Senha própria só do diário": "Mot de passe propre au journal",
 "Sequência dos hábitos": "Série des habitudes",
 "Seta": "Flèche",
 "Seu diário, só seu": "Votre journal, rien qu'à vous",
 "Seu texto de motivação": "Votre texte de motivation",
 "Sex": "Ven",
 "Sonho": "Rêve",
 "Suplementos arquivados": "Compléments archivés",
 "Sáb": "Sam",
 "Só abre com a senha do diário.": "Ne s'ouvre qu'avec le mot de passe du journal.",
 "TEMA DECORATIVO": "THÈME DÉCORATIF",
 "TIPO DE FOLHA": "TYPE DE FEUILLE",
 "Tarefas arquivadas": "Tâches archivées",
 "Ter": "Mar",
 "Texto para o paciente": "Texte pour le patient",
 "Tipo, cor e tema da folha": "Type, couleur et thème de la feuille",
 "Tirar a área \"{a}\"?": "Retirer le domaine \"{a}\" ?",
 "Tirar da frase do dia": "Retirer de la phrase du jour",
 "Tirar do arquivo": "Désarchiver",
 "Tirar esta foto do quadro?": "Retirer cette photo du tableau ?",
 "Tirar esta pergunta?": "Retirer cette question ?",
 "Tirar este vídeo?": "Retirer cette vidéo ?",
 "Todo dia às {h}: \"Como foi o seu dia? ✍️\"": "Tous les jours à {h} : \"Comment s'est passée votre journée ? ✍️\"",
 "Todos os alunos já têm uma cobrança com esta referência.": "Tous les élèves ont déjà un paiement dû avec cette référence.",
 "Toque de novo para \"Outros\" (dispensado, atestado...): não conta como falta nem como aula.": "Touchez à nouveau pour \"Autres\" (dispensé, certificat médical...) : ne compte ni comme absence ni comme cours.",
 "Toque no círculo para marcar o que fez hoje. Os hábitos não vão para o My Planner sozinhos: use Enviar, no menu ⋮.": "Touchez le cercle pour cocher ce que vous avez fait aujourd'hui. Les habitudes ne vont pas dans My Planner automatiquement : utilisez Envoyer, dans le menu ⋮.",
 "Toque num dia para marcar ou desmarcar.": "Touchez un jour pour le cocher ou le décocher.",
 "Toque numa bolinha para trocar a cor. Na página, segurar a bolinha faz o mesmo.": "Touchez une pastille pour changer la couleur. Sur la page, maintenir la pastille fait la même chose.",
 "Toque para abrir. Arraste para a esquerda para arquivar ou duplicar, ou para a direita para excluir.": "Touchez pour ouvrir. Glissez vers la gauche pour archiver ou dupliquer, ou vers la droite pour supprimer.",
 "Treino do dia feito (Bem-Estar)": "Entraînement du jour fait (Bien-être)",
 "Treinos arquivados": "Entraînements archivés",
 "Trocar a senha do diário": "Changer le mot de passe du journal",
 "Tudo o que você escrever no diário fica criptografado neste dispositivo antes de ir para a sua conta. Ninguém mais consegue ler, nem o suporte.": "Tout ce que vous écrivez dans le journal est chiffré sur cet appareil avant d'aller sur votre compte. Personne d'autre ne peut le lire, pas même le support.",
 "Tudo o que você exclui fica aqui por 30 dias. Depois disso sai de vez.": "Tout ce que vous supprimez reste ici 30 jours. Ensuite, c'est supprimé définitivement.",
 "Título (ex.: Ter uma boa alimentação)": "Titre (ex. : Bien manger)",
 "Uma cobrança avulsa para cada um dos {n} aluno(s). Para cobrar só um aluno, toque em +.": "Un paiement dû à l'unité pour chacun des {n} élève(s). Pour facturer un seul élève, touchez +.",
 "Uma senha própria, só do diário": "Un mot de passe propre, rien que pour le journal",
 "Usar a senha do diário": "Utiliser le mot de passe du journal",
 "Usar como frase do dia": "Utiliser comme phrase du jour",
 "Usar este valor": "Utiliser ce montant",
 "Usar o padrão do app": "Utiliser le réglage par défaut de l'app",
 "Vale para os valores de todas as abas (Finanças, aluguel, mensalidades...).": "S'applique aux montants de tous les onglets (Finance, loyer, mensualités...).",
 "Vale para todas as páginas com escrita (Estudos, Anotações, Diário, Documentos...). Cada aba pode ter o próprio padrão em Ajustes › Abas, e cada página pode mudar a folha no ⋮ › Folha.": "S'applique à toutes les pages d'écriture (Études, Notes, Journal, Documents...). Chaque onglet peut avoir son propre réglage dans Réglages › Onglets, et chaque page peut changer de feuille via ⋮ › Feuille.",
 "Valor da aula extra (por aluno)": "Prix du cours supplémentaire (par élève)",
 "Valor por aluno": "Montant par élève",
 "Valor previsto: {v}": "Montant prévu : {v}",
 "Vencimento: {d}": "Échéance : {d}",
 "Ver o comprovante": "Voir le justificatif",
 "Verde": "Vert",
 "Visualizar": "Aperçu",
 "Você está como convidado": "Vous êtes invité",
 "Voltar a acompanhar este hábito": "Recommencer à suivre cette habitude",
 "Voltar ao início da folha": "Revenir au début de la feuille",
 "Voltar ao padrão inicial (folha pautada; preto, azul, vermelho e verde)": "Revenir au réglage initial (feuille lignée ; noir, bleu, rouge et vert)",
 "Voltar para a nova avaliação": "Revenir à la nouvelle évaluation",
 "Vídeos": "Vidéos",
 "X vezes por semana": "X fois par semaine",
 "abre em {n} dias": "s'ouvre dans {n} jours",
 "agradável": "agréable",
 "arquivo": "archive",
 "aula extra": "cours supplémentaire",
 "calor": "chaud",
 "chuva": "pluie",
 "concluído": "terminé",
 "céu limpo": "ciel dégagé",
 "de {n} planejados": "sur {n} prévus",
 "dentro de {p}": "dans {p}",
 "enviado em {d}": "envoyé le {d}",
 "estudados na semana": "étudiés cette semaine",
 "excluído em {d}": "supprimé le {d}",
 "falta 1 dia": "reste 1 jour",
 "faltam {n} dias": "restent {n} jours",
 "feito {dur} na semana": "fait {dur} cette semaine",
 "fresco": "frais",
 "frio": "froid",
 "garoa": "bruine",
 "hoje não está planejado": "pas prévu aujourd'hui",
 "hábito formado ✨": "habitude acquise ✨",
 "incorreta": "incorrect",
 "neblina": "brouillard",
 "neve": "neige",
 "nublado": "nuageux",
 "não enviado": "non envoyé",
 "parcela {k}/{n}": "échéance {k}/{n}",
 "passou há {n} dias": "dépassé depuis {n} jours",
 "pelo Bem-Estar": "via Bien-être",
 "poucas nuvens": "peu nuageux",
 "reposição": "rattrapage",
 "sai de vez em {n} dia(s)": "supprimé définitivement dans {n} jour(s)",
 "sem registros": "aucun enregistrement",
 "tempestade": "orage",
 "tracejado: {d}": "pointillé : {d}",
 "ver mais": "voir plus",
 "ver menos": "voir moins",
 "{aluno}: {n} de {max}": "{aluno} : {n} sur {max}",
 "{d} é feriado: {f}. Registrar mesmo assim?": "Le {d} est férié : {f}. Enregistrer quand même ?",
 "{f} de {n} passos feitos": "{f} étape(s) sur {n} faites",
 "{f}/{n} passos": "{f}/{n} étapes",
 "{nome} daqui a 1 ano": "{nome} dans 1 an",
 "{nome} daqui a 10 anos": "{nome} dans 10 ans",
 "{nome} daqui a 6 meses": "{nome} dans 6 mois",
 "{n} aluno(s) recebem só a própria nota de \"{a}\".": "{n} élève(s) reçoivent uniquement leur propre note de \"{a}\".",
 "{n} aluno(s) receberam a nota.": "{n} élève(s) ont reçu la note.",
 "{n} aluno(s) · {v} cada": "{n} élève(s) · {v} chacun",
 "{n} anos": "{n} ans",
 "{n} dia(s) antes": "{n} jour(s) avant",
 "{n} dia(s) cumprido(s) no mês": "{n} jour(s) réussi(s) dans le mois",
 "{n} dia(s) registrado(s) · média {e}": "{n} jour(s) enregistré(s) · moyenne {e}",
 "{n} dia(s) registrado(s), média {m} de 6": "{n} jour(s) enregistré(s), moyenne {m} sur 6",
 "{n} dia(s) seguido(s)": "{n} jour(s) d'affilée",
 "{n} dispensada(s) hoje": "{n} dispensé(s) aujourd'hui",
 "{n} meses": "{n} mois",
 "{n} outro(s)": "{n} autre(s)",
 "{n} selecionado(s)": "{n} sélectionné(s)",
 "{n} tarefa(s) concluída(s) no My Planner": "{n} tâche(s) terminée(s) dans My Planner",
 "{n} vez(es) por semana": "{n} fois par semaine",
 "{n}x": "{n}x",
 "Água: {a} de {m} ml": "Eau : {a} sur {m} ml",
 "ÚLTIMAS 8 SEMANAS": "8 DERNIÈRES SEMAINES",
 "Última parcela em {d}": "Dernière échéance le {d}",
 "é hoje!": "c'est aujourd'hui !",
 "A mesma do app": "Le même que l'app",
 "Abrir com o código": "Ouvrir avec le code",
 "Ainda não criado": "Pas encore créé",
 "Ao criar, o app mostra um código de recuperação para você guardar.": "À la création, l'app affiche un code de récupération à conserver.",
 "Apagar o diário e começar de novo": "Supprimer le journal et recommencer",
 "Biometria ou código do dispositivo": "Biométrie ou code de l'appareil",
 "Biometria, PIN do dispositivo ou a senha do app. Não precisa criar outra senha.": "Biométrie, code PIN de l'appareil ou mot de passe de l'app. Inutile de créer un autre mot de passe.",
 "Bloquear o app": "Verrouiller l'app",
 "Cadastre digital, rosto ou um código de bloqueio no dispositivo para usar.": "Enregistrez une empreinte, votre visage ou un code de verrouillage sur l'appareil pour l'utiliser.",
 "Com a biometria ligada, ela aparece primeiro. Se falhar, a mesma janela oferece o código/PIN/padrão do dispositivo; a senha do app continua valendo.": "Avec la biométrie activée, elle apparaît en premier. En cas d'échec, la même fenêtre propose le code/PIN/schéma de l'appareil ; le mot de passe de l'app reste valable.",
 "Com ele você recupera o diário se esquecer a senha ou trocar de dispositivo.": "Il vous permet de récupérer le journal si vous oubliez le mot de passe ou changez d'appareil.",
 "Com este código você recupera o diário se esquecer a senha ou trocar de dispositivo. Guarde em lugar seguro e não mostre a ninguém.": "Ce code vous permet de récupérer le journal si vous oubliez le mot de passe ou changez d'appareil. Conservez-le en lieu sûr et ne le montrez à personne.",
 "Como funciona a Roda da Vida": "Comment fonctionne la Roue de la vie",
 "Como o diário abre": "Comment le journal s'ouvre",
 "Crie a senha que vai abrir o diário.": "Créez le mot de passe qui ouvrira le journal.",
 "Crie o PIN do diário (4 a 6 números)": "Créez le code PIN du journal (4 à 6 chiffres)",
 "Crie o diário de novo para começar.": "Recréez le journal pour commencer.",
 "Código aceito. Crie uma senha nova para o diário.": "Code accepté. Créez un nouveau mot de passe pour le journal.",
 "Código de recuperação": "Code de récupération",
 "Código de recuperação (ex.: ABCD-EFGH-...)": "Code de récupération (ex. : ABCD-EFGH-...)",
 "Código de recuperação incorreto.": "Code de récupération incorrect.",
 "Cômodos": "Pièces",
 "Depois de 1 minuto": "Après 1 minute",
 "Depois de {n} minutos": "Après {n} minutes",
 "Desenhe o padrão do diário": "Dessinez le schéma du journal",
 "Dias no mês": "Jours dans le mois",
 "Dias seguidos": "Jours d'affilée",
 "Digite o seu PIN": "Saisissez votre code PIN",
 "Diário ainda não criado": "Journal pas encore créé",
 "Dê uma nota de 0 a 10 para como você se sente hoje em cada área da vida. O desenho mostra onde a sua vida está equilibrada e onde precisa de atenção. Salve a avaliação e repita de tempos em tempos (por exemplo, todo mês) para comparar e ver a sua evolução. Você pode renomear, adicionar ou tirar áreas.": "Notez de 0 à 10 comment vous vous sentez aujourd'hui dans chaque domaine de la vie. Le dessin montre où votre vie est équilibrée et où elle demande de l'attention. Enregistrez l'évaluation et refaites-la de temps en temps (par exemple, chaque mois) pour comparer et voir votre évolution. Vous pouvez renommer, ajouter ou retirer des domaines.",
 "Entre na aba Diário para criar o seu diário.": "Allez dans l'onglet Journal pour créer votre journal.",
 "Entre no Diário (com a senha dele ou o desbloqueio do app) e volte aqui.": "Ouvrez le Journal (avec son mot de passe ou le déverrouillage de l'app) puis revenez ici.",
 "Esconder a senha": "Masquer le mot de passe",
 "Gerar novo código": "Générer un nouveau code",
 "Gerar um código de recuperação novo?": "Générer un nouveau code de récupération ?",
 "Guarde este código": "Conservez ce code",
 "Já guardei": "C'est noté",
 "Ligar um hábito que já existe": "Lier une habitude existante",
 "Mostrar a senha": "Afficher le mot de passe",
 "Mudar como o diário abre": "Changer la façon d'ouvrir le journal",
 "My Planner · Código de recuperação do Diário": "My Planner · Code de récupération du Journal",
 "Não foi possível abrir com a chave deste dispositivo. Use a senha do diário ou o código de recuperação.": "Impossible d'ouvrir avec la clé de cet appareil. Utilisez le mot de passe du journal ou le code de récupération.",
 "O Caps Lock parece estar ligado.": "Le verrouillage des majuscules semble activé.",
 "O PIN fica guardado só neste dispositivo, protegido. A senha continua valendo se você esquecer o PIN.": "Le code PIN est conservé uniquement sur cet appareil, protégé. Le mot de passe reste valable si vous oubliez le code PIN.",
 "O PIN precisa ter de 4 a 6 números.": "Le code PIN doit comporter de 4 à 6 chiffres.",
 "O código anterior deixa de valer. Por segurança, o código não fica guardado no app: só dá para ver na hora em que é gerado.": "L'ancien code ne sera plus valable. Par sécurité, le code n'est pas conservé dans l'app : il n'est visible qu'au moment où il est généré.",
 "O código não fica guardado em lugar nenhum que o suporte possa ver. Sem a senha e sem o código, o diário não pode ser recuperado.": "Le code n'est conservé nulle part où le support pourrait le voir. Sans le mot de passe ni le code, le journal ne peut pas être récupéré.",
 "O diário agora abre só com a senha dele.": "Le journal s'ouvre désormais uniquement avec son propre mot de passe.",
 "O reconhecimento de rosto deste dispositivo não pode ser usado por apps. Use a digital ou o código/PIN do dispositivo.": "La reconnaissance faciale de cet appareil ne peut pas être utilisée par les apps. Utilisez l'empreinte ou le code/PIN de l'appareil.",
 "O tempo conta a partir do momento em que o app sai da tela (outro app, tela inicial ou tela apagada). Puxar as notificações, a janela da biometria, um pedido de permissão ou escolher uma foto ou arquivo não contam.": "Le délai démarre dès que l'app quitte l'écran (autre app, écran d'accueil ou écran éteint). Ouvrir les notifications, la fenêtre de biométrie, une demande d'autorisation ou le choix d'une photo ou d'un fichier ne comptent pas.",
 "Os PINs não conferem.": "Les codes PIN ne correspondent pas.",
 "PIN": "PIN",
 "PIN (4 a 6 números)": "Code PIN (4 à 6 chiffres)",
 "PIN (só números, 4 a 6)": "Code PIN (chiffres uniquement, 4 à 6)",
 "PIN do diário": "Code PIN du journal",
 "PIN incorreto": "Code PIN incorrect",
 "PIN salvo.": "Code PIN enregistré.",
 "Padrão do app": "Par défaut de l'app",
 "Para apagar, confirme com a senha do app, biometria ou PIN do dispositivo. Isso apaga o Meu Dia, metas, hábitos, cartas e fotos do diário. Projetos em Grupo continuam.": "Pour supprimer, confirmez avec le mot de passe de l'app, la biométrie ou le code PIN de l'appareil. Cela supprime Ma journée, les objectifs, les habitudes, les lettres et les photos du journal. Les Projets de groupe sont conservés.",
 "Para continuar, digite a senha do app ou use a biometria/o código do dispositivo.": "Pour continuer, saisissez le mot de passe de l'app ou utilisez la biométrie/le code de l'appareil.",
 "Para recuperar o diário se esquecer a senha ou trocar de dispositivo.": "Pour récupérer le journal si vous oubliez le mot de passe ou changez d'appareil.",
 "Pastas": "Dossiers",
 "Pedir a senha de novo": "Redemander le mot de passe",
 "Personalizada": "Personnalisé",
 "Primeira vez neste dispositivo: digite a senha do diário ou use o código de recuperação.": "Première fois sur cet appareil : saisissez le mot de passe du journal ou utilisez le code de récupération.",
 "Primeira vez neste dispositivo: digite o código de recuperação do diário.": "Première fois sur cet appareil : saisissez le code de récupération du journal.",
 "Reconhecimento de rosto": "Reconnaissance faciale",
 "Repita o PIN": "Répétez le code PIN",
 "Salvar a senha nova": "Enregistrer le nouveau mot de passe",
 "Salvar em arquivo / no Drive": "Enregistrer dans un fichier / sur Drive",
 "Salvar o código de recuperação": "Enregistrer le code de récupération",
 "Senha (letras e números)": "Mot de passe (lettres et chiffres)",
 "Senha do app": "Mot de passe de l'app",
 "Senha nova do diário": "Nouveau mot de passe du journal",
 "Senha própria": "Mot de passe propre",
 "Senha própria do diário": "Mot de passe propre au journal",
 "Tarefas": "Tâches",
 "Trocar o PIN": "Changer le code PIN",
 "Usar a senha": "Utiliser le mot de passe",
 "Usar o PIN": "Utiliser le code PIN",
 "Usar o código de recuperação": "Utiliser le code de récupération",
 "Usar o desbloqueio do app": "Utiliser le déverrouillage de l'app",
 "Use a biometria ou o código/PIN/padrão do dispositivo.": "Utilisez la biométrie ou le code/PIN/schéma de l'appareil.",
 "Use o código de recuperação que apareceu quando o diário foi criado. Sem a senha e sem o código, ninguém consegue abrir o diário, nem o suporte.": "Utilisez le code de récupération affiché lors de la création du journal. Sans le mot de passe ni le code, personne ne peut ouvrir le journal, pas même le support.",
 "Voltar a usar só a senha?": "Revenir au mot de passe seul ?",
 "incorreto": "incorrect",
 "1 h": "1 h",
 "12 horas (2:30 PM)": "12 heures (2:30 PM)",
 "15 min": "15 min",
 "24 horas (14:30)": "24 heures (14:30)",
 "30 min": "30 min",
 "A lixeira tem itens grandes. Confirme com a senha do app, a biometria ou o código do dispositivo.": "La corbeille contient des éléments volumineux. Confirmez avec le mot de passe de l'app, la biométrie ou le code de l'appareil.",
 "A semana começa na": "La semaine commence le",
 "Abra o Diário primeiro": "Ouvrez d'abord le Journal",
 "Abrir configurações do celular": "Ouvrir les réglages du téléphone",
 "Agenda e mapas": "Agenda et cartes",
 "Agora: {m}": "Maintenant : {m}",
 "Ajuda e sobre": "Aide et à propos",
 "Alarme (som)": "Alarme (son)",
 "Alarme ou vibração das pausas": "Alarme ou vibration des pauses",
 "Apaga para sempre a conta e todos os dados na nuvem e neste dispositivo. Pede a sua senha antes.": "Supprime définitivement le compte et toutes les données dans le cloud et sur cet appareil. Votre mot de passe est demandé avant.",
 "Apagar todas ({n})": "Tout supprimer ({n})",
 "Apagar {n} selecionada(s)": "Supprimer {n} sélectionnée(s)",
 "Aparência": "Apparence",
 "App das rotas": "App d'itinéraires",
 "Ardósia": "Ardoise",
 "Arrastar para a direita": "Glisser vers la droite",
 "Arrastar para a esquerda": "Glisser vers la gauche",
 "As contas de Finanças aparecem no My Planner com essa antecedência.": "Les factures de Finance apparaissent dans My Planner avec cette avance.",
 "Atualizações e sobre": "Mises à jour et à propos",
 "Avisar antes do vencimento": "Prévenir avant l'échéance",
 "Aviso marcado": "Rappel programmé",
 "Aviso no começo e no fim de cada pausa": "Avis au début et à la fin de chaque pause",
 "Avisos desta aba": "Notifications de cet onglet",
 "Avisos e alarmes": "Notifications et alarmes",
 "Avisos silenciosos": "Notifications silencieuses",
 "Avisos: som e vibração": "Notifications : son et vibration",
 "Avisos: só som": "Notifications : son uniquement",
 "Avisos: só vibração": "Notifications : vibration uniquement",
 "Azul elétrico": "Bleu électrique",
 "Azul-aço": "Bleu acier",
 "Azul-bebê": "Bleu layette",
 "Azul-marinho": "Bleu marine",
 "Baixar meus dados": "Télécharger mes données",
 "Baixar todos os meus dados": "Télécharger toutes mes données",
 "Baixar todos os meus dados e excluir a conta (LGPD)": "Télécharger toutes mes données et supprimer le compte (LGPD)",
 "Biometria": "Biométrie",
 "Bissexual": "Bisexuel",
 "Brilhante": "Vif",
 "Buscar abas": "Rechercher des onglets",
 "Buscar nos ajustes": "Rechercher dans les réglages",
 "Cancelar aviso": "Annuler le rappel",
 "Cinza-chumbo": "Gris anthracite",
 "Cofre": "Coffre",
 "Coloque pelo menos uma matéria.": "Ajoutez au moins une matière.",
 "Como usar": "Mode d'emploi",
 "Conexões": "Connexions",
 "Cor da aba": "Couleur de l'onglet",
 "Cor de destaque": "Couleur d'accent",
 "Crie uma matéria primeiro": "Créez d'abord une matière",
 "Cítrico": "Agrumes",
 "Cópia de segurança em arquivo": "Sauvegarde dans un fichier",
 "Dados de paciente e prontuário. Confirme com a senha do app, a biometria ou o código do dispositivo.": "Données de patients et dossiers médicaux. Confirmez avec le mot de passe de l'app, la biométrie ou le code de l'appareil.",
 "Desligadas": "Désactivées",
 "Digite a senha da sua conta para confirmar.": "Saisissez le mot de passe de votre compte pour confirmer.",
 "Duração padrão de uma tarefa nova": "Durée par défaut d'une nouvelle tâche",
 "Editar sessão": "Modifier la séance",
 "Ela se repete sem data de fim: aparecem as vezes até {data}. Com todas marcadas, sai a tarefa inteira.": "Elle se répète sans date de fin : les occurrences jusqu'au {data} sont affichées. Si toutes sont cochées, la tâche entière est supprimée.",
 "Em atividade": "En activité",
 "Em pausa": "En pause",
 "Emoji da pausa": "Emoji de la pause",
 "Encerrar": "Terminer",
 "Encerrar a sessão?": "Terminer la séance ?",
 "Entra no modo seleção, para escolher vários itens de uma vez.": "Passe en mode sélection, pour choisir plusieurs éléments à la fois.",
 "Escolha um horário no futuro.": "Choisissez une heure dans le futur.",
 "Escolher a matéria": "Choisir la matière",
 "Esconde os valores em dinheiro (R$ •••)": "Masque les montants (R$ •••)",
 "Esconder o CPF": "Masquer le CPF",
 "Esconder os valores": "Masquer les montants",
 "Esta e as próximas": "Celle-ci et les suivantes",
 "Esta tarefa se repete. Onde aplicar a mudança?": "Cette tâche se répète. Où appliquer la modification ?",
 "Este item tem muita coisa dentro. Confirme com a senha do app, a biometria ou o código do dispositivo.": "Cet élément contient beaucoup de choses. Confirmez avec le mot de passe de l'app, la biométrie ou le code de l'appareil.",
 "Exclui o item (pede confirmação). Depois dá para desfazer ou restaurar pela Lixeira.": "Supprime l'élément (avec confirmation). Vous pourrez ensuite annuler ou le restaurer depuis la Corbeille.",
 "Excluir minha conta": "Supprimer mon compte",
 "Ficha protegida": "Fiche protégée",
 "Formato da hora": "Format de l'heure",
 "Foto do Quadro dos Sonhos": "Photo du Tableau des rêves",
 "Geral": "Général",
 "Gestos": "Gestes",
 "Google Drive, OneDrive e arquivo de cópia": "Google Drive, OneDrive et fichier de sauvegarde",
 "Grafite": "Graphite",
 "Guardar em": "Enregistrer dans",
 "Hábito do Diário": "Habitude du Journal",
 "Idioma e moeda": "Langue et devise",
 "Inspiração do Diário": "Inspiration du Journal",
 "Intenso": "Intense",
 "Item arquivado": "Élément archivé",
 "Item excluído": "Élément supprimé",
 "Lavanda": "Lavande",
 "Ligadas": "Activées",
 "Limite de energia": "Limite d'énergie",
 "Lésbica": "Lesbienne",
 "Marque as vezes que vão ser apagadas.": "Cochez les occurrences qui seront supprimées.",
 "Matéria": "Matière",
 "Me avise em…": "Me prévenir dans…",
 "Menta": "Menthe",
 "Menu ⋮": "Menu ⋮",
 "Meta do Diário": "Objectif du Journal",
 "Modo discreto": "Mode discret",
 "Monte a sessão uma vez (matérias, tempo de cada uma e pausas) e repita nos outros dias tocando em Começar. O tempo estudado entra sozinho na meta.": "Créez la séance une fois (matières, durée de chacune et pauses) et répétez-la les autres jours en touchant Démarrer. Le temps d'étude est compté automatiquement dans l'objectif.",
 "Mostra Arquivar e Duplicar.": "Affiche Archiver et Dupliquer.",
 "Mostrar feriados no topo": "Afficher les jours fériés en haut",
 "Mostrar os valores": "Afficher les montants",
 "Muda a ordem dos itens.": "Change l'ordre des éléments.",
 "Muda só a cor do My Planner. A cor de destaque do app fica em Ajustes > Aparência. Cada tarefa pode ter uma cor própria na ficha.": "Change uniquement la couleur de My Planner. La couleur d'accent de l'app se trouve dans Réglages > Apparence. Chaque tâche peut avoir sa propre couleur dans sa fiche.",
 "Nada encontrado nos ajustes.": "Aucun résultat dans les réglages.",
 "Nenhuma sessão salva ainda.": "Aucune séance enregistrée pour l'instant.",
 "Neon": "Néon",
 "Nesse horário o app não toca nem vibra. Os avisos continuam chegando, em silêncio.": "Pendant cette plage, l'app ne sonne ni ne vibre. Les notifications continuent d'arriver, en silence.",
 "No menu ⋮ de qualquer item: o celular avisa na hora escolhida, sem criar tarefa no My Planner.": "Dans le menu ⋮ de n'importe quel élément : le téléphone vous prévient à l'heure choisie, sans créer de tâche dans My Planner.",
 "Nome (ex.: Sessão do mestrado)": "Nom (ex. : Séance du master)",
 "Nova sessão": "Nouvelle séance",
 "Nuvem e cópias de segurança": "Cloud et sauvegardes",
 "Não perturbe": "Ne pas déranger",
 "Não perturbe {de}–{ate}": "Ne pas déranger {de}–{ate}",
 "Não-binário": "Non-binaire",
 "O botão 🎉 Feriados no topo do My Planner. O país e a lista de feriados ficam em Ajustes > Feriados.": "Le bouton 🎉 Jours fériés en haut de My Planner. Le pays et la liste des jours fériés se trouvent dans Réglages > Jours fériés.",
 "O celular avisa às {h}.": "Le téléphone vous préviendra à {h}.",
 "O que sai do Diário fica cifrado na lixeira. Entre no Diário e depois volte aqui para restaurar.": "Ce qui sort du Journal reste chiffré dans la corbeille. Ouvrez le Journal puis revenez ici pour restaurer.",
 "O que sair fica na Lixeira por 30 dias. Digite a senha da sua conta para confirmar.": "Ce qui est retiré reste dans la Corbeille pendant 30 jours. Saisissez le mot de passe de votre compte pour confirmer.",
 "O que saiu fica na Lixeira por 30 dias.": "Ce qui a été retiré reste dans la Corbeille pendant 30 jours.",
 "O tema muda as cores das abas, a cor de destaque e um toque leve no fundo, nos modos claro e escuro. Para trocar a cor de uma aba só, vá em Ajustes > Abas.": "Le thème change les couleurs des onglets, la couleur d'accent et une légère teinte de fond, en modes clair et sombre. Pour changer la couleur d'un seul onglet, allez dans Réglages > Onglets.",
 "O tempo estudado até agora entra na meta.": "Le temps d'étude jusqu'à présent est compté dans l'objectif.",
 "Oliva": "Olive",
 "Orgulho": "Fierté",
 "Os avisos funcionam no app instalado, com as notificações ligadas.": "Les notifications fonctionnent dans l'app installée, avec les notifications activées.",
 "Os gestos do app": "Les gestes de l'app",
 "Outro (escolher a hora)": "Autre (choisir l'heure)",
 "Pansexual": "Pansexuel",
 "Para ligar, use o app no celular (Ajustes › Agenda e mapas › Agenda do Google). Depois, tudo aparece aqui também.": "Pour l'activer, utilisez l'app sur le téléphone (Réglages › Agenda et cartes › Google Agenda). Ensuite, tout s'affiche aussi ici.",
 "Para não perguntar mais, escolha o app em Ajustes › Agenda e mapas.": "Pour ne plus être interrogé, choisissez l'app dans Réglages › Agenda et cartes.",
 "Pausa": "Pause",
 "Petróleo": "Bleu pétrole",
 "Pink elétrico": "Rose électrique",
 "Preto total": "Noir intégral",
 "Progresso": "Progrès",
 "Pêssego": "Pêche",
 "Quantos dias antes as contas aparecem fica em Ajustes > Avisos e alarmes.": "Le nombre de jours d'avance pour les factures se règle dans Réglages > Notifications et alarmes.",
 "Rosa-chá": "Rose thé",
 "Roxo-profundo": "Violet profond",
 "Segurança e dados": "Sécurité et données",
 "Segurar e arrastar": "Maintenir et faire glisser",
 "Segurar e soltar": "Maintenir et relâcher",
 "Selecionar todas": "Tout sélectionner",
 "Semana começa na {dia}": "La semaine commence le {dia}",
 "Sessão de estudo": "Séance d'étude",
 "Sessão encerrada": "Séance terminée",
 "Sessão pausada": "Séance en pause",
 "Som e vibração": "Son et vibration",
 "Suave": "Doux",
 "Só esta semana": "Cette semaine seulement",
 "Só hoje": "Aujourd'hui seulement",
 "Só neste dia ({data})": "Seulement ce jour-là ({data})",
 "Tamanho das caixas": "Taille des cases",
 "Tamanho do texto": "Taille du texte",
 "Tarefa nova": "Nouvelle tâche",
 "Tela inicial": "Écran d'accueil",
 "Tema e cor de destaque": "Thème et couleur d'accent",
 "Testar alerta": "Tester l'alerte",
 "Testar alerta, \"Não perturbe\" e as configurações do celular ficam em Ajustes > Avisos e alarmes.": "Tester l'alerte, « Ne pas déranger » et les réglages du téléphone se trouvent dans Réglages > Notifications et alarmes.",
 "Testar e conferir": "Tester et vérifier",
 "Todas as opções do item: editar, mover, compartilhar, arquivar, excluir...": "Toutes les options de l'élément : modifier, déplacer, partager, archiver, supprimer...",
 "Toque numa cor do tema {tema} para usar nos botões, no botão + e no item selecionado.": "Touchez une couleur du thème {tema} pour l'utiliser sur les boutons, le bouton + et l'élément sélectionné.",
 "Total: {dur}": "Total : {dur}",
 "Tropical": "Tropical",
 "Turquesa": "Turquoise",
 "Um arquivo com todos os seus dados do My Planner, para guardar ou levar para outro lugar (portabilidade, LGPD).": "Un fichier avec toutes vos données My Planner, à conserver ou à emporter ailleurs (portabilité, LGPD).",
 "Usar no computador, pelo navegador": "Utiliser sur ordinateur, dans le navigateur",
 "Usar o padrão": "Utiliser la valeur par défaut",
 "Usar o padrão ({emoji})": "Utiliser la valeur par défaut ({emoji})",
 "Use o app no celular para baixar o arquivo.": "Utilisez l'app sur le téléphone pour télécharger le fichier.",
 "Vale para todas as abas. Cada aba pode ter o seu em Ajustes > Abas.": "S'applique à tous les onglets. Chaque onglet peut avoir le sien dans Réglages > Onglets.",
 "Valem para as tarefas com pausas. Cada tarefa pode mudar o alarme e o emoji na própria ficha.": "S'appliquent aux tâches avec pauses. Chaque tâche peut changer l'alarme et l'emoji dans sa propre fiche.",
 "Ver lista": "Voir la liste",
 "Ver o CPF inteiro": "Voir le CPF complet",
 "Verde-floresta": "Vert forêt",
 "Verde-água": "Vert d'eau",
 "Vibração": "Vibration",
 "Vinho": "Bordeaux",
 "Você pediu para ser avisado agora.": "Vous avez demandé à être prévenu maintenant.",
 "Você pode: confirmar se tratamos seus dados, acessar, corrigir, pedir a portabilidade (baixar os seus dados em Ajustes > Meus dados), pedir a exclusão, saber com quem compartilhamos, revogar o consentimento e reclamar na ANPD.": "Vous pouvez : confirmer si nous traitons vos données, y accéder, les corriger, demander leur portabilité (télécharger vos données dans Réglages > Mes informations), demander leur suppression, savoir avec qui nous les partageons, retirer votre consentement et déposer une réclamation auprès de l'ANPD.",
 "Voltar ao filtro": "Retour au filtre",
 "Voltar à lista": "Retour à la liste",
 "Vá em Ajustes › My Planner Web e toque em \"Conectar navegador\".": "Allez dans Réglages › My Planner Web et touchez « Connecter le navigateur ».",
 "atividade {n} de {total}": "activité {n} sur {total}",
 "matéria {n} de {t}": "matière {n} sur {t}",
 "padrão": "par défaut",
 "pausa em {n} min": "pause dans {n} min",
 "pausa {n} de {total}": "pause {n} sur {total}",
 "termina em {n} min": "se termine dans {n} min",
 "todas as vezes": "toutes les occurrences",
 "troca em {n} min": "changement dans {n} min",
 "volta em {n} min": "reprise dans {n} min",
 "{nome} · {n} dia(s)": "{nome} · {n} jour(s)",
 "{n} de {total} vezes": "{n} occurrences sur {total}",
 "{n} itens arquivados": "{n} éléments archivés",
 "{n} itens excluídos": "{n} éléments supprimés",
 "{n} marcada(s)": "{n} cochée(s)",
 "{n} vezes": "{n} fois",
 "{rotulo}: {feito} min / {total}": "{rotulo} : {feito} min / {total}",
 "📔 Diário": "📔 Journal",
 "Agendados": "Planifiés",
 "Atrasado": "En retard",
 "Atrasado: {v}": "En retard : {v}",
 "Atualizar o a receber": "Mettre à jour les montants à recevoir",
 "Até (fim do contrato, se houver)": "Jusqu'au (fin du contrat, le cas échéant)",
 "Clínica": "Clinique",
 "Conta cada dia com chamada feita ou com plano de aula marcado como \"Aula dada\".": "Compte chaque jour avec appel fait ou avec un plan de cours marqué \"Cours donné\".",
 "Data do recebimento": "Date de réception",
 "Data prevista do pagamento": "Date de paiement prévue",
 "Desmarcar como recebido": "Ne plus marquer comme reçu",
 "Dia do pagamento": "Jour de paie",
 "Diferença: {v} (juros/multa)": "Différence : {v} (intérêts/pénalité)",
 "Diferença: {v} (taxas/descontos)": "Différence : {v} (frais/retenues)",
 "Escolas, universidades e cursos que pagam você. Com salário fixo, o app gera o a receber de todo mês; por hora-aula, soma as aulas dadas nas turmas ligadas à instituição.": "Écoles, universités et formations qui vous paient. Avec un salaire fixe, l'app crée le montant à recevoir de chaque mois ; à l'heure de cours, elle additionne les cours donnés dans les classes liées à l'établissement.",
 "Escolha o tipo de pagamento (Editar) para o app calcular o que você tem a receber.": "Choisissez le type de paiement (Modifier) pour que l'app calcule ce que vous avez à recevoir.",
 "Este valor vem da parte \"Onde trabalho\" da aba {aba}. Marque aqui como recebido ou abra a aba para ver a instituição.": "Ce montant provient de la section \"Où je travaille\" de l'onglet {aba}. Marquez-le ici comme reçu ou ouvrez l'onglet pour voir l'établissement.",
 "Ex.: Colégio Estadual, Universidade Federal": "Ex. : Lycée public, Université fédérale",
 "Ex.: Hospital Santa Casa, Clínica Vida": "Ex. : Hôpital Santa Casa, Clinique Vida",
 "Ex.: Salário de outubro, 13º, férias": "Ex. : Salaire d'octobre, 13e mois, congés payés",
 "Feitos": "Effectués",
 "Horas-aula de cada aula": "Heures de cours par cours",
 "Hospitais e clínicas que pagam você. Com salário fixo, o app gera o a receber de todo mês; por plantão ou atendimento, marque os feitos e o app calcula.": "Hôpitaux et cliniques qui vous paient. Avec un salaire fixe, l'app crée le montant à recevoir de chaque mois ; à la garde ou à la consultation, marquez ceux effectués et l'app calcule.",
 "Hospital": "Hôpital",
 "Instituição": "Établissement",
 "Instituição (Onde trabalho)": "Établissement (Où je travaille)",
 "Ligue as turmas a esta instituição (na turma, Editar › Instituição) para o app somar as aulas dadas.": "Liez les classes à cet établissement (dans la classe, Modifier › Établissement) pour que l'app additionne les cours donnés.",
 "Marque cada plantão ou atendimento como feito: o app soma e calcula o valor do mês.": "Marquez chaque garde ou consultation comme effectuée : l'app additionne et calcule le montant du mois.",
 "Marque cada plantão ou atendimento feito nesta instituição. O app soma e calcula o valor a receber do mês.": "Marquez chaque garde ou consultation effectuée dans cet établissement. L'app additionne et calcule le montant à recevoir du mois.",
 "Nome da instituição": "Nom de l'établissement",
 "O que a instituição tem a pagar a você, mês a mês. Marque como recebido quando o dinheiro entrar: vai junto para a aba Finanças.": "Ce que l'établissement doit vous payer, mois par mois. Marquez comme reçu quand l'argent arrive : il passe aussi dans l'onglet Finances.",
 "Onde trabalho": "Où je travaille",
 "Plantão": "Garde",
 "Plantão ou atendimento": "Garde ou consultation",
 "Plantões e atendimentos": "Gardes et consultations",
 "Por atendimento ou procedimento": "À la consultation ou à l'acte",
 "Por hora-aula": "À l'heure de cours",
 "Por plantão": "À la garde",
 "Previsto: {v}": "Prévu : {v}",
 "Previsão do mês: {v}": "Prévision du mois : {v}",
 "Quantidade (aulas, plantões ou atendimentos)": "Quantité (cours, gardes ou consultations)",
 "Recebe no mês seguinte ao trabalhado": "Payé le mois suivant le travail",
 "Receber: {t}": "Recevoir : {t}",
 "Recebimentos": "Encaissements",
 "Salário": "Salaire",
 "Salário (valor do mês)": "Salaire (montant du mois)",
 "Salário fixo": "Salaire fixe",
 "Telefone (RH ou financeiro)": "Téléphone (RH ou comptabilité)",
 "Tipo de pagamento": "Type de paiement",
 "Universidade": "Université",
 "Valor da hora-aula": "Tarif de l'heure de cours",
 "Valor de cada um (se for diferente)": "Montant de chacun (s'il est différent)",
 "Valor do plantão": "Tarif de la garde",
 "Valor por atendimento ou procedimento": "Montant par consultation ou acte",
 "Valor previsto": "Montant prévu",
 "feito": "effectué",
 "recebido em {d}": "reçu le {d}",
 "{n} aula(s) dada(s)": "{n} cours donné(s)",
 "{n} hora(s)-aula": "{n} heure(s) de cours",
 "{n} plantão(ões)": "{n} garde(s)",
 "Abas do My Planner Anne": "Onglets de My Planner Anne",
 "Acesso ao Não perturbe": "Accès à Ne pas déranger",
 "Alarme dos remédios (mesmo no silencioso)": "Alarme des médicaments (même en mode silencieux)",
 "Algodão-doce": "Barbe à papa",
 "Aplicar tema": "Appliquer le thème",
 "As cores próprias de cada tema: floral rosado, folhas verdes, céu azul...": "Les couleurs propres à chaque thème : floral rosé, feuilles vertes, ciel bleu...",
 "Assim ficam as letras no app.": "Voici l'aspect du texte dans l'app.",
 "Automática": "Automatique",
 "Baht tailandês": "Baht thaïlandais",
 "Boliviano": "Boliviano bolivien",
 "Bolívar venezuelano": "Bolívar vénézuélien",
 "Botão": "Bouton",
 "Buscar moeda": "Rechercher une devise",
 "Cor do desenho": "Couleur du dessin",
 "Coroa dinamarquesa": "Couronne danoise",
 "Coroa norueguesa": "Couronne norvégienne",
 "Coroa sueca": "Couronne suédoise",
 "Coroa tcheca": "Couronne tchèque",
 "Crepúsculo": "Crépuscule",
 "Crescente": "Croissante",
 "Curta": "Courte",
 "Despesas em outra moeda (fora do lucro): {v}": "Dépenses dans une autre devise (hors bénéfice) : {v}",
 "Dirham dos Emirados Árabes Unidos": "Dirham des Émirats arabes unis",
 "Dirham marroquino": "Dirham marocain",
 "Do seu país": "De votre pays",
 "Dong vietnamita": "Dông vietnamien",
 "Dupla": "Double",
 "Dólar americano": "Dollar américain",
 "Dólar australiano": "Dollar australien",
 "Dólar canadense": "Dollar canadien",
 "Dólar de Hong Kong": "Dollar de Hong Kong",
 "Dólar de Singapura": "Dollar de Singapour",
 "Dólar neozelandês": "Dollar néo-zélandais",
 "Envia todos os itens desta lista, inclusive os novos que forem criados depois.": "Envoie tous les éléments de cette liste, y compris ceux créés plus tard.",
 "Enviar todos para a equipe": "Tout envoyer à l'équipe",
 "Escolha se o alarme deste remédio deve tocar mesmo com o celular no silencioso.": "Choisissez si l'alarme de ce médicament doit sonner même lorsque le téléphone est en mode silencieux.",
 "Euro": "Euro",
 "Exemplo": "Exemple",
 "Falta uma resposta": "Il manque une réponse",
 "Folha, tema e cores da caneta e das letras": "Feuille, thème et couleurs du stylo et du texte",
 "Franco suíço": "Franc suisse",
 "Guarani paraguaio": "Guaraní paraguayen",
 "Hryvnia ucraniana": "Hryvnia ukrainienne",
 "Iene japonês": "Yen japonais",
 "Kwanza angolano": "Kwanza angolais",
 "Libra egípcia": "Livre égyptienne",
 "Libra esterlina": "Livre sterling",
 "Lira turca": "Livre turque",
 "Longa": "Longue",
 "Mais usadas": "Les plus utilisées",
 "Metical moçambicano": "Metical mozambicain",
 "Na página, segurar a bolinha faz o mesmo.": "Sur la page, maintenir la pastille enfoncée fait la même chose.",
 "Naira nigeriana": "Naira nigérian",
 "Nenhuma moeda encontrada": "Aucune devise trouvée",
 "No Android, para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "Sur Android, pour que l'alarme du médicament sonne avec \"Ne pas déranger\" activé, le téléphone doit autoriser l'accès à \"Ne pas déranger\" pour My Planner. Touchez \"Ouvrir les paramètres\", cherchez My Planner dans la liste et activez l'autorisation.",
 "No My Planner": "Dans My Planner",
 "No iPhone, o silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "Sur iPhone, le mode silencieux peut empêcher l'alarme. Laissez le téléphone en mode normal.",
 "No iPhone, o ▶ mostra uma ideia de cada tipo. Os avisos de verdade usam a vibração padrão do iPhone.": "Sur iPhone, ▶ donne une idée de chaque type. Les vraies alertes utilisent la vibration par défaut de l'iPhone.",
 "Novo dólar taiwanês": "Nouveau dollar de Taïwan",
 "Novo shekel israelense": "Nouveau shekel israélien",
 "Ouvir/Sentir": "Écouter/Ressentir",
 "Peso argentino": "Peso argentin",
 "Peso chileno": "Peso chilien",
 "Peso colombiano": "Peso colombien",
 "Peso filipino": "Peso philippin",
 "Peso mexicano": "Peso mexicain",
 "Peso uruguaio": "Peso uruguayen",
 "Política de privacidade": "Politique de confidentialité",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer em silêncio.": "C'est fait. Verrouillez l'écran et attendez 1 minute : l'alerte doit apparaître en silence.",
 "Pronto. Bloqueie a tela e espere 1 minuto: o aviso deve aparecer vibrando, sem som.": "C'est fait. Verrouillez l'écran et attendez 1 minute : l'alerte doit apparaître en vibrant, sans son.",
 "Páginas e canetas": "Pages et stylos",
 "Pôr do sol": "Coucher de soleil",
 "Rand sul-africano": "Rand sud-africain",
 "Real brasileiro": "Réal brésilien",
 "Ringgit malaio": "Ringgit malaisien",
 "Riyal saudita": "Riyal saoudien",
 "Rublo russo": "Rouble russe",
 "Rupia indiana": "Roupie indienne",
 "Rupia indonésia": "Roupie indonésienne",
 "Rupia paquistanesa": "Roupie pakistanaise",
 "Se o My Planner não aparecer na lista, essa permissão chega na próxima versão do app (atualize pela loja).": "Si My Planner n'apparaît pas dans la liste, cette autorisation arrive dans la prochaine version de l'app (mettez à jour via la boutique).",
 "Sentir": "Ressentir",
 "Sol peruano": "Sol péruvien",
 "São as cores rápidas da caneta e das letras nas páginas. A primeira é a cor padrão ao abrir uma página. Toque numa bolinha para trocar a cor dela.": "Ce sont les couleurs rapides du stylo et du texte sur les pages. La première est la couleur par défaut à l'ouverture d'une page. Touchez une pastille pour changer sa couleur.",
 "Taka bengali": "Taka bangladais",
 "Teste grátis por {n} dias": "Essai gratuit pendant {n} jours",
 "Tipo de vibração": "Type de vibration",
 "Tirar do My Planner": "Retirer de My Planner",
 "Tocar mesmo no silencioso e no Não perturbe": "Sonner même en mode silencieux et Ne pas déranger",
 "Tocar só se o celular estiver no normal": "Sonner seulement si le téléphone est en mode normal",
 "Todos os itens desta lista aparecem no My Planner, inclusive os novos.": "Tous les éléments de cette liste apparaissent dans My Planner, y compris les nouveaux.",
 "Vaga-lume": "Luciole",
 "Vale para todos os avisos que vibram (Vibração e Som e vibração).": "S'applique à toutes les alertes qui vibrent (Vibration et Son et vibration).",
 "Won sul-coreano": "Won sud-coréen",
 "Xelim queniano": "Shilling kényan",
 "Yuan chinês": "Yuan chinois",
 "Zloty polonês": "Złoty polonais",
 "🔕🔇 O alarme deste remédio deve tocar mesmo com o celular no silencioso?": "🔕🔇 L'alarme de ce médicament doit-elle sonner même en mode silencieux ?",
 "A galeria de fotos chega na próxima versão do app. Por enquanto, use Arquivos ou Tirar foto.": "La galerie photos arrive dans la prochaine version de l'app. Pour l'instant, utilisez Fichiers ou Prendre une photo.",
 "Abrir o fichário do grupo": "Ouvrir le classeur du groupe",
 "Arrastar a barra": "Faire glisser la barre",
 "Assim que o fichário for compartilhado, ele aparece aqui.": "Dès que le classeur est partagé, il apparaît ici.",
 "Buscar ícone pelo nome (ex.: livro, casa, café)": "Rechercher une icône par nom (ex. : livre, maison, café)",
 "Com a aba Estudos você cria seus fichários, usa o cronômetro, acompanha seu relatório e muito mais. ✨": "Avec l'onglet Études, vous créez vos classeurs, utilisez le chronomètre, suivez votre rapport et bien plus. ✨",
 "Com a aba {aba} você cria o que é seu e usa todos os recursos. ✨": "Avec l'onglet {aba}, vous créez ce qui vous appartient et utilisez toutes les fonctionnalités. ✨",
 "Conhecer a aba": "Découvrir l'onglet",
 "Crie um fichário em Estudos e volte aqui.": "Créez un classeur dans Études et revenez ici.",
 "Em sessão": "En session",
 "Encerrar e salvar o cronômetro e começar a sessão?": "Arrêter et enregistrer le chronomètre, puis démarrer la session ?",
 "Encerrar e salvar o cronômetro e continuar a sessão?": "Arrêter et enregistrer le chronomètre, puis continuer la session ?",
 "Enquadre e toque no botão": "Cadrez puis touchez le bouton",
 "Escolha o fichário que os colegas vão ver na tela (só para ler).": "Choisissez le classeur que vos camarades verront à l'écran (lecture seule).",
 "Esconder": "Masquer",
 "Este arquivo está guardado só no dispositivo ou no Drive de quem compartilhou, por isso não aparece aqui.": "Ce fichier est enregistré uniquement sur l'appareil ou dans le Drive de la personne qui l'a partagé, il n'apparaît donc pas ici.",
 "Fichário do grupo": "Classeur du groupe",
 "Guia passo a passo do app e de cada aba": "Guide pas à pas de l'app et de chaque onglet",
 "Há um cronômetro em andamento.": "Un chronomètre est en cours.",
 "Há uma sessão em andamento.": "Une session est en cours.",
 "Inserir imagem": "Insérer une image",
 "Mais ícones": "Plus d'icônes",
 "Nenhum ícone com esse nome. Tente outra palavra ou escolha numa categoria.": "Aucune icône avec ce nom. Essayez un autre mot ou choisissez une catégorie.",
 "Nenhuma matéria neste fichário ainda.": "Aucune matière dans ce classeur pour l'instant.",
 "Nenhuma página nesta matéria ainda.": "Aucune page dans cette matière pour l'instant.",
 "No grupo de estudos, imagens e PDFs abrem aqui na tela. Este tipo de arquivo não tem visualização dentro do app.": "Dans le groupe d'étude, les images et les PDF s'ouvrent ici à l'écran. Ce type de fichier ne peut pas être affiché dans l'app.",
 "Não deu para mostrar agora. Confira a internet e tente de novo.": "Impossible d'afficher pour le moment. Vérifiez votre connexion internet et réessayez.",
 "O compartilhamento de fichários ainda está sendo preparado. Volte daqui a pouco.": "Le partage des classeurs est encore en préparation. Revenez dans un instant.",
 "O fichário deste grupo está em outro dispositivo seu. Ele continua compartilhado a partir de lá.": "Le classeur de ce groupe se trouve sur un autre de vos appareils. Il reste partagé depuis celui-ci.",
 "OK = Conhecer a aba · Cancelar = Agora não": "OK = Découvrir l'onglet · Annuler = Pas maintenant",
 "Os colegas deixam de ver o fichário. Tudo continua com você.": "Vos camarades ne verront plus le classeur. Tout reste chez vous.",
 "Os colegas veem este fichário na tela, só para ler: não editam, não baixam, não imprimem e não compartilham. As suas metas, o cronômetro e as páginas revisadas continuam só seus.": "Vos camarades voient ce classeur à l'écran, en lecture seule : ils ne peuvent ni le modifier, ni le télécharger, ni l'imprimer, ni le partager. Vos objectifs, le chronomètre et les pages révisées restent à vous seul.",
 "Para ver PDFs aqui na tela, instale a versão mais nova do app pela loja.": "Pour afficher les PDF ici à l'écran, installez la dernière version de l'app depuis le store.",
 "Parar de compartilhar": "Arrêter le partage",
 "Pausar a sessão": "Mettre la session en pause",
 "Pausar a sessão e estudar só esta?": "Mettre la session en pause et étudier seulement celle-ci ?",
 "Página em branco.": "Page blanche.",
 "Quer estudar com tudo isso?": "Envie d'étudier avec tout ça ?",
 "Quer usar tudo isso?": "Envie d'utiliser tout ça ?",
 "Selecionar todos": "Tout sélectionner",
 "Trocar fichário": "Changer de classeur",
 "Você está participando do grupo de {nome}": "Vous participez au groupe de {nome}",
 "Você vê na tela o que foi compartilhado neste grupo, para ler e acompanhar.": "Vous voyez à l'écran ce qui a été partagé dans ce groupe, pour lire et suivre.",
 "abacate, fruta": "avocat, fruit",
 "academia, musculação, treino, peso": "salle de sport, musculation, entraînement, poids",
 "acampamento, camping": "campement, camping",
 "alfinete, fixar, importante": "épingle, punaise, important",
 "almoço, arroz, prato": "déjeuner, riz, assiette",
 "alvo, meta, objetivo, foco": "cible, but, objectif, concentration",
 "aniversário, bolo": "anniversaire, gâteau",
 "anotação, nota, lista, escrever": "annotation, note, liste, écrire",
 "arco-íris": "arc-en-ciel",
 "avião, viagem, voo": "avion, voyage, vol",
 "balança, direito, justiça, lei, processo": "balance, droit, justice, loi, procès",
 "balde, limpeza": "seau, ménage",
 "banana, fruta": "banane, fruit",
 "banheira, banho, banheiro": "baignoire, bain, salle de bain",
 "barbear, barba, lâmina": "rasage, barbe, rasoir",
 "bicicleta, pedalar, bike": "vélo, pédaler, bicyclette",
 "bolo, doce, sobremesa": "gâteau, sucré, dessert",
 "brilho, mágica": "étincelles, magie",
 "cabelo, cabeleireiro, corte": "cheveux, coiffeur, coupe",
 "cachorro, cão, pet": "chien, toutou, animal de compagnie",
 "caderno": "cahier",
 "caderno, fichário, amarelo": "cahier, classeur, jaune",
 "café, xícara, pausa": "café, tasse, pause",
 "caixa, pacote, mudança, entrega": "boîte, colis, déménagement, livraison",
 "calendário, agenda, data": "calendrier, agenda, date",
 "cama, quarto": "lit, chambre",
 "caminhada, caminhar, andar": "marche, marcher, promenade",
 "camisa, gravata, roupa, trabalho": "chemise, cravate, vêtements, travail",
 "carne, churrasco": "viande, barbecue",
 "carrinho, mercado, compras, supermercado": "chariot, marché, courses, supermarché",
 "carro, dirigir, veículo": "voiture, conduire, véhicule",
 "certo, feito, visto": "coche, fait, validé",
 "cesto, roupa, lavanderia, lavar roupa": "panier, linge, laverie, lessive",
 "chave de fenda, ferramenta, conserto": "tournevis, outil, réparation",
 "chave, senha": "clé, mot de passe",
 "chocolate, doce": "chocolat, sucré",
 "chuveiro, banho": "douche, bain",
 "chá, xícara": "thé, tasse",
 "compras, sacolas, shopping": "shopping, sacs, centre commercial",
 "computador, monitor, tela": "ordinateur, écran, moniteur",
 "computador, notebook, informática": "ordinateur, portable, informatique",
 "coração amarelo": "cœur jaune",
 "coração azul": "cœur bleu",
 "coração branco": "cœur blanc",
 "coração laranja": "cœur orange",
 "coração roxo": "cœur violet",
 "coração verde": "cœur vert",
 "coração, amor, saúde, vermelho": "cœur, amour, santé, rouge",
 "corrida, correr": "course, courir",
 "creme, hidratante, pele, skincare": "crème, hydratant, peau, soin",
 "croissant, pão, café da manhã": "croissant, pain, petit-déjeuner",
 "câmera, foto, fotografia": "appareil photo, photo, photographie",
 "cérebro, mente, memória, pensar": "cerveau, esprit, mémoire, penser",
 "dado, jogo de tabuleiro": "dé, jeu de société",
 "dente, dentista": "dent, dentiste",
 "despertador, relógio, alarme, acordar": "réveil, horloge, alarme, se réveiller",
 "diamante, joia": "diamant, bijou",
 "dinheiro, pagar, conta, pagamento": "argent, payer, facture, paiement",
 "dormir, sono, descanso": "dormir, sommeil, repos",
 "e-mail, mensagem, carta": "e-mail, message, lettre",
 "escada": "escalier",
 "escova de dentes, dentes": "brosse à dents, dents",
 "escrever, redação, caneta": "écrire, rédaction, stylo",
 "esponja, lavar louça": "éponge, faire la vaisselle",
 "esquadro, régua, geometria, desenho técnico": "équerre, règle, géométrie, dessin technique",
 "estrela brilhante, destaque": "étoile brillante, à la une",
 "estrela, favorito": "étoile, favori",
 "etiqueta, marcador": "étiquette, marqueur",
 "extintor, segurança, incêndio": "extincteur, sécurité, incendie",
 "falar, idioma, inglês, conversa": "parler, langue, anglais, conversation",
 "feito, concluído, certo": "fait, terminé, validé",
 "ferramenta, conserto, manutenção": "outil, réparation, entretien",
 "festa, comemoração": "fête, célébration",
 "filme, cinema, série": "film, cinéma, série",
 "fogo, urgente, sequência": "feu, urgent, série",
 "folha, natureza, erva, chá": "feuille, nature, herbe, thé",
 "fone de ouvido, áudio, música, podcast": "casque, audio, musique, podcast",
 "formatura, capelo, faculdade, diploma, universidade": "remise de diplôme, toque, fac, diplôme, université",
 "força, braço, músculo": "force, bras, muscle",
 "frango, coxa": "poulet, cuisse",
 "frigideira, cozinhar, ovo, cozinha": "poêle, cuisiner, œuf, cuisine",
 "futebol, bola, esporte": "football, ballon, sport",
 "gato, pet": "chat, animal de compagnie",
 "gelo, geladeira, congelador": "glace, frigo, congélateur",
 "gráfico, planilha, finanças, relatório": "graphique, tableur, finances, rapport",
 "ingresso, show, evento": "billet, concert, événement",
 "jogo, videogame, game": "jeu, jeu vidéo, gaming",
 "lancha, barco": "vedette, bateau",
 "leite, copo": "lait, verre",
 "letras, alfabeto, português": "lettres, alphabet, français",
 "link, corrente": "lien, chaîne",
 "livro aberto, leitura, ler": "livre ouvert, lecture, lire",
 "livro azul, caderno": "livre bleu, cahier",
 "livro laranja, caderno": "livre orange, cahier",
 "livro verde, caderno": "livre vert, cahier",
 "livro vermelho, caderno": "livre rouge, cahier",
 "livros, estudo, estudar, biblioteca": "livres, étude, étudier, bibliothèque",
 "lixo, lixeira": "déchets, poubelle",
 "lua, noite": "lune, nuit",
 "lâmpada, ideia, luz": "ampoule, idée, lumière",
 "macarrão, massa": "nouilles, pâtes",
 "maleta, trabalho, escritório, negócios": "mallette, travail, bureau, affaires",
 "massagem, relaxar": "massage, se détendre",
 "maçã, fruta": "pomme, fruit",
 "microfone, cantar, karaokê, palestra": "micro, chanter, karaoké, conférence",
 "microscópio, ciência, biologia": "microscope, science, biologie",
 "mochila, escola, filhos": "sac à dos, école, enfants",
 "montanha, trilha": "montagne, randonnée",
 "mundo, planeta, geografia": "monde, planète, géographie",
 "médico, consulta, exame, saúde": "médecin, consultation, examen, santé",
 "música, nota musical": "musique, note de musique",
 "natação, nadar, piscina": "natation, nager, piscine",
 "olho, visão, oftalmologista": "œil, vue, ophtalmologue",
 "oração, orar, gratidão, igreja": "prière, prier, gratitude, église",
 "ovo": "œuf",
 "pastas, arquivo, fichário, divisórias": "dossiers, archive, classeur, intercalaires",
 "peixe": "poisson",
 "pescaria, pescar": "pêche, pêcher",
 "pessoas, reunião, equipe, grupo": "personnes, réunion, équipe, groupe",
 "piano, teclado musical": "piano, clavier",
 "pintura, arte, desenho": "peinture, art, dessin",
 "pipa": "cerf-volant",
 "pipoca, cinema": "pop-corn, cinéma",
 "pizza": "pizza",
 "planta, vaso, regar": "plante, pot, arroser",
 "porta, entrada": "porte, entrée",
 "praia, férias": "plage, vacances",
 "prato, refeição, louça, jantar": "assiette, repas, vaisselle, dîner",
 "prédio, história, governo, tribunal": "bâtiment, histoire, gouvernement, tribunal",
 "pão, padaria": "pain, boulangerie",
 "pé, podólogo": "pied, podologue",
 "pôr do sol, amanhecer": "coucher de soleil, lever du soleil",
 "quebra-cabeça, peça": "puzzle, pièce",
 "queijo": "fromage",
 "raio, energia, rápido": "éclair, énergie, rapide",
 "refrigerante, suco, bebida": "soda, jus, boisson",
 "remédio, medicamento, vitamina, farmácia": "remède, médicament, vitamine, pharmacie",
 "sabão, sabonete, lavar": "savon, savonnette, laver",
 "salada, dieta, verdura": "salade, régime, légumes",
 "sanduíche, lanche": "sandwich, en-cas",
 "sino, aviso, lembrete": "cloche, alerte, rappel",
 "skate": "skateboard",
 "sofá, sala": "canapé, salon",
 "sol, manhã, dia": "soleil, matin, jour",
 "spa, sauna, autocuidado": "spa, sauna, prendre soin de soi",
 "teatro, máscaras": "théâtre, masques",
 "telefone, ligação, ligar": "téléphone, appel, appeler",
 "tigela, cereal, sopa, mingau": "bol, céréales, soupe, porridge",
 "trevo, sorte": "trèfle, chance",
 "troféu, conquista, prêmio": "trophée, réussite, prix",
 "tubo de ensaio, química, laboratório": "éprouvette, chimie, laboratoire",
 "tênis, esporte": "baskets, sport",
 "unha, manicure": "ongle, manucure",
 "vassoura, limpeza, faxina, varrer": "balai, ménage, nettoyage, balayer",
 "violão, guitarra": "guitare, guitare acoustique",
 "yoga, meditação, alongamento": "yoga, méditation, étirements",
 "{n} selecionada": "{n} sélectionnée",
 "{n} selecionadas": "{n} sélectionnées",
 "{n} selecionado": "{n} sélectionné",
 "{n} selecionados": "{n} sélectionnés",
 "ábaco, matemática, contas, cálculo, contabilidade": "boulier, maths, calculs, calcul, comptabilité",
 "água, gota, hidratar": "eau, goutte, s'hydrater",
 "árvore, jardim, quintal": "arbre, jardin, cour",
 "ônibus, transporte": "bus, transport",
 "1 dia antes": "1 jour avant",
 "1 dia depois": "1 jour après",
 "A assinatura é feita no app do celular, pela loja de apps, e vale também aqui no site.": "L'abonnement se fait dans l'app du téléphone, via la boutique d'apps, et il est aussi valable ici sur le site.",
 "A chave está incompleta (curta demais). Copie de novo pelo botão de copiar da página da chave.": "La clé est incomplète (trop courte). Copiez-la à nouveau avec le bouton de copie de la page de la clé.",
 "A chave tem caracteres que não fazem parte de uma chave. Copie de novo, só a chave, sem texto em volta.": "La clé contient des caractères qui ne font pas partie d'une clé. Copiez-la à nouveau, uniquement la clé, sans texte autour.",
 "A galeria chega na próxima atualização do app.": "La galerie arrive dans la prochaine mise à jour de l'app.",
 "ALERTAS": "ALERTES",
 "Abra uma aba paga e comece o teste grátis. Depois volte aqui.": "Ouvrez un onglet payant et commencez l'essai gratuit. Puis revenez ici.",
 "Abrir a barra do editor": "Ouvrir la barre de l'éditeur",
 "Agora é horário do Não perturbe do app: o aviso chega em até 5 segundos, sem som nem vibração.": "C'est maintenant l'horaire Ne pas déranger de l'app : la notification arrive en 5 secondes maximum, sans son ni vibration.",
 "Aguardando confirmação": "En attente de confirmation",
 "Aguardando envio ao My Planner": "En attente d'envoi vers My Planner",
 "Alertas de cada fatura": "Alertes pour chaque facture",
 "Alertas do fim da garantia": "Alertes de fin de garantie",
 "Alertas do vencimento": "Alertes d'échéance",
 "Alertas: {campo}": "Alertes : {campo}",
 "Alvorada": "Point du jour",
 "Ao abrir esta aba, o app pede o mesmo desbloqueio do app (senha, biometria ou PIN). Dá para mudar em Ajustes > Abas.": "À l'ouverture de cet onglet, l'app demande le même déverrouillage que l'app (mot de passe, biométrie ou PIN). Vous pouvez le modifier dans Réglages > Onglets.",
 "Ao tocar num arquivo anexado, ele abre no app do celular que você escolher (se o celular perguntar, \"Apenas uma vez\" ou \"Sempre\"). O que você editar lá fica salvo no próprio arquivo.": "Quand vous touchez un fichier joint, il s'ouvre dans l'app du téléphone de votre choix (si le téléphone le demande, « Une seule fois » ou « Toujours »). Ce que vous y modifiez est enregistré dans le fichier lui-même.",
 "App instalado": "App installée",
 "Apple Watch: já grava tudo no app Saúde do celular. Não precisa fazer nada.": "Apple Watch : elle enregistre déjà tout dans l'app Santé du téléphone. Vous n'avez rien à faire.",
 "Arquivados e fixados": "Archivés et épinglés",
 "Arquivo para ler e guardar, organizado por aba. Gerado em {data}.": "Fichier à lire et à conserver, organisé par onglet. Généré le {data}.",
 "As notificações do My Planner estão desligadas no celular.": "Les notifications de My Planner sont désactivées sur le téléphone.",
 "Atualização automática disponível no app instalado.": "Mise à jour automatique disponible dans l'app installée.",
 "Aurora": "Aurore",
 "Avisos: alarme (som)": "Notifications : alarme (son)",
 "Baixar o app": "Télécharger l'app",
 "Baixar o arquivo técnico": "Télécharger le fichier technique",
 "Baixar para ler (PDF)": "Télécharger pour lire (PDF)",
 "Barra do editor (caneta, marca-texto, texto)": "Barre de l'éditeur (stylo, surligneur, texte)",
 "Brisa": "Brise",
 "Campainha": "Sonnette",
 "Canal": "Canal",
 "Cole a chave antes de testar.": "Collez la clé avant de tester.",
 "Começa em": "Commence le",
 "Como avisar": "Comment notifier",
 "Confira a chave": "Vérifiez la clé",
 "Conta de teste de compras": "Compte de test des achats",
 "Conta vencida": "Facture échue",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-\".": "Copiez la clé tout de suite (elle n'apparaît qu'une fois). Elle commence par \"sk-\".",
 "Copie a chave na hora (ela só aparece uma vez). Começa com \"sk-ant-\".": "Copiez la clé tout de suite (elle n'apparaît qu'une fois). Elle commence par \"sk-ant-\".",
 "Cristal": "Cristal",
 "Daqui a 1 hora": "Dans 1 heure",
 "Daqui a 1 semana": "Dans 1 semaine",
 "Daqui a 3 dias": "Dans 3 jours",
 "Depois de 5 min fora": "Après 5 min d'absence",
 "Depois de 5 minutos fora": "Après 5 minutes d'absence",
 "Desligar a senha desta aba": "Désactiver le mot de passe de cet onglet",
 "Detalhes técnicos": "Détails techniques",
 "Dia {n} de {t}": "Jour {n} sur {t}",
 "Dica: a chave é como uma senha. Não mande por mensagem nem publique. Se vazar, apague-a no site e crie outra.": "Astuce : la clé est comme un mot de passe. Ne l'envoyez pas par message et ne la publiez pas. En cas de fuite, supprimez-la sur le site et créez-en une autre.",
 "Documento vencido": "Document expiré",
 "Ela abre em {d}.": "Elle s'ouvre le {d}.",
 "Ela abre em {d}. Você vai receber avisos: {quando}.": "Elle s'ouvre le {d}. Vous recevrez des notifications : {quando}.",
 "Ela abre em {d}. Você vai receber um aviso: {quando}.": "Elle s'ouvre le {d}. Vous recevrez une notification : {quando}.",
 "Em \"API keys\", toque em \"Create key\" (Criar chave) e dê um nome, por exemplo \"My Planner\".": "Dans \"API keys\", touchez \"Create key\" (Créer une clé) et donnez-lui un nom, par exemple \"My Planner\".",
 "Em \"Billing\" (Cobrança), adicione um cartão e alguns dólares de crédito. A assinatura ChatGPT Plus não vale aqui.": "Dans \"Billing\" (Facturation), ajoutez une carte et quelques dollars de crédit. L'abonnement ChatGPT Plus n'est pas valable ici.",
 "Em \"Billing\" (Cobrança), compre créditos. A assinatura Claude Pro não vale aqui.": "Dans \"Billing\" (Facturation), achetez des crédits. L'abonnement Claude Pro n'est pas valable ici.",
 "Em breve": "Bientôt disponible",
 "Entre com a mesma conta do ChatGPT ou crie uma.": "Connectez-vous avec le même compte que ChatGPT ou créez-en un.",
 "Entre com a sua conta Google (a mesma do Gmail serve).": "Connectez-vous avec votre compte Google (celui de Gmail convient).",
 "Entre ou crie uma conta (pode ser o mesmo e-mail do Claude).": "Connectez-vous ou créez un compte (vous pouvez utiliser la même adresse e-mail que pour Claude).",
 "Enviados para o My Planner": "Envoyés vers My Planner",
 "Enviar agora": "Envoyer maintenant",
 "Escolha hoje ou uma data futura.": "Choisissez aujourd'hui ou une date future.",
 "Escolhas lembradas": "Choix mémorisés",
 "Escolher a data": "Choisir la date",
 "Escolher células": "Choisir des cellules",
 "Escolher quando": "Choisir quand",
 "Espessura": "Épaisseur",
 "Esquecer": "Oublier",
 "Esta chave é de outro serviço ({servico}). Aqui funcionam só chaves do Claude, do ChatGPT ou do Gemini.": "Cette clé provient d'un autre service ({servico}). Seules les clés Claude, ChatGPT ou Gemini fonctionnent ici.",
 "Esta chave é do {ia}, não do {escolhida}.": "Cette clé est pour {ia}, pas pour {escolhida}.",
 "Esta conta vê o app como uma conta nova, sem nenhuma aba liberada, para conferir os cadeados, o teste grátis e a compra. As outras contas não mudam.": "Ce compte voit l'app comme un nouveau compte, sans aucun onglet débloqué, pour vérifier les cadenas, l'essai gratuit et l'achat. Les autres comptes ne changent pas.",
 "Esta ferramenta precisa ver as páginas do PDF, o que chega com o app novo (versão 0.50). Use o navegador ou atualize o My Planner pela loja.": "Cet outil doit voir les pages du PDF, ce qui arrive avec la nouvelle app (version 0.50). Utilisez le navigateur ou mettez à jour My Planner depuis la boutique.",
 "Esta não parece uma chave do {ia}. As chaves do {ia} começam com {ini}.": "Cela ne ressemble pas à une clé {ia}. Les clés {ia} commencent par {ini}.",
 "Este aviso está em \"Desligado\": nada vai tocar.": "Cette notification est réglée sur « Désactivée » : rien ne sonnera.",
 "Este celular ainda não recebe avisos com o app fechado. Atualize o My Planner pela loja (versão {v} ou mais nova). Com o app aberto, os avisos já funcionam.": "Ce téléphone ne reçoit pas encore de notifications quand l'app est fermée. Mettez à jour My Planner depuis la boutique (version {v} ou plus récente). Avec l'app ouverte, les notifications fonctionnent déjà.",
 "Este tipo de aviso está desligado nas configurações de notificação do celular.": "Ce type de notification est désactivé dans les réglages de notification du téléphone.",
 "Estudado": "Étudié",
 "Estudado: {dur}": "Étudié : {dur}",
 "Faltou: {dur}": "Manquant : {dur}",
 "Fazer os testes terminarem agora": "Faire terminer les essais maintenant",
 "Fechar a barra do editor": "Fermer la barre de l'éditeur",
 "Fichário": "Classeur",
 "Figurinhas e emojis": "Autocollants et emojis",
 "Garantia terminou": "Garantie terminée",
 "Gerando…": "Génération…",
 "Guarda documentos, exames e histórico de saúde com uma senha só dele. Nem o suporte consegue ler. Se você esquecer a senha, não há como recuperar.": "Conserve documents, résultats d'examens et historique de santé avec son propre mot de passe. Même le support ne peut pas le lire. Si vous oubliez le mot de passe, il est impossible de le récupérer.",
 "Harpa": "Harpe",
 "Horas por dia": "Heures par jour",
 "Identificação": "Identification",
 "Isso parece um link ou um e-mail, não uma chave. Copie a chave inteira na página de chaves de API.": "Cela ressemble à un lien ou à une adresse e-mail, pas à une clé. Copiez la clé entière sur la page des clés d'API.",
 "Isto só aparece no My Planner se você enviar. Quer enviar agora?": "Ceci n'apparaît dans My Planner que si vous l'envoyez. L'envoyer maintenant ?",
 "Já dá para confirmar {titulo}?": "Pouvez-vous déjà confirmer {titulo} ?",
 "Lembrar minha escolha nesta aba": "Mémoriser mon choix dans cet onglet",
 "Lembrete para confirmar: {data}": "Rappel pour confirmer : {data}",
 "Marimba": "Marimba",
 "Marque pelo menos um dia da semana no plano.": "Cochez au moins un jour de la semaine dans le plan.",
 "Me lembre de confirmar": "Me rappeler de confirmer",
 "Me lembre depois": "Me le rappeler plus tard",
 "Menos": "Moins",
 "Meta somada": "Objectif cumulé",
 "Meta somada: {dur}": "Objectif cumulé : {dur}",
 "Meus dados - My Planner {data}": "Mes données - My Planner {data}",
 "Meus dados do My Planner": "Mes données My Planner",
 "Mostrar a barra": "Afficher la barre",
 "Mudar senha do diário": "Changer le mot de passe du journal",
 "Na primeira vez, aceite os termos de uso.": "La première fois, acceptez les conditions d'utilisation.",
 "Na versão das lojas, a compra será pela loja de apps do celular. Por enquanto a chave simula a assinatura para testes.": "Dans la version des boutiques, l'achat se fera via la boutique d'apps du téléphone. Pour l'instant, la clé simule l'abonnement pour les tests.",
 "Nada de outras abas vai sozinho para o My Planner. Estes itens têm data e ainda não foram enviados.": "Rien des autres onglets ne part tout seul vers My Planner. Ces éléments ont une date et n'ont pas encore été envoyés.",
 "Nenhum estudo registrado neste mês.": "Aucune étude enregistrée ce mois-ci.",
 "Nenhum item aguardando envio.": "Aucun élément en attente d'envoi.",
 "Nenhum teste começado": "Aucun essai commencé",
 "Nesta tela não há nada para adicionar.": "Il n'y a rien à ajouter sur cet écran.",
 "No dia": "Le jour même",
 "Nova nota rápida": "Nouvelle note rapide",
 "Nova página do dia": "Nouvelle page du jour",
 "Não deu certo": "Ça n'a pas marché",
 "Não entram: o conteúdo do Diário e os campos do cofre (ficam protegidos pela senha), fotos e arquivos anexados. Para restaurar os dados no app, use o arquivo técnico.": "Non inclus : le contenu du Journal et les champs du coffre (protégés par le mot de passe), les photos et les fichiers joints. Pour restaurer les données dans l'app, utilisez le fichier technique.",
 "Não foi possível gerar o PDF.": "Impossible de générer le PDF.",
 "Não foi possível testar agora. Tente de novo em alguns segundos.": "Impossible de tester maintenant. Réessayez dans quelques secondes.",
 "Não lembrar": "Ne pas mémoriser",
 "Não, obrigada": "Non, merci",
 "O Diário é protegido pela senha dele e não entra neste arquivo.": "Le Journal est protégé par son propre mot de passe et n'est pas inclus dans ce fichier.",
 "O app abre \"Salvar em Arquivos\" para você escolher a pasta (pode ser o iCloud Drive).": "L'app ouvre « Enregistrer dans Fichiers » pour que vous choisissiez le dossier (cela peut être iCloud Drive).",
 "O app guarda só o atalho do arquivo escolhido: ele continua onde está (Drive, OneDrive, Downloads) e abre no app do celular. Nada é copiado. Esta opção vale para as fotos tiradas pela câmera.": "L'app ne garde que le raccourci du fichier choisi : il reste où il est (Drive, OneDrive, Téléchargements) et s'ouvre dans l'app du téléphone. Rien n'est copié. Cette option s'applique aux photos prises avec l'appareil photo.",
 "O app instalado neste dispositivo é a versão {v}. Para fazer chamadas de áudio e vídeo, atualize o My Planner pela loja (versão 0.35 ou mais nova). As mensagens já funcionam.": "L'app installée sur cet appareil est la version {v}. Pour passer des appels audio et vidéo, mettez à jour My Planner depuis la boutique (version 0.35 ou plus récente). Les messages fonctionnent déjà.",
 "O aviso vai chegar em silêncio, direto na lista de notificações: ligue os alertas do My Planner nas configurações do celular.": "La notification arrivera en silence, directement dans la liste des notifications : activez les alertes de My Planner dans les réglages du téléphone.",
 "O aviso vai chegar sem som: o som deste tipo de aviso foi desligado nas configurações do celular.": "La notification arrivera sans son : le son de ce type de notification a été désactivé dans les réglages du téléphone.",
 "O aviso vai chegar, mas o som das notificações do My Planner está desligado no celular.": "La notification arrivera, mais le son des notifications de My Planner est désactivé sur le téléphone.",
 "O convite leva o link para baixar o app. Quem entra pelo link cai direto no escritório.": "L'invitation contient le lien pour télécharger l'app. Ceux qui rejoignent par le lien arrivent directement au cabinet.",
 "O ditado chega com a versão nova do app. Atualize o My Planner pela loja para usar o microfone.": "La dictée arrive avec la nouvelle version de l'app. Mettez à jour My Planner depuis la boutique pour utiliser le micro.",
 "O mesmo desbloqueio do app: senha, biometria ou PIN. Pede uma vez ao entrar; dentro da aba não pede de novo. Abrir a galeria, a câmera ou os arquivos não conta como sair. Itens grandes continuam pedindo a senha para excluir.": "Le même déverrouillage que l'app : mot de passe, biométrie ou PIN. Il est demandé une fois à l'entrée ; dans l'onglet, il n'est plus redemandé. Ouvrir la galerie, l'appareil photo ou les fichiers ne compte pas comme une sortie. Les éléments importants demandent toujours le mot de passe pour être supprimés.",
 "O modo silencioso do celular pode impedir o alarme. Deixe o celular no modo normal.": "Le mode silencieux du téléphone peut empêcher l'alarme. Laissez le téléphone en mode normal.",
 "O plano fica só em Estudos (não vai para o My Planner).": "Le plan reste uniquement dans Études (il ne va pas dans My Planner).",
 "Opcional: prazo, horas por dia e dias da semana.": "Facultatif : échéance, heures par jour et jours de la semaine.",
 "Os avisos do celular funcionam no app instalado.": "Les notifications du téléphone fonctionnent dans l'app installée.",
 "Os avisos no celular funcionam no app instalado.": "Les notifications sur le téléphone fonctionnent dans l'app installée.",
 "Os testes começados terminaram. Abra a aba para ver \"O teste grátis terminou\".": "Les essais commencés sont terminés. Ouvrez l'onglet pour voir « L'essai gratuit est terminé ».",
 "Outros dados": "Autres données",
 "Ouvir": "Écouter",
 "Pacote em uso": "Pack utilisé",
 "Para assinar, atualize o My Planner pela loja de apps do celular.": "Pour vous abonner, mettez à jour My Planner depuis la boutique d'apps du téléphone.",
 "Para ler (PDF): organizado por aba, com títulos e datas. Abre em qualquer dispositivo ou computador.": "À lire (PDF) : organisé par onglet, avec titres et dates. S'ouvre sur n'importe quel appareil ou ordinateur.",
 "Para o alarme do remédio tocar com o \"Não perturbe\" ligado, o celular precisa permitir o acesso ao \"Não perturbe\" para o My Planner. Toque em \"Abrir configurações\", procure o My Planner na lista e ligue a permissão.": "Pour que l'alarme du médicament sonne avec « Ne pas déranger » activé, le téléphone doit autoriser My Planner à accéder à « Ne pas déranger ». Touchez « Ouvrir les réglages », cherchez My Planner dans la liste et activez l'autorisation.",
 "Passo a passo para criar a chave": "Étapes pour créer la clé",
 "Pedir de novo": "Redemander",
 "Pedir senha ao abrir esta aba": "Demander le mot de passe à l'ouverture de cet onglet",
 "Plano com período": "Plan avec période",
 "Plano começa em {d}": "Le plan commence le {d}",
 "Por matéria": "Par matière",
 "Prolongar": "Prolonger",
 "Pronto: o aviso chega em até 5 segundos, com som. Se não tocar, confira se o celular está no silencioso.": "C'est fait : la notification arrive en 5 secondes maximum, avec son. Si rien ne sonne, vérifiez que le téléphone n'est pas en silencieux.",
 "Pronto: o aviso chega em até 5 segundos, só vibrando.": "C'est fait : la notification arrive en 5 secondes maximum, en vibration seulement.",
 "Publicado em": "Publié le",
 "Pulso": "Pulsation",
 "Quando o app bloquear": "Quand l'app se verrouille",
 "Quer proteger esta aba com senha?": "Voulez-vous protéger cet onglet par un mot de passe ?",
 "Recolher ou arrastar a barra": "Réduire ou faire glisser la barre",
 "Recomeçar os testes grátis": "Relancer les essais gratuits",
 "Recomeçar os testes grátis?": "Relancer les essais gratuits ?",
 "Rolar a folha para os lados": "Faire défiler la feuille sur les côtés",
 "Se você conectar o relógio: totais de cada dia de passos, distância, calorias, exercício, batimentos e sono, lidos do Health Connect ou do app Saúde do celular. O app só lê e nunca altera esses dados.": "Si vous connectez la montre : totaux quotidiens de pas, distance, calories, exercice, fréquence cardiaque et sommeil, lus depuis Health Connect ou l'app Santé du téléphone. L'app ne fait que lire et ne modifie jamais ces données.",
 "Sem internet ou a conexão caiu. Confira o Wi-Fi ou os dados móveis e tente de novo.": "Pas d'internet ou la connexion a été coupée. Vérifiez le Wi-Fi ou les données mobiles et réessayez.",
 "Senha desta aba": "Mot de passe de cet onglet",
 "Seu plano terminou": "Votre plan est terminé",
 "Sino": "Cloche",
 "Som do alarme": "Son de l'alarme",
 "Soma a garantia legal e a do fabricante. Confira no termo de garantia.": "Additionne la garantie légale et celle du fabricant. Vérifiez le certificat de garantie.",
 "São dois arquivos com os seus dados do My Planner (portabilidade, LGPD):": "Il s'agit de deux fichiers avec vos données My Planner (portabilité, LGPD) :",
 "Só quando o app bloquear": "Seulement quand l'app se verrouille",
 "Tamanho da borracha": "Taille de la gomme",
 "Tamanho da letra": "Taille du texte",
 "Tempo": "Durée",
 "Termina em": "Se termine le",
 "Testar": "Tester",
 "Texto de exemplo": "Texte d'exemple",
 "Toca nos avisos em \"Alarme (som)\". \"Som e vibração\" usa o som de notificação do celular.": "Sonne pour les notifications réglées sur « Alarme (son) ». « Son et vibration » utilise le son de notification du téléphone.",
 "Toda vez que sair": "À chaque sortie",
 "Toda vez que sair da aba": "À chaque sortie de l'onglet",
 "Todas as abas voltam a \"{n} dias grátis para testar\", como numa conta nova. As assinaturas simuladas são desligadas.": "Tous les onglets reviennent à « {n} jours gratuits pour essayer », comme sur un nouveau compte. Les abonnements simulés sont désactivés.",
 "Todos os fichários": "Tous les classeurs",
 "Toque em \"Create API key\" (Criar chave de API). Se pedir um projeto, escolha o que aparecer ou crie um novo.": "Touchez \"Create API key\" (Créer une clé d'API). Si un projet est demandé, choisissez celui qui apparaît ou créez-en un nouveau.",
 "Toque em \"Criar minha chave de API\" acima. Abre a plataforma da OpenAI (não é o site do ChatGPT).": "Touchez « Créer ma clé d'API » ci-dessus. Cela ouvre la plateforme OpenAI (ce n'est pas le site de ChatGPT).",
 "Toque em \"Criar minha chave de API\" acima. Abre o Console da Anthropic (não é o site do Claude).": "Touchez « Créer ma clé d'API » ci-dessus. Cela ouvre la Console Anthropic (ce n'est pas le site de Claude).",
 "Toque em \"Criar minha chave de API\" acima. Abre o Google AI Studio.": "Touchez « Créer ma clé d'API » ci-dessus. Cela ouvre Google AI Studio.",
 "Toque em Conectar e, na tela do app Saúde, ligue os itens que o My Planner pode ler.": "Touchez Connecter et, sur l'écran de l'app Santé, activez les éléments que My Planner peut lire.",
 "Toque no ícone de copiar ao lado da chave. Ela começa com \"AIza\" ou \"AQ.\".": "Touchez l'icône de copie à côté de la clé. Elle commence par \"AIza\" ou \"AQ.\".",
 "Toque numa célula da tabela (ou em \"Escolher células\") para mudar o tamanho da letra dela.": "Touchez une cellule du tableau (ou « Choisir des cellules ») pour modifier sa taille de texte.",
 "Transparência": "Transparence",
 "Técnico (para restaurar): cópia completa que só o My Planner lê. Para usar, vá em Ajustes › Nuvem e cópias de segurança › Importar arquivo.": "Technique (pour restaurer) : copie complète que seul My Planner peut lire. Pour l'utiliser, allez dans Réglages › Cloud et sauvegardes › Importer un fichier.",
 "Uma carta da {nome} abre em {n} dias 💌": "Une lettre de {nome} s'ouvre dans {n} jours 💌",
 "Usa a senha do app": "Utilise le mot de passe de l'app",
 "Usar no {ia}": "Utiliser avec {ia}",
 "Use o app no celular para baixar o arquivo técnico.": "Utilisez l'app sur le téléphone pour télécharger le fichier technique.",
 "Valor final definido pela loja de apps, já na moeda do seu país.": "Prix final fixé par la boutique d'apps, déjà dans la devise de votre pays.",
 "Você ainda não enviou {titulo} para o My Planner.": "Vous n'avez pas encore envoyé {titulo} vers My Planner.",
 "Volte aqui, cole no campo abaixo e toque em \"Salvar e testar\".": "Revenez ici, collez-la dans le champ ci-dessous et touchez « Enregistrer et tester ».",
 "Volte em \"API keys\" e toque em \"Create new secret key\" (Criar chave).": "Retournez dans \"API keys\" et touchez \"Create new secret key\" (Créer une clé).",
 "atualização automática": "mise à jour automatique",
 "erro desconhecido": "erreur inconnue",
 "estudados no mês": "étudiés ce mois-ci",
 "faltou {dur}": "manque {dur}",
 "hoje {feito} de {meta}": "aujourd'hui {feito} sur {meta}",
 "hoje é folga": "aujourd'hui est un jour de repos",
 "login do Google (não é chave de API)": "connexion Google (ce n'est pas une clé d'API)",
 "meta cumprida": "objectif atteint",
 "o que veio com a instalação": "ce qui est venu avec l'installation",
 "outro": "autre",
 "provisório": "provisoire",
 "superou {dur}": "dépassé de {dur}",
 "token de login (não é chave de API)": "jeton de connexion (ce n'est pas une clé d'API)",
 "{ia} demorou demais para responder. Tente de novo em instantes.": "{ia} a mis trop de temps à répondre. Réessayez dans un instant.",
 "{ia} está fora do ar ou sobrecarregado agora. Não é problema da sua chave: tente de novo mais tarde.": "{ia} est en panne ou surchargé en ce moment. Ce n'est pas un problème de votre clé : réessayez plus tard.",
 "{ia} respondeu ao teste com o modelo {modelo}. Já pode usar nas abas.": "{ia} a répondu au test avec le modèle {modelo}. Vous pouvez maintenant l'utiliser dans les onglets.",
 "{ia} se recusou a ler este conteúdo (filtro de segurança da empresa).": "{ia} a refusé de lire ce contenu (filtre de sécurité de l'entreprise).",
 "{ia}: a chave existe, mas não tem permissão para usar a IA. Crie uma chave nova na página indicada no passo a passo.": "{ia} : la clé existe, mais elle n'a pas l'autorisation d'utiliser l'IA. Créez une nouvelle clé sur la page indiquée dans les étapes.",
 "{ia}: chave inválida. Confira se copiou a chave inteira ou crie uma nova.": "{ia} : clé non valide. Vérifiez que vous avez copié la clé entière ou créez-en une nouvelle.",
 "{ia}: esta chave foi bloqueada pela empresa porque apareceu publicada na internet. Apague-a e crie outra.": "{ia} : cette clé a été bloquée par l'entreprise car elle a été publiée sur internet. Supprimez-la et créez-en une autre.",
 "{ia}: limite de uso atingido. Espere alguns minutos (ou até amanhã, no plano gratuito) e tente de novo.": "{ia} : limite d'utilisation atteinte. Attendez quelques minutes (ou jusqu'à demain, avec le plan gratuit) et réessayez.",
 "{ia}: o modelo escolhido não está disponível para a sua conta. Escolha outro em \"Modelo\".": "{ia} : le modèle choisi n'est pas disponible pour votre compte. Choisissez-en un autre dans « Modèle ».",
 "{ia}: o serviço não está disponível na sua região ou para este tipo de conta.": "{ia} : le service n'est pas disponible dans votre région ou pour ce type de compte.",
 "{ia}: sua conta de API está sem saldo ou sem forma de pagamento. Adicione créditos no site da empresa.": "{ia} : votre compte API n'a pas de solde ou pas de moyen de paiement. Ajoutez des crédits sur le site de l'entreprise.",
 "{item}: a garantia termina hoje ({data}).": "{item} : la garantie se termine aujourd'hui ({data}).",
 "{item}: a garantia terminou em {data}.": "{item} : la garantie s'est terminée le {data}.",
 "{item}: venceu em {data}.": "{item} : expiré le {data}.",
 "{mes} de {ano}": "{mes} {ano}",
 "{nome} protegida com senha": "{nome} protégée par mot de passe",
 "{nome}: encerrar o plano ou prolongar com uma nova data final? Nada é apagado.": "{nome} : terminer le plan ou le prolonger avec une nouvelle date de fin ? Rien n'est supprimé.",
 "{n} dias antes": "{n} jours avant",
 "{n} dias de estudo no plano · {dur} por dia": "{n} jours d'étude dans le plan · {dur} par jour",
 "{n} dias de plano": "{n} jours de plan",
 "{n} dias depois": "{n} jours après",
 "{n} item(ns) aguardando envio ao My Planner": "{n} élément(s) en attente d'envoi vers My Planner",
 "{n} itens aguardando envio": "{n} éléments en attente d'envoi",
 "{quando} às {hora}": "{quando} à {hora}",
 "ÚLTIMOS 6 MESES": "6 DERNIERS MOIS",
 "Abra o My Planner Anne e entre com o seu CPF ou e-mail e a sua senha.": "Ouvrez My Planner Anne et connectez-vous avec votre CPF ou votre e-mail et votre mot de passe.",
 "Anexo": "Pièce jointe",
 "Assédio ou ameaça": "Harcèlement ou menace",
 "Bloquear {nome}": "Bloquer {nome}",
 "Conte mais (opcional)": "Dites-nous-en plus (facultatif)",
 "Conteúdo impróprio": "Contenu inapproprié",
 "Conteúdo ofensivo e usuários abusivos não são tolerados. As denúncias são analisadas pela nossa equipe em até 24 horas.": "Les contenus offensants et les utilisateurs abusifs ne sont pas tolérés. Les signalements sont examinés par notre équipe sous 24 heures.",
 "Denunciar": "Signaler",
 "Denunciar contato": "Signaler le contact",
 "Denunciar grupo": "Signaler le groupe",
 "Denunciar mensagem": "Signaler le message",
 "Denúncia enviada": "Signalement envoyé",
 "Denúncias que você faz nas Mensagens: o motivo, quem foi denunciado e o trecho da mensagem denunciada. Só a equipe do My Planner lê, para analisar o caso.": "Les signalements que vous faites dans Messages : le motif, la personne signalée et l'extrait du message signalé. Seule l'équipe My Planner les lit, pour examiner le cas.",
 "Enviar denúncia": "Envoyer le signalement",
 "Mande um e-mail pedindo a exclusão, com o CPF ou o e-mail da conta. Respondemos em até 15 dias.": "Envoyez un e-mail demandant la suppression, avec le CPF ou l'e-mail du compte. Nous répondons sous 15 jours.",
 "Não toleramos conteúdo ofensivo, ilegal ou impróprio nem usuários abusivos nas Mensagens e nos grupos. Qualquer pessoa pode denunciar uma mensagem, um contato ou um grupo (segure a mensagem ou toque em ⋮ > Denunciar) e bloquear quem quiser. As denúncias são analisadas pela nossa equipe em até 24 horas: o conteúdo pode ser removido e quem o enviou pode ter a conta suspensa ou encerrada.": "Nous ne tolérons ni contenu offensant, illégal ou inapproprié, ni utilisateurs abusifs dans Messages et les groupes. Tout le monde peut signaler un message, un contact ou un groupe (appuyez longuement sur le message ou touchez ⋮ > Signaler) et bloquer qui il veut. Les signalements sont examinés par notre équipe sous 24 heures : le contenu peut être supprimé et son auteur peut voir son compte suspendu ou fermé.",
 "Obrigado. Nossa equipe vai analisar em até 24 horas.": "Merci. Notre équipe l'examinera sous 24 heures.",
 "Para contas que entram com CPF, a senha nova é criada pelo nosso suporte, depois de confirmar que a conta é sua. Escreva para {email} informando o seu CPF ou o e-mail cadastrado.": "Pour les comptes qui se connectent avec le CPF, le nouveau mot de passe est créé par notre support, après avoir confirmé que le compte vous appartient. Écrivez à {email} en indiquant votre CPF ou l'e-mail enregistré.",
 "Por que você está denunciando? A pessoa denunciada não fica sabendo quem denunciou.": "Pourquoi faites-vous ce signalement ? La personne signalée ne saura pas qui l'a signalée.",
 "Spam": "Spam",
 "{nome} não pode mais conversar com você.": "{nome} ne peut plus discuter avec vous.",
 "{nome}\nVale até {d}. Ele fica criptografado no seu cofre, só neste dispositivo e na sua cópia da nuvem.": "{nome}\nValable jusqu'au {d}. Il est chiffré dans votre coffre, uniquement sur cet appareil et dans votre copie cloud.",
 "1. No computador, abra {url} e escolha Entrar com QR Code.": "1. Sur l'ordinateur, ouvrez {url} et choisissez Se connecter avec le QR code.",
 "2. Aqui, toque em Conectar navegador e aponte a câmera para o QR Code do computador.": "2. Ici, touchez Connecter le navigateur et pointez l'appareil photo vers le QR code de l'ordinateur.",
 "Abandonados": "Abandonnés",
 "Bloquear o computador": "Verrouiller l'ordinateur",
 "Cheguei na página...": "Je suis à la page...",
 "Computador conectado": "Ordinateur connecté",
 "Computador desconectado": "Ordinateur déconnecté",
 "Conectado em {d}": "Connecté le {d}",
 "Crie o grupo e mande o link: quem entrar vê o material do livro e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Créez le groupe et envoyez le lien : ceux qui rejoignent voient le contenu du livre et suivent la lecture. Les administrateurs ajoutent, modifient et mettent des photos, et peuvent l'autoriser à ceux qui utilisent aussi l'onglet. Seuls les administrateurs ajoutent ou retirent des personnes.",
 "Depois de {n} minutos parado": "Après {n} minutes d'inactivité",
 "Desconectar o computador?": "Déconnecter l'ordinateur ?",
 "Difícil demais": "Trop difficile",
 "Editar livro": "Modifier le livre",
 "Entrar com o QR Code": "Se connecter avec le QR code",
 "Escreva (ex.: filosofia)": "Écrivez (ex. : philosophie)",
 "Este computador": "Cet ordinateur",
 "Este computador foi desconectado (pelo celular ou porque outro computador entrou). Para usar de novo, entre com o QR Code.": "Cet ordinateur a été déconnecté (depuis le téléphone ou parce qu'un autre ordinateur s'est connecté). Pour l'utiliser à nouveau, connectez-vous avec le QR code.",
 "Já existe um computador conectado": "Un ordinateur est déjà connecté",
 "Já existe um computador conectado. Trocar para este? O outro será desconectado.": "Un ordinateur est déjà connecté. Passer à celui-ci ? L'autre sera déconnecté.",
 "Navegador": "Navigateur",
 "Nenhum computador conectado": "Aucun ordinateur connecté",
 "Novo livro": "Nouveau livre",
 "Não gostei": "Pas aimé",
 "Não, abandonei": "Non, abandonné",
 "O My Planner fecha no computador. Para usar de novo, é só conectar pelo QR Code.": "My Planner se fermera sur l'ordinateur. Pour l'utiliser à nouveau, connectez-vous avec le QR code.",
 "O QR Code muda a cada 3 minutos e só vale uma vez. Em computador compartilhado, use Ajustes › Sair deste computador ao terminar.": "Le QR code change toutes les 3 minutes et ne sert qu'une fois. Sur un ordinateur partagé, utilisez Réglages › Se déconnecter de cet ordinateur à la fin.",
 "Os seus dados continuam salvos na nuvem e no celular. Para entrar de novo, use o QR Code.": "Vos données restent enregistrées dans le cloud et sur le téléphone. Pour revenir, utilisez le QR code.",
 "Parei em": "Arrêté le",
 "Perdi o interesse": "Perdu l'intérêt",
 "Por que parei": "Pourquoi j'ai arrêté",
 "Páginas e meta": "Pages et objectif",
 "Quero voltar a ler?": "Je veux le reprendre ?",
 "Sair deste computador": "Se déconnecter de cet ordinateur",
 "Sair deste computador?": "Se déconnecter de cet ordinateur ?",
 "Se quiser, escreva com as suas palavras": "Si vous voulez, écrivez-le avec vos mots",
 "Sem mexer no mouse ou no teclado por esse tempo, o My Planner bloqueia. Para voltar, digite a senha da conta (ou entre com o QR Code de novo).": "Sans utiliser la souris ni le clavier pendant ce temps, My Planner se verrouille. Pour revenir, saisissez le mot de passe du compte (ou reconnectez-vous avec le QR code).",
 "Sem tempo": "Pas le temps",
 "Sim, depois": "Oui, plus tard",
 "Só um computador pode ficar conectado por vez.": "Un seul ordinateur peut être connecté à la fois.",
 "A foto ou o PDF do certificado vai em \"Fotos, arquivos e links\": marque como Certificado.": "La photo ou le PDF du certificat va dans « Photos, fichiers et liens » : marquez-le comme Certificat.",
 "ABNT copiada": "ABNT copiée",
 "APA copiada": "APA copiée",
 "Ano inválido": "Année non valide",
 "Ano ou data de publicação": "Année ou date de publication",
 "Assisti em": "Vu le",
 "Buscando os dados...": "Recherche des données...",
 "Calculado pelos módulos": "Calculé à partir des modules",
 "Carga horária (horas)": "Volume horaire (heures)",
 "Certificado": "Certificat",
 "Certificado emitido em": "Certificat délivré le",
 "Cheguei na aula": "Je suis à la leçon",
 "Cheguei na aula...": "Je suis à la leçon...",
 "Cheguei na temporada": "Je suis à la saison",
 "Cheguei no episódio": "Je suis à l'épisode",
 "Citação copiada": "Citation copiée",
 "Colocar em pasta": "Mettre dans un dossier",
 "Coloque livros, filmes ou cursos nesta pasta para montar a lista.": "Mettez des livres, films ou cours dans ce dossier pour créer la liste.",
 "Comentário": "Commentaire",
 "Copiar ABNT": "Copier ABNT",
 "Copiar APA": "Copier APA",
 "Copiar citação (ABNT)": "Copier la citation (ABNT)",
 "Copiar citação (APA)": "Copier la citation (APA)",
 "Crie cards com checklist, lista, texto livre ou desenho para esta matéria. Arraste para a direita para excluir e para a esquerda para Arquivar ou Duplicar.": "Créez des fiches avec checklist, liste, texte libre ou dessin pour cette matière. Glissez à droite pour supprimer et à gauche pour Archiver ou Dupliquer.",
 "Crie o grupo e mande o link: quem entrar vê a lista e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Créez le groupe et envoyez le lien : ceux qui rejoignent voient la liste et suivent. Les administrateurs ajoutent, modifient et mettent des photos, et peuvent l'autoriser à ceux qui utilisent aussi l'onglet. Seuls les administrateurs ajoutent ou retirent des personnes.",
 "Crie o grupo e mande o link: quem entrar vê o material do curso e acompanha. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Créez le groupe et envoyez le lien : ceux qui rejoignent voient le contenu du cours et suivent. Les administrateurs ajoutent, modifient et mettent des photos, et peuvent l'autoriser à ceux qui utilisent aussi l'onglet. Seuls les administrateurs ajoutent ou retirent des personnes.",
 "Crie uma pasta primeiro, na parte 📁 Pastas desta aba.": "Créez d'abord un dossier, dans la partie 📁 Dossiers de cet onglet.",
 "DOI (artigos)": "DOI (articles)",
 "Data de acesso": "Date d'accès",
 "Deixar avulsas": "Les garder à part",
 "Descrição (objetivo)": "Description (objectif)",
 "Digite o ano com 4 números (ex.: {a}).": "Saisissez l'année en 4 chiffres (ex. : {a}).",
 "Direção": "Réalisation",
 "Editar pasta": "Modifier le dossier",
 "Editora": "Éditeur",
 "Edição": "Édition",
 "Em 1 mês": "Dans 1 mois",
 "Em {n} meses": "Dans {n} mois",
 "Episódios por temporada (opcional)": "Épisodes par saison (facultatif)",
 "Escreva o trecho na anotação para copiar a citação.": "Écrivez l'extrait dans la note pour copier la citation.",
 "Este item já está em todas as pastas.": "Cet élément est déjà dans tous les dossiers.",
 "Ex.: 10.1590/...": "Ex. : 10.1590/...",
 "Ex.: TCC — Ética e Direito": "Ex. : Mémoire — Éthique et Droit",
 "Ex.: {a}": "Ex. : {a}",
 "Fazendo": "En cours",
 "Grupo de filmes e séries": "Groupe films et séries",
 "Grupo de leitura": "Groupe de lecture",
 "Grupo do curso": "Groupe du cours",
 "ISBN": "ISBN",
 "Ideia minha": "Mon idée",
 "Instrutor": "Formateur",
 "Itens da pasta": "Éléments du dossier",
 "Junte livros, filmes e cursos numa pasta (ex.: \"TCC\", \"Só romances\"). O mesmo item pode estar em várias pastas.": "Regroupez livres, films et cours dans un dossier (ex. : « Mémoire », « Romans »). Un même élément peut être dans plusieurs dossiers.",
 "Link (material online)": "Lien (contenu en ligne)",
 "Lista copiada": "Liste copiée",
 "Lista de referências": "Liste de références",
 "Mais de um autor: separe com ponto e vírgula (;).": "Plusieurs auteurs : séparez par un point-virgule (;).",
 "Módulo": "Module",
 "Nada novo": "Rien de nouveau",
 "No ⋮ de um livro, filme ou curso, toque em \"Colocar em pasta\".": "Dans le ⋮ d'un livre, film ou cours, touchez « Mettre dans un dossier ».",
 "Nome da pasta": "Nom du dossier",
 "Não achei dados novos para completar a ficha.": "Aucune nouvelle donnée pour compléter la fiche.",
 "Não foi possível preencher": "Impossible de remplir",
 "O módulo não tem cards de anotações.": "Le module n'a pas de fiches de notes.",
 "Organizador": "Directeur de publication",
 "Os dados vêm da ficha do livro (Editar › Referência).": "Les données viennent de la fiche du livre (Modifier › Référence).",
 "Os livros, filmes e cursos da pasta NÃO são apagados: continuam na aba.": "Les livres, films et cours du dossier ne sont PAS supprimés : ils restent dans l'onglet.",
 "Os {n} card(s) de anotações deste módulo também vão para a lixeira.": "Les {n} fiche(s) de notes de ce module vont aussi à la corbeille.",
 "Pasta vazia": "Dossier vide",
 "Preencha o título (e o que mais tiver) na ficha.": "Remplissez le titre (et le reste si possible) dans la fiche.",
 "Preencher pelo DOI": "Remplir via le DOI",
 "Preencher pelo link": "Remplir via le lien",
 "Produtora ou país": "Production ou pays",
 "Quero fazer": "À faire",
 "Quero voltar?": "Je veux reprendre ?",
 "Referência vazia": "Référence vide",
 "Referências": "Références",
 "Se deixar avulsas, elas continuam somando no total do curso.": "Si vous les gardez à part, elles comptent toujours dans le total du cours.",
 "Subtítulo": "Sous-titre",
 "Tirar da pasta": "Retirer du dossier",
 "Total de episódios (opcional)": "Nombre total d'épisodes (facultatif)",
 "Total de temporadas (opcional)": "Nombre de saisons (facultatif)",
 "Tradutor": "Traducteur",
 "Trecho (citação)": "Extrait (citation)",
 "Trecho vazio": "Extrait vide",
 "Você já assistiu {n} aula(s). Colocar em qual módulo?": "Vous avez déjà suivi {n} leçon(s). Dans quel module les mettre ?",
 "Volume": "Volume",
 "{n} item(ns)": "{n} élément(s)",
 "{n} referência(s) em ordem alfabética.": "{n} référence(s) par ordre alphabétique.",
 "Ícone": "Icône",
 "ASSISTIDOS POR DIA": "VUS PAR JOUR",
 "ASSISTIDOS POR MÊS": "VUS PAR MOIS",
 "AULAS POR DIA": "LEÇONS PAR JOUR",
 "AULAS POR MÊS": "LEÇONS PAR MOIS",
 "Apagar a meta": "Supprimer l'objectif",
 "Assisti {a} · Estou assistindo {b} · Parei {c} · Quero assistir {d}": "Vus {a} · En cours {b} · Arrêtés {c} · À voir {d}",
 "Aulas": "Leçons",
 "CURSOS": "COURS",
 "Concluí {a} · Fazendo {b} · Parei {c}": "Terminés {a} · En cours {b} · Arrêtés {c}",
 "Datas": "Dates",
 "Datas escolhidas": "Dates choisies",
 "Datas à escolha": "Dates au choix",
 "Definir meta de {ano}": "Définir l'objectif {ano}",
 "Definir meta do ano": "Définir un objectif pour l'année",
 "FILMES E SÉRIES": "FILMS ET SÉRIES",
 "Faltam {f} curso(s): dá cerca de {m} por mês": "Encore {f} cours : environ {m} par mois",
 "Faltam {f} livro(s): dá cerca de {m} por mês": "Encore {f} livre(s) : environ {m} par mois",
 "Faltam {f} título(s): dá cerca de {m} por mês": "Encore {f} titre(s) : environ {m} par mois",
 "Gênero": "Genre",
 "Incluir lista de referências no PDF": "Inclure la liste de références dans le PDF",
 "LIVROS": "LIVRES",
 "Li {a} livro(s) · Parei {b} · Estou lendo {c}": "Lu {a} livre(s) · Arrêtés {b} · En cours {c}",
 "Meta de {ano}": "Objectif {ano}",
 "Meta de {ano}: usar a de {antes} ({n})?": "Objectif {ano} : reprendre celui de {antes} ({n}) ?",
 "Meta do ano cumprida": "Objectif de l'année atteint",
 "Mudar": "Modifier",
 "Nada neste período.": "Rien sur cette période.",
 "Nota": "Note",
 "O PDF não leva as suas anotações, resumos e comentários.": "Le PDF n'inclut pas vos notes, résumés et commentaires.",
 "POR ITEM": "PAR ÉLÉMENT",
 "Plataforma": "Plateforme",
 "PÁGINAS POR DIA": "PAGES PAR JOUR",
 "PÁGINAS POR MÊS": "PAGES PAR MOIS",
 "Quantos no ano?": "Combien dans l'année ?",
 "Quero ler {a} · Abandonei {b}": "À lire {a} · Abandonnés {b}",
 "Relatório de leitura e mídia": "Rapport lecture et médias",
 "concluídos no período": "terminés sur la période",
 "cursos concluídos no período": "cours terminés sur la période",
 "livros lidos no período": "livres lus sur la période",
 "pág. {a} de {n}": "p. {a} sur {n}",
 "títulos assistidos no período": "titres vus sur la période",
 "{a} aula(s) assistida(s) no período · {h} hora(s) de cursos concluídos": "{a} leçon(s) suivie(s) sur la période · {h} heure(s) de cours terminés",
 "{a} de {n} aulas ({p}%)": "{a} sur {n} leçons ({p}%)",
 "{a} de {n} curso(s) concluído(s) em {ano}": "{a} sur {n} cours terminés en {ano}",
 "{a} de {n} livro(s) em {ano}": "{a} sur {n} livre(s) en {ano}",
 "{a} de {n} título(s) assistido(s) em {ano}": "{a} sur {n} titre(s) vus en {ano}",
 "{n} item(ns) sem data de mudança de situação: usei a data de criação.": "{n} élément(s) sans date de changement d'état : j'ai utilisé la date de création.",
 "{p} página(s) lida(s) em {d} dia(s) · melhor sequência: {s} dia(s)": "{p} page(s) lue(s) en {d} jour(s) · meilleure série : {s} jour(s)",
 "{p}% lido · falta {f}%": "{p}% lu · reste {f}%",
 "Esta aba pede senha. Desbloqueie a aba primeiro e o guia continua daqui.": "Cet onglet demande un mot de passe. Déverrouillez-le d'abord et le guide reprend ici.",
 "Abrir esta aba": "Ouvrir cet onglet",
 "Mostrar na tela": "Montrer à l'écran",
 "Não achei este ponto na tela agora. Confira se a tela certa está aberta e tente de novo.": "Je ne trouve pas cet endroit à l'écran. Vérifiez que le bon écran est ouvert et réessayez.",
 "Primeiros passos": "Premiers pas",
 "Buscar no guia": "Chercher dans le guide",
 "Entendi": "Compris",
 "{n} de {total} passos feitos": "{n} sur {total} étapes faites",
 "Já fiz": "C'est fait",
 "Guia em construção": "Guide en préparation",
 "Limpar marcações": "Effacer les coches",
 "Este ponto ainda não está marcado no app.": "Cet endroit n'est pas encore repéré dans l'app.",
 "Dicas e atalhos": "Astuces et raccourcis",
 "Gestos do app": "Gestes de l'app",
 "Procurando na tela…": "Recherche à l'écran…",
 "Guia das abas": "Guide des onglets",
 "Voltar ao guia": "Retour au guide",
 "Para que serve": "À quoi ça sert",
 "Disponível no app do celular.": "Disponible dans l'app du téléphone.",
 "Nada encontrado no guia.": "Rien trouvé dans le guide.",
 "Recursos que valem para todas as abas": "Fonctions valables pour tous les onglets",
 "Perguntas comuns": "Questions fréquentes",
 "Ligar e desligar partes": "Activer et désactiver des parties",
 "Entrada cancelada. Este computador não foi conectado.": "Connexion annulée. Cet ordinateur n’a pas été connecté.",
 "Alterações ainda não enviadas": "Modifications pas encore envoyées",
 "Algumas alterações ainda não foram enviadas para o servidor (sem internet?). Se sair agora, elas se perdem. Sair mesmo assim?": "Certaines modifications n’ont pas encore été envoyées au serveur (pas d’internet ?). Si vous vous déconnectez maintenant, elles seront perdues. Se déconnecter quand même ?",
 "Sair mesmo assim": "Se déconnecter quand même",
 "O seu papel no grupo não permite mudar aqui.": "Votre rôle dans le groupe ne permet pas de modifier ici.",
 "Não foi possível consultar o DOI agora (sem internet?). Tente de novo.": "Impossible de consulter le DOI pour le moment (pas d’internet ?). Réessayez.",
 "DOI inválido.": "DOI invalide.",
 "DOI não encontrado.": "DOI introuvable.",
 "O site não deixou ler os dados daqui (no navegador do computador isso é comum). Tente pelo app no celular, use o DOI, ou digite os campos.": "Le site n’a pas permis de lire ses données d’ici (fréquent dans le navigateur d’un ordinateur). Essayez l’app sur le téléphone, utilisez le DOI ou saisissez les champs.",
 "Atualizando...": "Mise à jour...",
 "Banco de dados (Supabase, plano grátis)": "Base de données (Supabase, offre gratuite)",
 "Cadeado (HTTPS) até": "Cadenas (HTTPS) jusqu’au",
 "Dados das abas: {d}": "Données des onglets : {d}",
 "Disco": "Disque",
 "Esta conta não tem acesso a estas informações.": "Ce compte n’a pas accès à ces informations.",
 "Ligado há": "Allumé depuis",
 "Livre: {l} · site: {s}": "Libre : {l} · site : {s}",
 "Maiores tabelas": "Plus grandes tables",
 "Memória em uso": "Mémoire utilisée",
 "O servidor ainda não mandou o relatório. Ele manda a cada 10 minutos depois do 53-SERVIDOR-0.78.bat.": "Le serveur n’a pas encore envoyé son rapport. Il l’envoie toutes les 10 minutes après le 53-SERVIDOR-0.78.bat.",
 "O servidor ainda não tem esta função. Rode o 53-SERVIDOR-0.78.bat no computador.": "Le serveur n’a pas encore cette fonction. Lancez 53-SERVIDOR-0.78.bat sur l’ordinateur.",
 "O sistema do servidor pede reinício (atualização de segurança instalada).": "Le système du serveur demande un redémarrage (mise à jour de sécurité installée).",
 "Processador": "Processeur",
 "Relatório do servidor: {q}": "Rapport du serveur : {q}",
 "Servidor": "Serveur",
 "Servidor do site (Locaweb)": "Serveur du site (Locaweb)",
 "Sistema": "Système",
 "Só você vê este quadro.": "Vous seul voyez ce cadre.",
 "Versão do site no ar": "Version du site en ligne",
 "atrasado: confira se o servidor está ligado": "en retard : vérifiez que le serveur est allumé",
 "sem cadeado": "pas de cadenas",
 "{a} ({n} guardadas)": "{a} ({n} conservées)",
 "{d} dia(s) e {h} h": "{d} jour(s) et {h} h",
 "{n} núcleo(s) · carga {c}": "{n} cœur(s) · charge {c}",
 "{n} · {novas} nova(s) e {ativas} ativa(s) em 7 dias": "{n} · {novas} nouveau(x) et {ativas} actif(s) en 7 jours",
 "{u} de {t} ({p}%)": "{u} sur {t} ({p} %)",
 "Fechar teclado": "Fermer le clavier",
 "Mostrar as ferramentas": "Afficher les outils",
 "Últimas cores usadas": "Dernières couleurs utilisées",
 "Voltar ao topo": "Revenir en haut",
 "Topo": "Haut",
 "1 atividade do roteiro por fazer": "1 activité de l'itinéraire à faire",
 "1 dia": "1 jour",
 "1 item por pôr na mala": "1 article à mettre dans la valise",
 "1 lista de Viagens ia inteira para o My Planner e saiu de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "1 liste de Voyages était envoyée entière vers My Planner et en a été retirée. Désormais, l'envoi se fait élément par élément, via le ⋮ de chaque élément.",
 "1 lugar não visitado": "1 lieu non visité",
 "1 reserva por confirmar": "1 réservation à confirmer",
 "Abrir o bloco": "Ouvrir la section",
 "Adicionar pessoa": "Ajouter une personne",
 "Ainda pode gastar {v}": "Vous pouvez encore dépenser {v}",
 "Ao ligar, o valor entra em Gastos como pago.": "Une fois activé, le montant est ajouté aux Dépenses comme payé.",
 "Até (dd/mm/aaaa)": "Jusqu'au (jj/mm/aaaa)",
 "Coloque as pessoas em \"Quem vai\" (edite a viagem).": "Ajoutez les personnes dans \"Qui part\" (modifiez le voyage).",
 "Como foi?": "Comment c'était ?",
 "Concluído em {d}": "Terminé le {d}",
 "Confirmada em {d}": "Confirmée le {d}",
 "Confirmadas": "Confirmées",
 "Dia anterior": "Jour précédent",
 "Dias": "Jours",
 "Dias × valor por dia": "Jours × montant par jour",
 "Documentos (só o tipo e a validade)": "Documents (type et validité uniquement)",
 "EXIGÊNCIAS DO DESTINO": "EXIGENCES DE LA DESTINATION",
 "Em mãos": "En main",
 "Escreva o que o destino pede (ex.: 2 páginas em branco no passaporte, certificado de vacina). Confira no site oficial do país.": "Indiquez ce que la destination exige (ex. : 2 pages vierges dans le passeport, certificat de vaccination). Vérifiez sur le site officiel du pays.",
 "Ex.: Lisboa (LIS)": "Ex. : Lisbonne (LIS)",
 "Ex.: São Paulo (GRU)": "Ex. : São Paulo (GRU)",
 "Falta confirmar": "À confirmer",
 "Falta pôr": "À mettre",
 "Faltou ({n}): {l}": "Oublié ({n}) : {l}",
 "Foi ({n}): {l}": "Emporté ({n}) : {l}",
 "Fotos (lista das legendas)": "Photos (liste des légendes)",
 "Gasto de {nome} em {d}": "Dépense de {nome} le {d}",
 "Gastos do dia": "Dépenses du jour",
 "Gastos em outras moedas (não convertidos): {v}": "Dépenses dans d'autres devises (non converties) : {v}",
 "Gastos por dia": "Dépenses par jour",
 "Horário de chegada": "Heure d'arrivée",
 "Lugares (visitados, faltam, imperdíveis e a nota)": "Lieux (visités, restants, incontournables et la note)",
 "Mala (o que foi e o que faltou)": "Valise (ce qui a été emporté et ce qui a été oublié)",
 "Marcar como acertado": "Marquer comme réglé",
 "Marcar como acertado?": "Marquer comme réglé ?",
 "Na mala": "Dans la valise",
 "Nenhuma parada ainda": "Aucune étape pour l'instant",
 "Nova exigência": "Nouvelle exigence",
 "Números de documentos e o que está no cofre nunca vão para o relatório. Valores em moedas diferentes aparecem separados.": "Les numéros de documents et le contenu du coffre ne figurent jamais dans le rapport. Les montants en devises différentes apparaissent séparément.",
 "O QUE AINDA FALTA": "CE QUI RESTE À FAIRE",
 "O QUE INCLUIR": "CE QU'IL FAUT INCLURE",
 "Opcional. O app avisa se o passaporte vencer antes disso, contado da volta. Confira a exigência do país.": "Facultatif. L'app vous prévient si le passeport expire avant, à compter du retour. Vérifiez l'exigence du pays.",
 "Orçamento previsto × gasto por categoria": "Budget prévu × dépensé par catégorie",
 "Passou do previsto em {v}": "Dépassement du prévu de {v}",
 "Ponha a validade de cada documento: o app avisa antes de vencer. As fotos dos documentos ficam protegidas no cofre.": "Indiquez la date de validité de chaque document : l'app vous prévient avant l'expiration. Les photos des documents restent protégées dans le coffre.",
 "Próximo dia": "Jour suivant",
 "Quem está no grupo da viagem entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app.": "Les membres du groupe du voyage sont ajoutés automatiquement. Utilisez \"+ Ajouter une personne\" pour ceux qui n'ont pas l'app.",
 "Recolher o bloco": "Réduire la section",
 "Relatório da viagem": "Rapport du voyage",
 "Reserva confirmada": "Réservation confirmée",
 "Resumo da viagem": "Résumé du voyage",
 "Resumo da viagem (datas, destino, pessoas)": "Résumé du voyage (dates, destination, personnes)",
 "Roteiro por dia (feito e falta)": "Itinéraire par jour (fait et à faire)",
 "Sem data": "Sans date",
 "Seu passaporte pode não ser aceito. Confira a exigência do país": "Votre passeport risque de ne pas être accepté. Vérifiez l'exigence du pays",
 "Subir": "Monter",
 "Total do dia: {v}": "Total du jour : {v}",
 "Uma frase (opcional)": "Une phrase (facultatif)",
 "Validade mínima exigida (meses)": "Validité minimale exigée du passeport (mois)",
 "Validade: {d}": "Validité : {d}",
 "Valor por dia": "Montant par jour",
 "Viagens no My Planner": "Voyages dans My Planner",
 "Visitado": "Visité",
 "Visitado em {d}": "Visité le {d}",
 "Voltaria: {r}": "J'y retournerais : {r}",
 "Voltaria?": "Vous y retourneriez ?",
 "confirmada": "confirmée",
 "em mãos": "en main",
 "gasto na viagem {d}": "dépense du voyage {d}",
 "meses": "mois",
 "outro gasto": "autre dépense",
 "vence em {d}": "expire le {d}",
 "{a} de {b} confirmadas": "{a} sur {b} confirmées",
 "{a} de {b} em mãos": "{a} sur {b} en main",
 "{a} de {b} feitos": "{a} sur {b} faits",
 "{a} de {b} na mala": "{a} sur {b} dans la valise",
 "{a} de {b} pagos": "{a} sur {b} payés",
 "{a} de {b} visitados": "{a} sur {b} visités",
 "{de} deve {v} a {para}": "{de} doit {v} à {para}",
 "{g} de {p}": "{g} sur {p}",
 "{n} atividades do roteiro por fazer": "{n} activités de l'itinéraire à faire",
 "{n} item(ns) enviado(s).": "{n} élément(s) envoyé(s).",
 "{n} itens por pôr na mala": "{n} articles à mettre dans la valise",
 "{n} já estava(m) no My Planner.": "{n} déjà dans My Planner.",
 "{n} listas de Viagens iam inteiras para o My Planner e saíram de lá. Agora o envio é item por item, pelo ⋮ de cada item.": "{n} listes de Voyages étaient envoyées entières vers My Planner et en ont été retirées. Désormais, l'envoi se fait élément par élément, via le ⋮ de chaque élément.",
 "{n} lugares não visitados": "{n} lieux non visités",
 "{n} reservas por confirmar": "{n} réservations à confirmer",
 "{n} sem data (não foi).": "{n} sans date (non envoyé).",
 "ARTIGOS E SITES": "ARTICLES ET SITES",
 "Agora o envio é item por item (pelo ⋮ do item ou selecionando vários). Estas listas iam inteiras e saíram do My Planner ({n} item(ns), nada foi apagado):": "L’envoi se fait maintenant élément par élément (depuis le ⋮ de l’élément ou en en sélectionnant plusieurs). Ces listes étaient envoyées en entier et ont été retirées de My Planner ({n} élément(s), rien n’a été supprimé) :",
 "Artigo científico": "Article scientifique",
 "Artigo de site ou blog": "Article de site ou de blog",
 "Artigo ou site": "Article ou site",
 "Artigos e sites": "Articles et sites",
 "Autor(es)": "Auteur(s)",
 "Cadastrar pela foto ou PDF": "Ajouter à partir d’une photo ou d’un PDF",
 "Capítulo de livro": "Chapitre de livre",
 "Crie o grupo e mande o link: quem entrar vê os artigos e acompanha a leitura. Quem administra inclui, edita e põe fotos, e pode liberar isso para quem também usa a aba. Só quem administra coloca ou tira pessoas.": "Créez le groupe et envoyez le lien : qui le rejoint voit les articles et suit la lecture. Les administrateurs ajoutent, modifient et mettent des photos, et peuvent l’autoriser à ceux qui utilisent aussi l’onglet. Seuls les administrateurs ajoutent ou retirent des personnes.",
 "DOI": "DOI",
 "Data ou ano de publicação": "Date ou année de publication",
 "Editar artigo ou site": "Modifier l’article ou le site",
 "Enviar para o My Planner (lembrete de renovação)": "Envoyer vers My Planner (rappel de renouvellement)",
 "Envio para o My Planner": "Envoi vers My Planner",
 "Ex.: 2024 ou 12/03/2024": "Ex. : 2024 ou 12/03/2024",
 "Ex.: 45-60": "Ex. : 45-60",
 "Grupo de artigos": "Groupe d’articles",
 "Guarde artigos, notícias e páginas da internet com a referência pronta (ABNT e APA). Preencha pelo DOI ou pelo link.": "Gardez articles, actualités et pages web avec la référence prête (ABNT et APA). Remplissez-la par le DOI ou le lien.",
 "Li {a} · Lendo {b} · Parei {c} · Quero ler {d}": "Lus {a} · En cours {b} · Arrêtés {c} · À lire {d}",
 "Minhas anotações do artigo": "Mes notes sur l’article",
 "Notícia": "Actualité",
 "Novo artigo ou site": "Nouvel article ou site",
 "Os dados vêm da ficha do artigo (Editar).": "Les données viennent de la fiche de l’article (Modifier).",
 "Páginas (opcional)": "Pages (facultatif)",
 "Revista, site ou veículo": "Revue, site ou média",
 "artigos e sites lidos no período": "articles et sites lus sur la période",
 "1 confirmado": "1 confirmé",
 "1 convidado que estava em \"Pendente\" passou para \"A convidar\". Ao enviar o convite pelo app, ele passa sozinho para \"Convidado, sem resposta\".": "1 invité qui était « En attente » est passé à « À inviter ». En envoyant l’invitation via l’app, il passe automatiquement à « Invité, sans réponse ».",
 "1 extra": "1 en plus",
 "1 talvez": "1 peut-être",
 "A convidar": "À inviter",
 "Agendar na igreja": "Réserver à l’église",
 "Agora": "Maintenant",
 "Agradeci": "Remercié",
 "Agradeci em {d}": "Remercié le {d}",
 "Agradecidos": "Remerciés",
 "Alianças": "Alliances",
 "Aluguéis (mesas, cadeiras, louças)": "Locations (tables, chaises, vaisselle)",
 "Avisar a data (save the date)": "Annoncer la date (save the date)",
 "Bebidas": "Boissons",
 "Beca e cerimônia": "Toge et cérémonie",
 "Bolo": "Gâteau",
 "Brincadeiras": "Jeux",
 "Brincadeiras e amigo secreto": "Jeux et Père Noël secret",
 "Brindes": "Cadeaux",
 "Buffet": "Traiteur",
 "Calculado sozinho: valor menos o sinal.": "Calculé automatiquement : montant moins l’acompte.",
 "Calcular quantidades": "Calculer les quantités",
 "Categoria do orçamento": "Catégorie du budget",
 "Celebrante": "Officiant",
 "Cerimônia": "Cérémonie",
 "Cerveja (adultos)": "Bière (adultes)",
 "Checklist de preparação": "Liste de préparation",
 "Coloque a data do evento (edite o evento) para ver até quando fazer cada item.": "Indiquez la date de l’événement (modifiez l’événement) pour voir l’échéance de chaque élément.",
 "Coloque as pessoas em \"Pessoas do evento\" (edite o evento).": "Ajoutez les personnes dans « Personnes de l’événement » (modifiez l’événement).",
 "Coloque quanto pretende gastar em cada categoria. Use o ⊕ para calcular por convidado. Os fornecedores contratados entram sozinhos na categoria escolhida.": "Indiquez combien vous comptez dépenser par catégorie. Utilisez ⊕ pour calculer par invité. Les prestataires engagés sont ajoutés automatiquement à la catégorie choisie.",
 "Combinado: {v}": "Convenu : {v}",
 "Comprado": "Acheté",
 "Comprados": "Achetés",
 "Comprar a decoração e as lembrancinhas": "Acheter la décoration et les petits cadeaux",
 "Comprar as alianças": "Acheter les alliances",
 "Comprar as lembrancinhas": "Acheter les petits cadeaux",
 "Comprar bebidas e gelo": "Acheter boissons et glaçons",
 "Comprar comida e bebidas": "Acheter nourriture et boissons",
 "Comprar o que falta": "Acheter ce qui manque",
 "Comprar ou alugar a roupa": "Acheter ou louer la tenue",
 "Confirmados com os acompanhantes. Muda sozinho quando alguém confirma ou desconfirma.": "Confirmés avec les accompagnants. Se met à jour automatiquement quand quelqu’un confirme ou annule.",
 "Confirmar a presença dos convidados": "Confirmer la présence des invités",
 "Confirmar os fornecedores": "Confirmer les prestataires",
 "Confirmar os fornecedores e os convidados": "Confirmer les prestataires et les invités",
 "Contratar a comida": "Réserver le traiteur",
 "Contratar a comida e o bolo": "Réserver le traiteur et le gâteau",
 "Contratar a decoração": "Réserver la décoration",
 "Contratar comida e bebidas": "Réserver nourriture et boissons",
 "Contratar foto e vídeo": "Réserver photo et vidéo",
 "Contratar o buffet": "Réserver le traiteur",
 "Convidado, sem resposta": "Invité, sans réponse",
 "Convidados (por situação, com acompanhantes)": "Invités (par statut, avec accompagnants)",
 "Convidados que contam no ⊕": "Invités comptés dans ⊕",
 "Convites": "Invitations",
 "Cronograma do dia (com responsáveis e situação)": "Programme du jour (avec responsables et statut)",
 "Data do restante": "Date du solde",
 "Data do sinal": "Date de l’acompte",
 "Decoração": "Décoration",
 "Definir a data e o orçamento": "Fixer la date et le budget",
 "Definir a lista de convidados": "Établir la liste des invités",
 "Doces": "Douceurs",
 "Dá para mudar, tirar e incluir itens depois.": "Vous pourrez modifier, retirer et ajouter des éléments plus tard.",
 "Enviar os convites": "Envoyer les invitations",
 "Equipamentos (projetor, som)": "Équipement (projecteur, son)",
 "Equipe (garçons, limpeza)": "Personnel (serveurs, ménage)",
 "Escolha \"Outro\" para escrever o nome.": "Choisissez « Autre » pour saisir le nom.",
 "Escolher a roupa": "Choisir la tenue",
 "Escolher a roupa dos noivos": "Choisir les tenues des mariés",
 "Escolher os padrinhos": "Choisir les témoins et parrains",
 "Estimativa para {n} convidados. Mude o que quiser antes de levar.": "Estimation pour {n} invités. Modifiez ce que vous voulez avant de l’ajouter.",
 "Eu faço": "Je m’en charge",
 "Ex.: 200 un.": "Ex. : 200 u.",
 "Ex.: Copos descartáveis": "Ex. : Gobelets jetables",
 "Ex.: Jogo de panelas": "Ex. : Batterie de casseroles",
 "Ex.: Reservar o local": "Ex. : Réserver le lieu",
 "Ex.: em negociação": "Ex. : en négociation",
 "Extras de margem (quem aparece sem avisar)": "Marge supplémentaire (ceux qui viennent sans prévenir)",
 "Falta 1 dia": "Plus que 1 jour",
 "Falta agradecer": "À remercier",
 "Falta comprar": "À acheter",
 "Falta pagar": "À payer",
 "Fazer a lista de presentes": "Faire la liste de cadeaux",
 "Fazer o curso de batismo": "Suivre la préparation au baptême",
 "Fornecedores (contratado, pago, falta)": "Prestataires (convenu, payé, reste)",
 "Foto e vídeo": "Photo et vidéo",
 "Fraldas": "Couches",
 "Frase curta (opcional)": "Phrase courte (facultatif)",
 "Hoje é o dia do evento!": "C’est le jour de l’événement !",
 "Igreja e celebrante": "Église et officiant",
 "Incluir os Talvez": "Inclure les Peut-être",
 "Incluir telefones": "Inclure les téléphones",
 "Item da lista de compras": "Élément de la liste de courses",
 "Item da preparação": "Élément de préparation",
 "Já deram: {d} · Falta: {f}": "Déjà donné : {d} · Reste : {f}",
 "Já deu": "A donné",
 "L": "L",
 "Lance aqui o que foi gasto. Os pagamentos aos fornecedores e as compras marcadas entram sozinhos.": "Saisissez ici ce qui a été dépensé. Les paiements aux prestataires et les achats cochés sont ajoutés automatiquement.",
 "Lançar o gasto": "Saisir la dépense",
 "Lembrancinhas": "Petits cadeaux",
 "Levar para os itens": "Ajouter aux éléments",
 "Local / espaço": "Lieu / salle",
 "Mais um extra": "Un de plus",
 "Menos um extra": "Un de moins",
 "Música / som / DJ": "Musique / son / DJ",
 "No dia do evento": "Le jour de l’événement",
 "O que comprar": "Quoi acheter",
 "O total muda sozinho quando alguém confirma ou desconfirma.": "Le total se met à jour automatiquement quand quelqu’un confirme ou annule.",
 "O valor do contrato entra sozinho como previsto nesta categoria, e o que for pago entra nos gastos.": "Le montant du contrat est ajouté automatiquement comme prévu dans cette catégorie, et ce qui est payé va dans les dépenses.",
 "O valor entra nos gastos do evento, na categoria do item. Se preferir, pule.": "Le montant va dans les dépenses de l’événement, dans la catégorie de l’élément. Vous pouvez passer.",
 "Onde comprar": "Où acheter",
 "Orçamento do evento": "Budget de l’événement",
 "Os itens marcados entram na categoria com o ⊕ por convidado. Depois é só tocar no ⊕ e pôr o valor unitário.": "Les éléments cochés vont dans la catégorie avec ⊕ par invité. Il suffit ensuite de toucher ⊕ et d’indiquer le prix unitaire.",
 "Os telefones dos convidados só saem no PDF se você marcar \"Incluir telefones\". Valores em moedas diferentes aparecem separados.": "Les téléphones des invités n’apparaissent dans le PDF que si vous cochez « Inclure les téléphones ». Les montants en devises différentes sont affichés séparément.",
 "Pago em {d}": "Payé le {d}",
 "Parte da vaquinha": "Part de la cagnotte",
 "Pessoas do evento": "Personnes de l’événement",
 "Pessoas do evento: {p}": "Personnes de l’événement : {p}",
 "Preparar as brincadeiras": "Préparer les jeux",
 "Preparação": "Préparation",
 "Presente recebido": "Cadeau reçu",
 "Presentes": "Cadeaux",
 "Prova final da roupa": "Essayage final",
 "Pular": "Passer",
 "Quantidade por convidado": "Quantité par invité",
 "Quantidade por convidado × valor unitário": "Quantité par invité × prix unitaire",
 "Quanto custou?": "Combien ça a coûté ?",
 "Quanto já deu": "Montant déjà donné",
 "Quanto vai contribuir": "Montant prévu",
 "Quantos dias antes do evento": "Combien de jours avant l’événement",
 "Quem deu": "Offert par",
 "Quem está no grupo do evento entra sozinho. Use \"+ Adicionar pessoa\" para quem não tem o app. Esta lista é usada no cronograma, nos gastos e na vaquinha.": "Les membres du groupe de l’événement sont ajoutés automatiquement. Utilisez « + Ajouter une personne » pour ceux qui n’ont pas l’app. Cette liste sert au programme, aux dépenses et à la cagnotte.",
 "Recreação e brinquedos": "Animation et jeux",
 "Refrigerante": "Sodas",
 "Relatório do evento": "Rapport de l’événement",
 "Relatório do evento (PDF)": "Rapport de l’événement (PDF)",
 "Reservar o local": "Réserver le lieu",
 "Reservar o local da cerimônia e da festa": "Réserver le lieu de la cérémonie et de la fête",
 "Reservar o local ou a mesa da festa": "Réserver le lieu ou la table de la fête",
 "Restante": "Solde",
 "Restante pago": "Solde payé",
 "Resumo do evento": "Résumé de l’événement",
 "Roupa e beleza": "Tenue et beauté",
 "Salgados": "Amuse-bouches salés",
 "Separar a roupa e o que levar": "Préparer la tenue et ce qu’il faut emporter",
 "Separar os documentos e as alianças": "Préparer les documents et les alliances",
 "Separar os documentos e os ingressos": "Préparer les documents et les billets",
 "Sinal": "Acompte",
 "Sinal pago": "Acompte payé",
 "Sinal {v} pago": "Acompte {v} payé",
 "Usar a lista pronta para {tipo}": "Utiliser la liste toute prête pour {tipo}",
 "Vai contribuir": "Va contribuer",
 "Valor unitário": "Prix unitaire",
 "Vaquinha": "Cagnotte",
 "Você acompanha tudo o que foi compartilhado, sempre atualizado. Para incluir, editar e pegar tarefas, assine a aba.": "Vous suivez tout ce qui a été partagé, toujours à jour. Pour ajouter, modifier et prendre des tâches, abonnez-vous à l’onglet.",
 "agradeci": "remercié",
 "atrasado": "en retard",
 "completo": "complet",
 "deu {d} de {v}": "a donné {d} sur {v}",
 "em {l}": "à {l}",
 "falta o valor": "montant manquant",
 "falta {v} até {d}": "reste {v} d’ici le {d}",
 "gasto em {e}": "dépensé pour {e}",
 "kg": "kg",
 "o evento": "l’événement",
 "restante": "solde",
 "sinal": "acompte",
 "total": "total",
 "un.": "u.",
 "{n} confirmados": "{n} confirmés",
 "{n} convidados contam no ⊕ por convidado.": "{n} invités comptent dans ⊕ par invité.",
 "{n} convidados que estavam em \"Pendente\" passaram para \"A convidar\". Ao enviar o convite pelo app, eles passam sozinhos para \"Convidado, sem resposta\".": "{n} invités qui étaient « En attente » sont passés à « À inviter ». En envoyant l’invitation via l’app, ils passent automatiquement à « Invité, sans réponse ».",
 "{n} extras": "{n} en plus",
 "{n} talvez": "{n} peut-être",
 "{q} por convidado": "{q} par invité",
 "{v} por convidado": "{v} par invité",
 "Item completo": "Élément complet",
 "Nota rápida": "Note rapide",
 "📝 Nota rápida": "📝 Note rapide",
 "Conteúdo da nota": "Contenu de la note",
 "{c} confirmado(s) de {n} convidado(s)": "{c} confirmé(s) sur {n} invité(s)",
 "Serão apagados para todos: os documentos, as reuniões marcadas e as gravações do escritório \"{nome}\". A conversa continua no Mensagens.": "Seront supprimés pour tous : les documents, les réunions prévues et les enregistrements du bureau « {nome} ». La conversation reste dans Messages.",
 "Confirme para apagar o escritório": "Confirmez pour supprimer le bureau",
 "Escreva o assunto da reunião para poder marcar.": "Écrivez le sujet de la réunion pour pouvoir la planifier.",
 "{n} min (marcada para {m} min)": "{n} min (prévue pour {m} min)",
 "Não foi possível baixar o arquivo agora. Confira a internet e tente de novo.": "Impossible de télécharger le fichier pour l’instant. Vérifiez Internet et réessayez.",
 "Meus clientes": "Mes clients",
 "Uma lista só de clientes, usada por todas as abas de trabalho: contato, endereço, etiquetas, anotações e arquivos.": "Une seule liste de clients, utilisée par tous les onglets de travail : contact, adresse, étiquettes, notes et fichiers.",
 "Copiar para Meus clientes": "Copier dans Mes clients",
 "Ver ou mudar": "Voir ou modifier",
 "Ver o documento completo": "Voir le document complet",
 "CEP incompleto": "CEP incomplet",
 "O CEP tem 8 números.": "Le CEP comporte 8 chiffres.",
 "CEP não encontrado": "CEP introuvable",
 "Confira os números ou preencha o endereço à mão.": "Vérifiez les chiffres ou saisissez l’adresse à la main.",
 "Não foi possível buscar o CEP": "Impossible de rechercher le CEP",
 "Confira a internet ou preencha o endereço à mão.": "Vérifiez votre connexion internet ou saisissez l’adresse à la main.",
 "Parece que falta algo neste e-mail (ex.: nome@site.com).": "Il semble manquer quelque chose dans cet e-mail (ex. : nom@site.com).",
 "opcional": "facultatif",
 "Os seus clientes agora ficam numa lista só, usada por todas as abas de trabalho.": "Vos clients sont désormais dans une seule liste, utilisée par tous les onglets de travail.",
 "Portal do Cliente: {n} cliente(s).": "Portail client : {n} client(s).",
 "Freelancer & Projetos: {n} cliente(s).": "Freelance & Projets : {n} client(s).",
 "{n} eram o mesmo cliente em mais de uma aba e viraram uma ficha só.": "{n} étaient le même client dans plusieurs onglets et forment désormais une seule fiche.",
 "Nenhum cliente repetido.": "Aucun client en double.",
 "Nada foi apagado: documentos, pedidos, cartões e horas continuam onde estavam.": "Rien n’a été supprimé : documents, commandes, cartes et heures restent où ils étaient.",
 "Já está em Meus clientes": "Déjà dans Mes clients",
 "{nome} já está na lista.": "{nome} est déjà dans la liste.",
 "Copiado para Meus clientes": "Copié dans Mes clients",
 "Só o nome e o contato foram copiados.": "Seuls le nom et le contact ont été copiés.",
 "Aniversário hoje!": "Anniversaire aujourd’hui !",
 "Fechar tudo": "Tout replier",
 "Abrir tudo": "Tout déplier",
 "Quem é": "Qui c’est",
 "Razão social": "Raison sociale",
 "Nome fantasia": "Nom commercial",
 "Data de abertura": "Date de création",
 "Inscrição estadual / municipal": "Immatriculation d’État / municipale",
 "Outras pessoas de contato": "Autres personnes à contacter",
 "Como chamar": "Comment l’appeler",
 "Cliente desde": "Client depuis",
 "Outro telefone": "Autre téléphone",
 "Site": "Site web",
 "Melhor jeito de falar": "Meilleur moyen de le joindre",
 "Autorizou receber mensagens": "A accepté de recevoir des messages",
 "Outros endereços": "Autres adresses",
 "Relacionamento": "Relation",
 "Como me conheceu": "Comment il m’a connu",
 "Etiquetas": "Étiquettes",
 "Nada anotado ainda.": "Aucune note pour l’instant.",
 "Bloco da aba {aba}": "Section de l’onglet {aba}",
 "Abrir na aba {aba}": "Ouvrir dans l’onglet {aba}",
 "Uma lista só, usada por todas as abas de trabalho.": "Une seule liste, utilisée par tous les onglets de travail.",
 "Escreva o nome do cliente.": "Saisissez le nom du client.",
 "Telefone / WhatsApp": "Téléphone / WhatsApp",
 "Só o nome é obrigatório. Abra as partes que quiser preencher.": "Seul le nom est obligatoire. Ouvrez les parties que vous voulez remplir.",
 "Como chamar (apelido)": "Comment l’appeler (surnom)",
 "Inscrição estadual / municipal (opcional)": "Immatriculation d’État / municipale (facultatif)",
 "Cargo": "Fonction",
 "Telefone da pessoa de contato": "Téléphone de la personne à contacter",
 "Outras pessoas de contato (uma por linha: nome, cargo, telefone)": "Autres personnes à contacter (une par ligne : nom, fonction, téléphone)",
 "O telefone principal é WhatsApp": "Le téléphone principal est sur WhatsApp",
 "O outro telefone é WhatsApp": "L’autre téléphone est sur WhatsApp",
 "Instagram": "Instagram",
 "Ex.: @nome": "Ex. : @nom",
 "Ex.: WhatsApp, à tarde": "Ex. : WhatsApp, l’après-midi",
 "Estado (UF)": "État (UF)",
 "Endereço (como estava escrito)": "Adresse (telle qu’elle était écrite)",
 "Outros endereços (trabalho, entrega...)": "Autres adresses (travail, livraison...)",
 "Google": "Google",
 "Passou na frente": "Passait devant",
 "Indicado por": "Recommandé par",
 "Criar etiqueta": "Créer une étiquette",
 "Ex.: VIP, Mensal, Atacado": "Ex. : VIP, Mensuel, Grossiste",
 "Ativo": "Actif",
 "Inativo": "Inactif",
 "Em negociação": "En négociation",
 "O cliente autorizou receber mensagens?": "Le client a-t-il accepté de recevoir des messages ?",
 "Sem autorização, nada de mensagem de aniversário, cobrança automática ou promoção para este cliente.": "Sans accord, pas de message d’anniversaire, de relance de paiement automatique ni de promotion pour ce client.",
 "aniversário hoje": "anniversaire aujourd’hui",
 "contato: {n}": "contact : {n}",
 "com esse telefone": "avec ce téléphone",
 "com esse e-mail": "avec cet e-mail",
 "com esse documento": "avec ce numéro",
 "com esse nome": "avec ce nom",
 "Cliente parecido": "Client similaire",
 "Já existe {nome} {por}. Abrir?": "{nome} existe déjà {por}. Ouvrir ?",
 "Cadastrar mesmo assim": "Ajouter quand même",
 "Serão apagados: a ficha, as anotações e os arquivos deste cliente.": "Seront supprimés : la fiche, les notes et les fichiers de ce client.",
 "Também nas abas: {abas} (com os documentos, pedidos, cartões e horas de lá).": "Aussi dans les onglets : {abas} (avec leurs documents, commandes, cartes et heures).",
 "Juntar com outra ficha": "Fusionner avec une autre fiche",
 "Juntar fichas": "Fusionner les fiches",
 "Não há outra ficha para juntar.": "Aucune autre fiche à fusionner.",
 "Juntar \"{nome}\" com:": "Fusionner « {nome} » avec :",
 "Juntar as duas fichas?": "Fusionner les deux fiches ?",
 "\"{a}\" fica com tudo de \"{b}\" (dados, anotações, arquivos e as ligações com as abas). A ficha \"{b}\" deixa de existir.": "« {a} » récupère tout de « {b} » (données, notes, fichiers et liens avec les onglets). La fiche « {b} » n’existera plus.",
 "Juntar": "Fusionner",
 "Confirme para juntar as fichas": "Confirmez pour fusionner les fiches",
 "Aniversariantes do mês": "Anniversaires du mois",
 "Ativos": "Actifs",
 "Inativos": "Inactifs",
 "Cadastre cada cliente uma vez: ele aparece em todas as abas de trabalho que você usa.": "Ajoutez chaque client une seule fois : il apparaît dans tous les onglets de travail que vous utilisez.",
 "Novo cliente": "Nouveau client",
 "Editar cliente": "Modifier le client",
 "Linha do tempo": "Historique",
 "{n} registro(s)": "{n} enregistrement(s)",
 "Nada ainda. Vendas, pagamentos, documentos e horas aparecem aqui.": "Rien pour l’instant. Les ventes, paiements, documents et heures apparaissent ici.",
 "Me deve": "Me doit",
 "Total pago": "Total payé",
 "Última compra ou atendimento": "Dernier achat ou service",
 "Próximo compromisso": "Prochain rendez-vous",
 "na entrega": "à la livraison",
 "Passou do limite de fiado ({v}).": "Limite de crédit dépassé ({v}).",
 "Recebeu {v} ({p})": "{v} reçu ({p})",
 "Hoje é aniversário de {n}.": "C’est l’anniversaire de {n} aujourd’hui.",
 "Mandar parabéns": "Envoyer ses vœux",
 "{n}: parcela de {v} atrasada.": "{n} : échéance de {v} en retard.",
 "Cobrar": "Relancer",
 "{n} não compra há {d} dias.": "{n} n’a rien acheté depuis {d} jours.",
 "Chamar de volta": "Reprendre contact",
 "🟢 em dia · 🟡 sumido": "🟢 à jour · 🟡 absent",
 "🟢 em dia · 🟡 algo vencendo ou cliente sumido · 🔴 atrasado": "🟢 à jour · 🟡 échéance proche ou client absent · 🔴 en retard",
 "Limite de fiado (opcional)": "Limite de crédit (facultatif)",
 "Avisa quando o que ele deve passar deste valor.": "Vous avertit quand sa dette dépasse ce montant.",
 "A prazo": "En plusieurs fois",
 "parcela atrasada": "échéance en retard",
 "falta na entrega": "reste à la livraison",
 "Sumidos": "Absents",
 "Sinal pago, falta o resto": "Acompte payé, reste à régler",
 "Pagou {a} de {b}": "{a} payé sur {b}",
 "Esta parcela vem de Meus clientes. Marque aqui como recebida ou abra o cliente para cobrar e gerar o recibo.": "Cette échéance provient de Mes clients. Marquez-la ici comme reçue ou ouvrez le client pour relancer et générer le reçu.",
 "Sinal + restante": "Acompte + solde",
 "Pix": "Pix",
 "Cartão de crédito à vista": "Carte de crédit en une fois",
 "Cartão de crédito parcelado": "Carte de crédit en plusieurs fois",
 "Fiado / a prazo": "À crédit / en plusieurs fois",
 "Parcela única": "Paiement unique",
 "Oi, {nome}! Feliz aniversário! 🎉 Que o seu dia seja lindo. Um abraço!": "Bonjour {nome} ! Joyeux anniversaire ! 🎉 Je vous souhaite une très belle journée. Bien à vous !",
 "Oi, {nome}! Faz tempo que a gente não se fala. Posso ajudar em alguma coisa? Vai ser um prazer te atender de novo!": "Bonjour {nome} ! Cela fait longtemps. Puis-je vous aider ? Ce serait un plaisir de vous servir à nouveau !",
 "Oi, {nome}! Passando para lembrar da parcela de {v} que venceu dia {d}. Qualquer coisa, me chama. Obrigada!": "Bonjour {nome} ! Petit rappel pour l’échéance de {v} arrivée à terme le {d}. N’hésitez pas à me contacter. Merci !",
 "Oi, {nome}! Passando para lembrar da parcela de {v}{d}. Qualquer coisa, me chama. Obrigada!": "Bonjour {nome} ! Petit rappel pour l’échéance de {v}{d}. N’hésitez pas à me contacter. Merci !",
 "que vence dia {d}": "qui arrive à terme le {d}",
 "Quanto recebeu?": "Combien avez-vous reçu ?",
 "Falta {v}. Pode ser só uma parte.": "Reste {v}. Ce peut être une partie seulement.",
 "(seu nome ou sua marca, em Como você recebe?)": "(votre nom ou votre marque, dans Comment êtes-vous payé ?)",
 "Recibo {c}": "Reçu {c}",
 "Recebi de {c} a quantia de {v}, referente a {o}.": "J’ai reçu de {c} la somme de {v}, au titre de {o}.",
 "{v} no {f} → recebe {l}": "{v} par {f} → vous recevez {l}",
 "Pagou {a} de {b}, faltam {c}": "{a} payé sur {b}, reste {c}",
 "Recebido em {d}": "Reçu le {d}",
 "Cobrar pelo WhatsApp": "Relancer sur WhatsApp",
 "Sem autorização": "Non autorisé",
 "Este cliente não autorizou receber mensagens (ficha do cliente › Relacionamento).": "Ce client n’a pas accepté de recevoir des messages (fiche client › Relation).",
 "Sem telefone": "Pas de téléphone",
 "Coloque o telefone na ficha do cliente.": "Ajoutez le téléphone dans la fiche client.",
 "Gerar recibo": "Générer le reçu",
 "Como você recebe?": "Comment êtes-vous payé ?",
 "Só \"À vista\": a tela fica limpa, sem a prazo, parcelas nem vermelho.": "Seulement \"Comptant\" : écran épuré, sans crédit, échéances ni rouge.",
 "Taxa da maquininha (%)": "Frais du terminal de paiement (%)",
 "Taxa {k}": "Frais {k}",
 "Cliente sumido depois de (dias sem comprar)": "Client absent après (jours sans achat)",
 "Dias para considerar sumido": "Jours avant de considérer absent",
 "Lembretes de cobrança por parcela atrasada": "Rappels de paiement pour échéances en retard",
 "Nome ou marca no recibo": "Nom ou marque sur le reçu",
 "Ex.: Ana Beatriz Doces": "Ex. : Ana Beatriz Douceurs",
 "Venda ou serviço": "Vente ou service",
 "O que foi vendido ou feito": "Ce qui a été vendu ou réalisé",
 "Ex.: Bolo de aniversário": "Ex. : Gâteau d’anniversaire",
 "Como paga": "Mode de paiement",
 "Sinal (%)": "Acompte (%)",
 "Ou escreva o valor do sinal logo abaixo.": "Ou saisissez le montant de l’acompte juste en dessous.",
 "Sinal (valor)": "Acompte (montant)",
 "Restante na entrega": "Solde à la livraison",
 "Próximo vencimento": "Prochaine échéance",
 "Sinal a receber": "Acompte à recevoir",
 "falta {v}{q}": "reste {v}{q}",
 "quitado": "soldé",
 "Parcelas mantidas": "Échéances conservées",
 "Já há pagamento registrado: as parcelas não foram refeitas. Para mudar, desfaça os pagamentos primeiro.": "Un paiement est déjà enregistré : les échéances n’ont pas été recalculées. Pour les modifier, annulez d’abord les paiements.",
 "Registre o que o cliente comprou ou o serviço que você fez, e como ele paga.": "Enregistrez ce que le client a acheté ou le service réalisé, et comment il paie.",
 "Débito": "Débit",
 "Crédito à vista": "Crédit en une fois",
 "Crédito 2x": "Crédit en 2 fois",
 "Crédito 3x": "Crédit en 3 fois",
 "Crédito 4x": "Crédit en 4 fois",
 "Crédito 5x": "Crédit en 5 fois",
 "Crédito 6x": "Crédit en 6 fois",
 "Crédito 7x": "Crédit en 7 fois",
 "Crédito 8x": "Crédit en 8 fois",
 "Crédito 9x": "Crédit en 9 fois",
 "Crédito 10x": "Crédit en 10 fois",
 "Crédito 11x": "Crédit en 11 fois",
 "Crédito 12x": "Crédit en 12 fois",
 "ATRASADOS": "EN RETARD",
 "Atrasado (hoje): {v}": "En retard (aujourd’hui) : {v}",
 "Buscar um cliente": "Rechercher un client",
 "CPF/CNPJ completo, endereço completo e data de nascimento. Pede a senha do app.": "CPF/CNPJ complet, adresse complète et date de naissance. Demande le mot de passe de l’app.",
 "Cliente cadastrado": "Client ajouté",
 "Com documentos: guarde o arquivo em lugar seguro.": "Avec documents : conservez le fichier en lieu sûr.",
 "Como pagou": "Mode de paiement",
 "Esse contato não tem nome.": "Ce contact n’a pas de nom.",
 "Exportar planilha": "Exporter le tableur",
 "Falta receber": "Reste à encaisser",
 "Falta receber (hoje): {v}": "Reste à encaisser (aujourd’hui) : {v}",
 "Importar dos contatos": "Importer depuis les contacts",
 "Importar dos contatos do celular": "Importer depuis les contacts du téléphone",
 "Incluir documentos": "Inclure les documents",
 "Incluir documentos no relatório": "Inclure les documents dans le rapport",
 "MELHORES CLIENTES": "MEILLEURS CLIENTS",
 "Melhores clientes": "Meilleurs clients",
 "Não foi possível gerar a planilha.": "Impossible de générer le tableur.",
 "O que foi": "Description",
 "Pago em": "Payé le",
 "Para trazer clientes dos contatos do celular, atualize o My Planner pela loja de aplicativos.": "Pour importer des clients depuis les contacts du téléphone, mettez à jour My Planner via la boutique d’applications.",
 "RECEBIDO POR DIA": "ENCAISSÉ PAR JOUR",
 "RECEBIDO POR MÊS": "ENCAISSÉ PAR MOIS",
 "Recebeu": "Encaissé",
 "Recebeu no período": "Encaissé sur la période",
 "Recebeu no período: {v}": "Encaissé sur la période : {v}",
 "Recebido no período": "Encaissé sur la période",
 "Relatório de clientes": "Rapport clients",
 "Relatório deste cliente": "Rapport de ce client",
 "Sem a permissão de contatos não dá para escolher um contato. Você pode liberar nos ajustes do celular.": "Sans l’autorisation d’accès aux contacts, impossible de choisir un contact. Vous pouvez l’activer dans les réglages du téléphone.",
 "Sem documentos: o CPF/CNPJ sai só com os 2 últimos números. As anotações nunca saem.": "Sans documents : le CPF/CNPJ n’affiche que les 2 derniers chiffres. Les notes ne sont jamais incluses.",
 "Todos os clientes": "Tous les clients",
 "Trabalha em: {e}": "Travaille chez : {e}",
 "Trazer outro": "En ajouter un autre",
 "VENDAS E ATENDIMENTOS": "VENTES ET SERVICES",
 "Vence": "Échéance",
 "Venceu": "Échu",
 "Vendas e atendimentos": "Ventes et services",
 "Vendeu": "Vendu",
 "Vendeu no período": "Vendu sur la période",
 "Vendeu no período: {v}": "Vendu sur la période : {v}",
 "venceu {d}": "échu le {d}",
 "vendido no período": "vendu sur la période",
 "{nome} comprou no período": "{nome} a acheté sur la période",
 "{nome} entrou em Meus clientes. Confira a ficha e marque se ele autorizou receber mensagens.": "{nome} a été ajouté à Mes clients. Vérifiez la fiche et indiquez s’il a accepté de recevoir des messages.",
 "{n} compra(s)": "{n} achat(s)",
 "Arraste uma caixa para a esquerda para arquivar ou para a direita para excluir. Segure numa parte livre da caixa e arraste para mudar a ordem.": "Faites glisser une boîte vers la gauche pour l’archiver ou vers la droite pour la supprimer. Maintenez une zone libre de la boîte et faites glisser pour changer l’ordre.",
 "Bloco": "Bloc",
 "Confirme para apagar o grupo": "Confirmez pour supprimer le groupe",
 "Descer": "Descendre",
 "Opções do bloco": "Options du bloc",
 "Exigências do destino": "Exigences de la destination",
 "{n} para acertar": "{n} à régler",
 "{n} parada(s)": "{n} étape(s)",
 "Cor do item selecionado": "Couleur de l’élément sélectionné",
 "Abrir o grupo": "Ouvrir le groupe",
 "Recolher o grupo": "Replier le groupe",
 "Arraste uma caixa para a direita para excluir ou para a esquerda para arquivar. Segure e arraste para mudar a ordem.": "Faites glisser une boîte vers la droite pour la supprimer ou vers la gauche pour l’archiver. Maintenez et faites glisser pour changer l’ordre.",
 "Editar subtítulo": "Modifier le sous-titre",
 "Início da caixa": "Début de la boîte",
 "Mover para…": "Déplacer vers…",
 "Mover {n} item(ns) para": "Déplacer {n} élément(s) vers",
 "Opções do item": "Options de l’élément",
 "Transformar em subtítulo": "Transformer en sous-titre",
 "Transformar em texto": "Transformer en texte",
 "esta caixa": "cette boîte",
 "{a} de {n} feitos": "{a} sur {n} faits",
 "1 documento pedido atrasado": "1 document demandé en retard",
 "1 pedido vence logo": "1 demande arrive bientôt à échéance",
 "A lista vem de \"Meus clientes\".": "La liste vient de « Mes clients ».",
 "Abrir Meus clientes": "Ouvrir Mes clients",
 "As abas Escritório e Portal do Cliente agora são uma aba só.": "Les onglets Cabinet et Portail client ne font plus qu’un.",
 "Clientes com pendência": "Clients avec des éléments en attente",
 "Com pendência ({n})": "En attente ({n})",
 "Conversa da equipe": "Discussion d’équipe",
 "Crie o escritório e chame a equipe (amigos do app ou convite pelo link): conversa, reuniões de vídeo e documentos internos. Trabalha sozinho? Use só os Clientes.": "Créez le cabinet et invitez l’équipe (amis de l’app ou lien d’invitation) : discussion, réunions vidéo et documents internes. Vous travaillez seul ? Utilisez seulement Clients.",
 "Documentos internos": "Documents internes",
 "Entrar com um código de convite": "Rejoindre avec un code d’invitation",
 "Escritório & Clientes": "Cabinet & Clients",
 "Escritórios: {n}": "Cabinets : {n}",
 "Esta parte é para quem trabalha com equipe": "Cette partie est pour ceux qui travaillent en équipe",
 "Guias vencendo": "Avis d’impôt à échéance",
 "Minhas tarefas": "Mes tâches",
 "Nada foi apagado: a equipe, a conversa, as reuniões, os documentos e os clientes convidados continuam como estavam.": "Rien n’a été supprimé : l’équipe, la discussion, les réunions, les documents et les clients invités sont toujours là.",
 "Nenhum cliente ainda. Cadastre em \"Meus clientes\": ele aparece aqui na hora.": "Aucun client pour l’instant. Ajoutez-en un dans « Mes clients » : il apparaît ici aussitôt.",
 "Para quem trabalha com clientes, sozinho ou com equipe: a pasta de cada cliente (documentos, pedidos, guias), equipe, conversa, reuniões e documentos internos.": "Pour ceux qui travaillent avec des clients, seuls ou en équipe : le dossier de chaque client (documents, demandes, avis d’impôt), équipe, discussion, réunions et documents internes.",
 "Pastas de clientes do Portal: {c} (com {d} documentos e {p} pedidos)": "Dossiers clients du Portail : {c} (avec {d} documents et {p} demandes)",
 "Pessoa física": "Particulier",
 "Procurar por nome, CNPJ ou CPF": "Rechercher par nom, CNPJ ou CPF",
 "Reuniões hoje": "Réunions aujourd’hui",
 "Sem escritório (equipe). Toque para criar ou entrar com um código.": "Aucun cabinet (équipe). Touchez pour en créer un ou rejoindre avec un code.",
 "Só a equipe vê. Clientes nunca veem esta parte.": "Seule l’équipe le voit. Les clients ne voient jamais cette partie.",
 "Tudo em dia": "Tout est à jour",
 "Vencendo ({n})": "Bientôt dus ({n})",
 "chega na próxima versão": "arrive dans la prochaine version",
 "nos próximos 7 dias": "dans les 7 prochains jours",
 "vence amanhã": "échéance demain",
 "vence hoje": "échéance aujourd’hui",
 "{doc} venceu em {d}": "{doc} était dû le {d}",
 "{n} documentos pedidos atrasados": "{n} documents demandés en retard",
 "{n} pedidos vencem logo": "{n} demandes arrivent bientôt à échéance",
 "🟢 em dia · 🟡 algo vence logo · 🔴 pedido atrasado ou guia vencida": "🟢 à jour · 🟡 échéance proche · 🔴 demande en retard ou avis d’impôt échu",
 "Acesso ao gov.br": "Accès à gov.br",
 "Alvará": "Licence d’exploitation",
 "Até o dia (do mês)": "Jusqu’au jour (du mois)",
 "CCMEI (certificado do MEI)": "CCMEI (certificat MEI)",
 "Cadastre o telefone do cliente para lembrar pelo WhatsApp.": "Ajoutez le téléphone du client pour lui rappeler par WhatsApp.",
 "Cartão CNPJ": "Carte CNPJ",
 "Checklist criado": "Checklist créée",
 "Checklist de cliente novo": "Checklist nouveau client",
 "Cliente viu {doc}": "Le client a vu {doc}",
 "Cole no app do banco, em Pix copia e cola.": "Collez-le dans l’app de votre banque, dans Pix copier-coller.",
 "Cole no app do banco.": "Collez-le dans l’app de votre banque.",
 "Comprovante de endereço": "Justificatif de domicile",
 "Contrato social e alterações": "Statuts et modifications",
 "Copiado": "Copié",
 "Copiar Pix": "Copier Pix",
 "Copiar código de barras": "Copier le code-barres",
 "Código de barras (linha digitável)": "Code-barres (ligne numérique)",
 "Dados bancários": "Coordonnées bancaires",
 "Escreva o recado.": "Écrivez le message.",
 "Escritório enviou {doc}": "Le cabinet a envoyé {doc}",
 "Este cliente não autorizou receber mensagens (ficha em Meus clientes).": "Ce client n’a pas accepté de recevoir des messages (fiche dans Mes clients).",
 "Extratos bancários": "Relevés bancaires",
 "Ficha completa": "Fiche complète",
 "Guia": "Bordereau",
 "Guias a pagar": "Bordereaux à payer",
 "Honorário": "Honoraires",
 "Honorário por": "Honoraires par",
 "Informes de rendimentos": "Attestations de revenus",
 "Lembrar pelo WhatsApp": "Rappeler par WhatsApp",
 "Ler a guia ou o boleto com a minha IA": "Lire le bordereau ou le boleto avec mon IA",
 "Lucro presumido": "Bénéfice présumé",
 "Lucro real": "Bénéfice réel",
 "Nada ainda.": "Rien pour l’instant.",
 "Nenhum pedido em aberto.": "Aucune demande en cours.",
 "Notas fiscais emitidas": "Factures émises",
 "O cliente": "Le client",
 "O pedido entrou em Pedidos de documentos.": "La demande a été ajoutée aux Demandes de documents.",
 "Oi, {nome}! Falta: {itens}. Pode mandar por aqui?": "Bonjour {nome} ! Il manque : {itens}. Pouvez-vous l’envoyer ici ?",
 "Oi, {nome}! Faltam: {itens}. Pode mandar por aqui?": "Bonjour {nome} ! Il manque : {itens}. Pouvez-vous les envoyer ici ?",
 "Oi, {nome}! Tudo certo por aí?": "Bonjour {nome} ! Tout va bien de votre côté ?",
 "Pedido criado": "Demande créée",
 "Pedido feito: {o}": "Demande envoyée : {o}",
 "Pedido recebido: {o}": "Demande reçue : {o}",
 "Pedidos pendentes": "Demandes en attente",
 "Pedir de novo todo mês": "Redemander chaque mois",
 "Pedir nova ({c})": "Demander une nouvelle ({c})",
 "Pendentes": "En attente",
 "Que tipo de cliente?": "Quel type de client ?",
 "RG e CPF": "RG et CPF",
 "RG e CPF do titular": "RG et CPF du titulaire",
 "RG e CPF dos sócios": "RG et CPF des associés",
 "Recados": "Messages",
 "Recados entre você e o cliente, presos à pasta dele.": "Messages entre vous et le client, rangés dans son dossier.",
 "Responde ao pedido": "Répond à la demande",
 "Tipo / regime": "Type / régime",
 "Visto pelo cliente em {d}": "Vu par le client le {d}",
 "Válido até": "Valable jusqu’au",
 "ano": "an",
 "código Pix copia e cola, se houver": "code Pix copier-coller, s’il y en a un",
 "data de vencimento": "date d’échéance",
 "documento": "document",
 "linha digitável do boleto ou da guia, só números": "ligne numérique du boleto ou du bordereau, chiffres uniquement",
 "mês": "mois",
 "novo": "nouveau",
 "todo mês, até o dia {n}": "chaque mois, avant le {n}",
 "valor a pagar": "montant à payer",
 "válido até {d}": "valable jusqu’au {d}",
 "{c} nova": "Nouveau {c}",
 "{doc} pago": "{doc} payé",
 "{n} a pagar": "{n} à payer",
 "{n} enviou {doc}": "{n} a envoyé {doc}",
 "{n} novo(s)": "{n} nouveau(x)",
 "{n} pedido(s) de documentos criados, com prazo de 7 dias.": "{n} demande(s) de documents créée(s), à rendre sous 7 jours.",
 "{n} vencida(s)": "{n} en retard",
 "Última declaração do Imposto de Renda": "Dernière déclaration d’impôt sur le revenu",
 "Últimas guias pagas": "Derniers bordereaux payés",
 "Esta parte do Escritório ainda não foi ligada no servidor. No computador, rode o 56-SERVIDOR-0.96.bat (uma vez só).": "Cette partie du Bureau n’est pas encore reliée au serveur. Sur l’ordinateur, lancez 56-SERVIDOR-0.96.bat (une seule fois).",
 "Só vê": "Voit seulement",
 "Nova versão": "Nouvelle version",
 "Já havia um arquivo com este nome: o anterior fica guardado como versão {n}.": "Un fichier portait déjà ce nom : l’ancien est conservé comme version {n}.",
 "Visto por e comentários": "Vu par et commentaires",
 "Arquivar (só neste aparelho)": "Archiver (sur cet appareil seulement)",
 "Tirar do topo": "Retirer du haut",
 "Fixar no topo (para todos)": "Épingler en haut (pour tous)",
 "Mover para a pasta…": "Déplacer vers le dossier…",
 "versão {n}": "version {n}",
 "visto por {n}": "vu par {n}",
 "Até 50 MB por arquivo. Enviar um arquivo com o mesmo nome guarda o anterior como versão.": "Jusqu’à 50 Mo par fichier. Envoyer un fichier du même nom conserve l’ancien comme version.",
 "Procurar documento ou pasta": "Rechercher un document ou un dossier",
 "Fixados": "Épinglés",
 "Abrir o documento": "Ouvrir le document",
 "enviado por {nome}": "envoyé par {nome}",
 "Versões ({n})": "Versions ({n})",
 "Versão {n} (atual)": "Version {n} (actuelle)",
 "Versão {n}": "Version {n}",
 "Visto por ({n})": "Vu par ({n})",
 "Ninguém da equipe abriu ainda.": "Personne de l’équipe ne l’a encore ouvert.",
 "{nome} em {d}": "{nome} le {d}",
 "Comentários ({n})": "Commentaires ({n})",
 "Escreva um comentário": "Écrivez un commentaire",
 "Contratos": "Contrats",
 "Financeiro do escritório": "Finances du bureau",
 "RH": "RH",
 "Mover para a pasta": "Déplacer vers le dossier",
 "Ou escreva o nome de uma pasta nova": "Ou saisissez le nom d’un nouveau dossier",
 "Ela se repete toda semana: cancelando, sai de todas as semanas, da lista e dos Recebidos da equipe.": "Elle se répète chaque semaine : en l’annulant, elle disparaît de toutes les semaines, de la liste et des Reçus de l’équipe.",
 "a equipe toda": "toute l’équipe",
 "Com {quem}": "Avec {quem}",
 "toda semana": "chaque semaine",
 "Vão: {n}": "Présents : {n}",
 "Não vão: {n}": "Absents : {n}",
 "Vou": "J’y vais",
 "Não vou": "Je n’y vais pas",
 "Pauta": "Ordre du jour",
 "Ata": "Compte rendu",
 "Escrever a ata": "Rédiger le compte rendu",
 "Abrir o link": "Ouvrir le lien",
 "Cada pessoa convidada recebe a reunião em Recebidos e coloca no Planner com um toque, com o alerta.": "Chaque personne invitée reçoit la réunion dans Reçus et l’ajoute au Planner d’un seul geste, avec l’alerte.",
 "Escreva primeiro as anotações da reunião (o que foi falado e decidido); a IA organiza em ata.": "Écrivez d’abord les notes de la réunion (ce qui a été dit et décidé) ; l’IA les organise en compte rendu.",
 "Ata: {nome}": "Compte rendu : {nome}",
 "Gerando...": "Génération...",
 "Gerar ata com a minha IA": "Générer le compte rendu avec mon IA",
 "A IA organiza a pauta e as suas anotações em ata. Confira antes de salvar.": "L’IA organise l’ordre du jour et vos notes en compte rendu. Vérifiez avant d’enregistrer.",
 "Ainda sem ata.": "Pas encore de compte rendu.",
 "Tarefas da reunião ({n})": "Tâches de la réunion ({n})",
 "Tarefa da reunião": "Tâche de la réunion",
 "Salvar a ata": "Enregistrer le compte rendu",
 "Repetir toda semana ({dia})": "Répéter chaque semaine ({dia})",
 "Quem participa": "Qui participe",
 "A equipe toda": "Toute l’équipe",
 "Link externo (opcional: Meet, Zoom, Teams)": "Lien externe (facultatif : Meet, Zoom, Teams)",
 "O link precisa começar com https://": "Le lien doit commencer par https://",
 "Marcar e avisar quem participa": "Planifier et prévenir les participants",
 "Cargo e papel": "Poste et rôle",
 "Passar o Admin": "Transférer l’Admin",
 "Passar o Admin para {nome}?": "Transférer l’Admin à {nome} ?",
 "{nome} passa a ser quem cuida do escritório (pode apagá-lo). Você continua na equipe como administrador (quem recebe pode mudar isso depois).": "{nome} devient la personne qui gère le bureau (et peut le supprimer). Vous restez dans l’équipe comme administrateur (le nouveau responsable pourra le modifier ensuite).",
 "Passar": "Transférer",
 "{nome} agora cuida do escritório.": "{nome} gère désormais le bureau.",
 "Seu papel aqui é \"Só vê\": você acompanha avisos, tarefas, reuniões e documentos.": "Votre rôle ici est « Voit seulement » : vous suivez les avis, tâches, réunions et documents.",
 "Edita": "Peut modifier",
 "Incluir": "Ajouter",
 "Novo aviso no mural": "Nouvel avis sur le tableau",
 "Você só pode ver este escritório: quem administra escolheu o papel \"Só vê\" para você. Peça a quem administra para mudar, se precisar.": "Vous ne pouvez que consulter ce bureau : l’administrateur a choisi le rôle « Voit seulement » pour vous. Demandez-lui de le changer si besoin.",
 "Quem viu": "Qui l’a vu",
 "Apagar aviso": "Supprimer l’avis",
 "Mural de avisos": "Tableau d’affichage",
 "Novo aviso": "Nouvel avis",
 "Ex.: Feriado na sexta: escritório fechado": "Ex. : Jour férié vendredi : bureau fermé",
 "Fixar no mural": "Épingler au tableau",
 "Nenhum aviso. Os avisos ficam fixados aqui para toda a equipe.": "Aucun avis. Les avis restent épinglés ici pour toute l’équipe.",
 "visto por {n} de {m}": "vu par {n} sur {m}",
 "sem responsável": "sans responsable",
 "atrasada desde {d}": "en retard depuis le {d}",
 "prazo {d}": "échéance {d}",
 "Comecei": "J’ai commencé",
 "Terminei": "Terminé",
 "Reabrir": "Rouvrir",
 "Tarefas da equipe": "Tâches de l’équipe",
 "1 aberta": "1 ouverte",
 "{n} abertas": "{n} ouvertes",
 "Minhas tarefas ({n})": "Mes tâches ({n})",
 "Nenhuma tarefa sua aberta. Toque em \"Eu faço\" numa tarefa da equipe.": "Aucune de vos tâches n’est ouverte. Touchez « Je m’en occupe » sur une tâche de l’équipe.",
 "Nenhuma tarefa aberta.": "Aucune tâche ouverte.",
 "Feitas ({n})": "Terminées ({n})",
 "Apagar a tarefa?": "Supprimer la tâche ?",
 "O que precisa ser feito? (ex.: Apurar o DAS de março)": "Que faut-il faire ? (ex. : Calculer le DAS de mars)",
 "Cliente (opcional)": "Client (facultatif)",
 "Prazo (opcional)": "Échéance (facultatif)",
 "Responsável (opcional; senão, alguém toca em \"Eu faço\")": "Responsable (facultatif ; sinon, quelqu’un touche « Je m’en occupe »)",
 "Escreva a tarefa para poder salvar.": "Écrivez la tâche pour pouvoir enregistrer.",
 "Membro": "Membre",
 "Cargo (livre)": "Poste (libre)",
 "Ex.: Advogada, Assistente, Estagiário": "Ex. : Avocate, Assistante, Stagiaire",
 "Papel": "Rôle",
 "Admin: pode tudo no escritório.": "Admin : peut tout faire dans le bureau.",
 "Edita: inclui tarefas, avisos, documentos e reuniões": "Modifie : ajoute des tâches, avis, documents et réunions",
 "Só vê: acompanha tudo, sem incluir nem mudar": "Voit seulement : suit tout, sans ajouter ni modifier",
 "Proposta": "Proposition",
 "Documento sensível (pede a senha do app para abrir)": "Document sensible (demande le mot de passe de l’app pour l’ouvrir)",
 "Li e concordo: {d}": "Lu et approuvé : {d}",
 "Li e concordo": "J’ai lu et j’accepte",
 "Ao tocar em Concordo, o app guarda a data e a hora em que você leu e concordou com \"{doc}\". É um aceite simples: não substitui uma assinatura digital oficial.": "En touchant J’accepte, l’app enregistre la date et l’heure auxquelles vous avez lu et accepté « {doc} ». C’est une acceptation simple : elle ne remplace pas une signature numérique officielle.",
 "Concordo": "J’accepte",
 "Fotos (escolha quais entram)": "Photos (choisissez lesquelles)",
 "1 foto não pôde ser lida neste dispositivo e ficou de fora.": "1 photo n’a pas pu être lue sur cet appareil et a été laissée de côté.",
 "{n} fotos não puderam ser lidas neste dispositivo e ficaram de fora.": "{n} photos n’ont pas pu être lues sur cet appareil et ont été laissées de côté.",
 "Nenhuma foto no álbum desta viagem.": "Aucune photo dans l’album de ce voyage.",
 "Toque nas fotos para marcar ou desmarcar. Elas entram reduzidas, para o PDF ficar leve.": "Touchez les photos pour les cocher ou décocher. Elles sont réduites pour que le PDF reste léger.",
 "Sugerir até 12": "Suggérer jusqu’à 12",
 "1 foto marcada": "1 photo cochée",
 "{n} fotos marcadas": "{n} photos cochées",
 "Com mais de 12 fotos o PDF fica mais pesado.": "Avec plus de 12 photos, le PDF devient plus lourd.",
 "Confirme para abrir este documento": "Confirmez pour ouvrir ce document",
 "Como usar esta aba": "Comment utiliser cet onglet",
 "1 cliente estava em mais de uma aba e virou uma ficha só.": "1 client figurait dans plusieurs onglets et ne forme plus qu’une seule fiche.",
 "Juntar {n} fotos num PDF?": "Réunir {n} photos dans un PDF ?",
 "As fotos viram as páginas de um PDF só, na ordem da lista. As fotos soltas saem desta ficha.": "Les photos deviennent les pages d’un seul PDF, dans l’ordre de la liste. Les photos isolées sont retirées de cette fiche.",
 "Não foi possível ler as fotos neste dispositivo.": "Impossible de lire les photos sur cet appareil.",
 "PDF criado": "PDF créé",
 "Montando o PDF...": "Création du PDF...",
 "Juntar as {n} fotos num PDF": "Réunir les {n} photos dans un PDF",
 "Baixar o mês": "Télécharger le mois",
 "Os arquivos deste mês estão em outro dispositivo e não puderam ser lidos aqui.": "Les fichiers de ce mois se trouvent sur un autre appareil et n’ont pas pu être lus ici.",
 "Os documentos deste mês não têm arquivos.": "Les documents de ce mois n’ont pas de fichiers.",
 "1 arquivo está em outro dispositivo e ficou de fora.": "1 fichier se trouve sur un autre appareil et a été exclu.",
 "{n} arquivos estão em outro dispositivo e ficaram de fora.": "{n} fichiers se trouvent sur un autre appareil et ont été exclus.",
 "Conversa sobre este documento": "Conversation sur ce document",
 "Pergunte ou responda algo sobre este documento. O escritório e o cliente veem.": "Posez une question ou répondez à propos de ce document. Le cabinet et le client le voient.",
 "Escreva a mensagem": "Écrivez le message",
 "Usar um modelo de pedido ({n})": "Utiliser un modèle de demande ({n})",
 "Lembrar {nome} pelo WhatsApp: {o}": "Rappeler à {nome} par WhatsApp : {o}",
 "Sem honorário": "Sans honoraires",
 "Cadastre o valor do honorário no bloco \"Escritório\" da ficha do cliente, em Meus clientes.": "Saisissez le montant des honoraires dans le bloc « Cabinet » de la fiche du client, dans Mes clients.",
 "Recebi de {c} a quantia de {v}, referente aos honorários da competência {m}.": "J’ai reçu de {c} la somme de {v}, au titre des honoraires de la période {m}.",
 "Recibo honorário {m} {c}": "Reçu honoraires {m} {c}",
 "Recibo do honorário {m}": "Reçu des honoraires {m}",
 "Recibo criado": "Reçu créé",
 "O recibo entrou em Documentos, na competência {m}.": "Le reçu a été ajouté à Documents, à la période {m}.",
 "Vendo como o cliente": "Vue en tant que client",
 "É assim que o cliente vê a pasta dele: sem as anotações internas e sem o que é só da equipe. Nada pode ser mudado neste modo.": "Voici comment le client voit son dossier : sans les notes internes et sans ce qui est réservé à l’équipe. Rien ne peut être modifié dans ce mode.",
 "Voltar a ver como escritório": "Revenir à la vue cabinet",
 "Ver como o cliente": "Voir comme le client",
 "🔒 Anotações internas (o cliente nunca vê)": "🔒 Notes internes (le client ne les voit jamais)",
 "Recibo do honorário…": "Reçu des honoraires…",
 "Competência do recibo": "Période du reçu",
 "⬇️ Baixar o mês": "⬇️ Télécharger le mois",
 "Me avisar para lembrar o cliente": "Me prévenir pour relancer le client",
 "Guardar como modelo": "Enregistrer comme modèle",
 "Modelo guardado": "Modèle enregistré",
 "Ao criar um pedido para qualquer cliente, toque em \"Usar um modelo de pedido\".": "Lorsque vous créez une demande pour un client, touchez « Utiliser un modèle de demande ».",
 "Relatório do mês": "Rapport du mois",
 "Notas rápidas": "Notes rapides",
 "Item completo: {o}": "Élément complet : {o}",
 "Reuniões do mês": "Réunions du mois",
 "Tarefas feitas e pendentes": "Tâches terminées et en attente",
 "Documentos internos enviados": "Documents internes envoyés",
 "Documentos enviados e recebidos dos clientes": "Documents envoyés aux clients et reçus des clients",
 "Documentos da competência": "Documents de la période",
 "Guias pagas e vencidas": "Bordereaux d’impôt payés et échus",
 "Honorários": "Honoraires",
 "Relatório do mês · {m}": "Rapport du mois · {m}",
 "Reuniões ({n})": "Réunions ({n})",
 "Tarefas: {f} feitas no mês · {p} pendentes": "Tâches : {f} terminées dans le mois · {p} en attente",
 "Quem fez": "Fait par",
 "Feita em": "Faite le",
 "Documentos internos enviados ({n})": "Documents internes envoyés ({n})",
 "Documentos trocados com os clientes": "Documents échangés avec les clients",
 "Enviados pelo escritório": "Envoyés par le cabinet",
 "Recebidos do cliente": "Reçus du client",
 "Nenhum documento trocado neste mês.": "Aucun document échangé ce mois-ci.",
 "Clientes com pendência ({n})": "Clients avec éléments en attente ({n})",
 "Pendência": "En attente",
 "Nenhum cliente com pendência.": "Aucun client avec des éléments en attente.",
 "Documentos da competência {m} ({n})": "Documents de la période {m} ({n})",
 "Pedidos de documentos ({n})": "Demandes de documents ({n})",
 "Guias do mês: {p} pagas · {v} vencidas": "Bordereaux du mois : {p} payés · {v} échus",
 "Vencida": "Échue",
 "Recebido no mês": "Reçu dans le mois",
 "Relatório {m} {q}": "Rapport {m} {q}",
 "MÊS": "MOIS",
 "DE QUEM": "DE QUI",
 "O escritório": "Le cabinet",
 "Reuniões, tarefas e documentos internos entram quando há um escritório (equipe).": "Les réunions, tâches et documents internes sont inclus lorsqu’il y a un cabinet (équipe).",
 "CPF, CNPJ, anotações internas e conversas nunca vão para o relatório.": "Le CPF, le CNPJ, les notes internes et les conversations ne figurent jamais dans le rapport.",
 "Anotações recebidas": "Notes reçues",
 "Os valores a receber desta lista aparecem no My Planner, inclusive os novos.": "Les montants à recevoir de cette liste apparaissent dans My Planner, y compris les nouveaux.",
 "Envia só os valores a receber desta lista (as consultas já vão sozinhas), inclusive os novos.": "N’envoie que les montants à recevoir de cette liste (les rendez-vous y vont déjà seuls), y compris les nouveaux.",
 "Acrescentar": "Ajouter",
 "As {n} caixas estão em {aba}, em \"Anotações recebidas\".": "Les {n} boîtes sont dans {aba}, dans « Notes reçues ».",
 "Enviadas": "Envoyées",
 "Enviar para": "Envoyer vers",
 "Excluir 1 item?": "Supprimer 1 élément ?",
 "Excluir {n} itens?": "Supprimer {n} éléments ?",
 "Inserir abaixo": "Insérer en dessous",
 "Mover para": "Déplacer vers",
 "Mover {n} selecionados para": "Déplacer {n} éléments vers",
 "adicionar aqui": "ajouter ici",
 "continue segurando para selecionar": "maintenez pour sélectionner"
}
